var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g5, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _rect4, _path157, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path158, _path159, _rect20, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _rect21, _rect22, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _g6, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _line, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _line2, _path413, _path414, _path415, _path416, _rect23, _rect24, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagEcu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2631 3341)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_584",
    "data-name": "Ret\\xE2ngulo 584",
    width: 102.836,
    height: 59.988,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_557",
    "data-name": "Ret\\xE2ngulo 557",
    width: 102.837,
    height: 59.988,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9355",
    "data-name": "Caminho 9355",
    d: "M26.3,18.216c0,4.469,2.815,8.09,6.286,8.09s6.288-3.622,6.288-8.09-2.817-8.091-6.288-8.091S26.3,13.747,26.3,18.216",
    transform: "translate(-26.302 -10.125)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.102,
    y1: 2.468,
    x2: -2.982,
    y2: 2.468,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea8d1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9445",
    "data-name": "Caminho 9445",
    d: "M28.117,17.568l-.022-.007.022.007m-.022-.007-.021-.005.021.005m4.094-.122h0m0,0h0l0,0,0,0m.065-.012.295-.065c-.106.022-.211.043-.295.065m.348-.077-.053.012a4.535,4.535,0,0,0,.463-.1c-.005,0-.207.043-.41.087M28.7,14.874c-.081.051-.394.192-.559.273s-.17.245-.111.273a3.742,3.742,0,0,1,.459.3c.027.043-.161.123-.182.137s-.012.063-.012.063c.2.273.969.288.845.375s-.348.072-.194.226a2.808,2.808,0,0,0,.525.393c.23.118.218.216.271.269.1.106.043.07.185.139s.3.115.189.163-.255.029-.389.087-.046.069-.247.1a1.748,1.748,0,0,1-.291.029c-.048,0-.019-.021-.142-.021a1.521,1.521,0,0,0-.218,0,3.2,3.2,0,0,1-.708-.113l.7.182c.153.039.142.021.264.058s.238.048.322.077a.587.587,0,0,1,.209.125c.067.058.077.079.123.087s.18.06.048.108-.048.077-.19.077a2.151,2.151,0,0,0-.218.009.754.754,0,0,1-.226.01c-.069-.019-.153-.077-.153-.019s.029.077-.058.077a.736.736,0,0,1-.207-.048.445.445,0,0,1-.2.048c-.07.005-.1.005-.134.005s-.065,0-.141.005a1.051,1.051,0,0,1-.129,0c-.055,0-.082-.007-.1.019s.153.087-.1.05-.159-.039.115.046.075,0,.406.1a3.831,3.831,0,0,1,.37.135c.266.087.228.019.351.1s.159.058.2.1.084-.019.1.077.123.194.039.213a.383.383,0,0,1-.19.021c-.115-.01-.048-.029-.218-.039s-.295-.021-.295-.021-.113.012,0,.069-.009.117-.113.156a1.21,1.21,0,0,1-.228.057c-.046.012.01,0-.17.05s-.142.069-.255.117a1.356,1.356,0,0,1-.274.077c-.123.029-.115.019-.219.038s-.17.029-.237.039a.836.836,0,0,1-.115.01,4.817,4.817,0,0,0,.77,1.394c.549.7,1.819,2.043,3.127,2.177a4.859,4.859,0,0,0,2.947-.319,6.121,6.121,0,0,0,2.3-2.061,10.63,10.63,0,0,0,.67-1.185.44.44,0,0,0-.23-.036c-.1.022-.1-.183-.252-.183s-.141.067-.331-.021-.134-.117-.286-.125a1.99,1.99,0,0,1-.444-.135,2.433,2.433,0,0,0-.37-.069,1.2,1.2,0,0,1-.444-.106A3.658,3.658,0,0,0,34.264,19a1.3,1.3,0,0,1-.219-.087c-.055-.039-.2-.106-.017-.242s.247-.214.312-.252a.891.891,0,0,1,.333-.135,1.876,1.876,0,0,1,.312-.039c.18,0-.094-.077-.276-.067s-.178.038-.341.038a3.447,3.447,0,0,0-.473.021,1.772,1.772,0,0,1-.473-.01,1.781,1.781,0,0,1-.521-.048,3.343,3.343,0,0,0-.456-.058A.893.893,0,0,1,32.019,18a1.159,1.159,0,0,0-.295-.106c-.075-.019-.134-.039-.057-.1s.367-.281.432-.321a.851.851,0,0,1,.156-.051l-.065.014-.031.007a1.285,1.285,0,0,1-.339-.009,3.687,3.687,0,0,1-.5-.086,1.81,1.81,0,0,0-.557-.117c-.314-.01-.209-.039-.341-.135a1.2,1.2,0,0,1-.257-.213.363.363,0,0,0-.207-.165c-.276-.089-.531-.286-.494-.331.065-.077.161-.117.048-.213a5.849,5.849,0,0,0-.958-.267s0-.033.015-.036a.831.831,0,0,0,.206-.089c.089-.063,0-.1-.108-.158-.146-.079-.4-.192-.511-.274s.123-.23.362-.334a6.475,6.475,0,0,0,.929-.7l-.005-.029s-.662.531-.741.585",
    transform: "translate(-27.193 -14.289)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4.725,
    y1: 3.843,
    x2: -4.551,
    y2: 3.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#c1d3e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#88b0d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#5998c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#2c87bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#007db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#0077b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_560",
    "data-name": "Ret\\xE2ngulo 560",
    width: 10.739,
    height: 3.301,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_580",
    "data-name": "Ret\\xE2ngulo 580",
    width: 2.026,
    height: 0.386,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "flag_ECU",
    transform: "translate(-2631 -3341)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_equador",
    transform: "translate(2609.862 3341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_871",
    "data-name": "Grupo 871",
    clipPath: "url(#clip-path-2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_550",
    "data-name": "Ret\\xE2ngulo 550",
    width: 102.837,
    height: 58.776,
    transform: "translate(0 1.212)",
    fill: "#ed1c24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_551",
    "data-name": "Ret\\xE2ngulo 551",
    width: 102.837,
    height: 37.142,
    transform: "translate(0 5.707)",
    fill: "#034ea2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_552",
    "data-name": "Ret\\xE2ngulo 552",
    width: 102.837,
    height: 25.709,
    transform: "translate(0 0)",
    fill: "#fd0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_856",
    "data-name": "Grupo 856",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_855",
    "data-name": "Grupo 855",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8888",
    "data-name": "Caminho 8888",
    d: "M23.381,21.674l-.009.015a1.349,1.349,0,0,1-.468.135,2.654,2.654,0,0,1-.482.921,3.159,3.159,0,0,1,.927-.413c.007-.2.041-.429.165-.5l.019,0A.8.8,0,0,0,23.381,21.674Z",
    transform: "translate(16.016 15.481)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8889",
    "data-name": "Caminho 8889",
    d: "M23.381,21.674l-.009.015a1.349,1.349,0,0,1-.468.135,2.654,2.654,0,0,1-.482.921,3.159,3.159,0,0,1,.927-.413c.007-.2.041-.429.165-.5l.019,0A.8.8,0,0,0,23.381,21.674Z",
    transform: "translate(16.016 15.481)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_59",
    "data-name": "Linha 59",
    y1: 0.874,
    x2: 0.897,
    transform: "translate(38.567 37.235)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_60",
    "data-name": "Linha 60",
    x1: 0.446,
    y1: 0.507,
    transform: "translate(38.923 37.296)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8890",
    "data-name": "Caminho 8890",
    d: "M24.663,20.65l.262.317-1.661,1.591h-.1l-.187-.173.009-.134Z",
    transform: "translate(16.41 14.75)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8891",
    "data-name": "Caminho 8891",
    d: "M24.663,20.65l.262.317-1.661,1.591h-.1l-.187-.173.009-.134Z",
    transform: "translate(16.41 14.75)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_61",
    "data-name": "Linha 61",
    y1: 1.534,
    x2: 1.623,
    transform: "translate(39.543 35.629)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8892",
    "data-name": "Caminho 8892",
    d: "M24.326,9.041l.694.67-.178.077-.686-.662.17-.086",
    transform: "translate(17.255 6.458)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8893",
    "data-name": "Caminho 8893",
    d: "M24.326,9.041l.694.67-.178.077-.686-.662.17-.086",
    transform: "translate(17.255 6.458)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8894",
    "data-name": "Caminho 8894",
    d: "M25.736,16.353l.907.915.425-1.047.082-.643c-.065-1.841-.033-3.651-.033-3.651l.267.237c-.3-.3-.646-.66-1.018-1.041l-.6-.6S25.757,14.394,25.736,16.353Z",
    transform: "translate(18.383 7.515)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8895",
    "data-name": "Caminho 8895",
    d: "M25.736,16.353l.907.915.425-1.047.082-.643c-.065-1.841-.033-3.651-.033-3.651l.267.237c-.3-.3-.646-.66-1.018-1.041l-.6-.6S25.757,14.394,25.736,16.353Z",
    transform: "translate(18.383 7.515)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8896",
    "data-name": "Caminho 8896",
    d: "M26.577,14.992l.9-2.734-.931-.917S26.514,13.151,26.577,14.992Z",
    transform: "translate(18.956 8.101)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8897",
    "data-name": "Caminho 8897",
    d: "M26.577,14.992l.9-2.734-.931-.917S26.514,13.151,26.577,14.992Z",
    transform: "translate(18.956 8.101)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8898",
    "data-name": "Caminho 8898",
    d: "M26.82,11.561l.6.6c-1.092-1.116-2.369-2.426-3.017-3.1a44.285,44.285,0,0,0-.135,5.781l2.522,2.546c.019-1.958.031-5.832.031-5.832",
    transform: "translate(17.332 6.473)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8899",
    "data-name": "Caminho 8899",
    d: "M26.82,11.561l.6.6c-1.092-1.116-2.369-2.426-3.017-3.1a44.285,44.285,0,0,0-.135,5.781l2.522,2.546C26.808,15.435,26.82,11.561,26.82,11.561Z",
    transform: "translate(17.332 6.473)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_62",
    "data-name": "Linha 62",
    x1: 4.841,
    y1: 4.975,
    transform: "translate(41.325 15.108)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8900",
    "data-name": "Caminho 8900",
    d: "M24.684,9.391l-.017-.012a1.8,1.8,0,0,1-.153-.6,3.051,3.051,0,0,1-1.085-.636,4.244,4.244,0,0,1,.471,1.2c.233.012.509.062.595.221l0,.024a.986.986,0,0,0,.185-.192",
    transform: "translate(16.735 5.815)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8901",
    "data-name": "Caminho 8901",
    d: "M24.684,9.391l-.017-.012a1.8,1.8,0,0,1-.153-.6,3.051,3.051,0,0,1-1.085-.636,4.244,4.244,0,0,1,.471,1.2c.233.012.509.062.595.221l0,.024A.986.986,0,0,0,24.684,9.391Z",
    transform: "translate(16.735 5.815)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8902",
    "data-name": "Caminho 8902",
    d: "M24.751,9.418,24.537,9.2c-.015.05-.039.135-.081.285-.084.321-.019,1.39-.067,1.757s-.132.871-.141,1.087l0,.014a2.271,2.271,0,0,0,.091.567s.151.079.175.01a6.069,6.069,0,0,0,.038-.711,6.86,6.86,0,0,1,.125-.7,3.413,3.413,0,0,0,.014-1.15,4.652,4.652,0,0,1,.062-.934",
    transform: "translate(17.319 6.569)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8903",
    "data-name": "Caminho 8903",
    d: "M24.751,9.418,24.537,9.2c-.015.05-.039.135-.081.285-.084.321-.019,1.39-.067,1.757s-.132.871-.141,1.087l0,.014a2.271,2.271,0,0,0,.091.567s.151.079.175.01a6.069,6.069,0,0,0,.038-.711,6.86,6.86,0,0,1,.125-.7,3.413,3.413,0,0,0,.014-1.15A4.652,4.652,0,0,1,24.751,9.418Z",
    transform: "translate(17.319 6.569)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8904",
    "data-name": "Caminho 8904",
    d: "M24.477,9.061a4.013,4.013,0,0,0-.226,1.157,12.339,12.339,0,0,1-.075,1.3,7.165,7.165,0,0,0-.1.792c0,.11.024.1.048.161,0,0,.163.1.255-.038v-.014c.01-.214.094-.718.142-1.085S24.5,9.9,24.584,9.58c.039-.151.065-.237.081-.286a.441.441,0,0,1,.022-.065Z",
    transform: "translate(17.193 6.472)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8905",
    "data-name": "Caminho 8905",
    d: "M24.477,9.061a4.013,4.013,0,0,0-.226,1.157,12.339,12.339,0,0,1-.075,1.3,7.165,7.165,0,0,0-.1.792c0,.11.024.1.048.161,0,0,.163.1.255-.038v-.014c.01-.214.094-.718.142-1.085S24.5,9.9,24.584,9.58c.039-.151.065-.237.081-.286a.441.441,0,0,1,.022-.065Z",
    transform: "translate(17.193 6.472)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8906",
    "data-name": "Caminho 8906",
    d: "M24.945,9c-.12.041-.49.11-.607.13L24.3,9.14a.911.911,0,0,1,.746.336l.18-.221c.159-.271-.142-.3-.285-.252",
    transform: "translate(17.36 6.417)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8907",
    "data-name": "Caminho 8907",
    d: "M24.945,9c-.12.041-.49.11-.607.13L24.3,9.14a.911.911,0,0,1,.746.336l.18-.221C25.389,8.984,25.087,8.955,24.945,9Z",
    transform: "translate(17.36 6.417)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8908",
    "data-name": "Caminho 8908",
    d: "M24.3,9.075l.014.027c.063.117.322.555.622.4l.11-.086a.915.915,0,0,0-.746-.338",
    transform: "translate(17.36 6.482)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8909",
    "data-name": "Caminho 8909",
    d: "M24.3,9.075l.014.027c.063.117.322.555.622.4l.11-.086A.915.915,0,0,0,24.3,9.075Z",
    transform: "translate(17.36 6.482)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8910",
    "data-name": "Caminho 8910",
    d: "M24.33,9.2a4.143,4.143,0,0,1,.6-.295c.074,0,.082.125.1.2s0,.159-.261.151-.183-.036-.437-.055",
    transform: "translate(17.379 6.359)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8911",
    "data-name": "Caminho 8911",
    d: "M24.33,9.2a4.143,4.143,0,0,1,.6-.295c.074,0,.082.125.1.2s0,.159-.261.151S24.584,9.217,24.33,9.2Z",
    transform: "translate(17.379 6.359)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8912",
    "data-name": "Caminho 8912",
    d: "M25.171,9a.371.371,0,0,0-.447-.291c-.362.063-.408.513-.415.631v.029c.855-.744.737.017.737.017A1.478,1.478,0,0,0,25.171,9Z",
    transform: "translate(17.364 6.215)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8913",
    "data-name": "Caminho 8913",
    d: "M25.171,9a.371.371,0,0,0-.447-.291c-.362.063-.408.513-.415.631v.029c.855-.744.737.017.737.017A1.478,1.478,0,0,0,25.171,9Z",
    transform: "translate(17.364 6.215)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_63",
    "data-name": "Linha 63",
    x2: 1.126,
    y2: 1.281,
    transform: "translate(40.208 14.026)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_64",
    "data-name": "Linha 64",
    y1: 0.561,
    x2: 0.621,
    transform: "translate(40.635 14.594)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8914",
    "data-name": "Caminho 8914",
    d: "M24.918,8.383a.144.144,0,0,0-.036-.038,1.245,1.245,0,0,1-.081.706,1.046,1.046,0,0,1-.305.4,1.035,1.035,0,0,1-1.046.122l.019.014c.033.021.063.041.1.06a.991.991,0,0,0,1.462-.288A1.065,1.065,0,0,0,24.918,8.383Z",
    transform: "translate(16.751 5.961)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8915",
    "data-name": "Caminho 8915",
    d: "M24.918,8.383a.144.144,0,0,0-.036-.038,1.245,1.245,0,0,1-.081.706,1.046,1.046,0,0,1-.305.4,1.035,1.035,0,0,1-1.046.122l.019.014c.033.021.063.041.1.06a.991.991,0,0,0,1.462-.288A1.065,1.065,0,0,0,24.918,8.383Z",
    transform: "translate(16.751 5.961)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8916",
    "data-name": "Caminho 8916",
    d: "M24.234,10.887a.175.175,0,1,1-.171.175.173.173,0,0,1,.171-.175",
    transform: "translate(17.188 7.776)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8917",
    "data-name": "Caminho 8917",
    d: "M24.234,10.887a.175.175,0,1,1-.171.175A.173.173,0,0,1,24.234,10.887Z",
    transform: "translate(17.188 7.776)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8918",
    "data-name": "Caminho 8918",
    d: "M24.51,11.928c-.243-.009-.377-.024-.535-.033.021-.343.05-.816.315-.8s.24.492.219.833",
    transform: "translate(17.125 7.925)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8919",
    "data-name": "Caminho 8919",
    d: "M24.51,11.928c-.243-.009-.377-.024-.535-.033.021-.343.05-.816.315-.8S24.53,11.587,24.51,11.928Z",
    transform: "translate(17.125 7.925)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8920",
    "data-name": "Caminho 8920",
    d: "M24.127,11.264s-.046.489-.05.516",
    transform: "translate(17.198 8.046)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8921",
    "data-name": "Caminho 8921",
    d: "M24.192,11.267a4.193,4.193,0,0,1-.022.525",
    transform: "translate(17.264 8.048)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8922",
    "data-name": "Caminho 8922",
    d: "M24.409,11.175a.175.175,0,1,1-.171.175.174.174,0,0,1,.171-.175",
    transform: "translate(17.313 7.982)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8923",
    "data-name": "Caminho 8923",
    d: "M24.409,11.175a.175.175,0,1,1-.171.175A.174.174,0,0,1,24.409,11.175Z",
    transform: "translate(17.313 7.982)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8924",
    "data-name": "Caminho 8924",
    d: "M24.721,12.2c-.243.005-.377,0-.535,0,0-.343,0-.818.267-.818S24.721,11.858,24.721,12.2Z",
    transform: "translate(17.276 8.131)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8925",
    "data-name": "Caminho 8925",
    d: "M24.721,12.2c-.243.005-.377,0-.535,0,0-.343,0-.818.267-.818S24.721,11.858,24.721,12.2Z",
    transform: "translate(17.276 8.131)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8926",
    "data-name": "Caminho 8926",
    d: "M24.306,11.554s-.017.49-.019.519",
    transform: "translate(17.348 8.253)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8927",
    "data-name": "Caminho 8927",
    d: "M24.375,11.553a4.076,4.076,0,0,1,.009.525",
    transform: "translate(17.411 8.252)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8928",
    "data-name": "Caminho 8928",
    d: "M37.029,21.674l.009.015a1.349,1.349,0,0,0,.468.135,2.654,2.654,0,0,0,.482.921,3.159,3.159,0,0,0-.927-.413c-.007-.2-.041-.429-.165-.5l-.019,0A.8.8,0,0,1,37.029,21.674Z",
    transform: "translate(26.34 15.481)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8929",
    "data-name": "Caminho 8929",
    d: "M37.029,21.674l.009.015a1.349,1.349,0,0,0,.468.135,2.654,2.654,0,0,0,.482.921,3.159,3.159,0,0,0-.927-.413c-.007-.2-.041-.429-.165-.5l-.019,0A.8.8,0,0,1,37.029,21.674Z",
    transform: "translate(26.34 15.481)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_65",
    "data-name": "Linha 65",
    x1: 0.897,
    y1: 0.874,
    transform: "translate(63.304 37.235)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_66",
    "data-name": "Linha 66",
    y1: 0.507,
    x2: 0.446,
    transform: "translate(63.399 37.296)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8930",
    "data-name": "Caminho 8930",
    d: "M36.1,20.65l-.262.317L37.5,22.558h.1l.187-.173-.009-.134Z",
    transform: "translate(25.597 14.75)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8931",
    "data-name": "Caminho 8931",
    d: "M36.1,20.65l-.262.317L37.5,22.558h.1l.187-.173-.009-.134Z",
    transform: "translate(25.597 14.75)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_67",
    "data-name": "Linha 67",
    x1: 1.623,
    y1: 1.534,
    transform: "translate(61.6 35.629)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8932",
    "data-name": "Caminho 8932",
    d: "M35.981,9.041l-.694.67.178.077.686-.662Z",
    transform: "translate(25.205 6.458)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8933",
    "data-name": "Caminho 8933",
    d: "M35.981,9.041l-.694.67.178.077.686-.662-.17-.086",
    transform: "translate(25.205 6.458)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8934",
    "data-name": "Caminho 8934",
    d: "M34.9,16.353l-.907.915-.425-1.047-.082-.643c.065-1.841.033-3.651.033-3.651l-.267.237c.3-.3.646-.66,1.018-1.041l.6-.6S34.878,14.394,34.9,16.353Z",
    transform: "translate(23.749 7.515)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8935",
    "data-name": "Caminho 8935",
    d: "M34.9,16.353l-.907.915-.425-1.047-.082-.643c.065-1.841.033-3.651.033-3.651l-.267.237c.3-.3.646-.66,1.018-1.041l.6-.6S34.878,14.394,34.9,16.353Z",
    transform: "translate(23.749 7.515)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8936",
    "data-name": "Caminho 8936",
    d: "M33.762,14.992l-.9-2.734.931-.917S33.825,13.151,33.762,14.992Z",
    transform: "translate(23.473 8.101)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8937",
    "data-name": "Caminho 8937",
    d: "M33.762,14.992l-.9-2.734.931-.917S33.825,13.151,33.762,14.992Z",
    transform: "translate(23.473 8.101)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8938",
    "data-name": "Caminho 8938",
    d: "M34.443,11.561l-.6.6c1.092-1.116,2.369-2.426,3.017-3.1A44.29,44.29,0,0,1,37,14.847l-2.522,2.546c-.019-1.958-.031-5.832-.031-5.832",
    transform: "translate(24.174 6.473)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8939",
    "data-name": "Caminho 8939",
    d: "M34.443,11.561l-.6.6c1.092-1.116,2.369-2.426,3.017-3.1A44.29,44.29,0,0,1,37,14.847l-2.522,2.546C34.455,15.435,34.443,11.561,34.443,11.561Z",
    transform: "translate(24.174 6.473)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_68",
    "data-name": "Linha 68",
    y1: 4.975,
    x2: 4.841,
    transform: "translate(56.601 15.108)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8940",
    "data-name": "Caminho 8940",
    d: "M35.787,9.391l.017-.012a1.8,1.8,0,0,0,.153-.6,3.051,3.051,0,0,0,1.085-.636,4.245,4.245,0,0,0-.471,1.2c-.233.012-.509.062-.595.221l0,.024a.986.986,0,0,1-.185-.192",
    transform: "translate(25.562 5.815)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8941",
    "data-name": "Caminho 8941",
    d: "M35.787,9.391l.017-.012a1.8,1.8,0,0,0,.153-.6,3.051,3.051,0,0,0,1.085-.636,4.245,4.245,0,0,0-.471,1.2c-.233.012-.509.062-.595.221l0,.024A.986.986,0,0,1,35.787,9.391Z",
    transform: "translate(25.562 5.815)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8942",
    "data-name": "Caminho 8942",
    d: "M35.406,9.418,35.62,9.2c.015.05.039.135.081.285.084.321.019,1.39.067,1.757s.132.871.141,1.087l0,.014a2.27,2.27,0,0,1-.091.567s-.151.079-.175.01a6.072,6.072,0,0,1-.038-.711,6.862,6.862,0,0,0-.125-.7,3.412,3.412,0,0,1-.014-1.15,4.652,4.652,0,0,0-.062-.934",
    transform: "translate(25.29 6.569)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8943",
    "data-name": "Caminho 8943",
    d: "M35.406,9.418,35.62,9.2c.015.05.039.135.081.285.084.321.019,1.39.067,1.757s.132.871.141,1.087l0,.014a2.27,2.27,0,0,1-.091.567s-.151.079-.175.01a6.072,6.072,0,0,1-.038-.711,6.862,6.862,0,0,0-.125-.7,3.412,3.412,0,0,1-.014-1.15A4.652,4.652,0,0,0,35.406,9.418Z",
    transform: "translate(25.29 6.569)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8944",
    "data-name": "Caminho 8944",
    d: "M35.727,9.061a4.012,4.012,0,0,1,.226,1.157,12.341,12.341,0,0,0,.075,1.3,7.176,7.176,0,0,1,.1.792c0,.11-.024.1-.048.161,0,0-.163.1-.255-.038v-.014c-.01-.214-.094-.718-.142-1.085s.019-1.438-.067-1.757c-.039-.151-.065-.237-.081-.286a.441.441,0,0,0-.022-.065Z",
    transform: "translate(25.37 6.472)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8945",
    "data-name": "Caminho 8945",
    d: "M35.727,9.061a4.012,4.012,0,0,1,.226,1.157,12.341,12.341,0,0,0,.075,1.3,7.176,7.176,0,0,1,.1.792c0,.11-.024.1-.048.161,0,0-.163.1-.255-.038v-.014c-.01-.214-.094-.718-.142-1.085s.019-1.438-.067-1.757c-.039-.151-.065-.237-.081-.286a.441.441,0,0,0-.022-.065Z",
    transform: "translate(25.37 6.472)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8946",
    "data-name": "Caminho 8946",
    d: "M35.406,9c.12.041.49.11.607.13l.034.007a.911.911,0,0,0-.746.336l-.18-.221c-.159-.271.142-.3.285-.252",
    transform: "translate(25.055 6.417)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8947",
    "data-name": "Caminho 8947",
    d: "M35.406,9c.12.041.49.11.607.13l.034.007a.911.911,0,0,0-.746.336l-.18-.221C34.962,8.984,35.264,8.955,35.406,9Z",
    transform: "translate(25.055 6.417)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8948",
    "data-name": "Caminho 8948",
    d: "M35.954,9.075,35.94,9.1c-.063.117-.322.555-.622.4l-.11-.086a.915.915,0,0,1,.746-.338",
    transform: "translate(25.149 6.482)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8949",
    "data-name": "Caminho 8949",
    d: "M35.954,9.075,35.94,9.1c-.063.117-.322.555-.622.4l-.11-.086A.915.915,0,0,1,35.954,9.075Z",
    transform: "translate(25.149 6.482)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8950",
    "data-name": "Caminho 8950",
    d: "M35.91,9.2a4.143,4.143,0,0,0-.6-.295c-.074,0-.082.125-.1.2s0,.159.261.151.183-.036.437-.055",
    transform: "translate(25.148 6.359)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8951",
    "data-name": "Caminho 8951",
    d: "M35.91,9.2a4.143,4.143,0,0,0-.6-.295c-.074,0-.082.125-.1.2s0,.159.261.151S35.656,9.217,35.91,9.2Z",
    transform: "translate(25.148 6.359)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8952",
    "data-name": "Caminho 8952",
    d: "M35.136,9a.369.369,0,0,1,.446-.291c.362.063.408.513.417.631v.029c-.857-.744-.739.017-.739.017A1.516,1.516,0,0,1,35.136,9",
    transform: "translate(25.097 6.215)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8953",
    "data-name": "Caminho 8953",
    d: "M35.136,9a.369.369,0,0,1,.446-.291c.362.063.408.513.417.631v.029c-.857-.744-.739.017-.739.017A1.516,1.516,0,0,1,35.136,9Z",
    transform: "translate(25.097 6.215)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_69",
    "data-name": "Linha 69",
    x1: 1.126,
    y2: 1.281,
    transform: "translate(61.433 14.026)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_70",
    "data-name": "Linha 70",
    x1: 0.621,
    y1: 0.561,
    transform: "translate(61.512 14.594)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8954",
    "data-name": "Caminho 8954",
    d: "M35.718,8.383a.144.144,0,0,1,.036-.038,1.245,1.245,0,0,0,.081.706,1.046,1.046,0,0,0,.305.4,1.035,1.035,0,0,0,1.046.122l-.021.014c-.031.021-.062.041-.1.06a.991.991,0,0,1-1.462-.288,1.065,1.065,0,0,1,.111-.974",
    transform: "translate(25.381 5.961)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8955",
    "data-name": "Caminho 8955",
    d: "M35.718,8.383a.144.144,0,0,1,.036-.038,1.245,1.245,0,0,0,.081.706,1.046,1.046,0,0,0,.305.4,1.035,1.035,0,0,0,1.046.122l-.021.014c-.031.021-.062.041-.1.06a.991.991,0,0,1-1.462-.288A1.065,1.065,0,0,1,35.718,8.383Z",
    transform: "translate(25.381 5.961)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8956",
    "data-name": "Caminho 8956",
    d: "M35.856,10.887a.175.175,0,1,0,.171.175.174.174,0,0,0-.171-.175",
    transform: "translate(25.489 7.776)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8957",
    "data-name": "Caminho 8957",
    d: "M35.856,10.887a.175.175,0,1,0,.171.175A.174.174,0,0,0,35.856,10.887Z",
    transform: "translate(25.489 7.776)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8958",
    "data-name": "Caminho 8958",
    d: "M35.665,11.928c.243-.009.377-.024.535-.033-.021-.343-.05-.816-.315-.8s-.24.492-.219.833",
    transform: "translate(25.466 7.925)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8959",
    "data-name": "Caminho 8959",
    d: "M35.665,11.928c.243-.009.377-.024.535-.033-.021-.343-.05-.816-.315-.8S35.644,11.587,35.665,11.928Z",
    transform: "translate(25.466 7.925)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8960",
    "data-name": "Caminho 8960",
    d: "M35.842,11.264s.046.489.05.516",
    transform: "translate(25.601 8.046)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8961",
    "data-name": "Caminho 8961",
    d: "M35.764,11.267a4.192,4.192,0,0,0,.022.525",
    transform: "translate(25.546 8.048)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8962",
    "data-name": "Caminho 8962",
    d: "M35.68,11.175a.175.175,0,1,0,.171.175.174.174,0,0,0-.171-.175",
    transform: "translate(25.364 7.982)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8963",
    "data-name": "Caminho 8963",
    d: "M35.68,11.175a.175.175,0,1,0,.171.175A.174.174,0,0,0,35.68,11.175Z",
    transform: "translate(25.364 7.982)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8964",
    "data-name": "Caminho 8964",
    d: "M35.45,12.2c.243.005.377,0,.535,0,0-.343,0-.818-.267-.818s-.267.475-.267.818",
    transform: "translate(25.321 8.131)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8965",
    "data-name": "Caminho 8965",
    d: "M35.45,12.2c.243.005.377,0,.535,0,0-.343,0-.818-.267-.818S35.45,11.858,35.45,12.2Z",
    transform: "translate(25.321 8.131)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8966",
    "data-name": "Caminho 8966",
    d: "M35.649,11.554s.017.49.019.519",
    transform: "translate(25.464 8.253)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8967",
    "data-name": "Caminho 8967",
    d: "M35.578,11.553a4.074,4.074,0,0,0-.009.525",
    transform: "translate(25.402 8.252)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8968",
    "data-name": "Caminho 8968",
    d: "M27.069,10.973a5.325,5.325,0,0,1-.917.3",
    transform: "translate(18.68 7.838)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8969",
    "data-name": "Caminho 8969",
    d: "M25.879,12.536a7.068,7.068,0,0,1-.009-.753A1.9,1.9,0,0,0,26.3,10.1s-.113-.387-.057-.482a8.029,8.029,0,0,0-.542,1.265,3.064,3.064,0,0,0,.058.881c.027.115.072.427.072.427",
    transform: "translate(18.351 6.869)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8970",
    "data-name": "Caminho 8970",
    d: "M25.879,12.536a7.068,7.068,0,0,1-.009-.753A1.9,1.9,0,0,0,26.3,10.1s-.113-.387-.057-.482a8.029,8.029,0,0,0-.542,1.265,3.064,3.064,0,0,0,.058.881c.027.115.072.427.072.427",
    transform: "translate(18.351 6.869)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8971",
    "data-name": "Caminho 8971",
    d: "M26.138,9.795a2.529,2.529,0,0,1-.07.42,2.3,2.3,0,0,1-.086.391,3.469,3.469,0,0,0-.168.509,3.08,3.08,0,0,0-.029.435",
    transform: "translate(18.418 6.996)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8972",
    "data-name": "Caminho 8972",
    d: "M25.769,11.043c-.009-.127.146-.293.243-.379",
    transform: "translate(18.406 7.617)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8973",
    "data-name": "Caminho 8973",
    d: "M25.836,10.743c.036-.091-.077-.279-.091-.379",
    transform: "translate(18.389 7.403)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8974",
    "data-name": "Caminho 8974",
    d: "M25.793,10.873c0-.221.261-.281.271-.482",
    transform: "translate(18.424 7.422)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8975",
    "data-name": "Caminho 8975",
    d: "M25.913,10.521c-.022-.106-.192-.19-.141-.312",
    transform: "translate(18.402 7.292)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8976",
    "data-name": "Caminho 8976",
    d: "M25.9,10.419a.913.913,0,0,1,.115-.2c.038-.057.11-.1.135-.156",
    transform: "translate(18.497 7.191)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8977",
    "data-name": "Caminho 8977",
    d: "M25.942,10.3c.005-.139-.039-.252-.034-.386",
    transform: "translate(18.506 7.079)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8978",
    "data-name": "Caminho 8978",
    d: "M26.142,11.266a.575.575,0,0,1,.23-.542c.173-.134.4-.2.47-.417a.971.971,0,0,0-.041.255,1.4,1.4,0,0,1-.1.295,2.445,2.445,0,0,1-.243.4",
    transform: "translate(18.673 7.363)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8979",
    "data-name": "Caminho 8979",
    d: "M26.142,11.266a.575.575,0,0,1,.23-.542c.173-.134.4-.2.47-.417a.971.971,0,0,0-.041.255,1.4,1.4,0,0,1-.1.295,2.445,2.445,0,0,1-.243.4",
    transform: "translate(18.673 7.363)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8980",
    "data-name": "Caminho 8980",
    d: "M25.694,11.79a1.306,1.306,0,0,1,.662-.708,2.078,2.078,0,0,1,.749-.158,1.565,1.565,0,0,0,.453-.06.838.838,0,0,0,.37-.183c-.437.249-.689.742-1.162.941-.374.156-.869.079-1.2.339",
    transform: "translate(18.264 7.629)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8981",
    "data-name": "Caminho 8981",
    d: "M25.694,11.79a1.306,1.306,0,0,1,.662-.708,2.078,2.078,0,0,1,.749-.158,1.565,1.565,0,0,0,.453-.06.838.838,0,0,0,.37-.183c-.437.249-.689.742-1.162.941-.374.156-.869.079-1.2.339",
    transform: "translate(18.264 7.629)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8982",
    "data-name": "Caminho 8982",
    d: "M25.66,11.684a1.878,1.878,0,0,1,.859-.511,3.041,3.041,0,0,0,.771-.3",
    transform: "translate(18.329 7.766)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8983",
    "data-name": "Caminho 8983",
    d: "M26.166,11.066a.738.738,0,0,0,.334.106",
    transform: "translate(18.69 7.904)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8984",
    "data-name": "Caminho 8984",
    d: "M26.35,11c.079,0,.207.063.273.033",
    transform: "translate(18.821 7.855)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8985",
    "data-name": "Caminho 8985",
    d: "M26.212,11.146c-.091-.161.135-.171.189-.267",
    transform: "translate(18.708 7.771)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8986",
    "data-name": "Caminho 8986",
    d: "M27.018,10.714c.082-.1.053-.369.1-.5a4.123,4.123,0,0,1,.257-.449c-.067.156-.007.367-.06.531a2.611,2.611,0,0,1-.3.5",
    transform: "translate(19.291 6.976)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8987",
    "data-name": "Caminho 8987",
    d: "M27.018,10.714c.082-.1.053-.369.1-.5a4.123,4.123,0,0,1,.257-.449c-.067.156-.007.367-.06.531a2.611,2.611,0,0,1-.3.5",
    transform: "translate(19.291 6.976)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8988",
    "data-name": "Caminho 8988",
    d: "M27.088,10.368c-.017-.154.1-.278.135-.417",
    transform: "translate(19.347 7.108)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8989",
    "data-name": "Caminho 8989",
    d: "M25.743,13.368c.18.279.4.727.151,1.039-.053-.081-.058-.235-.142-.291-.062-.039-.173-.022-.247-.053-.2-.086-.158-.3-.288-.408l-.033-.081.514-.259Z",
    transform: "translate(17.989 9.511)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8990",
    "data-name": "Caminho 8990",
    d: "M25.743,13.368c.18.279.4.727.151,1.039-.053-.081-.058-.235-.142-.291-.062-.039-.173-.022-.247-.053-.2-.086-.158-.3-.288-.408l-.033-.081.514-.259Z",
    transform: "translate(17.989 9.511)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8991",
    "data-name": "Caminho 8991",
    d: "M25.374,13.477a.9.9,0,0,1,.365.758",
    transform: "translate(18.124 9.626)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8992",
    "data-name": "Caminho 8992",
    d: "M25.355,13.471c.065.161.009.283.022.435l.019-.029",
    transform: "translate(18.111 9.622)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8993",
    "data-name": "Caminho 8993",
    d: "M25.41,13.5a1.337,1.337,0,0,1,.355.353",
    transform: "translate(18.15 9.64)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8994",
    "data-name": "Caminho 8994",
    d: "M25.093,13.243a3.862,3.862,0,0,0,.178-.406.861.861,0,0,1,.406-.36,1.977,1.977,0,0,1,.605-.12c.2-.009.43.079.6.063a5.641,5.641,0,0,0-1.1.35,3.122,3.122,0,0,0-.586.54,1.585,1.585,0,0,0-.25.509",
    transform: "translate(17.819 8.825)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8995",
    "data-name": "Caminho 8995",
    d: "M25.093,13.243a3.862,3.862,0,0,0,.178-.406.861.861,0,0,1,.406-.36,1.977,1.977,0,0,1,.605-.12c.2-.009.43.079.6.063a5.641,5.641,0,0,0-1.1.35,3.122,3.122,0,0,0-.586.54,1.585,1.585,0,0,0-.25.509",
    transform: "translate(17.819 8.825)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8996",
    "data-name": "Caminho 8996",
    d: "M25.038,13.3a1.631,1.631,0,0,1,.441-.619.99.99,0,0,1,.646-.214",
    transform: "translate(17.884 8.901)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8997",
    "data-name": "Caminho 8997",
    d: "M25.123,12.9a2.674,2.674,0,0,0,.377-.267",
    transform: "translate(17.945 9.021)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8998",
    "data-name": "Caminho 8998",
    d: "M25.52,12.535c.111-.127.266-.117.408-.135",
    transform: "translate(18.229 8.857)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8999",
    "data-name": "Caminho 8999",
    d: "M25.52,12.535c.111-.127.266-.117.408-.135",
    transform: "translate(18.229 8.857)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9000",
    "data-name": "Caminho 9000",
    d: "M24.961,13.9a1.487,1.487,0,0,0,.106-.216,2.075,2.075,0,0,1,.187-.273,3.436,3.436,0,0,1,.429-.5,1.17,1.17,0,0,1,.523-.286c.18-.043.5,0,.633-.139a4.6,4.6,0,0,1-.261.394,2.679,2.679,0,0,1-.562.487,2.35,2.35,0,0,1-.555.235c-.158.038-.429.038-.518.2a.066.066,0,0,1,.019.019.653.653,0,0,0,.084-.07",
    transform: "translate(17.816 8.916)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9001",
    "data-name": "Caminho 9001",
    d: "M24.961,13.9a1.487,1.487,0,0,0,.106-.216,2.075,2.075,0,0,1,.187-.273,3.436,3.436,0,0,1,.429-.5,1.17,1.17,0,0,1,.523-.286c.18-.043.5,0,.633-.139a4.6,4.6,0,0,1-.261.394,2.679,2.679,0,0,1-.562.487,2.35,2.35,0,0,1-.555.235c-.158.038-.429.038-.518.2a.066.066,0,0,1,.019.019.653.653,0,0,0,.084-.07",
    transform: "translate(17.816 8.916)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9002",
    "data-name": "Caminho 9002",
    d: "M25.014,13.58c.093-.033.177-.166.249-.235a2.029,2.029,0,0,1,.334-.255,3.146,3.146,0,0,1,.47-.261,1.567,1.567,0,0,0,.379-.2",
    transform: "translate(17.867 9.021)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9003",
    "data-name": "Caminho 9003",
    d: "M25.306,12.987a2.364,2.364,0,0,1,.334-.106.6.6,0,0,0,.2-.033",
    transform: "translate(18.076 9.177)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9004",
    "data-name": "Caminho 9004",
    d: "M25.4,13.011a2.151,2.151,0,0,0,.271-.363",
    transform: "translate(18.146 9.034)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9005",
    "data-name": "Caminho 9005",
    d: "M26.444,11.173a2.51,2.51,0,0,1,.5-.5,1.726,1.726,0,0,1,.382-.309c.41-.171.864.159,1.284.153a3.507,3.507,0,0,1-.54.249,2.393,2.393,0,0,1-.595.082c-.362,0-.838.009-1.046.374",
    transform: "translate(18.881 7.371)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9006",
    "data-name": "Caminho 9006",
    d: "M26.444,11.173a2.51,2.51,0,0,1,.5-.5,1.726,1.726,0,0,1,.382-.309c.41-.171.864.159,1.284.153a3.507,3.507,0,0,1-.54.249,2.393,2.393,0,0,1-.595.082c-.362,0-.838.009-1.046.374",
    transform: "translate(18.881 7.371)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9007",
    "data-name": "Caminho 9007",
    d: "M26.581,10.871a6.148,6.148,0,0,0,.7-.307c.233-.093.489-.045.718-.12",
    transform: "translate(18.986 7.46)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9008",
    "data-name": "Caminho 9008",
    d: "M26.986,10.524c.153-.057.367.063.533.063",
    transform: "translate(19.276 7.507)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9009",
    "data-name": "Caminho 9009",
    d: "M26.855,10.721c.075-.063.153-.134.233-.192.06-.043.146-.084.165-.161",
    transform: "translate(19.182 7.406)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9010",
    "data-name": "Caminho 9010",
    d: "M25.479,12.754c.171-.036.231-.336.278-.47a2.5,2.5,0,0,1,.228-.593,1.4,1.4,0,0,1,.317-.255.662.662,0,0,1,.348-.156,4.921,4.921,0,0,1,.636-.055,1.272,1.272,0,0,0,.579-.06,1.15,1.15,0,0,0-.5.386,2.252,2.252,0,0,1-.573.645,3.264,3.264,0,0,1-.821.317c-.156.048-.418.106-.458.29",
    transform: "translate(18.199 7.975)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9011",
    "data-name": "Caminho 9011",
    d: "M25.479,12.754c.171-.036.231-.336.278-.47a2.5,2.5,0,0,1,.228-.593,1.4,1.4,0,0,1,.317-.255.662.662,0,0,1,.348-.156,4.921,4.921,0,0,1,.636-.055,1.272,1.272,0,0,0,.579-.06,1.15,1.15,0,0,0-.5.386,2.252,2.252,0,0,1-.573.645,3.264,3.264,0,0,1-.821.317c-.156.048-.418.106-.458.29",
    transform: "translate(18.199 7.975)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9012",
    "data-name": "Caminho 9012",
    d: "M25.623,12.48c.3-.309.422-.753.879-.876.278-.074.711-.115.9-.363",
    transform: "translate(18.302 8.029)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9013",
    "data-name": "Caminho 9013",
    d: "M25.762,11.872a.5.5,0,0,1,.353-.149.806.806,0,0,0,.4-.033",
    transform: "translate(18.401 8.35)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9014",
    "data-name": "Caminho 9014",
    d: "M26.154,11.483c.082-.031.166.021.249.022a1.173,1.173,0,0,0,.233-.065",
    transform: "translate(18.681 8.171)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9015",
    "data-name": "Caminho 9015",
    d: "M26,11.671A1.1,1.1,0,0,1,26.2,11.3",
    transform: "translate(18.568 8.069)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9016",
    "data-name": "Caminho 9016",
    d: "M25.331,12.684c.132-.009.192-.177.233-.249a1.2,1.2,0,0,1,.2-.322,1.06,1.06,0,0,1,.254-.125.592.592,0,0,1,.273-.065,4.63,4.63,0,0,1,.487.01,1.332,1.332,0,0,0,.444,0,.873.873,0,0,0-.4.187,1.476,1.476,0,0,1-.466.327,2.976,2.976,0,0,1-.639.127c-.123.019-.324.034-.363.135",
    transform: "translate(18.094 8.515)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9017",
    "data-name": "Caminho 9017",
    d: "M25.331,12.684c.132-.009.192-.177.233-.249a1.2,1.2,0,0,1,.2-.322,1.06,1.06,0,0,1,.254-.125.592.592,0,0,1,.273-.065,4.63,4.63,0,0,1,.487.01,1.332,1.332,0,0,0,.444,0,.873.873,0,0,0-.4.187,1.476,1.476,0,0,1-.466.327,2.976,2.976,0,0,1-.639.127c-.123.019-.324.034-.363.135",
    transform: "translate(18.094 8.515)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9018",
    "data-name": "Caminho 9018",
    d: "M25.447,12.547c.242-.156.357-.4.71-.441a1.514,1.514,0,0,0,.7-.147",
    transform: "translate(18.176 8.542)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9019",
    "data-name": "Caminho 9019",
    d: "M25.59,12.233a.455.455,0,0,1,.276-.062.806.806,0,0,0,.307.007",
    transform: "translate(18.279 8.693)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9020",
    "data-name": "Caminho 9020",
    d: "M25.875,12.054a.643.643,0,0,1,.187.029,1.2,1.2,0,0,0,.18-.022",
    transform: "translate(18.482 8.608)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9021",
    "data-name": "Caminho 9021",
    d: "M25.751,12.154c.038-.093.1-.127.177-.2",
    transform: "translate(18.394 8.539)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9022",
    "data-name": "Caminho 9022",
    d: "M25.135,14.577a2.7,2.7,0,0,1-.507-2.679,2.584,2.584,0,0,0,.053.465,3.3,3.3,0,0,1,.559,1.8c-.087.813-.043.483-.043.483Z",
    transform: "translate(17.465 8.499)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9023",
    "data-name": "Caminho 9023",
    d: "M25.135,14.577a2.7,2.7,0,0,1-.507-2.679,2.584,2.584,0,0,0,.053.465,3.3,3.3,0,0,1,.559,1.8c-.087.813-.043.483-.043.483Z",
    transform: "translate(17.465 8.499)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9024",
    "data-name": "Caminho 9024",
    d: "M25.06,14.281a4.856,4.856,0,0,0-.315-1.205,1.794,1.794,0,0,1-.183-.9",
    transform: "translate(17.54 8.696)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9025",
    "data-name": "Caminho 9025",
    d: "M24.666,12.724a.4.4,0,0,0,.1-.206",
    transform: "translate(17.619 8.941)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9026",
    "data-name": "Caminho 9026",
    d: "M24.758,12.965a.709.709,0,0,0,.079-.223",
    transform: "translate(17.684 9.101)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9027",
    "data-name": "Caminho 9027",
    d: "M24.864,13.052c-.057-.074-.269-.087-.279-.17",
    transform: "translate(17.561 9.201)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9028",
    "data-name": "Caminho 9028",
    d: "M24.755,12.814c-.043-.091-.259-.113-.262-.223",
    transform: "translate(17.495 8.994)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9029",
    "data-name": "Caminho 9029",
    d: "M24.609,12.5a.366.366,0,0,1-.132-.214",
    transform: "translate(17.484 8.778)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9030",
    "data-name": "Caminho 9030",
    d: "M24.912,13.263a.985.985,0,0,0-.271-.187",
    transform: "translate(17.601 9.34)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9031",
    "data-name": "Caminho 9031",
    d: "M24.8,13.169c.015-.084.1-.166.1-.25",
    transform: "translate(17.717 9.228)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9032",
    "data-name": "Caminho 9032",
    d: "M25.937,11.631a6.5,6.5,0,0,1,.321-.667,1.8,1.8,0,0,0,1.119-1.287s.065-.394.158-.451a7.733,7.733,0,0,0-1.037.862,3.051,3.051,0,0,0-.331.806c-.024.115-.12.411-.12.411",
    transform: "translate(18.526 6.59)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9033",
    "data-name": "Caminho 9033",
    d: "M25.937,11.631a6.5,6.5,0,0,1,.321-.667,1.8,1.8,0,0,0,1.119-1.287s.065-.394.158-.451a7.733,7.733,0,0,0-1.037.862,3.051,3.051,0,0,0-.331.806c-.024.115-.12.411-.12.411",
    transform: "translate(18.526 6.59)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9034",
    "data-name": "Caminho 9034",
    d: "M27.224,9.371a2.358,2.358,0,0,1-.245.338,2.134,2.134,0,0,1-.247.305,3.163,3.163,0,0,0-.372.37,3,3,0,0,0-.225.387",
    transform: "translate(18.668 6.694)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9035",
    "data-name": "Caminho 9035",
    d: "M26.1,10.322c.048-.115.257-.19.384-.221",
    transform: "translate(18.641 7.215)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9036",
    "data-name": "Caminho 9036",
    d: "M26.253,10.135c.072-.063.051-.283.084-.377",
    transform: "translate(18.752 6.97)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9037",
    "data-name": "Caminho 9037",
    d: "M26.23,10.091c.067-.2.454-.027.533-.194",
    transform: "translate(18.736 7.069)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9038",
    "data-name": "Caminho 9038",
    d: "M26.4,9.974c.026-.1-.091-.257.009-.341",
    transform: "translate(18.833 6.881)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9039",
    "data-name": "Caminho 9039",
    d: "M26.477,9.83a.815.815,0,0,1,.189-.118c.058-.033.141-.036.189-.075",
    transform: "translate(18.912 6.883)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9040",
    "data-name": "Caminho 9040",
    d: "M26.566,9.791c.065-.12.074-.24.137-.357",
    transform: "translate(18.976 6.739)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9041",
    "data-name": "Caminho 9041",
    d: "M25.234,11.549a3.054,3.054,0,0,0,.024-.423.891.891,0,0,1-.276-.95s.094-.216.053-.271a3.944,3.944,0,0,1,.369.713,1.353,1.353,0,0,1-.065.5c-.022.065-.063.242-.063.242",
    transform: "translate(17.819 7.075)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9042",
    "data-name": "Caminho 9042",
    d: "M25.234,11.549a3.054,3.054,0,0,0,.024-.423.891.891,0,0,1-.276-.95s.094-.216.053-.271a3.944,3.944,0,0,1,.369.713,1.353,1.353,0,0,1-.065.5c-.022.065-.063.242-.063.242",
    transform: "translate(17.819 7.075)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9043",
    "data-name": "Caminho 9043",
    d: "M25.014,10.012a1.018,1.018,0,0,0,.039.237,1.077,1.077,0,0,0,.053.219,1.472,1.472,0,0,1,.111.286,1.434,1.434,0,0,1,.01.257",
    transform: "translate(17.867 7.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9044",
    "data-name": "Caminho 9044",
    d: "M25.221,10.715c.009-.07-.1-.165-.17-.214",
    transform: "translate(17.894 7.501)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9045",
    "data-name": "Caminho 9045",
    d: "M25.138,10.546c-.024-.051.065-.158.075-.214",
    transform: "translate(17.953 7.38)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9046",
    "data-name": "Caminho 9046",
    d: "M25.254,10.579c.024-.117-.281-.135-.274-.24",
    transform: "translate(17.843 7.385)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9047",
    "data-name": "Caminho 9047",
    d: "M25.1,10.421c.019-.06.146-.106.111-.175",
    transform: "translate(17.93 7.319)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9048",
    "data-name": "Caminho 9048",
    d: "M25.145,10.364a.429.429,0,0,0-.081-.11c-.026-.033-.077-.055-.094-.089",
    transform: "translate(17.836 7.261)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9049",
    "data-name": "Caminho 9049",
    d: "M25.051,10.294c0-.079.034-.141.034-.218",
    transform: "translate(17.894 7.197)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9050",
    "data-name": "Caminho 9050",
    d: "M25.107,13.234s.041-.785.074-.867a2.427,2.427,0,0,0,.59-1.889,1.592,1.592,0,0,1,0-.562,10.129,10.129,0,0,0-.651,1.392,4.479,4.479,0,0,0-.039,1.022c.015.137.024.5.024.5",
    transform: "translate(17.904 7.082)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9051",
    "data-name": "Caminho 9051",
    d: "M25.107,13.234s.041-.785.074-.867a2.427,2.427,0,0,0,.59-1.889,1.592,1.592,0,0,1,0-.562,10.129,10.129,0,0,0-.651,1.392,4.479,4.479,0,0,0-.039,1.022c.015.137.024.5.024.5",
    transform: "translate(17.904 7.082)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9052",
    "data-name": "Caminho 9052",
    d: "M25.653,10.117a3.412,3.412,0,0,1-.111.475,3.159,3.159,0,0,1-.123.441,4.085,4.085,0,0,0-.214.566,4.74,4.74,0,0,0-.077.519",
    transform: "translate(17.948 7.226)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9053",
    "data-name": "Caminho 9053",
    d: "M25.107,11.515a.729.729,0,0,1,.271-.406",
    transform: "translate(17.934 7.935)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9054",
    "data-name": "Caminho 9054",
    d: "M25.185,11.189c.045-.1-.045-.331-.046-.447",
    transform: "translate(17.956 7.673)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9055",
    "data-name": "Caminho 9055",
    d: "M25.166,11.24c0-.243.4-.226.415-.444",
    transform: "translate(17.976 7.711)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9056",
    "data-name": "Caminho 9056",
    d: "M25.284,10.944c-.01-.125-.163-.242-.1-.377",
    transform: "translate(17.977 7.548)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9057",
    "data-name": "Caminho 9057",
    d: "M25.293,10.813a1.09,1.09,0,0,1,.13-.213c.041-.06.115-.1.146-.163",
    transform: "translate(18.066 7.456)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9058",
    "data-name": "Caminho 9058",
    d: "M25.338,10.688c.019-.159-.01-.295.009-.449",
    transform: "translate(18.099 7.314)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9059",
    "data-name": "Caminho 9059",
    d: "M25.286,11.794A4.406,4.406,0,0,1,25,11.213a1.364,1.364,0,0,0-.237-.437,2.283,2.283,0,0,1,.516.367",
    transform: "translate(17.685 7.695)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9060",
    "data-name": "Caminho 9060",
    d: "M25.286,11.794A4.406,4.406,0,0,1,25,11.213a1.364,1.364,0,0,0-.237-.437,2.283,2.283,0,0,1,.516.367",
    transform: "translate(17.685 7.695)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9061",
    "data-name": "Caminho 9061",
    d: "M25.207,11.38a.956.956,0,0,0-.35-.5",
    transform: "translate(17.755 7.771)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9062",
    "data-name": "Caminho 9062",
    d: "M25.091,11.229c-.017-.079-.1-.135-.158-.178",
    transform: "translate(17.809 7.894)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9063",
    "data-name": "Caminho 9063",
    d: "M25.037,11.165c-.021-.07-.034-.154-.053-.223",
    transform: "translate(17.846 7.816)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9064",
    "data-name": "Caminho 9064",
    d: "M25.137,12.721s.062-.813.42-1.027a2.7,2.7,0,0,0,.5-.322s.211-.295.079-.106a5.831,5.831,0,0,0-.226,1.294,2.211,2.211,0,0,1-.386.768,3.444,3.444,0,0,0-.41.6,2.011,2.011,0,0,0-.1.394",
    transform: "translate(17.868 8.002)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9065",
    "data-name": "Caminho 9065",
    d: "M25.137,12.721s.062-.813.42-1.027a2.7,2.7,0,0,0,.5-.322s.211-.295.079-.106a5.831,5.831,0,0,0-.226,1.294,2.211,2.211,0,0,1-.386.768,3.444,3.444,0,0,0-.41.6,2.011,2.011,0,0,0-.1.394",
    transform: "translate(17.868 8.002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9066",
    "data-name": "Caminho 9066",
    d: "M25.066,13.456a1,1,0,0,0,.219-.449,2.477,2.477,0,0,0,.168-.526,1.976,1.976,0,0,1,.147-.531,4.492,4.492,0,0,1,.314-.477",
    transform: "translate(17.904 8.195)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9067",
    "data-name": "Caminho 9067",
    d: "M25.294,12.218c.115-.161.242-.165.387-.267",
    transform: "translate(18.067 8.536)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9068",
    "data-name": "Caminho 9068",
    d: "M25.192,12.5c.081-.127.254-.1.314-.255",
    transform: "translate(17.994 8.743)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9069",
    "data-name": "Caminho 9069",
    d: "M25.283,12.359c.046-.173-.1-.269-.135-.427",
    transform: "translate(17.963 8.523)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9070",
    "data-name": "Caminho 9070",
    d: "M25.351,12.108a.619.619,0,0,1,0-.523",
    transform: "translate(18.067 8.275)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9071",
    "data-name": "Caminho 9071",
    d: "M25.111,12.3a2.028,2.028,0,0,1,.166-.651c.051-.115.127-.221.187-.327a.6.6,0,0,1,.17-.228",
    transform: "translate(17.936 7.927)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9072",
    "data-name": "Caminho 9072",
    d: "M25.445,11.222c-.007.041.048.065.093.041a.17.17,0,0,0,0-.029c.053.015.175.015.106-.065.05-.009.129-.057.06-.1a.1.1,0,0,0,0-.147l-.021.019c0-.048-.045-.069-.093-.058,0,.009,0,.019,0,.026a.093.093,0,0,0-.1,0c0,.005.014.012.015.019-.029-.005-.043.01-.067.012,0,.009.005.033.009.041s.009,0,0,0a.094.094,0,0,0-.062.074l.038.015c-.062.019-.06.072-.007.094.009,0,.009,0,0,0-.06.057.046.072.082.022",
    transform: "translate(18.125 7.771)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9073",
    "data-name": "Caminho 9073",
    d: "M25.445,11.222c-.007.041.048.065.093.041a.17.17,0,0,0,0-.029c.053.015.175.015.106-.065.05-.009.129-.057.06-.1a.1.1,0,0,0,0-.147l-.021.019c0-.048-.045-.069-.093-.058,0,.009,0,.019,0,.026a.093.093,0,0,0-.1,0c0,.005.014.012.015.019-.029-.005-.043.01-.067.012,0,.009.005.033.009.041s.009,0,0,0a.094.094,0,0,0-.062.074l.038.015c-.062.019-.06.072-.007.094.009,0,.009,0,0,0-.06.057.046.072.082.022",
    transform: "translate(18.125 7.771)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9074",
    "data-name": "Caminho 9074",
    d: "M25.456,10.961c.034.022.015.084.084.089a.425.425,0,0,0,.033-.084c-.021,0-.1.012-.057.026",
    transform: "translate(18.183 7.829)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9075",
    "data-name": "Caminho 9075",
    d: "M25.5,11.509c-.007.041.05.065.093.041a.17.17,0,0,0,0-.029c.053.015.175.015.106-.065.05-.009.129-.057.06-.1a.1.1,0,0,0,0-.147l-.021.019c0-.048-.045-.069-.093-.058,0,.009,0,.019,0,.026a.093.093,0,0,0-.1,0c0,.005.014.012.015.019-.029-.005-.043.01-.067.012,0,.009.005.033.009.041s.009,0,0,0a.1.1,0,0,0-.063.074l.038.015c-.062.019-.06.072-.007.094.009,0,.009,0,0,0-.06.057.046.072.082.022",
    transform: "translate(18.165 7.976)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9076",
    "data-name": "Caminho 9076",
    d: "M25.5,11.509c-.007.041.05.065.093.041a.17.17,0,0,0,0-.029c.053.015.175.015.106-.065.05-.009.129-.057.06-.1a.1.1,0,0,0,0-.147l-.021.019c0-.048-.045-.069-.093-.058,0,.009,0,.019,0,.026a.093.093,0,0,0-.1,0c0,.005.014.012.015.019-.029-.005-.043.01-.067.012,0,.009.005.033.009.041s.009,0,0,0a.1.1,0,0,0-.063.074l.038.015c-.062.019-.06.072-.007.094.009,0,.009,0,0,0-.06.057.046.072.082.022",
    transform: "translate(18.165 7.976)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9077",
    "data-name": "Caminho 9077",
    d: "M25.514,11.245c.031.022.015.086.077.091a.5.5,0,0,0,.027-.086c-.017,0-.091.012-.05.027",
    transform: "translate(18.224 8.032)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9078",
    "data-name": "Caminho 9078",
    d: "M25.7,11.322a1.087,1.087,0,0,0-.607,1.1",
    transform: "translate(17.912 8.087)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9079",
    "data-name": "Caminho 9079",
    d: "M25.929,11.167c.305-.154.386-.509.672-.681a1.818,1.818,0,0,1,.614-.183c.147-.029.346-.057.434-.2a4.887,4.887,0,0,1-.432.432,1.177,1.177,0,0,1-.5.343c-.163.048-.333.031-.494.087a1.306,1.306,0,0,0-.324.243Z",
    transform: "translate(18.499 7.217)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9080",
    "data-name": "Caminho 9080",
    d: "M25.929,11.167c.305-.154.386-.509.672-.681a1.818,1.818,0,0,1,.614-.183c.147-.029.346-.057.434-.2a4.887,4.887,0,0,1-.432.432,1.177,1.177,0,0,1-.5.343c-.163.048-.333.031-.494.087a1.306,1.306,0,0,0-.324.243Z",
    transform: "translate(18.499 7.217)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9081",
    "data-name": "Caminho 9081",
    d: "M26.093,10.807c.156-.1.255-.255.427-.327.189-.081.4-.1.586-.185",
    transform: "translate(18.638 7.353)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9082",
    "data-name": "Caminho 9082",
    d: "M26.227,10.519c.137-.081.333,0,.459-.1",
    transform: "translate(18.734 7.445)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9083",
    "data-name": "Caminho 9083",
    d: "M26.355,10.465c.069-.06.156-.111.219-.171",
    transform: "translate(18.825 7.353)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9084",
    "data-name": "Caminho 9084",
    d: "M26.208,11.172c-.171.086-.528.141-.6.363",
    transform: "translate(18.294 7.98)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9085",
    "data-name": "Caminho 9085",
    d: "M25.984,11.287a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.305.305,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.517 7.855)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9086",
    "data-name": "Caminho 9086",
    d: "M25.984,11.287a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.305.305,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.517 7.855)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9087",
    "data-name": "Caminho 9087",
    d: "M26.014,11.109c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.581 7.916)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9088",
    "data-name": "Caminho 9088",
    d: "M26.35,11.586a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.306.306,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.778 8.068)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9089",
    "data-name": "Caminho 9089",
    d: "M26.35,11.586a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.306.306,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.778 8.068)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9090",
    "data-name": "Caminho 9090",
    d: "M26.38,11.408c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.843 8.13)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9091",
    "data-name": "Caminho 9091",
    d: "M26.124,11.754a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.305.305,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.617 8.188)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9092",
    "data-name": "Caminho 9092",
    d: "M26.124,11.754a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.305.305,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.617 8.188)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9093",
    "data-name": "Caminho 9093",
    d: "M26.154,11.576c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.681 8.25)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9094",
    "data-name": "Caminho 9094",
    d: "M25.827,11.779a.117.117,0,0,0,.144.074l.012-.029c.077.036.149-.021.1-.1.053-.009.06-.051.038-.094a.281.281,0,0,0-.038,0c.089-.117-.2-.206-.2-.075-.053,0-.125.038-.065.077-.055.029-.07.12.005.139",
    transform: "translate(18.404 8.206)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9095",
    "data-name": "Caminho 9095",
    d: "M25.855,11.6c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.468 8.267)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9096",
    "data-name": "Caminho 9096",
    d: "M25.6,12.034a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.307.307,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.242 8.388)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9097",
    "data-name": "Caminho 9097",
    d: "M25.6,12.034a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.307.307,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.242 8.388)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9098",
    "data-name": "Caminho 9098",
    d: "M25.629,11.856c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.306 8.45)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9099",
    "data-name": "Caminho 9099",
    d: "M26.721,11.156a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.305.305,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(19.043 7.761)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9100",
    "data-name": "Caminho 9100",
    d: "M26.721,11.156a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.305.305,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(19.043 7.761)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9101",
    "data-name": "Caminho 9101",
    d: "M26.751,10.977c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(19.108 7.822)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9102",
    "data-name": "Caminho 9102",
    d: "M27.13,10.546a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.306.306,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(19.335 7.325)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9103",
    "data-name": "Caminho 9103",
    d: "M27.13,10.546a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.306.306,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(19.335 7.325)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9104",
    "data-name": "Caminho 9104",
    d: "M27.16,10.367c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(19.4 7.386)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9105",
    "data-name": "Caminho 9105",
    d: "M26.8,10.521a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094-.012,0-.027-.005-.039-.005.091-.115-.2-.2-.2-.074-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(19.1 7.307)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9106",
    "data-name": "Caminho 9106",
    d: "M26.8,10.521a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094-.012,0-.027-.005-.039-.005.091-.115-.2-.2-.2-.074-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(19.1 7.307)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9107",
    "data-name": "Caminho 9107",
    d: "M26.831,10.342c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(19.165 7.368)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9108",
    "data-name": "Caminho 9108",
    d: "M25.959,12.259a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.307.307,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.499 8.549)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9109",
    "data-name": "Caminho 9109",
    d: "M25.959,12.259a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.307.307,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.499 8.549)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9110",
    "data-name": "Caminho 9110",
    d: "M25.99,12.08c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.564 8.61)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9111",
    "data-name": "Caminho 9111",
    d: "M25.618,12.377a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.306.306,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.255 8.633)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9112",
    "data-name": "Caminho 9112",
    d: "M25.618,12.377a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.306.306,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.255 8.633)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9113",
    "data-name": "Caminho 9113",
    d: "M25.648,12.2c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.32 8.695)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9114",
    "data-name": "Caminho 9114",
    d: "M25.6,12.9a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.306.306,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.242 9.007)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9115",
    "data-name": "Caminho 9115",
    d: "M25.6,12.9a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.306.306,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.242 9.007)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9116",
    "data-name": "Caminho 9116",
    d: "M25.629,12.722c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.306 9.068)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9117",
    "data-name": "Caminho 9117",
    d: "M25.289,13.118a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.307.307,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139l.01.007",
    transform: "translate(18.02 9.162)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9118",
    "data-name": "Caminho 9118",
    d: "M25.289,13.118a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094a.307.307,0,0,0-.039,0c.091-.117-.2-.206-.2-.075-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139l.01.007",
    transform: "translate(18.02 9.162)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9119",
    "data-name": "Caminho 9119",
    d: "M25.319,12.94c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.085 9.224)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9120",
    "data-name": "Caminho 9120",
    d: "M26.246,10.907a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094-.012,0-.027-.005-.039-.005.091-.115-.2-.2-.2-.074-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.704 7.583)",
    fill: "#ffdf4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9121",
    "data-name": "Caminho 9121",
    d: "M26.246,10.907a.118.118,0,0,0,.144.074l.012-.029c.077.036.151-.021.1-.1.053-.009.06-.051.038-.094-.012,0-.027-.005-.039-.005.091-.115-.2-.2-.2-.074-.055,0-.127.038-.065.077-.057.029-.07.12,0,.139",
    transform: "translate(18.704 7.583)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9122",
    "data-name": "Caminho 9122",
    d: "M26.276,10.729c0,.17.139-.094,0-.009,0,.014.015.012.019.019",
    transform: "translate(18.769 7.645)",
    fill: "#de2126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9123",
    "data-name": "Caminho 9123",
    d: "M27.063,10.665c.225-.209.213-.557.523-.7a2.19,2.19,0,0,0,.477-.231,2.29,2.29,0,0,1-1,.936",
    transform: "translate(19.331 6.949)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9124",
    "data-name": "Caminho 9124",
    d: "M27.063,10.665c.225-.209.213-.557.523-.7a2.19,2.19,0,0,0,.477-.231,2.29,2.29,0,0,1-1,.936",
    transform: "translate(19.331 6.949)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9125",
    "data-name": "Caminho 9125",
    d: "M27.032,10.461c.153-.057.266-.19.413-.261.163-.079.3-.022.473-.038a2.03,2.03,0,0,0,.494-.117c-.312.434-.972.113-1.359.394",
    transform: "translate(19.309 7.176)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9126",
    "data-name": "Caminho 9126",
    d: "M27.032,10.461c.153-.057.266-.19.413-.261.163-.079.3-.022.473-.038a2.03,2.03,0,0,0,.494-.117c-.312.434-.972.113-1.359.394",
    transform: "translate(19.309 7.176)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9127",
    "data-name": "Caminho 9127",
    d: "M27.136,10.4c.137-.026.206-.185.279-.288.089-.123.216-.149.348-.214",
    transform: "translate(19.383 7.068)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9128",
    "data-name": "Caminho 9128",
    d: "M25.223,12.791a2.589,2.589,0,0,1,.24-.331",
    transform: "translate(18.016 8.9)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9129",
    "data-name": "Caminho 9129",
    d: "M24.935,13.937a1.225,1.225,0,0,1,.159-.35,1.476,1.476,0,0,1,.4-.286c.365-.175.857-.106,1.164-.4a1.9,1.9,0,0,1-.939.874,1.715,1.715,0,0,1-.453.159,2.742,2.742,0,0,0-.4.033",
    transform: "translate(17.766 9.216)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9130",
    "data-name": "Caminho 9130",
    d: "M24.935,13.937a1.225,1.225,0,0,1,.159-.35,1.476,1.476,0,0,1,.4-.286c.365-.175.857-.106,1.164-.4a1.9,1.9,0,0,1-.939.874,1.715,1.715,0,0,1-.453.159,2.742,2.742,0,0,0-.4.033",
    transform: "translate(17.766 9.216)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9131",
    "data-name": "Caminho 9131",
    d: "M24.921,13.832c.118-.055.19-.168.295-.237a1.624,1.624,0,0,1,.386-.183,4.474,4.474,0,0,0,.494-.177c.062-.026.247-.111.257-.171",
    transform: "translate(17.801 9.331)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9132",
    "data-name": "Caminho 9132",
    d: "M25.123,13.369c.113.033.219.113.345.043",
    transform: "translate(17.945 9.549)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9133",
    "data-name": "Caminho 9133",
    d: "M25.287,13.3a1.173,1.173,0,0,0,.574-.063",
    transform: "translate(18.062 9.456)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9134",
    "data-name": "Caminho 9134",
    d: "M25.134,13.495c.046-.048.053-.12.091-.175s.094-.1.129-.151",
    transform: "translate(17.953 9.406)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9135",
    "data-name": "Caminho 9135",
    d: "M25.335,13.357a.709.709,0,0,1,.144-.142c.057-.038.147-.051.19-.113",
    transform: "translate(18.096 9.359)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9136",
    "data-name": "Caminho 9136",
    d: "M24.86,13.787a1.475,1.475,0,0,1,.192-.394,1.223,1.223,0,0,0,.081-.348",
    transform: "translate(17.757 9.318)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9137",
    "data-name": "Caminho 9137",
    d: "M25.117,14.926s.062-.893.034-.991a2.791,2.791,0,0,1-.41-2.223,1.8,1.8,0,0,0,.079-.634,11.687,11.687,0,0,1,.55,1.67,5.069,5.069,0,0,1-.1,1.161c-.036.153-.1.562-.1.562",
    transform: "translate(17.634 7.912)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9138",
    "data-name": "Caminho 9138",
    d: "M25.117,14.926s.062-.893.034-.991a2.791,2.791,0,0,1-.41-2.223,1.8,1.8,0,0,0,.079-.634,11.687,11.687,0,0,1,.55,1.67,5.069,5.069,0,0,1-.1,1.161c-.036.153-.1.562-.1.562",
    transform: "translate(17.634 7.912)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9139",
    "data-name": "Caminho 9139",
    d: "M24.785,11.311a3.992,3.992,0,0,0,.062.554,3.23,3.23,0,0,0,.081.516,5.035,5.035,0,0,1,.166.67,5.375,5.375,0,0,1,.015.6",
    transform: "translate(17.703 8.079)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9140",
    "data-name": "Caminho 9140",
    d: "M25.1,12.958a.839.839,0,0,0-.254-.5",
    transform: "translate(17.744 8.898)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9141",
    "data-name": "Caminho 9141",
    d: "M25.1,12.958a.839.839,0,0,0-.254-.5",
    transform: "translate(17.744 8.898)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9142",
    "data-name": "Caminho 9142",
    d: "M24.972,12.562c-.036-.12.1-.367.113-.5",
    transform: "translate(17.832 8.615)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9143",
    "data-name": "Caminho 9143",
    d: "M25.145,12.64c.038-.274-.42-.315-.411-.562",
    transform: "translate(17.667 8.627)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9144",
    "data-name": "Caminho 9144",
    d: "M25.145,12.64c.038-.274-.42-.315-.411-.562",
    transform: "translate(17.667 8.627)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9145",
    "data-name": "Caminho 9145",
    d: "M24.918,12.269c.029-.139.218-.249.166-.411",
    transform: "translate(17.799 8.47)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9146",
    "data-name": "Caminho 9146",
    d: "M24.981,12.136a1.222,1.222,0,0,0-.12-.259c-.038-.074-.117-.129-.142-.206",
    transform: "translate(17.656 8.336)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9147",
    "data-name": "Caminho 9147",
    d: "M24.842,11.971c0-.183.053-.331.053-.509",
    transform: "translate(17.744 8.187)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9148",
    "data-name": "Caminho 9148",
    d: "M35.689,15.511c-.063-.957-.5-4.745-1.339-5.966,0,0,.818,1.183.91,6.425Z",
    transform: "translate(24.536 6.818)",
    fill: "#009c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9149",
    "data-name": "Caminho 9149",
    d: "M35.689,15.511c-.063-.957-.5-4.745-1.339-5.966,0,0,.818,1.183.91,6.425Z",
    transform: "translate(24.536 6.818)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9150",
    "data-name": "Caminho 9150",
    d: "M35.913,15.031a17.284,17.284,0,0,0-2.054-5.606A29.575,29.575,0,0,1,35.794,15.9l.19-.187Z",
    transform: "translate(24.185 6.732)",
    fill: "#009c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9151",
    "data-name": "Caminho 9151",
    d: "M35.913,15.031a17.284,17.284,0,0,0-2.054-5.606A29.575,29.575,0,0,1,35.794,15.9l.19-.187Z",
    transform: "translate(24.185 6.732)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9152",
    "data-name": "Caminho 9152",
    d: "M33.592,9.514a23.167,23.167,0,0,1,1.99,6.729l.475-.465a22.025,22.025,0,0,0-2.465-6.264",
    transform: "translate(23.994 6.796)",
    fill: "#009c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9153",
    "data-name": "Caminho 9153",
    d: "M33.592,9.514a23.167,23.167,0,0,1,1.99,6.729l.475-.465a22.025,22.025,0,0,0-2.465-6.264",
    transform: "translate(23.994 6.796)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9154",
    "data-name": "Caminho 9154",
    d: "M33.13,9.37a32.9,32.9,0,0,1,1.68,3.675,30.193,30.193,0,0,1,.835,3.574l.583-.574a25.518,25.518,0,0,0-3.1-6.675",
    transform: "translate(23.664 6.693)",
    fill: "#009c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9155",
    "data-name": "Caminho 9155",
    d: "M33.13,9.37a32.9,32.9,0,0,1,1.68,3.675,30.193,30.193,0,0,1,.835,3.574l.583-.574a25.518,25.518,0,0,0-3.1-6.675",
    transform: "translate(23.664 6.693)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9156",
    "data-name": "Caminho 9156",
    d: "M32.641,9.224a23.2,23.2,0,0,1,2.249,4.553c.166.585.667,2.343.855,3.173l.674-.549c-.533-1.591-2.2-5.619-3.778-7.178",
    transform: "translate(23.315 6.589)",
    fill: "#009c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9157",
    "data-name": "Caminho 9157",
    d: "M32.641,9.224a23.2,23.2,0,0,1,2.249,4.553c.166.585.667,2.343.855,3.173l.674-.549c-.533-1.591-2.2-5.619-3.778-7.178",
    transform: "translate(23.315 6.589)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9158",
    "data-name": "Caminho 9158",
    d: "M32.653,10.134a18.783,18.783,0,0,1,2.837,6.435l.775-.761a26.927,26.927,0,0,0-3.612-5.674",
    transform: "translate(23.324 7.239)",
    fill: "#009c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9159",
    "data-name": "Caminho 9159",
    d: "M32.653,10.134a18.783,18.783,0,0,1,2.837,6.435l.775-.761a26.927,26.927,0,0,0-3.612-5.674",
    transform: "translate(23.324 7.239)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9160",
    "data-name": "Caminho 9160",
    d: "M32.995,11.138a11.485,11.485,0,0,1,1.944,4.937l.662-.549a22.223,22.223,0,0,0-2.606-4.389",
    transform: "translate(23.568 7.956)",
    fill: "#009c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9161",
    "data-name": "Caminho 9161",
    d: "M32.995,11.138a11.485,11.485,0,0,1,1.944,4.937l.662-.549a22.223,22.223,0,0,0-2.606-4.389",
    transform: "translate(23.568 7.956)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9162",
    "data-name": "Caminho 9162",
    d: "M34.814,15.115a12.622,12.622,0,0,0-1.21-3.033",
    transform: "translate(24.003 8.63)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9163",
    "data-name": "Caminho 9163",
    d: "M35.484,15.414a20.658,20.658,0,0,0-2.218-4.38",
    transform: "translate(23.761 7.881)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9164",
    "data-name": "Caminho 9164",
    d: "M35.578,15.057a27.917,27.917,0,0,0-2.637-5.409",
    transform: "translate(23.529 6.891)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9165",
    "data-name": "Caminho 9165",
    d: "M35.506,15.058a28.9,28.9,0,0,0-1.79-4.6",
    transform: "translate(24.083 7.471)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9166",
    "data-name": "Caminho 9166",
    d: "M35.39,14.541a27.846,27.846,0,0,0-1.318-4.018",
    transform: "translate(24.337 7.516)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9167",
    "data-name": "Caminho 9167",
    d: "M35.575,15.017A19.311,19.311,0,0,0,34.2,10.178",
    transform: "translate(24.431 7.27)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9168",
    "data-name": "Caminho 9168",
    d: "M35.09,13.109a22.51,22.51,0,0,0-.418-2.65",
    transform: "translate(24.766 7.471)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9169",
    "data-name": "Caminho 9169",
    d: "M25.034,23.408l-.009.015a1.35,1.35,0,0,1-.468.135,2.654,2.654,0,0,1-.482.921A3.16,3.16,0,0,1,25,24.066c.007-.2.041-.429.165-.5l.019,0A.8.8,0,0,0,25.034,23.408Z",
    transform: "translate(17.197 16.72)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9170",
    "data-name": "Caminho 9170",
    d: "M25.034,23.408l-.009.015a1.35,1.35,0,0,1-.468.135,2.654,2.654,0,0,1-.482.921A3.16,3.16,0,0,1,25,24.066c.007-.2.041-.429.165-.5l.019,0A.8.8,0,0,0,25.034,23.408Z",
    transform: "translate(17.197 16.72)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_71",
    "data-name": "Linha 71",
    y1: 0.874,
    x2: 0.897,
    transform: "translate(41.401 40.208)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_72",
    "data-name": "Linha 72",
    x1: 0.446,
    y1: 0.509,
    transform: "translate(41.756 40.266)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9171",
    "data-name": "Caminho 9171",
    d: "M27.987,21.888l-3.069,2.981h-.1l-.189-.173.01-.134,3.087-2.99.262.315",
    transform: "translate(17.59 15.409)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9172",
    "data-name": "Caminho 9172",
    d: "M27.987,21.888l-3.069,2.981h-.1l-.189-.173.01-.134,3.087-2.99.262.315",
    transform: "translate(17.59 15.409)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_73",
    "data-name": "Linha 73",
    y1: 2.762,
    x2: 2.88,
    transform: "translate(42.377 37.373)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9173",
    "data-name": "Caminho 9173",
    d: "M28.092,26.722c-2.026-1.3-2.359-5.285-2.326-5.829s.05-6.9.05-6.9l.6.6c-1.092-1.116-2.369-2.426-3.017-3.1-.209-.214-.06,8.331-.06,12.125,0,1.779,1.087,8.057,7.459,4.9,0,0,3.183-1.167,4.114-2.575a4.977,4.977,0,0,1-.643-.041c-.1.053-.2.1-.31.149C30.283,28.582,28.092,26.722,28.092,26.722Z",
    transform: "translate(16.634 8.21)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9174",
    "data-name": "Caminho 9174",
    d: "M28.092,26.722c-2.026-1.3-2.359-5.285-2.326-5.829s.05-6.9.05-6.9l.6.6c-1.092-1.116-2.369-2.426-3.017-3.1-.209-.214-.06,8.331-.06,12.125,0,1.779,1.087,8.057,7.459,4.9,0,0,3.183-1.167,4.114-2.575a4.977,4.977,0,0,1-.643-.041c-.1.053-.2.1-.31.149C30.283,28.582,28.092,26.722,28.092,26.722Z",
    transform: "translate(16.634 8.21)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9175",
    "data-name": "Caminho 9175",
    d: "M24.734,19.853c-.031.543.3,4.524,2.326,5.829,0,0,2.193,1.862,5.868-.669a4.1,4.1,0,0,1-2.613.387,6.332,6.332,0,0,1-3.955-4.755,55.28,55.28,0,0,1-.226-6.288l.267.238-1.018-1.042-.6-.6S24.765,19.309,24.734,19.853Z",
    transform: "translate(17.666 9.251)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9176",
    "data-name": "Caminho 9176",
    d: "M24.734,19.853c-.031.543.3,4.524,2.326,5.829,0,0,2.193,1.862,5.868-.669a4.1,4.1,0,0,1-2.613.387,6.332,6.332,0,0,1-3.955-4.755,55.28,55.28,0,0,1-.226-6.288l.267.238-1.018-1.042-.6-.6S24.765,19.309,24.734,19.853Z",
    transform: "translate(17.666 9.251)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9177",
    "data-name": "Caminho 9177",
    d: "M26.754,16.545c-.017-.192-.031-.876-.033-1.622-.418-.429.081.1-.9-.9l-.273-.285v.135a53.493,53.493,0,0,0,.226,6.213,6.276,6.276,0,0,0,3.9,4.755,4.256,4.256,0,0,0,2.664-.389q.113-.077.226-.159C29.359,23.824,27.143,20.764,26.754,16.545Z",
    transform: "translate(18.246 9.812)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9178",
    "data-name": "Caminho 9178",
    d: "M26.754,16.545c-.017-.192-.031-.876-.033-1.622-.418-.429.081.1-.9-.9l-.273-.285v.135a53.493,53.493,0,0,0,.226,6.213,6.276,6.276,0,0,0,3.9,4.755,4.256,4.256,0,0,0,2.664-.389q.113-.077.226-.159C29.359,23.824,27.143,20.764,26.754,16.545Z",
    transform: "translate(18.246 9.812)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_74",
    "data-name": "Linha 74",
    x1: 4.841,
    y1: 4.975,
    transform: "translate(40.06 19.705)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9179",
    "data-name": "Caminho 9179",
    d: "M23.61,11.469a.481.481,0,0,0-.25-.137.154.154,0,0,0-.026-.144c-.069-.069-.221-.024-.341.1s-.161.279-.093.348a.142.142,0,0,0,.139.026.507.507,0,0,0,.137.255.363.363,0,0,0,.506.069A.381.381,0,0,0,23.61,11.469Z",
    transform: "translate(16.334 7.968)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9180",
    "data-name": "Caminho 9180",
    d: "M23.61,11.469a.481.481,0,0,0-.25-.137.154.154,0,0,0-.026-.144c-.069-.069-.221-.024-.341.1s-.161.279-.093.348a.142.142,0,0,0,.139.026.507.507,0,0,0,.137.255.363.363,0,0,0,.506.069A.381.381,0,0,0,23.61,11.469Z",
    transform: "translate(16.334 7.968)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9181",
    "data-name": "Caminho 9181",
    d: "M23.306,11.491l-.014-.027Z",
    transform: "translate(16.637 8.189)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9182",
    "data-name": "Caminho 9182",
    d: "M23.772,11.66l-.11.087A.48.48,0,0,0,23.772,11.66Z",
    transform: "translate(16.901 8.329)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9183",
    "data-name": "Caminho 9183",
    d: "M23.5,16.11c.026-.082.038-.729.038-.862s.031-.211.125-.85A4.922,4.922,0,0,0,23.676,13a7.47,7.47,0,0,1,.082-1.226l-.233-.173c-.015.06-.041.165-.081.346-.086.386-.019,1.682-.067,2.127s-.132,1.053-.142,1.315v.015a3.292,3.292,0,0,0,.091.689",
    transform: "translate(16.596 8.289)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9184",
    "data-name": "Caminho 9184",
    d: "M23.5,16.11c.026-.082.038-.729.038-.862s.031-.211.125-.85A4.922,4.922,0,0,0,23.676,13a7.47,7.47,0,0,1,.082-1.226l-.233-.173c-.015.06-.041.165-.081.346-.086.386-.019,1.682-.067,2.127s-.132,1.053-.142,1.315v.015a3.292,3.292,0,0,0,.091.689",
    transform: "translate(16.596 8.289)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9185",
    "data-name": "Caminho 9185",
    d: "M23.447,11.49A5.009,5.009,0,0,0,23.24,12.8c.009.61-.067,1.45-.077,1.577a4.871,4.871,0,0,0-.075,1.286l.113.165a.433.433,0,0,0,.161-.343v-.015c.01-.261.094-.871.142-1.315s-.019-1.742.067-2.127c.039-.182.065-.286.081-.346a.374.374,0,0,1,.024-.079Z",
    transform: "translate(16.47 8.207)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9186",
    "data-name": "Caminho 9186",
    d: "M23.447,11.49A5.009,5.009,0,0,0,23.24,12.8c.009.61-.067,1.45-.077,1.577a4.871,4.871,0,0,0-.075,1.286l.113.165a.433.433,0,0,0,.161-.343v-.015c.01-.261.094-.871.142-1.315s-.019-1.742.067-2.127c.039-.182.065-.286.081-.346a.374.374,0,0,1,.024-.079Z",
    transform: "translate(16.47 8.207)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9187",
    "data-name": "Caminho 9187",
    d: "M23.933,11.392c-.12.041-.49.11-.607.13l-.034.007a.911.911,0,0,1,.746.336l.18-.221c.159-.271-.142-.3-.285-.252",
    transform: "translate(16.637 8.124)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9188",
    "data-name": "Caminho 9188",
    d: "M23.933,11.392c-.12.041-.49.11-.607.13l-.034.007a.911.911,0,0,1,.746.336l.18-.221C24.377,11.373,24.075,11.344,23.933,11.392Z",
    transform: "translate(16.637 8.124)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9189",
    "data-name": "Caminho 9189",
    d: "M23.291,11.463l.014.027c.063.117.322.555.622.4l.11-.086a.915.915,0,0,0-.746-.338",
    transform: "translate(16.636 8.188)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9190",
    "data-name": "Caminho 9190",
    d: "M23.291,11.463l.014.027c.063.117.322.555.622.4l.11-.086A.915.915,0,0,0,23.291,11.463Z",
    transform: "translate(16.636 8.188)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9191",
    "data-name": "Caminho 9191",
    d: "M23.312,11.653a4.2,4.2,0,0,1,.489-.461c.07-.019.115.1.151.161s.045.153-.206.223-.185.021-.434.077",
    transform: "translate(16.651 7.993)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9192",
    "data-name": "Caminho 9192",
    d: "M23.312,11.653a4.2,4.2,0,0,1,.489-.461c.07-.019.115.1.151.161s.045.153-.206.223S23.561,11.6,23.312,11.653Z",
    transform: "translate(16.651 7.993)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9193",
    "data-name": "Caminho 9193",
    d: "M24.031,11.206a.367.367,0,0,0-.511-.146c-.329.168-.243.612-.216.727l.007.027c.607-.967.71-.2.71-.2a1.416,1.416,0,0,0,.01-.406",
    transform: "translate(16.624 7.864)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9194",
    "data-name": "Caminho 9194",
    d: "M24.031,11.206a.367.367,0,0,0-.511-.146c-.329.168-.243.612-.216.727l.007.027c.607-.967.71-.2.71-.2A1.416,1.416,0,0,0,24.031,11.206Z",
    transform: "translate(16.624 7.864)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9195",
    "data-name": "Caminho 9195",
    d: "M23.487,14.909c.021-.341.046-.816-.219-.833s-.295.458-.315.8c.158.012.293.026.535.034",
    transform: "translate(16.394 10.054)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9196",
    "data-name": "Caminho 9196",
    d: "M23.487,14.909c.021-.341.046-.816-.219-.833s-.295.458-.315.8c.158.012.293.026.535.034",
    transform: "translate(16.394 10.054)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9197",
    "data-name": "Caminho 9197",
    d: "M23.207,13.876a.175.175,0,1,1-.171.175.174.174,0,0,1,.171-.175",
    transform: "translate(16.454 9.911)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9198",
    "data-name": "Caminho 9198",
    d: "M23.207,13.876a.175.175,0,1,1-.171.175A.174.174,0,0,1,23.207,13.876Z",
    transform: "translate(16.454 9.911)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9199",
    "data-name": "Caminho 9199",
    d: "M23.1,14.24s-.046.489-.05.516",
    transform: "translate(16.462 10.171)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9200",
    "data-name": "Caminho 9200",
    d: "M23.162,14.243a4.192,4.192,0,0,1-.022.525",
    transform: "translate(16.529 10.174)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9201",
    "data-name": "Caminho 9201",
    d: "M23.488,14.436a4.059,4.059,0,0,1,.009.523m-.142-.521s-.015.49-.019.519m.362.005c-.243.005-.377,0-.535,0,0-.343,0-.818.267-.818S23.7,14.62,23.7,14.963Z",
    transform: "translate(16.544 10.104)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9202",
    "data-name": "Caminho 9202",
    d: "M23.488,14.436a4.059,4.059,0,0,1,.009.523m-.142-.521s-.015.49-.019.519m.362.005c-.243.005-.377,0-.535,0,0-.343,0-.818.267-.818S23.7,14.62,23.7,14.963Z",
    transform: "translate(16.544 10.104)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9203",
    "data-name": "Caminho 9203",
    d: "M23.386,14.013a.175.175,0,1,1-.171.175.174.174,0,0,1,.171-.175",
    transform: "translate(16.582 10.009)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9204",
    "data-name": "Caminho 9204",
    d: "M23.386,14.013a.175.175,0,1,1-.171.175A.174.174,0,0,1,23.386,14.013Z",
    transform: "translate(16.582 10.009)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9205",
    "data-name": "Caminho 9205",
    d: "M23.311,11.2c.063.063.024.209-.087.324s-.252.156-.315.091-.026-.209.086-.324.254-.154.317-.091",
    transform: "translate(16.341 7.976)",
    fill: "#c0cad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9206",
    "data-name": "Caminho 9206",
    d: "M23.311,11.2c.063.063.024.209-.087.324s-.252.156-.315.091-.026-.209.086-.324S23.247,11.133,23.311,11.2Z",
    transform: "translate(16.341 7.976)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 4.635,
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9207",
    "data-name": "Caminho 9207",
    d: "M23.645,13.237a.56.56,0,0,1-.254-.411.669.669,0,0,1,.2-.459.2.2,0,0,0,.089.046l.05-.029.177-.187.11-.113a.326.326,0,0,0,.07-.113l-.014-.041c.141-.161.466-.549.322-.648-.123-.082-.494.225-.619.334l-.06-.027a.244.244,0,0,0-.086.055,2.7,2.7,0,0,1-.254-.871,4.684,4.684,0,0,1-1.707-.893,6.452,6.452,0,0,1,.806,1.795,1.248,1.248,0,0,1,.891.252.189.189,0,0,0-.041.072.228.228,0,0,0,.022.1.8.8,0,0,1-.408.235c-.245.045-.468-.228-.468-.228h-.005a.968.968,0,0,0-.041.285.905.905,0,0,0,.883.927.855.855,0,0,0,.345-.072Z",
    transform: "translate(15.479 7.056)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9208",
    "data-name": "Caminho 9208",
    d: "M23.645,13.237a.56.56,0,0,1-.254-.411.669.669,0,0,1,.2-.459.2.2,0,0,0,.089.046l.05-.029.177-.187.11-.113a.326.326,0,0,0,.07-.113l-.014-.041c.141-.161.466-.549.322-.648-.123-.082-.494.225-.619.334l-.06-.027a.244.244,0,0,0-.086.055,2.7,2.7,0,0,1-.254-.871,4.684,4.684,0,0,1-1.707-.893,6.452,6.452,0,0,1,.806,1.795,1.248,1.248,0,0,1,.891.252.189.189,0,0,0-.041.072.228.228,0,0,0,.022.1.8.8,0,0,1-.408.235c-.245.045-.468-.228-.468-.228h-.005a.968.968,0,0,0-.041.285.905.905,0,0,0,.883.927.855.855,0,0,0,.345-.072Z",
    transform: "translate(15.479 7.056)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_75",
    "data-name": "Linha 75",
    x2: 1.745,
    y2: 1.783,
    transform: "translate(37.25 17.07)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_76",
    "data-name": "Linha 76",
    y1: 0.897,
    x2: 0.891,
    transform: "translate(37.953 17.845)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9209",
    "data-name": "Caminho 9209",
    d: "M22.69,11.23a.278.278,0,0,1,.281-.276.285.285,0,1,1-.281.276Z",
    transform: "translate(16.207 7.824)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9210",
    "data-name": "Caminho 9210",
    d: "M22.205,11.243a1.035,1.035,0,0,0,.238.689.9.9,0,0,0,.734.273",
    transform: "translate(15.859 8.031)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9211",
    "data-name": "Caminho 9211",
    d: "M35.417,23.408l.007.015a1.351,1.351,0,0,0,.47.135,2.642,2.642,0,0,0,.48.921,3.121,3.121,0,0,0-.927-.413c-.005-.2-.039-.429-.165-.5l-.017,0A.756.756,0,0,1,35.417,23.408Z",
    transform: "translate(25.189 16.72)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9212",
    "data-name": "Caminho 9212",
    d: "M35.417,23.408l.007.015a1.351,1.351,0,0,0,.47.135,2.642,2.642,0,0,0,.48.921,3.121,3.121,0,0,0-.927-.413c-.005-.2-.039-.429-.165-.5l-.017,0A.756.756,0,0,1,35.417,23.408Z",
    transform: "translate(25.189 16.72)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_77",
    "data-name": "Linha 77",
    x1: 0.897,
    y1: 0.874,
    transform: "translate(60.539 40.208)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_78",
    "data-name": "Linha 78",
    y1: 0.509,
    x2: 0.446,
    transform: "translate(60.635 40.266)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9213",
    "data-name": "Caminho 9213",
    d: "M33.4,21.888l3.069,2.981h.1l.189-.173-.01-.134-3.087-2.99-.262.315",
    transform: "translate(23.858 15.409)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9214",
    "data-name": "Caminho 9214",
    d: "M33.4,21.888l3.069,2.981h.1l.189-.173-.01-.134-3.087-2.99-.262.315",
    transform: "translate(23.858 15.409)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_79",
    "data-name": "Linha 79",
    x1: 2.88,
    y1: 2.762,
    transform: "translate(57.579 37.373)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9215",
    "data-name": "Caminho 9215",
    d: "M36.739,26.722c2.026-1.3,2.359-5.285,2.326-5.829s-.05-6.9-.05-6.9l-.6.6c1.092-1.116,2.369-2.426,3.017-3.1.209-.214.06,8.331.06,12.125,0,1.779-1.087,8.057-7.459,4.9,0,0-3.183-1.167-4.114-2.575a4.978,4.978,0,0,0,.643-.041c.1.053.2.1.31.149C34.549,28.582,36.739,26.722,36.739,26.722Z",
    transform: "translate(21.371 8.21)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9216",
    "data-name": "Caminho 9216",
    d: "M36.739,26.722c2.026-1.3,2.359-5.285,2.326-5.829s-.05-6.9-.05-6.9l-.6.6c1.092-1.116,2.369-2.426,3.017-3.1.209-.214.06,8.331.06,12.125,0,1.779-1.087,8.057-7.459,4.9,0,0-3.183-1.167-4.114-2.575a4.978,4.978,0,0,0,.643-.041c.1.053.2.1.31.149C34.549,28.582,36.739,26.722,36.739,26.722Z",
    transform: "translate(21.371 8.21)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9217",
    "data-name": "Caminho 9217",
    d: "M38.669,19.853c.031.543-.3,4.524-2.326,5.829,0,0-2.193,1.862-5.868-.669a4.1,4.1,0,0,0,2.613.387,6.332,6.332,0,0,0,3.955-4.755,55.28,55.28,0,0,0,.226-6.288L37,14.6l1.018-1.042.6-.6S38.638,19.309,38.669,19.853Z",
    transform: "translate(21.768 9.251)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9218",
    "data-name": "Caminho 9218",
    d: "M38.669,19.853c.031.543-.3,4.524-2.326,5.829,0,0-2.193,1.862-5.868-.669a4.1,4.1,0,0,0,2.613.387,6.332,6.332,0,0,0,3.955-4.755,55.28,55.28,0,0,0,.226-6.288L37,14.6l1.018-1.042.6-.6S38.638,19.309,38.669,19.853Z",
    transform: "translate(21.768 9.251)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9219",
    "data-name": "Caminho 9219",
    d: "M36.161,16.545c.017-.192.031-.876.033-1.622.418-.429-.081.1.9-.9l.273-.285v.135a53.486,53.486,0,0,1-.226,6.213,6.276,6.276,0,0,1-3.9,4.755,4.256,4.256,0,0,1-2.664-.389q-.113-.077-.226-.159C33.556,23.824,35.772,20.764,36.161,16.545Z",
    transform: "translate(21.674 9.812)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9220",
    "data-name": "Caminho 9220",
    d: "M36.161,16.545c.017-.192.031-.876.033-1.622.418-.429-.081.1.9-.9l.273-.285v.135a53.486,53.486,0,0,1-.226,6.213,6.276,6.276,0,0,1-3.9,4.755,4.256,4.256,0,0,1-2.664-.389q-.113-.077-.226-.159C33.556,23.824,35.772,20.764,36.161,16.545Z",
    transform: "translate(21.674 9.812)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_80",
    "data-name": "Linha 80",
    y1: 4.975,
    x2: 4.841,
    transform: "translate(57.935 19.705)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9221",
    "data-name": "Caminho 9221",
    d: "M36.747,11.469a.481.481,0,0,1,.25-.137.155.155,0,0,1,.026-.144c.069-.069.221-.024.341.1s.161.279.093.348a.142.142,0,0,1-.139.026.508.508,0,0,1-.137.255.363.363,0,0,1-.506.069.381.381,0,0,1,.072-.516",
    transform: "translate(26.145 7.968)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9222",
    "data-name": "Caminho 9222",
    d: "M36.747,11.469a.481.481,0,0,1,.25-.137.155.155,0,0,1,.026-.144c.069-.069.221-.024.341.1s.161.279.093.348a.142.142,0,0,1-.139.026.508.508,0,0,1-.137.255.363.363,0,0,1-.506.069A.381.381,0,0,1,36.747,11.469Z",
    transform: "translate(26.145 7.968)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9223",
    "data-name": "Caminho 9223",
    d: "M36.688,11.491l.014-.027Z",
    transform: "translate(26.206 8.189)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9224",
    "data-name": "Caminho 9224",
    d: "M36.261,11.66l.11.087A.48.48,0,0,1,36.261,11.66Z",
    transform: "translate(25.901 8.329)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9225",
    "data-name": "Caminho 9225",
    d: "M36.705,16.11c-.026-.082-.038-.729-.038-.862s-.031-.211-.125-.85A4.921,4.921,0,0,1,36.53,13a7.472,7.472,0,0,0-.082-1.226l.233-.173c.015.06.041.165.081.346.086.386.019,1.682.067,2.127s.132,1.053.142,1.315v.015a3.292,3.292,0,0,1-.091.689",
    transform: "translate(26.034 8.289)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9226",
    "data-name": "Caminho 9226",
    d: "M36.705,16.11c-.026-.082-.038-.729-.038-.862s-.031-.211-.125-.85A4.921,4.921,0,0,1,36.53,13a7.472,7.472,0,0,0-.082-1.226l.233-.173c.015.06.041.165.081.346.086.386.019,1.682.067,2.127s.132,1.053.142,1.315v.015a3.292,3.292,0,0,1-.091.689",
    transform: "translate(26.034 8.289)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9227",
    "data-name": "Caminho 9227",
    d: "M36.8,11.49a5.01,5.01,0,0,1,.207,1.315c-.009.61.067,1.45.077,1.577a4.87,4.87,0,0,1,.075,1.286l-.113.165a.433.433,0,0,1-.161-.343v-.015c-.01-.261-.094-.871-.142-1.315s.019-1.742-.067-2.127c-.039-.182-.065-.286-.081-.346a.377.377,0,0,0-.024-.079Z",
    transform: "translate(26.121 8.207)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9228",
    "data-name": "Caminho 9228",
    d: "M36.8,11.49a5.01,5.01,0,0,1,.207,1.315c-.009.61.067,1.45.077,1.577a4.87,4.87,0,0,1,.075,1.286l-.113.165a.433.433,0,0,1-.161-.343v-.015c-.01-.261-.094-.871-.142-1.315s.019-1.742-.067-2.127c-.039-.182-.065-.286-.081-.346a.377.377,0,0,0-.024-.079Z",
    transform: "translate(26.121 8.207)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9229",
    "data-name": "Caminho 9229",
    d: "M36.459,11.392c.12.041.49.11.607.13l.034.007a.911.911,0,0,0-.746.336l-.18-.221c-.159-.271.142-.3.285-.252",
    transform: "translate(25.807 8.124)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9230",
    "data-name": "Caminho 9230",
    d: "M36.459,11.392c.12.041.49.11.607.13l.034.007a.911.911,0,0,0-.746.336l-.18-.221C36.015,11.373,36.317,11.344,36.459,11.392Z",
    transform: "translate(25.807 8.124)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9231",
    "data-name": "Caminho 9231",
    d: "M37.007,11.463l-.014.027c-.063.117-.322.555-.622.4l-.11-.086a.915.915,0,0,1,.746-.338",
    transform: "translate(25.901 8.188)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9232",
    "data-name": "Caminho 9232",
    d: "M37.007,11.463l-.014.027c-.063.117-.322.555-.622.4l-.11-.086A.915.915,0,0,1,37.007,11.463Z",
    transform: "translate(25.901 8.188)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9233",
    "data-name": "Caminho 9233",
    d: "M36.951,11.653a4.2,4.2,0,0,0-.489-.461c-.07-.019-.115.1-.151.161s-.045.153.206.223.185.021.434.077",
    transform: "translate(25.923 7.993)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9234",
    "data-name": "Caminho 9234",
    d: "M36.951,11.653a4.2,4.2,0,0,0-.489-.461c-.07-.019-.115.1-.151.161s-.045.153.206.223S36.7,11.6,36.951,11.653Z",
    transform: "translate(25.923 7.993)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9235",
    "data-name": "Caminho 9235",
    d: "M36.276,11.206a.367.367,0,0,1,.511-.146c.329.168.243.612.216.727L37,11.815c-.607-.967-.71-.2-.71-.2a1.415,1.415,0,0,1-.01-.406",
    transform: "translate(25.904 7.864)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9236",
    "data-name": "Caminho 9236",
    d: "M36.276,11.206a.367.367,0,0,1,.511-.146c.329.168.243.612.216.727L37,11.815c-.607-.967-.71-.2-.71-.2A1.415,1.415,0,0,1,36.276,11.206Z",
    transform: "translate(25.904 7.864)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9237",
    "data-name": "Caminho 9237",
    d: "M36.729,14.909c-.021-.341-.046-.816.219-.833s.295.458.315.8c-.158.012-.293.026-.535.034",
    transform: "translate(26.226 10.054)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9238",
    "data-name": "Caminho 9238",
    d: "M36.729,14.909c-.021-.341-.046-.816.219-.833s.295.458.315.8c-.158.012-.293.026-.535.034",
    transform: "translate(26.226 10.054)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9239",
    "data-name": "Caminho 9239",
    d: "M36.923,13.876a.175.175,0,1,0,.171.175.174.174,0,0,0-.171-.175",
    transform: "translate(26.251 9.911)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9240",
    "data-name": "Caminho 9240",
    d: "M36.923,13.876a.175.175,0,1,0,.171.175A.174.174,0,0,0,36.923,13.876Z",
    transform: "translate(26.251 9.911)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9241",
    "data-name": "Caminho 9241",
    d: "M36.912,14.24s.046.489.05.516",
    transform: "translate(26.366 10.171)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9242",
    "data-name": "Caminho 9242",
    d: "M36.835,14.243a4.2,4.2,0,0,0,.022.525",
    transform: "translate(26.311 10.174)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9243",
    "data-name": "Caminho 9243",
    d: "M36.723,14.436a4.059,4.059,0,0,0-.009.523m.142-.521s.015.49.019.519m-.362.005c.243.005.377,0,.535,0,0-.343,0-.818-.267-.818S36.514,14.62,36.514,14.963Z",
    transform: "translate(26.081 10.104)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9244",
    "data-name": "Caminho 9244",
    d: "M36.723,14.436a4.059,4.059,0,0,0-.009.523m.142-.521s.015.49.019.519m-.362.005c.243.005.377,0,.535,0,0-.343,0-.818-.267-.818S36.514,14.62,36.514,14.963Z",
    transform: "translate(26.081 10.104)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9245",
    "data-name": "Caminho 9245",
    d: "M36.744,14.013a.175.175,0,1,0,.171.175.174.174,0,0,0-.171-.175",
    transform: "translate(26.124 10.009)",
    fill: "#e8b909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9246",
    "data-name": "Caminho 9246",
    d: "M36.744,14.013a.175.175,0,1,0,.171.175A.174.174,0,0,0,36.744,14.013Z",
    transform: "translate(26.124 10.009)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9247",
    "data-name": "Caminho 9247",
    d: "M36.871,11.2c-.063.063-.024.209.087.324s.252.156.315.091.026-.209-.086-.324-.254-.154-.317-.091",
    transform: "translate(26.315 7.976)",
    fill: "#c0cad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9248",
    "data-name": "Caminho 9248",
    d: "M36.871,11.2c-.063.063-.024.209.087.324s.252.156.315.091.026-.209-.086-.324S36.934,11.133,36.871,11.2Z",
    transform: "translate(26.315 7.976)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 4.635,
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9249",
    "data-name": "Caminho 9249",
    d: "M37.494,13.237a.555.555,0,0,0,.252-.411.66.66,0,0,0-.2-.459.206.206,0,0,1-.089.046l-.05-.029-.177-.187-.111-.113a.326.326,0,0,1-.07-.113l.015-.041c-.142-.161-.468-.549-.322-.648.123-.082.494.225.619.334l.06-.027a.228.228,0,0,1,.084.055,2.694,2.694,0,0,0,.255-.871,4.667,4.667,0,0,0,1.706-.893,6.556,6.556,0,0,0-.806,1.795,1.244,1.244,0,0,0-.89.252.2.2,0,0,1,.039.072.207.207,0,0,1-.022.1.811.811,0,0,0,.408.235c.245.045.47-.228.47-.228h0a.967.967,0,0,1,.043.285.906.906,0,0,1-.885.927.861.861,0,0,1-.345-.072Z",
    transform: "translate(26.219 7.056)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9250",
    "data-name": "Caminho 9250",
    d: "M37.494,13.237a.555.555,0,0,0,.252-.411.66.66,0,0,0-.2-.459.206.206,0,0,1-.089.046l-.05-.029-.177-.187-.111-.113a.326.326,0,0,1-.07-.113l.015-.041c-.142-.161-.468-.549-.322-.648.123-.082.494.225.619.334l.06-.027a.228.228,0,0,1,.084.055,2.694,2.694,0,0,0,.255-.871,4.667,4.667,0,0,0,1.706-.893,6.556,6.556,0,0,0-.806,1.795,1.244,1.244,0,0,0-.89.252.2.2,0,0,1,.039.072.207.207,0,0,1-.022.1.811.811,0,0,0,.408.235c.245.045.47-.228.47-.228h0a.967.967,0,0,1,.043.285.906.906,0,0,1-.885.927.861.861,0,0,1-.345-.072Z",
    transform: "translate(26.219 7.056)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_81",
    "data-name": "Linha 81",
    x1: 1.745,
    y2: 1.783,
    transform: "translate(63.842 17.07)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_82",
    "data-name": "Linha 82",
    x1: 0.891,
    y1: 0.897,
    transform: "translate(63.992 17.845)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9251",
    "data-name": "Caminho 9251",
    d: "M37.525,11.23a.278.278,0,0,0-.281-.276.285.285,0,1,0,.281.276Z",
    transform: "translate(26.414 7.824)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9252",
    "data-name": "Caminho 9252",
    d: "M38.189,11.243a1.035,1.035,0,0,1-.238.689.9.9,0,0,1-.734.273",
    transform: "translate(26.584 8.031)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9253",
    "data-name": "Caminho 9253",
    d: "M30.475,21.253c-.507.014-1.445.134-1.445.134a15.571,15.571,0,0,0-1.675,2.678c-.039.463-.039.845,1.044.684,0,0,.525-.1.958-.135.477-.158.528-.041.578-.009.039-.168.132-.574.243-1.046a20.686,20.686,0,0,1,.6-2.247l0-.033a.721.721,0,0,0-.309-.026",
    transform: "translate(19.531 15.179)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9254",
    "data-name": "Caminho 9254",
    d: "M30.475,21.253c-.507.014-1.445.134-1.445.134a15.571,15.571,0,0,0-1.675,2.678c-.039.463-.039.845,1.044.684,0,0,.525-.1.958-.135.477-.158.528-.041.578-.009.039-.168.132-.574.243-1.046a20.686,20.686,0,0,1,.6-2.247l0-.033A.721.721,0,0,0,30.475,21.253Z",
    transform: "translate(19.531 15.179)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9255",
    "data-name": "Caminho 9255",
    d: "M29.68,20.779s-.026.156-.062.415l.434.209s-.038.645-.058,1.027c-.014.252-.18,1.987-.293,3.137-.036.386-.067.706-.086.881a1.091,1.091,0,0,1-.25.67,1.02,1.02,0,0,0-.3.453l-.01.1.009.041c.045.213.329.291.519.267a3.284,3.284,0,0,0,.905-.425l.06-6.117Z",
    transform: "translate(20.752 14.842)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9256",
    "data-name": "Caminho 9256",
    d: "M29.68,20.779s-.026.156-.062.415l.434.209s-.038.645-.058,1.027c-.014.252-.18,1.987-.293,3.137-.036.386-.067.706-.086.881a1.091,1.091,0,0,1-.25.67,1.02,1.02,0,0,0-.3.453l-.01.1.009.041c.045.213.329.291.519.267a3.284,3.284,0,0,0,.905-.425l.06-6.117Z",
    transform: "translate(20.752 14.842)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9257",
    "data-name": "Caminho 9257",
    d: "M30.15,21.021c-.017.12-.036.262-.058.423.009.007.009.015,0,.027l0,.005a20.986,20.986,0,0,0-.6,2.247c-.111.47-.247,1.034-.285,1.2-.048.1-.874,1.073-.89,1.389-.007.129.094.206.381.189a4.8,4.8,0,0,0,.957-.163c.273-.069.4-.1.482.082l.014-.147c.017-.175.05-.5.087-.883.111-1.149.279-2.883.293-3.137.019-.382.058-1.025.058-1.025Z",
    transform: "translate(20.223 15.015)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9258",
    "data-name": "Caminho 9258",
    d: "M30.15,21.021c-.017.12-.036.262-.058.423.009.007.009.015,0,.027l0,.005a20.986,20.986,0,0,0-.6,2.247c-.111.47-.247,1.034-.285,1.2-.048.1-.874,1.073-.89,1.389-.007.129.094.206.381.189a4.8,4.8,0,0,0,.957-.163c.273-.069.4-.1.482.082l.014-.147c.017-.175.05-.5.087-.883.111-1.149.279-2.883.293-3.137.019-.382.058-1.025.058-1.025Z",
    transform: "translate(20.223 15.015)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9259",
    "data-name": "Caminho 9259",
    d: "M29.209,23.2c-.034-.026-.01-.115-.607.057-.134.612-.291,1.531-.291,1.531,0-.31.639-.95.823-1.241C29.228,23.4,29.252,23.275,29.209,23.2Z",
    transform: "translate(20.222 16.539)",
    fill: "#ebc900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9260",
    "data-name": "Caminho 9260",
    d: "M29.209,23.2c-.034-.026-.01-.115-.607.057-.134.612-.291,1.531-.291,1.531,0-.31.639-.95.823-1.241C29.228,23.4,29.252,23.275,29.209,23.2Z",
    transform: "translate(20.222 16.539)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9261",
    "data-name": "Caminho 9261",
    d: "M29.562,24.4l.041-.168c-.077-.178-.211-.151-.487-.082-.015.369-.033.78-.057,1.059a1.016,1.016,0,0,1,.305-.454.741.741,0,0,0,.2-.355",
    transform: "translate(20.757 17.21)",
    fill: "#023f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9262",
    "data-name": "Caminho 9262",
    d: "M29.562,24.4l.041-.168c-.077-.178-.211-.151-.487-.082-.015.369-.033.78-.057,1.059a1.016,1.016,0,0,1,.305-.454A.741.741,0,0,0,29.562,24.4Z",
    transform: "translate(20.757 17.21)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9263",
    "data-name": "Caminho 9263",
    d: "M30.746,21.253c.507.014,1.445.134,1.445.134a15.573,15.573,0,0,1,1.675,2.678c.039.463.039.845-1.044.684,0,0-.525-.1-.958-.135-.477-.158-.528-.041-.578-.009-.039-.168-.132-.574-.243-1.046a21.11,21.11,0,0,0-.6-2.247l0-.033a.721.721,0,0,1,.309-.026",
    transform: "translate(21.741 15.179)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9264",
    "data-name": "Caminho 9264",
    d: "M30.746,21.253c.507.014,1.445.134,1.445.134a15.573,15.573,0,0,1,1.675,2.678c.039.463.039.845-1.044.684,0,0-.525-.1-.958-.135-.477-.158-.528-.041-.578-.009-.039-.168-.132-.574-.243-1.046a21.11,21.11,0,0,0-.6-2.247l0-.033A.721.721,0,0,1,30.746,21.253Z",
    transform: "translate(21.741 15.179)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9265",
    "data-name": "Caminho 9265",
    d: "M30.73,20.779s.024.156.06.415l-.434.209s.039.645.058,1.027c.014.252.18,1.987.293,3.137.038.386.069.706.087.881a1.08,1.08,0,0,0,.25.67,1,1,0,0,1,.3.453l.01.1-.007.041c-.046.213-.329.291-.521.267a3.31,3.31,0,0,1-.905-.425l-.06-6.117Z",
    transform: "translate(21.331 14.842)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9266",
    "data-name": "Caminho 9266",
    d: "M30.73,20.779s.024.156.06.415l-.434.209s.039.645.058,1.027c.014.252.18,1.987.293,3.137.038.386.069.706.087.881a1.08,1.08,0,0,0,.25.67,1,1,0,0,1,.3.453l.01.1-.007.041c-.046.213-.329.291-.521.267a3.31,3.31,0,0,1-.905-.425l-.06-6.117Z",
    transform: "translate(21.331 14.842)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9267",
    "data-name": "Caminho 9267",
    d: "M30.585,21.021c.017.12.036.262.058.423-.009.007-.009.015,0,.027l0,.005a20.993,20.993,0,0,1,.6,2.247c.111.47.247,1.034.285,1.2.048.1.874,1.073.89,1.389.007.129-.094.206-.381.189a4.8,4.8,0,0,1-.957-.163c-.273-.069-.4-.1-.482.082l-.014-.147c-.017-.175-.05-.5-.087-.883-.111-1.149-.279-2.883-.293-3.137-.019-.382-.058-1.025-.058-1.025Z",
    transform: "translate(21.536 15.015)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9268",
    "data-name": "Caminho 9268",
    d: "M30.585,21.021c.017.12.036.262.058.423-.009.007-.009.015,0,.027l0,.005a20.993,20.993,0,0,1,.6,2.247c.111.47.247,1.034.285,1.2.048.1.874,1.073.89,1.389.007.129-.094.206-.381.189a4.8,4.8,0,0,1-.957-.163c-.273-.069-.4-.1-.482.082l-.014-.147c-.017-.175-.05-.5-.087-.883-.111-1.149-.279-2.883-.293-3.137-.019-.382-.058-1.025-.058-1.025Z",
    transform: "translate(21.536 15.015)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9269",
    "data-name": "Caminho 9269",
    d: "M30.961,23.2c.034-.026.01-.115.607.057.134.612.291,1.531.291,1.531,0-.31-.639-.95-.823-1.241C30.942,23.4,30.918,23.275,30.961,23.2Z",
    transform: "translate(22.1 16.539)",
    fill: "#ebc900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9270",
    "data-name": "Caminho 9270",
    d: "M30.961,23.2c.034-.026.01-.115.607.057.134.612.291,1.531.291,1.531,0-.31-.639-.95-.823-1.241C30.942,23.4,30.918,23.275,30.961,23.2Z",
    transform: "translate(22.1 16.539)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9271",
    "data-name": "Caminho 9271",
    d: "M30.452,24.4l-.041-.168c.077-.178.211-.151.487-.082.015.369.033.78.057,1.059a1.016,1.016,0,0,0-.305-.454.741.741,0,0,1-.2-.355",
    transform: "translate(21.722 17.21)",
    fill: "#023f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9272",
    "data-name": "Caminho 9272",
    d: "M30.452,24.4l-.041-.168c.077-.178.211-.151.487-.082.015.369.033.78.057,1.059a1.016,1.016,0,0,0-.305-.454A.741.741,0,0,1,30.452,24.4Z",
    transform: "translate(21.722 17.21)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9273",
    "data-name": "Caminho 9273",
    d: "M29.943,9.246s-.689,1.6-.451,1.761A7.272,7.272,0,0,1,30.8,9.292c.321-.3.514,0,.555-.262s-.84-.645-.84-.645l-.566.794",
    transform: "translate(21.03 5.989)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9274",
    "data-name": "Caminho 9274",
    d: "M29.943,9.246s-.689,1.6-.451,1.761A7.272,7.272,0,0,1,30.8,9.292c.321-.3.514,0,.555-.262s-.84-.645-.84-.645l-.566.794",
    transform: "translate(21.03 5.989)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9275",
    "data-name": "Caminho 9275",
    d: "M28.592,9.789s-1,1.745-.739,1.766S29.187,9.33,29.187,9.33l-.365.062Z",
    transform: "translate(19.864 6.664)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9276",
    "data-name": "Caminho 9276",
    d: "M28.592,9.789s-1,1.745-.739,1.766S29.187,9.33,29.187,9.33l-.365.062Z",
    transform: "translate(19.864 6.664)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9277",
    "data-name": "Caminho 9277",
    d: "M28.787,9.5S27.739,11.218,28,11.245s1.392-2.189,1.392-2.189l-.367.053Z",
    transform: "translate(19.971 6.469)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9278",
    "data-name": "Caminho 9278",
    d: "M28.787,9.5S27.739,11.218,28,11.245s1.392-2.189,1.392-2.189l-.367.053Z",
    transform: "translate(19.971 6.469)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9279",
    "data-name": "Caminho 9279",
    d: "M28.971,9.3s-1.193,1.615-.934,1.666,1.577-2.052,1.577-2.052l-.37.019Z",
    transform: "translate(20 6.368)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9280",
    "data-name": "Caminho 9280",
    d: "M28.971,9.3s-1.193,1.615-.934,1.666,1.577-2.052,1.577-2.052l-.37.019Z",
    transform: "translate(20 6.368)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9281",
    "data-name": "Caminho 9281",
    d: "M29.242,9.111s-1.4,1.435-1.147,1.521,1.836-1.814,1.836-1.814l-.37-.033Z",
    transform: "translate(20.047 6.275)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9282",
    "data-name": "Caminho 9282",
    d: "M29.242,9.111s-1.4,1.435-1.147,1.521,1.836-1.814,1.836-1.814l-.37-.033Z",
    transform: "translate(20.047 6.275)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9283",
    "data-name": "Caminho 9283",
    d: "M29.2,8.826s-1.219,1.594-.962,1.651,1.611-2.026,1.611-2.026l-.37.012Z",
    transform: "translate(20.142 6.036)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9284",
    "data-name": "Caminho 9284",
    d: "M29.2,8.826s-1.219,1.594-.962,1.651,1.611-2.026,1.611-2.026l-.37.012Z",
    transform: "translate(20.142 6.036)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9285",
    "data-name": "Caminho 9285",
    d: "M29,9.631s-1.193,1.615-.934,1.666,1.577-2.052,1.577-2.052l-.37.019Z",
    transform: "translate(20.024 6.604)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9286",
    "data-name": "Caminho 9286",
    d: "M29,9.631s-1.193,1.615-.934,1.666,1.577-2.052,1.577-2.052l-.37.019Z",
    transform: "translate(20.024 6.604)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9287",
    "data-name": "Caminho 9287",
    d: "M29.253,9.484a7.861,7.861,0,0,0-.619,1.37,4.328,4.328,0,0,0,1.347-1.533c.417-.782-.758.13-.758.13",
    transform: "translate(20.448 6.432)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9288",
    "data-name": "Caminho 9288",
    d: "M29.253,9.484a7.861,7.861,0,0,0-.619,1.37,4.328,4.328,0,0,0,1.347-1.533c.417-.782-.758.13-.758.13",
    transform: "translate(20.448 6.432)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9289",
    "data-name": "Caminho 9289",
    d: "M29.6,9.472s-.689,1.6-.451,1.761A5.982,5.982,0,0,0,30.244,9.5c.226-.766,0-.051,0-.051l-.062-.835-.566.794",
    transform: "translate(20.788 6.151)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9290",
    "data-name": "Caminho 9290",
    d: "M29.6,9.472s-.689,1.6-.451,1.761A5.982,5.982,0,0,0,30.244,9.5c.226-.766,0-.051,0-.051l-.062-.835-.566.794",
    transform: "translate(20.788 6.151)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9291",
    "data-name": "Caminho 9291",
    d: "M29.244,9.567s-.689,1.6-.451,1.761a5.982,5.982,0,0,0,1.09-1.735c.226-.766,0-.051,0-.051l-.062-.835-.566.794",
    transform: "translate(20.531 6.219)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9292",
    "data-name": "Caminho 9292",
    d: "M29.244,9.567s-.689,1.6-.451,1.761a5.982,5.982,0,0,0,1.09-1.735c.226-.766,0-.051,0-.051l-.062-.835-.566.794",
    transform: "translate(20.531 6.219)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9293",
    "data-name": "Caminho 9293",
    d: "M29.317,9.262s-1.4,1.435-1.149,1.521,1.838-1.814,1.838-1.814l-.37-.033Z",
    transform: "translate(20.099 6.383)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9294",
    "data-name": "Caminho 9294",
    d: "M29.317,9.262s-1.4,1.435-1.149,1.521,1.838-1.814,1.838-1.814l-.37-.033Z",
    transform: "translate(20.099 6.383)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9295",
    "data-name": "Caminho 9295",
    d: "M29.382,9.375s-1.4,1.435-1.149,1.521,1.838-1.814,1.838-1.814l-.37-.033Z",
    transform: "translate(20.146 6.464)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9296",
    "data-name": "Caminho 9296",
    d: "M29.382,9.375s-1.4,1.435-1.149,1.521,1.838-1.814,1.838-1.814l-.37-.033Z",
    transform: "translate(20.146 6.464)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9297",
    "data-name": "Caminho 9297",
    d: "M29.446,9.508s-1.4,1.435-1.147,1.521,1.836-1.814,1.836-1.814l-.37-.033Z",
    transform: "translate(20.192 6.559)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9298",
    "data-name": "Caminho 9298",
    d: "M29.446,9.508s-1.4,1.435-1.147,1.521,1.836-1.814,1.836-1.814l-.37-.033Z",
    transform: "translate(20.192 6.559)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9299",
    "data-name": "Caminho 9299",
    d: "M29.392,8.252S28.355,9.578,28.5,9.806s1.1-.609,1.4-1.195-.5-.4-.5-.4",
    transform: "translate(20.35 5.844)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9300",
    "data-name": "Caminho 9300",
    d: "M29.392,8.252S28.355,9.578,28.5,9.806s1.1-.609,1.4-1.195-.5-.4-.5-.4",
    transform: "translate(20.35 5.844)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9301",
    "data-name": "Caminho 9301",
    d: "M29.288,9.309s-.89,1.7-.66,1.6a6.666,6.666,0,0,0,1.231-1.661,1.475,1.475,0,0,0,.067-.578l-.689.425.06.329",
    transform: "translate(20.421 6.196)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9302",
    "data-name": "Caminho 9302",
    d: "M29.288,9.309s-.89,1.7-.66,1.6a6.666,6.666,0,0,0,1.231-1.661,1.475,1.475,0,0,0,.067-.578l-.689.425.06.329",
    transform: "translate(20.421 6.196)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9303",
    "data-name": "Caminho 9303",
    d: "M29.43,8.941s.739-1.358-.005.255S28.4,10.543,28.4,10.543a6.469,6.469,0,0,1,.646-1.185,7.5,7.5,0,0,1,.648-.922",
    transform: "translate(20.286 6.005)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9304",
    "data-name": "Caminho 9304",
    d: "M29.43,8.941s.739-1.358-.005.255S28.4,10.543,28.4,10.543a6.469,6.469,0,0,1,.646-1.185,7.5,7.5,0,0,1,.648-.922",
    transform: "translate(20.286 6.005)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9305",
    "data-name": "Caminho 9305",
    d: "M29.942,8.834s.821-1.347,0,.255-1.145,1.334-1.145,1.334c-.067-.093.72-1.178.72-1.178a7.21,7.21,0,0,1,.725-.912",
    transform: "translate(20.565 5.931)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9306",
    "data-name": "Caminho 9306",
    d: "M29.942,8.834s.821-1.347,0,.255-1.145,1.334-1.145,1.334c-.067-.093.72-1.178.72-1.178a7.21,7.21,0,0,1,.725-.912",
    transform: "translate(20.565 5.931)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9307",
    "data-name": "Caminho 9307",
    d: "M29.759,8.96s-.83,1.764-.639,1.894a4.9,4.9,0,0,0,.869-1.423c.178-.631,0-.043,0-.043l.23-1.135",
    transform: "translate(20.78 5.896)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9308",
    "data-name": "Caminho 9308",
    d: "M29.759,8.96s-.83,1.764-.639,1.894a4.9,4.9,0,0,0,.869-1.423c.178-.631,0-.043,0-.043l.23-1.135",
    transform: "translate(20.78 5.896)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9309",
    "data-name": "Caminho 9309",
    d: "M30.257,8.731s-.83,1.764-.639,1.894A4.9,4.9,0,0,0,30.487,9.2c.178-.631,0-.045,0-.045l.23-1.133",
    transform: "translate(21.135 5.732)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9310",
    "data-name": "Caminho 9310",
    d: "M30.257,8.731s-.83,1.764-.639,1.894A4.9,4.9,0,0,0,30.487,9.2c.178-.631,0-.045,0-.045l.23-1.133",
    transform: "translate(21.135 5.732)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9311",
    "data-name": "Caminho 9311",
    d: "M29.663,8.31s-1.037,1.325-.888,1.553,1.1-.609,1.4-1.195-.5-.4-.5-.4",
    transform: "translate(20.543 5.886)",
    fill: "#452c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9312",
    "data-name": "Caminho 9312",
    d: "M29.663,8.31s-1.037,1.325-.888,1.553,1.1-.609,1.4-1.195-.5-.4-.5-.4",
    transform: "translate(20.543 5.886)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9313",
    "data-name": "Caminho 9313",
    d: "M39.074,20.942c0,.243-.079.29-.079.29h-12.2v-.555H39S39.074,20.7,39.074,20.942Z",
    transform: "translate(19.136 14.769)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9314",
    "data-name": "Caminho 9314",
    d: "M39.074,20.942c0,.243-.079.29-.079.29h-12.2v-.555H39S39.074,20.7,39.074,20.942Z",
    transform: "translate(19.136 14.769)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9315",
    "data-name": "Caminho 9315",
    d: "M27.3,20.969c0,.084,0,.166.005.249h9.038q.005-.123.005-.247c0-.1,0-.2-.007-.291H27.311C27.306,20.775,27.3,20.871,27.3,20.969Z",
    transform: "translate(19.503 14.771)",
    fill: "#b87510"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9316",
    "data-name": "Caminho 9316",
    d: "M27.3,20.969c0,.084,0,.166.005.249h9.038q.005-.123.005-.247c0-.1,0-.2-.007-.291H27.311C27.306,20.775,27.3,20.871,27.3,20.969Z",
    transform: "translate(19.503 14.771)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9317",
    "data-name": "Caminho 9317",
    d: "M27.307,20.847h9.036q-.01-.206-.031-.406H27.336C27.322,20.575,27.312,20.71,27.307,20.847Z",
    transform: "translate(19.505 14.601)",
    fill: "#b76e11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9318",
    "data-name": "Caminho 9318",
    d: "M27.307,20.847h9.036q-.01-.206-.031-.406H27.336C27.322,20.575,27.312,20.71,27.307,20.847Z",
    transform: "translate(19.505 14.601)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9319",
    "data-name": "Caminho 9319",
    d: "M27.325,20.607H36.3c-.015-.134-.033-.267-.055-.4H27.38C27.358,20.34,27.339,20.474,27.325,20.607Z",
    transform: "translate(19.518 14.434)",
    fill: "#ac620e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9320",
    "data-name": "Caminho 9320",
    d: "M27.325,20.607H36.3c-.015-.134-.033-.267-.055-.4H27.38C27.358,20.34,27.339,20.474,27.325,20.607Z",
    transform: "translate(19.518 14.434)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9321",
    "data-name": "Caminho 9321",
    d: "M35.935,19.976H27.643c-.166,0-.264.264-.286.4h8.866C36.2,20.24,36.093,19.976,35.935,19.976Z",
    transform: "translate(19.541 14.269)",
    fill: "#a2550b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9322",
    "data-name": "Caminho 9322",
    d: "M35.935,19.976H27.643c-.166,0-.264.264-.286.4h8.866C36.2,20.24,36.093,19.976,35.935,19.976Z",
    transform: "translate(19.541 14.269)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9323",
    "data-name": "Caminho 9323",
    d: "M27.336,21.427h8.978c.015-.142.026-.288.031-.434H27.307C27.312,21.139,27.322,21.284,27.336,21.427Z",
    transform: "translate(19.505 14.995)",
    fill: "#b76e11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9324",
    "data-name": "Caminho 9324",
    d: "M27.336,21.427h8.978c.015-.142.026-.288.031-.434H27.307C27.312,21.139,27.322,21.284,27.336,21.427Z",
    transform: "translate(19.505 14.995)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9325",
    "data-name": "Caminho 9325",
    d: "M27.37,21.6h8.887c.017-.117.033-.233.045-.351H27.324C27.336,21.365,27.351,21.482,27.37,21.6Z",
    transform: "translate(19.517 15.176)",
    fill: "#ac620e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9326",
    "data-name": "Caminho 9326",
    d: "M27.37,21.6h8.887c.017-.117.033-.233.045-.351H27.324C27.336,21.365,27.351,21.482,27.37,21.6Z",
    transform: "translate(19.517 15.176)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9327",
    "data-name": "Caminho 9327",
    d: "M27.648,21.827h8.29c.163,0,.279-.249.3-.375H27.351C27.372,21.579,27.473,21.827,27.648,21.827Z",
    transform: "translate(19.536 15.323)",
    fill: "#a2550b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9328",
    "data-name": "Caminho 9328",
    d: "M27.648,21.827h8.29c.163,0,.279-.249.3-.375H27.351C27.372,21.579,27.473,21.827,27.648,21.827Z",
    transform: "translate(19.536 15.323)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9329",
    "data-name": "Caminho 9329",
    d: "M28.218,22.9a6.655,6.655,0,0,1-.149-1.493,7.079,7.079,0,0,1,.183-1.447H27.8a7.079,7.079,0,0,0-.183,1.447A6.554,6.554,0,0,0,27.77,22.9Z",
    transform: "translate(19.729 14.258)",
    fill: "#c69024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9330",
    "data-name": "Caminho 9330",
    d: "M28.218,22.9a6.655,6.655,0,0,1-.149-1.493,7.079,7.079,0,0,1,.183-1.447H27.8a7.079,7.079,0,0,0-.183,1.447A6.554,6.554,0,0,0,27.77,22.9Z",
    transform: "translate(19.729 14.258)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9331",
    "data-name": "Caminho 9331",
    d: "M31.942,22.9a6.654,6.654,0,0,0,.149-1.493,7.077,7.077,0,0,0-.183-1.447h.447a7.078,7.078,0,0,1,.183,1.447A6.655,6.655,0,0,1,32.39,22.9Z",
    transform: "translate(22.791 14.26)",
    fill: "#c69024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9332",
    "data-name": "Caminho 9332",
    d: "M31.942,22.9a6.654,6.654,0,0,0,.149-1.493,7.077,7.077,0,0,0-.183-1.447h.447a7.078,7.078,0,0,1,.183,1.447A6.655,6.655,0,0,1,32.39,22.9Z",
    transform: "translate(22.791 14.26)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9333",
    "data-name": "Caminho 9333",
    d: "M29.748,22.9a9.522,9.522,0,0,1-.075-1.493,8.523,8.523,0,0,1,.11-1.447h-.447a6.9,6.9,0,0,0-.11,1.447A11.031,11.031,0,0,0,29.3,22.9Z",
    transform: "translate(20.875 14.258)",
    fill: "#c69024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9334",
    "data-name": "Caminho 9334",
    d: "M29.748,22.9a9.522,9.522,0,0,1-.075-1.493,8.523,8.523,0,0,1,.11-1.447h-.447a6.9,6.9,0,0,0-.11,1.447A11.031,11.031,0,0,0,29.3,22.9Z",
    transform: "translate(20.875 14.258)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9335",
    "data-name": "Caminho 9335",
    d: "M30.36,22.9a9.551,9.551,0,0,0,.074-1.493,8.576,8.576,0,0,0-.108-1.447h.447a7.042,7.042,0,0,1,.108,1.447,11.056,11.056,0,0,1-.074,1.493Z",
    transform: "translate(21.661 14.258)",
    fill: "#c69024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9336",
    "data-name": "Caminho 9336",
    d: "M30.36,22.9a9.551,9.551,0,0,0,.074-1.493,8.576,8.576,0,0,0-.108-1.447h.447a7.042,7.042,0,0,1,.108,1.447,11.056,11.056,0,0,1-.074,1.493Z",
    transform: "translate(21.661 14.258)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9337",
    "data-name": "Caminho 9337",
    d: "M29,21.467l.8,1.455.381-.01s-.223-.468-.819-1.474a12.469,12.469,0,0,0-.994-1.486l-.379.01S28.737,20.993,29,21.467Z",
    transform: "translate(19.996 14.251)",
    fill: "#c69024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9338",
    "data-name": "Caminho 9338",
    d: "M29,21.467l.8,1.455.381-.01s-.223-.468-.819-1.474a12.469,12.469,0,0,0-.994-1.486l-.379.01S28.737,20.993,29,21.467Z",
    transform: "translate(19.996 14.251)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9339",
    "data-name": "Caminho 9339",
    d: "M31.809,21.467c-.264.475-.806,1.455-.806,1.455l-.379-.01s.221-.468.818-1.474a12.472,12.472,0,0,1,.994-1.486l.379.01S32.073,20.993,31.809,21.467Z",
    transform: "translate(21.874 14.251)",
    fill: "#c69024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9340",
    "data-name": "Caminho 9340",
    d: "M31.809,21.467c-.264.475-.806,1.455-.806,1.455l-.379-.01s.221-.468.818-1.474a12.472,12.472,0,0,1,.994-1.486l.379.01S32.073,20.993,31.809,21.467Z",
    transform: "translate(21.874 14.251)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9341",
    "data-name": "Caminho 9341",
    d: "M31.631,21.467c.264.475.806,1.455.806,1.455l.379-.01s-.221-.468-.818-1.474A12.469,12.469,0,0,0,31,19.952l-.379.01S31.367,20.993,31.631,21.467Z",
    transform: "translate(21.875 14.251)",
    fill: "#c69024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9342",
    "data-name": "Caminho 9342",
    d: "M31.631,21.467c.264.475.806,1.455.806,1.455l.379-.01s-.221-.468-.818-1.474A12.469,12.469,0,0,0,31,19.952l-.379.01S31.367,20.993,31.631,21.467Z",
    transform: "translate(21.875 14.251)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9343",
    "data-name": "Caminho 9343",
    d: "M26.824,22.329a2.625,2.625,0,0,0-.117-1.5c-.314-.54-.722-.7-.814-.658a1.2,1.2,0,0,1,2.165-.026s-1.025.118-.814,2.119",
    transform: "translate(18.491 13.894)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9344",
    "data-name": "Caminho 9344",
    d: "M26.824,22.329a2.625,2.625,0,0,0-.117-1.5c-.314-.54-.722-.7-.814-.658a1.2,1.2,0,0,1,2.165-.026s-1.025.118-.814,2.119",
    transform: "translate(18.491 13.894)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9345",
    "data-name": "Caminho 9345",
    d: "M26.051,20.171a1.128,1.128,0,0,1,1.855.021.562.562,0,0,1,.153-.048,1.2,1.2,0,0,0-2.165.026.233.233,0,0,1,.142.019l.015-.017",
    transform: "translate(18.491 13.894)",
    fill: "#d3dce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9346",
    "data-name": "Caminho 9346",
    d: "M27.158,21.2a2.01,2.01,0,0,0-.6.329,4.378,4.378,0,0,0-1.275-.465,1.047,1.047,0,0,0-.123-.007c.039-.007.081-.01.122-.021a4.831,4.831,0,0,0,1.269-.494c.182.183.42.374.615.357",
    transform: "translate(17.971 14.672)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9347",
    "data-name": "Caminho 9347",
    d: "M27.158,21.2a2.01,2.01,0,0,0-.6.329,4.378,4.378,0,0,0-1.275-.465,1.047,1.047,0,0,0-.123-.007c.039-.007.081-.01.122-.021a4.831,4.831,0,0,0,1.269-.494c.182.183.42.374.615.357",
    transform: "translate(17.971 14.672)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_83",
    "data-name": "Linha 83",
    x2: 1.891,
    transform: "translate(43.256 35.722)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_84",
    "data-name": "Linha 84",
    x2: 0.007,
    y2: 0.979,
    transform: "translate(44.523 35.206)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9348",
    "data-name": "Caminho 9348",
    d: "M26.85,21.136c-.015.3-.1.526-.2.526s-.187-.235-.2-.54",
    transform: "translate(18.892 15.087)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9349",
    "data-name": "Caminho 9349",
    d: "M26.85,21.136c-.015.3-.1.526-.2.526s-.187-.235-.2-.54",
    transform: "translate(18.892 15.087)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_553",
    "data-name": "Ret\\xE2ngulo 553",
    width: 0.931,
    height: 0.974,
    transform: "translate(45.077 35.235)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_554",
    "data-name": "Ret\\xE2ngulo 554",
    width: 0.931,
    height: 0.974,
    transform: "translate(45.077 35.235)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_555",
    "data-name": "Ret\\xE2ngulo 555",
    width: 0.559,
    height: 0.585,
    transform: "translate(45.262 35.431)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_556",
    "data-name": "Ret\\xE2ngulo 556",
    width: 0.223,
    height: 0.233,
    transform: "translate(45.43 35.606)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9350",
    "data-name": "Caminho 9350",
    d: "M27.9,20.2l.022-.007a.559.559,0,0,1,.144-.045,1.2,1.2,0,0,0-2.165.026.213.213,0,0,1,.132.014l.015.009",
    transform: "translate(18.493 13.894)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9351",
    "data-name": "Caminho 9351",
    d: "M27.835,20.091a1.13,1.13,0,0,0-1.862-.007",
    transform: "translate(18.552 13.995)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9352",
    "data-name": "Caminho 9352",
    d: "M29.18,21.467c-.264.475-.806,1.455-.806,1.455L28,22.913s.221-.468.818-1.474a12.469,12.469,0,0,1,.994-1.486l.379.01S29.444,20.993,29.18,21.467Z",
    transform: "translate(19.996 14.251)",
    fill: "#c69024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9353",
    "data-name": "Caminho 9353",
    d: "M29.18,21.467c-.264.475-.806,1.455-.806,1.455L28,22.913s.221-.468.818-1.474a12.469,12.469,0,0,1,.994-1.486l.379.01S29.444,20.993,29.18,21.467Z",
    transform: "translate(19.996 14.251)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_858",
    "data-name": "Grupo 858",
    transform: "translate(45.089 17.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_857",
    "data-name": "Grupo 857",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9354",
    "data-name": "Caminho 9354",
    d: "M39.192,27.276l.88-16.82L26.69,9.726l-.88,16.82Z",
    transform: "translate(-26.654 -10.41)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_860",
    "data-name": "Grupo 860",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_859",
    "data-name": "Grupo 859",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9356",
    "data-name": "Caminho 9356",
    d: "M32.022,14.657a3.177,3.177,0,0,1,.864-.283c.228-.074.5-.087.725-.141.2-.048.814.36,1.02.423l.014.567a4.61,4.61,0,0,1-1.377-.031c-.362-.139-1.246-.573-1.246-.573",
    transform: "translate(22.873 10.164)",
    fill: "#395054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9357",
    "data-name": "Caminho 9357",
    d: "M32.022,14.657a3.177,3.177,0,0,1,.864-.283c.228-.074.5-.087.725-.141.2-.048.814.36,1.02.423l.014.567a4.61,4.61,0,0,1-1.377-.031c-.362-.139-1.246-.573-1.246-.573",
    transform: "translate(22.873 10.164)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9358",
    "data-name": "Caminho 9358",
    d: "M29.426,15.367c.115.094.019.135-.048.213-.038.045.219.242.494.329a.382.382,0,0,1,.209.165,1.125,1.125,0,0,0,.255.214c.132.1.027.125.341.135a1.826,1.826,0,0,1,.559.115,3.6,3.6,0,0,0,.5.087c.3.039,1.378,0,1.349.007s-.753.163-.819.2-.406-.045-.473-.005a1.953,1.953,0,0,0-.207.154c-.077.058-.019.077.057.1a1.152,1.152,0,0,1,.293.106.9.9,0,0,0,.427.117,3.069,3.069,0,0,1,.454.058,1.854,1.854,0,0,0,.521.048,1.874,1.874,0,0,0,.475.009,3.283,3.283,0,0,1,.473-.019c.161,0,.161-.029.341-.038s.307.273.127.273.142-.057.019-.046a2.7,2.7,0,0,0-.514.015c-.067.038-.134.117-.314.252s-.038.2.019.242a1.227,1.227,0,0,0,.218.087,3.442,3.442,0,0,1,.389.106,1.237,1.237,0,0,0,.446.106,2.579,2.579,0,0,1,.37.067,1.964,1.964,0,0,0,.444.137c.153.009.1.038.285.125s.18.019.333.019a.437.437,0,0,1,.293.077,1.325,1.325,0,0,0,.209.108,11.74,11.74,0,0,1-.693,1.219,6.109,6.109,0,0,1-2.3,2.062,4.891,4.891,0,0,1-2.949.321c-1.308-.135-2.577-1.483-3.127-2.179a4.855,4.855,0,0,1-.768-1.4l.113-.009c.067-.01.134-.019.238-.039s.094-.009.218-.038a1.205,1.205,0,0,0,.274-.079c.115-.048.075-.067.255-.115s.123-.039.171-.05a1.118,1.118,0,0,0,.228-.058c.1-.038.226-.1.113-.154s0-.067,0-.067l.293.019c.171.009.1.029.219.038a.38.38,0,0,0,.189-.019c.086-.019-.019-.117-.038-.213s-.067-.039-.1-.077-.075-.021-.2-.1-.086-.009-.351-.1-.027.077-.358-.019-.147.067-.423-.019-.363-.283-.108-.243.075-.01.1-.048.075-.01.226-.021.134,0,.276-.009a.456.456,0,0,0,.2-.048.736.736,0,0,0,.207.048c.086,0,.057-.019.057-.077s.086,0,.153.019a.762.762,0,0,0,.228-.01,2.154,2.154,0,0,1,.218-.009c.142,0,.057-.029.189-.079s0-.1-.046-.106-.057-.029-.123-.087a.587.587,0,0,0-.207-.122c-.086-.029-.585.038-.708,0s-.118-.2.129-.206a1.512,1.512,0,0,1,.218,0c.123,0,.094.021.142.021a1.747,1.747,0,0,0,.293-.029c.2-.029.115-.039.247-.1s.274-.038.389-.087-.048-.1-.19-.165,0,.039-.1-.067-.633-.418-.8-.562c-.147-.135.129-.084.269-.149a.141.141,0,0,0-.1-.194c-.154-.051-.137-.051-.3-.113s-.242-.177-.362-.2a.717.717,0,0,1-.182-.062",
    transform: "translate(19.366 10.829)",
    fill: "#006c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9359",
    "data-name": "Caminho 9359",
    d: "M28.488,15.4a.177.177,0,0,0-.048.213.64.64,0,0,0,.4.381c.115.036.262.055.3.113a1.188,1.188,0,0,0,.257.214c.132.1.027.125.341.135a1.774,1.774,0,0,1,.559.115,3.6,3.6,0,0,0,.5.087c.3.039,1.323.012,1.294.022s-.91.194-.977.231-.194-.089-.261-.05a1.947,1.947,0,0,0-.207.154c-.077.058-.019.077.057.1a1.153,1.153,0,0,1,.293.106.9.9,0,0,0,.427.117,3.069,3.069,0,0,1,.454.058,1.854,1.854,0,0,0,.521.048c.314.009.063.075.471.046a1.553,1.553,0,0,1,.432.007c.159,0,.207.048.387.038s.6.118.423.118a3.548,3.548,0,0,0-.485-.036c-.123.009-.243-.019-.309.021s-.134.115-.314.252-.038.2.019.242a1.224,1.224,0,0,0,.218.087,3.442,3.442,0,0,1,.389.106,1.237,1.237,0,0,0,.446.106,2.345,2.345,0,0,1,.37.067,1.965,1.965,0,0,0,.444.137c.153.009.1.038.285.125s.18.019.333.019a.428.428,0,0,1,.293.077.942.942,0,0,0,.166.089s.391-1.094.542-1.569a14.237,14.237,0,0,0,.314-1.934c0-.082-.223-.206-.293-.185a3.373,3.373,0,0,1-.466.021H34.793c-.081,0-.142.062-.293-.01a1.31,1.31,0,0,0-.516-.1c-.091.01-.466.021-.547.021s-.981-.043-1.133-.033a5.7,5.7,0,0,1-.617,0c-.182-.01-.415-.01-.506-.021a1.167,1.167,0,0,0-.506.033,1.3,1.3,0,0,1-.4.1c-.1.021-.374.072-.516.082a5.411,5.411,0,0,1-.687.072c-.132-.021-.579-.022-.579-.022",
    transform: "translate(20.304 10.799)",
    fill: "#6dbe45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9360",
    "data-name": "Caminho 9360",
    d: "M28.488,15.391a.224.224,0,0,0-.031.276.652.652,0,0,0,.384.336.883.883,0,0,1,.29.1c.026.021.045.055.07.077.045.039.094.074.142.11a.712.712,0,0,1,.137.122.2.2,0,0,0,.144.046c.12.012.237.01.355.031a1.831,1.831,0,0,1,.247.07,2.3,2.3,0,0,0,.418.087,6.63,6.63,0,0,0,1.011.043l.312,0c.022,0,.11-.014.127,0v-.019a.277.277,0,0,1-.065.015l-.18.039c-.154.034-.309.067-.461.1a2,2,0,0,0-.285.081c-.062.024-.154-.058-.218-.063-.043-.005-.1.053-.13.077a.6.6,0,0,0-.141.122c-.05.072.231.118.266.132.075.027.146.07.219.1a.768.768,0,0,0,.206.05c.161.026.327.027.489.057a2.613,2.613,0,0,0,.487.063,1.253,1.253,0,0,1,.266.019c.029.007.053.026.082.033a.828.828,0,0,0,.243,0c.093-.005.187-.014.279-.01a2.624,2.624,0,0,1,.285.029c.182.031.365.022.545.067a.659.659,0,0,1,.17.057c.009.007.005,0,0,0a.105.105,0,0,1-.033,0,1.1,1.1,0,0,1-.166-.019,2.4,2.4,0,0,0-.384-.015c-.106,0-.2-.019-.29.05-.072.057-.139.12-.211.177-.05.039-.142.089-.146.165,0,.125.18.178.269.207s.185.048.278.072c.153.041.295.11.449.142.13.027.264.027.394.055a1.137,1.137,0,0,1,.211.06,1.371,1.371,0,0,0,.374.108,1.023,1.023,0,0,1,.317.139c.122.053.237,0,.363.007a1.082,1.082,0,0,1,.4.165c.082-.231.165-.463.245-.694.115-.327.243-.657.331-.993a9.49,9.49,0,0,0,.189-1.054c.034-.249.074-.5.091-.751.007-.094-.094-.149-.166-.185a.263.263,0,0,0-.177-.021,2.5,2.5,0,0,1-.278.01c-.243,0-.487,0-.729,0H35.01a1.25,1.25,0,0,0-.266.007.372.372,0,0,1-.264-.027,1.233,1.233,0,0,0-.324-.082,2.547,2.547,0,0,0-.471,0c-.259.009-.516,0-.777-.014-.315-.01-.629,0-.945,0-.235,0-.471-.012-.706-.022a2.5,2.5,0,0,0-.48-.007.944.944,0,0,0-.19.072,1.955,1.955,0,0,1-.3.06c-.182.033-.362.072-.547.087a3.093,3.093,0,0,1-.686.069,4.476,4.476,0,0,0-.567-.021v.019a6.652,6.652,0,0,0,.847.009c.363-.046.723-.106,1.083-.166a.632.632,0,0,0,.257-.077.428.428,0,0,1,.226-.043c.171-.005.343.017.513.022.242.007.48.021.722.015.132,0,.262-.009.394-.005.293.005.586.021.879.029a4.382,4.382,0,0,1,.9.021c.1.024.2.081.3.1a1.27,1.27,0,0,0,.2-.024h1.186c.117,0,.233,0,.351,0a1.323,1.323,0,0,0,.2-.019c.074-.014.17.057.223.1.089.07.051.178.039.278-.019.163-.039.327-.062.49a10.875,10.875,0,0,1-.194,1.1c-.082.336-.214.662-.327.987l-.252.717s-.231-.129-.259-.139a.533.533,0,0,0-.3-.015.34.34,0,0,1-.231-.031,2.023,2.023,0,0,0-.206-.115c-.079-.026-.165-.024-.245-.046a2.04,2.04,0,0,1-.249-.089,1.413,1.413,0,0,0-.42-.081,2.661,2.661,0,0,1-.569-.153,1.643,1.643,0,0,1-.473-.153.518.518,0,0,1-.07-.055c-.07-.07.043-.147.091-.183.082-.063.158-.134.238-.2a.353.353,0,0,1,.257-.05,3.772,3.772,0,0,1,.417.015c.026,0,.23.057.209-.012-.007-.027-.1-.045-.12-.051a1.646,1.646,0,0,0-.259-.051c-.094-.01-.185,0-.278-.017a2.543,2.543,0,0,0-.254-.026,1.86,1.86,0,0,0-.278-.012.82.82,0,0,1-.4-.017.556.556,0,0,0-.206-.024c-.084,0-.168,0-.254-.005-.141-.01-.278-.06-.42-.075s-.3-.026-.454-.053a1.829,1.829,0,0,1-.358-.141c-.081-.033-.168-.043-.247-.077-.039-.017.111-.13.122-.139a.3.3,0,0,1,.13-.077c.06-.007.127.05.185.063a.184.184,0,0,0,.094-.024c.11-.033.221-.055.331-.081.134-.031.267-.06.4-.089a.688.688,0,0,0,.2-.045v-.019c-.009-.009-.048,0-.058,0h-.175c-.168,0-.336,0-.506,0a4.536,4.536,0,0,1-.974-.089c-.144-.033-.283-.089-.429-.115a3.392,3.392,0,0,0-.35-.029.171.171,0,0,1-.129-.051.826.826,0,0,0-.156-.134c-.041-.029-.081-.058-.118-.091s-.053-.063-.084-.089a1.018,1.018,0,0,0-.3-.1.614.614,0,0,1-.262-.183c-.086-.1-.187-.273-.063-.381v-.019",
    transform: "translate(20.304 10.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9361",
    "data-name": "Caminho 9361",
    d: "M29.588,15.705c.1.123.01.039-.231.17-.19.1.819.629.924.735s-.038,0,.1.069.3.117.19.165-.255.029-.389.087-.046.067-.245.1a1.774,1.774,0,0,1-.295.029.907.907,0,0,0-.159-.017c-.123,0-.019.024-.266.034-.024,0-.348.038-.345.038.154.017.523.033.687.039a1.15,1.15,0,0,1,.3.091.555.555,0,0,1,.209.125c.067.058.075.077.123.087s.18.058.046.106-.046.077-.189.077a1.8,1.8,0,0,0-.218.01.722.722,0,0,1-.228.009c-.067-.019-.151-.077-.151-.019s.027.077-.058.077a.736.736,0,0,1-.207-.048.418.418,0,0,1-.2.048c-.142.01-.123,0-.276.01s-.231-.029-.226.019c.009.094-.13.051-.108.12.021.007-.175.007-.159.012.274.087.353-.034.684.062s.1.048.37.135.226.021.35.1.161.058.2.1.086-.019.1.077.123.194.038.214a.38.38,0,0,1-.189.019c-.115-.01-.048-.029-.219-.039s-.293-.019-.293-.019-.113.01,0,.069-.009.115-.113.154a1.25,1.25,0,0,1-.228.058c-.048.009.01,0-.17.048s-.142.069-.257.117a1.3,1.3,0,0,1-.274.077c-.123.029-.113.019-.218.039s-.171.029-.237.038l-.19.031a6.465,6.465,0,0,1-.653-1.617,16.99,16.99,0,0,1-.315-2.424c0-.07.321-.074.43-.034s.627.079.867.111.838.118.885.135.19-.081.307,0,.454.317.454.317",
    transform: "translate(19.007 10.749)",
    fill: "#6dbe45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9362",
    "data-name": "Caminho 9362",
    d: "M29.588,15.718c.014.017.055.048.022.06a.787.787,0,0,1-.091.024c-.048.012-.166.036-.185.093s.022.086.048.113a1.8,1.8,0,0,0,.317.242c.129.084.261.163.389.243.046.029.091.057.135.087l.043.031.014.012.029.033q.015.031.01,0c-.014.007.058.033.063.036.058.026.115.05.171.077.077.039.021.07-.036.086a1.719,1.719,0,0,1-.209.034.472.472,0,0,0-.219.093.626.626,0,0,1-.269.055,1.36,1.36,0,0,1-.168.014c-.067,0-.13-.021-.2-.017a.423.423,0,0,0-.081.019,1.279,1.279,0,0,1-.182.017c-.106.01-.214.017-.317.036v.019c.4.041.864-.029,1.2.255a.434.434,0,0,0,.1.082c.033.014.065.017.1.034.06.033-.062.07-.082.081s-.039.039-.069.05a1.314,1.314,0,0,1-.274.014c-.057.005-.111.015-.168.017a.269.269,0,0,1-.12-.024c-.027-.01-.075-.043-.1-.017s.014.065-.007.086c-.045.045-.2-.021-.25-.038-.014-.005-.015,0-.031.007a.464.464,0,0,1-.146.034,2.409,2.409,0,0,1-.249.01c-.06,0-.118.005-.178,0-.031,0-.079-.015-.1,0l-.005.022a.061.061,0,0,1-.045.06c-.029.012-.065.012-.065.051l.005.024V17.86a1.253,1.253,0,0,1-.161.009v.019c.01.017.084.024.1.027a.64.64,0,0,0,.129.007c.091,0,.182-.014.274-.007a1.109,1.109,0,0,1,.408.12,1.484,1.484,0,0,0,.408.11,1.9,1.9,0,0,1,.2.1.446.446,0,0,1,.074.031.4.4,0,0,0,.086.033c.029.01.05.118.065.147.024.05.045.089-.022.106a.474.474,0,0,1-.23,0,.986.986,0,0,0-.225-.033,1.447,1.447,0,0,0-.226-.015c-.021,0-.05.007-.05.031,0,.062.151.072.046.142a1.5,1.5,0,0,1-.425.134.859.859,0,0,0-.25.091.8.8,0,0,1-.254.1c-.194.043-.389.075-.585.1-.022,0-.159.041-.171.022s-.034-.06-.05-.089c-.079-.142-.151-.288-.218-.435a6.245,6.245,0,0,1-.456-1.431c-.084-.444-.137-.895-.182-1.344-.017-.17-.033-.341-.045-.511-.005-.055-.043-.207.014-.238a.673.673,0,0,1,.43.007,3.441,3.441,0,0,0,.531.069c.353.036.7.087,1.056.144a1.119,1.119,0,0,1,.132.024.184.184,0,0,0,.086-.012.371.371,0,0,1,.173-.012.747.747,0,0,1,.2.129l.226.159.077.053v-.019l-.339-.237A.465.465,0,0,0,29,15.281c-.074-.005-.144.046-.216.029a9.26,9.26,0,0,0-.946-.141c-.2-.022-.4-.039-.595-.065a3.519,3.519,0,0,0-.422-.062c-.057,0-.209-.007-.207.081s.01.154.015.23a8.519,8.519,0,0,0,.955,3.809,3.173,3.173,0,0,0,1.041-.254,1.333,1.333,0,0,1,.386-.111c.072-.015.343-.063.3-.185,0-.015-.1-.058-.077-.07a.075.075,0,0,1,.039-.01c.1.007.2.014.291.019a.963.963,0,0,0,.425.014c.021-.007.017-.038.015-.053a.227.227,0,0,0-.033-.079c-.019-.036-.027-.113-.055-.139s-.048-.014-.074-.022-.043-.031-.067-.039c-.077-.027-.142-.077-.218-.1a.565.565,0,0,0-.108-.015,1.378,1.378,0,0,1-.257-.075c-.075-.026-.142-.062-.219-.086a1.09,1.09,0,0,0-.312-.058c-.075,0-.149.009-.223.01a.466.466,0,0,1-.11-.009c-.026,0-.05-.01-.075-.015s-.036.009-.007.007a.549.549,0,0,0,.141-.007V17.86c-.015-.014.069-.041.072-.043a.058.058,0,0,0,.034-.043c0-.017,0-.036.019-.041a.5.5,0,0,1,.142.007c.087,0,.177-.005.264-.007a.639.639,0,0,0,.271-.05c.034-.019.276.115.276.012,0-.026-.014-.065.019-.07s.093.033.127.045a.476.476,0,0,0,.225-.009,1.367,1.367,0,0,1,.187-.01.257.257,0,0,0,.125-.014.53.53,0,0,1,.1-.063c.13-.053.009-.111-.065-.13-.041-.012-.075-.057-.1-.082a.712.712,0,0,0-.132-.094,1.124,1.124,0,0,0-.351-.12c-.2-.031-.4-.019-.6-.033-.039,0-.077-.005-.115-.009v.019c.086-.015.173-.021.261-.029a1.092,1.092,0,0,0,.269-.033.6.6,0,0,1,.24.007A1.754,1.754,0,0,0,30,17.032a.238.238,0,0,0,.106-.041.463.463,0,0,1,.2-.082c.053-.01.307-.01.305-.094,0-.027-.017-.038-.039-.051a1.061,1.061,0,0,0-.245-.113c-.027-.009-.009.026-.007.024v-.019c-.012-.038-.067-.07-.1-.093-.062-.043-.127-.082-.192-.122-.163-.1-.327-.2-.482-.312a1.313,1.313,0,0,1-.168-.139.215.215,0,0,1-.046-.065c-.015-.041.091-.07.111-.079s.173-.029.182-.065-.024-.06-.041-.081v.019",
    transform: "translate(19.006 10.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9363",
    "data-name": "Caminho 9363",
    d: "M26.477,16.1s.019-.153.394-.153a3.371,3.371,0,0,1,.694.094c.432.058.751.058.9.077a4.7,4.7,0,0,1,.583.1,3.059,3.059,0,0,1,.3.134s-.075.058.243.058.225-.019.675-.019.151.115.732,0,1.032-.173,1.183-.211-.17-.154.394-.077a3.575,3.575,0,0,0,.919.019c.094,0,.489.019.675.019a4.922,4.922,0,0,1,.564.019c.111.021.281-.019.525.021s.3-.077.489.038a1.109,1.109,0,0,0,.657.019,3.873,3.873,0,0,1,.47,0c.074,0,.43.039.6.039s.506-.039.506-.039l.319.039s.057-.825.057-.921.2-.24-.154-.274c-1.322-.129-.811-.211-1.591-.262-.187-.039-1.089-.269-1.275-.307a12.457,12.457,0,0,0-1.5-.346c-.3,0-1.051.039-1.238.039s-1.821-.039-2.047-.039c0,0-.6-.211-.751-.267s-.168-.039-.657-.019a4.936,4.936,0,0,1-1.051.019,3.313,3.313,0,0,0-1.032.038,3.557,3.557,0,0,0-.506.154Z",
    transform: "translate(18.912 9.901)",
    fill: "#557176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9364",
    "data-name": "Caminho 9364",
    d: "M26.479,16.128c.007-.046.058-.079.094-.1a.882.882,0,0,1,.432-.051,1.4,1.4,0,0,1,.267.043,3.871,3.871,0,0,0,.506.075c.279.031.561.036.84.072a3.111,3.111,0,0,1,.417.072,1.763,1.763,0,0,1,.314.139v-.038a.05.05,0,0,0,0,.067c.048.038.151.027.206.027.082,0,.166,0,.249,0a2.675,2.675,0,0,1,.785.029.36.36,0,0,0,.129,0c.118-.012.237-.039.353-.062.25-.048.5-.091.754-.132.081-.014.161-.026.24-.041a.53.53,0,0,0,.146-.034.044.044,0,0,0,.017-.041c0-.017.005-.062-.005-.031.009-.027.077-.021.1-.019.122,0,.242.024.362.038a3.4,3.4,0,0,0,.619.021c.291-.017.579,0,.871.005.207,0,.411.014.617.024.1.005.2-.005.3,0a2.305,2.305,0,0,0,.377.015.4.4,0,0,1,.231.014c.046.019.086.046.134.062a.672.672,0,0,0,.173.026c.187.007.369-.05.554-.051.339,0,.679.06,1.018.043.093,0,.185-.012.278-.022a.637.637,0,0,1,.127-.012l.317.038,0-.009c.017-.252.034-.506.05-.758a.674.674,0,0,1,.048-.267.115.115,0,0,0-.048-.168A1.173,1.173,0,0,0,38,15.05c-.113-.014-.228-.027-.341-.045a3,3,0,0,1-.37-.07,2.773,2.773,0,0,0-.439-.106,3.35,3.35,0,0,1-.372-.053c-.163-.038-.326-.079-.489-.118-.257-.063-.516-.12-.773-.187-.336-.087-.669-.185-1.006-.259a1.766,1.766,0,0,0-.4-.055c-.182,0-.363.009-.545.015-.264.01-.526.026-.79.021l-.891-.017c-.3-.007-.6-.014-.9-.019a.547.547,0,0,1-.19-.022c-.149-.053-.3-.1-.447-.159a1.372,1.372,0,0,0-.483-.125c-.341.009-.681.045-1.02.06a3.739,3.739,0,0,1-.554-.034,3.144,3.144,0,0,0-.622.005,3.212,3.212,0,0,0-.809.2l0,.014q-.036,1.005-.074,2.013c0,.012,0,.038,0,.01l.051-1.4c.007-.2.015-.4.022-.6v-.014c0,.021.012.007.029,0,.089-.034.18-.063.271-.091a2.86,2.86,0,0,1,.588-.1,4.665,4.665,0,0,1,.8.031,3.391,3.391,0,0,0,.59-.017c.23-.019.459-.027.689-.036a.674.674,0,0,1,.274.036c.249.094.5.18.751.269a.287.287,0,0,0,.086,0l.163,0c.149,0,.3.005.446.009.545.01,1.094.038,1.639.019.2-.009.4-.015.593-.022a3.223,3.223,0,0,1,.446,0,6.909,6.909,0,0,1,1.015.235c.545.147,1.1.285,1.649.406.12.026.249.021.37.041a1.561,1.561,0,0,1,.2.051,3.664,3.664,0,0,0,.72.141c.129.015.259.024.387.043.072.01.171.036.13.127a.542.542,0,0,0-.045.228c-.014.266-.033.531-.05.8a3,3,0,0,0-.307-.041.488.488,0,0,0-.1.009c-.1.01-.2.019-.291.024-.346.022-.7-.041-1.042-.043-.185,0-.367.053-.552.051a.553.553,0,0,1-.285-.075.357.357,0,0,0-.255-.024,1.548,1.548,0,0,1-.345-.015c-.111-.007-.223,0-.334,0-.084,0-.168-.017-.252-.021-.122-.005-.243,0-.365,0-.291,0-.579-.024-.871-.005a3.552,3.552,0,0,1-.619-.021c-.115-.012-.23-.033-.345-.038-.029,0-.091-.01-.111.017a.064.064,0,0,0-.005.036l0,.019c0,.026,0,0,0,0-.01.027-.063.031-.086.036-.067.014-.134.024-.2.036-.209.034-.418.069-.626.106a5.412,5.412,0,0,1-.636.108.7.7,0,0,1-.2-.036,2.311,2.311,0,0,0-.511-.009c-.108,0-.218.012-.327.014a1.075,1.075,0,0,1-.257-.015.066.066,0,0,1-.041-.022c.017.029-.009.031.005.019v-.038a1.962,1.962,0,0,0-.314-.139,2.544,2.544,0,0,0-.441-.075c-.295-.039-.59-.043-.885-.075-.261-.029-.516-.108-.778-.113-.106,0-.429-.014-.454.156a.15.15,0,0,0,0,.033",
    transform: "translate(18.912 9.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9365",
    "data-name": "Caminho 9365",
    d: "M32.719,14.874c-.036.072-.07.144-.113.213-.005.009,0,.033,0,.036.041-.069.077-.141.113-.213,0-.009,0-.031,0-.036",
    transform: "translate(23.289 10.624)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9366",
    "data-name": "Caminho 9366",
    d: "M27.106,14.8a1.529,1.529,0,0,0-.122.194c0,.01,0,.033,0,.038a1.541,1.541,0,0,1,.122-.2c.005-.007,0-.033,0-.036",
    transform: "translate(19.274 10.573)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9367",
    "data-name": "Caminho 9367",
    d: "M27.205,14.742l-.009.026a.075.075,0,0,0,0,.027s0,.014,0,.007l.009-.027a.065.065,0,0,0,0-.026s0-.014,0-.007",
    transform: "translate(19.425 10.528)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9368",
    "data-name": "Caminho 9368",
    d: "M27.407,14.667c-.019.072-.043.142-.069.213-.005.01,0,.031,0,.036a2.2,2.2,0,0,0,.07-.213c0-.01,0-.029,0-.036",
    transform: "translate(19.526 10.476)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9369",
    "data-name": "Caminho 9369",
    d: "M27.445,14.639a.609.609,0,0,1-.017.125.129.129,0,0,0,0,.026s0,.014,0,.007a.986.986,0,0,0,.017-.158c0-.022,0-.022,0,0",
    transform: "translate(19.591 10.444)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9370",
    "data-name": "Caminho 9370",
    d: "M27.658,14.549c-.093.156-.18.314-.259.477-.005.01,0,.033,0,.038.081-.163.168-.322.261-.478.005-.009,0-.033,0-.036",
    transform: "translate(19.569 10.392)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9371",
    "data-name": "Caminho 9371",
    d: "M27.658,14.513a1.179,1.179,0,0,1-.1.331c0,.01,0,.031,0,.036a1.185,1.185,0,0,0,.106-.339c0-.005,0-.043,0-.027",
    transform: "translate(19.682 10.363)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9372",
    "data-name": "Caminho 9372",
    d: "M27.689,14.515a1.146,1.146,0,0,1-.034.228.15.15,0,0,0,0,.033,1.261,1.261,0,0,0,.036-.25c0-.012,0-.038,0-.01",
    transform: "translate(19.753 10.359)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9373",
    "data-name": "Caminho 9373",
    d: "M27.769,14.514a.415.415,0,0,1-.043.18c0,.01,0,.031,0,.036a.539.539,0,0,0,.043-.243c0-.014,0,.022,0,.027",
    transform: "translate(19.804 10.345)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9374",
    "data-name": "Caminho 9374",
    d: "M27.228,15.079c.043-.024.079-.057.122-.079.007-.005,0-.038,0-.039-.043.024-.079.057-.122.081-.007,0,0,.036,0,.038",
    transform: "translate(19.447 10.686)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9375",
    "data-name": "Caminho 9375",
    d: "M27.392,14.951c-.015.024-.027.048-.043.07l0,.024,0,.014.045-.072v-.022l0-.014",
    transform: "translate(19.534 10.679)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9376",
    "data-name": "Caminho 9376",
    d: "M28.194,14.338a.2.2,0,0,1-.043.07l0,.019,0,.019a.221.221,0,0,0,.045-.072.1.1,0,0,0,0-.022l0-.014",
    transform: "translate(20.106 10.241)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9377",
    "data-name": "Caminho 9377",
    d: "M28.217,14.675a.567.567,0,0,0,.141-.391c0-.024,0,.012,0,.019a.53.53,0,0,1-.137.334c-.007.009.005.033,0,.038",
    transform: "translate(20.153 10.197)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9378",
    "data-name": "Caminho 9378",
    d: "M28.4,14.273a1.229,1.229,0,0,1-.034.237.15.15,0,0,0,0,.033,1.323,1.323,0,0,0,.036-.259c0-.012,0-.038,0-.01",
    transform: "translate(20.258 10.186)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9379",
    "data-name": "Caminho 9379",
    d: "M28.3,14.286a1.239,1.239,0,0,1-.139.283c-.005.009,0,.033,0,.036a1.313,1.313,0,0,0,.139-.283c0-.01,0-.029,0-.036",
    transform: "translate(20.117 10.204)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9380",
    "data-name": "Caminho 9380",
    d: "M27.646,14.853c-.019.048-.038.1-.06.142-.005.009,0,.031,0,.036.022-.046.043-.094.062-.142,0-.009,0-.031,0-.036",
    transform: "translate(19.703 10.609)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9381",
    "data-name": "Caminho 9381",
    d: "M27.734,14.853a.965.965,0,0,1-.111.149c-.009.009,0,.034,0,.038a1.119,1.119,0,0,0,.113-.151c.005-.009,0-.033,0-.036",
    transform: "translate(19.728 10.609)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9382",
    "data-name": "Caminho 9382",
    d: "M27.844,14.879l-.051.106,0,.024,0,.012c.017-.034.034-.07.053-.106v-.022l0-.014",
    transform: "translate(19.851 10.628)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9383",
    "data-name": "Caminho 9383",
    d: "M27.952,14.817a1.14,1.14,0,0,1-.165.283c-.007.007.005.033,0,.038a1.18,1.18,0,0,0,.166-.285c0-.009,0-.031,0-.036",
    transform: "translate(19.847 10.584)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9384",
    "data-name": "Caminho 9384",
    d: "M29.161,14.389a.185.185,0,0,0-.053.062.111.111,0,0,0,0,.024l0,.014a.163.163,0,0,1,.051-.062l0-.019,0-.019",
    transform: "translate(20.791 10.278)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9385",
    "data-name": "Caminho 9385",
    d: "M29.125,14.778a.5.5,0,0,0,.2-.417c0-.022,0-.022,0,0a.485.485,0,0,1-.2.379c-.007.005,0,.036,0,.038",
    transform: "translate(20.802 10.246)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9386",
    "data-name": "Caminho 9386",
    d: "M28.594,14.719a.552.552,0,0,1-.166.149c-.005.005,0,.036,0,.038a.538.538,0,0,0,.166-.151c.007-.007,0-.033,0-.036",
    transform: "translate(20.304 10.514)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9387",
    "data-name": "Caminho 9387",
    d: "M28.362,15.2a.942.942,0,0,0,.511-.442c.005-.009,0-.033,0-.038a.933.933,0,0,1-.509.442V15.2",
    transform: "translate(20.259 10.517)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9388",
    "data-name": "Caminho 9388",
    d: "M28.565,15.257a.676.676,0,0,0,.225-.221c.007-.009,0-.034,0-.038a.692.692,0,0,1-.225.221c-.007,0,0,.036,0,.038",
    transform: "translate(20.402 10.713)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9389",
    "data-name": "Caminho 9389",
    d: "M29.031,14.961a2.593,2.593,0,0,1-.441.468c-.009.007,0,.034,0,.038A2.593,2.593,0,0,0,29.031,15c.007-.009-.005-.031,0-.038",
    transform: "translate(20.419 10.686)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9390",
    "data-name": "Caminho 9390",
    d: "M28.924,15.008a.77.77,0,0,1,.094-.158c.007-.009-.005-.033,0-.039a.8.8,0,0,0-.1.161c0,.009,0,.031,0,.036",
    transform: "translate(20.658 10.579)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9391",
    "data-name": "Caminho 9391",
    d: "M29.135,15.308a1.573,1.573,0,0,1,.259-.4c.007-.007-.005-.033,0-.038a1.559,1.559,0,0,0-.261.4c0,.009,0,.031,0,.036",
    transform: "translate(20.809 10.624)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9392",
    "data-name": "Caminho 9392",
    d: "M29.414,14.956c-.077.086-.161.166-.233.255-.007.01,0,.033,0,.039.072-.091.156-.17.233-.257.007-.009-.005-.033,0-.038",
    transform: "translate(20.842 10.683)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9393",
    "data-name": "Caminho 9393",
    d: "M29.832,15.009a.914.914,0,0,0,.053-.333c0-.027,0,0,0,.01a.82.82,0,0,1-.051.286c0,.01,0,.031,0,.036",
    transform: "translate(21.307 10.474)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9394",
    "data-name": "Caminho 9394",
    d: "M29.836,14.674a1.39,1.39,0,0,1-.086.334c-.005.009,0,.031,0,.036a1.343,1.343,0,0,0,.087-.338.15.15,0,0,0,0-.033",
    transform: "translate(21.249 10.481)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9395",
    "data-name": "Caminho 9395",
    d: "M29.943,14.669a1.484,1.484,0,0,1-.051.326c0,.01,0,.031,0,.036a1.515,1.515,0,0,0,.051-.329.15.15,0,0,0,0-.033",
    transform: "translate(21.35 10.478)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9396",
    "data-name": "Caminho 9396",
    d: "M30.019,14.732a.828.828,0,0,1-.077.314c0,.01,0,.031,0,.036a.893.893,0,0,0,.079-.339c0-.012,0-.038,0-.01",
    transform: "translate(21.386 10.514)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9397",
    "data-name": "Caminho 9397",
    d: "M30.146,14.778a.89.89,0,0,1-.223.6c-.007.009,0,.033,0,.038a.941.941,0,0,0,.226-.655c0-.024,0,.012,0,.019",
    transform: "translate(21.372 10.537)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9398",
    "data-name": "Caminho 9398",
    d: "M30.166,14.8c-.036.1-.077.194-.113.291,0,.01,0,.031,0,.036.036-.1.077-.192.113-.291,0-.01,0-.031,0-.036",
    transform: "translate(21.465 10.569)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9399",
    "data-name": "Caminho 9399",
    d: "M30.208,14.766a1.7,1.7,0,0,1-.094.185c-.005.01,0,.033,0,.038a1.484,1.484,0,0,0,.1-.187c0-.01,0-.031,0-.036",
    transform: "translate(21.508 10.547)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9400",
    "data-name": "Caminho 9400",
    d: "M30.306,14.838a1.208,1.208,0,0,1-.233.37c-.007.007.005.034,0,.038a1.233,1.233,0,0,0,.235-.372c0-.009,0-.031,0-.036",
    transform: "translate(21.479 10.599)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9401",
    "data-name": "Caminho 9401",
    d: "M30.273,14.8a.435.435,0,0,1-.043.139c-.005.01,0,.033,0,.038a.465.465,0,0,0,.043-.144l0-.026s0-.014,0-.007",
    transform: "translate(21.591 10.573)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9402",
    "data-name": "Caminho 9402",
    d: "M30.437,14.787a3.721,3.721,0,0,1-.267.415c-.007.009,0,.034,0,.038a3.924,3.924,0,0,0,.269-.417c0-.009,0-.031,0-.036",
    transform: "translate(21.548 10.562)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9403",
    "data-name": "Caminho 9403",
    d: "M30.635,14.576a.366.366,0,0,1-.043.163c0,.01,0,.031,0,.036a.47.47,0,0,0,.045-.226c0-.014,0,.022,0,.027",
    transform: "translate(21.851 10.389)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9404",
    "data-name": "Caminho 9404",
    d: "M30.6,15.128a1.408,1.408,0,0,0,.243-.55l0-.033a1.387,1.387,0,0,1-.24.547c-.007.007,0,.033,0,.036",
    transform: "translate(21.855 10.389)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9405",
    "data-name": "Caminho 9405",
    d: "M30.845,14.557a.344.344,0,0,1-.05.173c-.007.009,0,.033,0,.036a.384.384,0,0,0,.053-.2c0-.012,0-.038,0-.01",
    transform: "translate(21.995 10.389)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9406",
    "data-name": "Caminho 9406",
    d: "M30.493,14.868c-.086.1-.163.2-.242.3-.007.009,0,.033,0,.038.079-.1.156-.2.242-.3.007-.009-.005-.033,0-.038",
    transform: "translate(21.606 10.62)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9407",
    "data-name": "Caminho 9407",
    d: "M30.577,14.9c-.089.127-.182.249-.276.37-.007.009.005.033,0,.038.094-.122.189-.245.278-.372.005-.007,0-.033,0-.036",
    transform: "translate(21.642 10.646)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9408",
    "data-name": "Caminho 9408",
    d: "M30.548,15l-.122.1c-.007.005.005.034,0,.038l.122-.1c.007-.005,0-.034,0-.038",
    transform: "translate(21.731 10.716)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9409",
    "data-name": "Caminho 9409",
    d: "M31.218,14.667a1.1,1.1,0,0,1-.12.132c-.009.007,0,.033,0,.038a1.007,1.007,0,0,0,.122-.134c.005-.007,0-.033,0-.036",
    transform: "translate(22.211 10.476)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9410",
    "data-name": "Caminho 9410",
    d: "M31.194,14.883a.258.258,0,0,0,.089-.209c0-.012,0-.036-.005-.009a.226.226,0,0,1-.084.18c-.007.005,0,.036,0,.038",
    transform: "translate(22.28 10.466)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9411",
    "data-name": "Caminho 9411",
    d: "M30.91,14.955a.191.191,0,0,1-.024.093l0,.024,0,.012a.216.216,0,0,0,.027-.118.057.057,0,0,0,0-.024l0,.014",
    transform: "translate(22.06 10.672)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9412",
    "data-name": "Caminho 9412",
    d: "M30.987,15.289a1.264,1.264,0,0,0,.122-.358c0-.005,0-.041,0-.027a1.344,1.344,0,0,1-.122.35c0,.009,0,.031,0,.036",
    transform: "translate(22.132 10.643)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9413",
    "data-name": "Caminho 9413",
    d: "M31.016,14.9a1.709,1.709,0,0,1-.094.185c-.007.01,0,.033,0,.038a1.476,1.476,0,0,0,.1-.187c0-.01,0-.031,0-.036",
    transform: "translate(22.085 10.646)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9414",
    "data-name": "Caminho 9414",
    d: "M31.152,14.9c0,.1-.079.18-.12.259-.005.01,0,.033,0,.038a.621.621,0,0,0,.122-.307c0-.027,0,0,0,.01",
    transform: "translate(22.164 10.628)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9415",
    "data-name": "Caminho 9415",
    d: "M31.139,15.178a.752.752,0,0,0,.087-.2.129.129,0,0,0,0-.026s0-.014,0-.007a.731.731,0,0,1-.087.194c0,.009,0,.031,0,.036",
    transform: "translate(22.24 10.676)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9416",
    "data-name": "Caminho 9416",
    d: "M31.334,14.678a1.589,1.589,0,0,0-.122.255c0,.01,0,.033,0,.038a1.411,1.411,0,0,1,.122-.257c.005-.009,0-.033,0-.036",
    transform: "translate(22.294 10.484)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9417",
    "data-name": "Caminho 9417",
    d: "M31.439,14.726a.683.683,0,0,1-.094.228c-.005.009,0,.033,0,.036a.656.656,0,0,0,.1-.231.15.15,0,0,0,0-.033",
    transform: "translate(22.388 10.518)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9418",
    "data-name": "Caminho 9418",
    d: "M31.534,14.766a1.08,1.08,0,0,1-.1.247c-.005.009,0,.033,0,.038a1.14,1.14,0,0,0,.1-.249c0-.01,0-.029,0-.036",
    transform: "translate(22.449 10.547)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9419",
    "data-name": "Caminho 9419",
    d: "M31.567,15.115A.361.361,0,0,0,31.6,14.9c0-.022,0-.022,0,0a.3.3,0,0,1-.034.177c-.005.007,0,.033,0,.036",
    transform: "translate(22.546 10.632)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9420",
    "data-name": "Caminho 9420",
    d: "M31.756,14.929a.7.7,0,0,1-.214.382c-.007.007,0,.029,0,.034a.711.711,0,0,0,.218-.4c0-.005,0-.038,0-.017",
    transform: "translate(22.528 10.659)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9421",
    "data-name": "Caminho 9421",
    d: "M31.423,15.013a.619.619,0,0,1-.113.1c-.007,0,0,.036,0,.038a.619.619,0,0,0,.113-.1l0-.019,0-.019",
    transform: "translate(22.363 10.724)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9422",
    "data-name": "Caminho 9422",
    d: "M31.595,15a1.491,1.491,0,0,0-.2.2c-.007.007.005.033,0,.038a1.6,1.6,0,0,1,.2-.2c.007-.005,0-.034,0-.038",
    transform: "translate(22.424 10.712)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9423",
    "data-name": "Caminho 9423",
    d: "M31.953,14.764a.252.252,0,0,1-.007.062l0,.022,0,.014a.316.316,0,0,0,.01-.1l0-.019,0,.019",
    transform: "translate(22.817 10.532)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9424",
    "data-name": "Caminho 9424",
    d: "M32.042,14.711a.353.353,0,0,1-.077.228c-.005.009,0,.034,0,.038a.432.432,0,0,0,.079-.285c0-.024,0,.012,0,.019",
    transform: "translate(22.831 10.489)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9425",
    "data-name": "Caminho 9425",
    d: "M32.173,14.745c-.053.1-.1.2-.147.3,0,.01,0,.033,0,.038.045-.1.094-.2.147-.3,0-.009,0-.031,0-.036",
    transform: "translate(22.875 10.532)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9426",
    "data-name": "Caminho 9426",
    d: "M32.222,14.8a.741.741,0,0,1-.086.261c-.005.009,0,.033,0,.036a.742.742,0,0,0,.087-.269c0-.005,0-.043,0-.027",
    transform: "translate(22.954 10.57)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9427",
    "data-name": "Caminho 9427",
    d: "M32.368,14.838c-.06.115-.122.23-.182.345-.005.009,0,.033,0,.036.06-.115.12-.23.182-.345,0-.009,0-.031,0-.036",
    transform: "translate(22.989 10.599)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9428",
    "data-name": "Caminho 9428",
    d: "M32.426,14.941a1.792,1.792,0,0,1-.173.3c-.007.009.005.033,0,.038a1.817,1.817,0,0,0,.175-.3c0-.009,0-.031,0-.036",
    transform: "translate(23.036 10.672)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9429",
    "data-name": "Caminho 9429",
    d: "M32.55,15.023a2.931,2.931,0,0,1-.25.309c-.009.007,0,.034,0,.039a3.137,3.137,0,0,0,.25-.31c.007-.009-.005-.033,0-.038",
    transform: "translate(23.069 10.731)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9430",
    "data-name": "Caminho 9430",
    d: "M31.966,15.243a.133.133,0,0,0,.081-.058.439.439,0,0,1,.058-.093c.007-.007-.005-.033,0-.038a.338.338,0,0,0-.055.084.127.127,0,0,1-.084.067c-.007,0,0,.038,0,.038",
    transform: "translate(22.831 10.753)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9431",
    "data-name": "Caminho 9431",
    d: "M32.15,15.067a.346.346,0,0,1-.094.182c-.005.007,0,.033,0,.036a.381.381,0,0,0,.1-.207c0-.012,0-.038,0-.01",
    transform: "translate(22.896 10.753)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9432",
    "data-name": "Caminho 9432",
    d: "M32.241,15.1c0,.1-.093.171-.154.238-.007.007,0,.029,0,.033a.426.426,0,0,0,.158-.262c0-.01,0-.033,0-.009",
    transform: "translate(22.918 10.776)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9433",
    "data-name": "Caminho 9433",
    d: "M32.826,14.8c-.015.141-.135.24-.214.348-.007.009,0,.031,0,.038.081-.111.2-.213.216-.358,0-.005,0-.043,0-.027",
    transform: "translate(23.293 10.566)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9434",
    "data-name": "Caminho 9434",
    d: "M32.763,15.114a.694.694,0,0,0,.147-.24c0-.009,0-.031,0-.036a.709.709,0,0,1-.146.238c-.007.007.005.033,0,.038",
    transform: "translate(23.401 10.599)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9435",
    "data-name": "Caminho 9435",
    d: "M33,14.838a1.519,1.519,0,0,1-.182.3c-.005.009,0,.034,0,.038a1.679,1.679,0,0,0,.182-.3c0-.009,0-.031,0-.036",
    transform: "translate(23.44 10.599)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9436",
    "data-name": "Caminho 9436",
    d: "M33.138,14.843a2.979,2.979,0,0,1-.243.283c-.009.007,0,.034,0,.038a2.979,2.979,0,0,0,.243-.283c.005-.009-.007-.033,0-.038",
    transform: "translate(23.494 10.602)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9437",
    "data-name": "Caminho 9437",
    d: "M33.145,14.864a.874.874,0,0,1-.094.213c-.007.009,0,.033,0,.036a.792.792,0,0,0,.1-.213c0-.01,0-.029,0-.036",
    transform: "translate(23.606 10.617)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9438",
    "data-name": "Caminho 9438",
    d: "M33.137,15.085a.836.836,0,0,1-.329.23c-.007,0,0,.038,0,.038a.836.836,0,0,0,.329-.23c.007-.009-.005-.031,0-.038",
    transform: "translate(23.432 10.775)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9439",
    "data-name": "Caminho 9439",
    d: "M32.687,15.206a.715.715,0,0,1,.182-.089c.007,0,0-.036,0-.038a.716.716,0,0,0-.182.089c-.007.005,0,.034,0,.038",
    transform: "translate(23.346 10.771)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9440",
    "data-name": "Caminho 9440",
    d: "M33.2,15.085a.551.551,0,0,1-.216.185c-.007,0,0,.036,0,.038a.531.531,0,0,0,.216-.187c.007-.009,0-.033,0-.036",
    transform: "translate(23.555 10.775)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9441",
    "data-name": "Caminho 9441",
    d: "M31.686,14.441a.358.358,0,0,1-.216.149v.038a.357.357,0,0,0,.218-.151c.005-.009,0-.033,0-.036",
    transform: "translate(22.479 10.315)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9442",
    "data-name": "Caminho 9442",
    d: "M29.621,14.65a.393.393,0,0,1-.137.319c-.007.007,0,.033,0,.038a.444.444,0,0,0,.139-.389.149.149,0,0,0,0,.033",
    transform: "translate(21.058 10.441)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9443",
    "data-name": "Caminho 9443",
    d: "M27.508,14.265a2.914,2.914,0,0,1-.346.2c-.007,0,0,.036,0,.038a2.91,2.91,0,0,0,.346-.2c.007-.005,0-.034,0-.038",
    transform: "translate(19.4 10.189)",
    fill: "#99afca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9444",
    "data-name": "Caminho 9444",
    d: "M27.173,14.234a1,1,0,0,1-.267.221c-.009,0,0,.036,0,.038a1,1,0,0,0,.267-.221c.007-.007-.005-.033,0-.038",
    transform: "translate(19.216 10.167)",
    fill: "#99afca"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_862",
    "data-name": "Grupo 862",
    transform: "translate(46.617 24.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_861",
    "data-name": "Grupo 861",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_559",
    "data-name": "Ret\\xE2ngulo 559",
    width: 9.861,
    height: 9.242,
    transform: "matrix(1, -0.005, 0.005, 1, -0.043, -0.001)",
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_870",
    "data-name": "Grupo 870",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_869",
    "data-name": "Grupo 869",
    clipPath: "url(#clip-path-3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9446",
    "data-name": "Caminho 9446",
    d: "M29.441,14.312c-.153.139-.312.267-.473.394-.1.077-.2.153-.3.221s-.243.125-.362.194c-.067.038-.183.1-.185.189s.122.118.173.147c.142.077.288.144.43.219.213.113-.158.149-.175.233v.017a5.823,5.823,0,0,1,.924.247c.036.019.1.065.077.117s-.07.06-.091.1a.052.052,0,0,0,0,.039.381.381,0,0,0,.141.135,1.362,1.362,0,0,0,.355.173.453.453,0,0,1,.216.177,1.206,1.206,0,0,0,.247.2.816.816,0,0,1,.094.094c.045.041.13.036.185.039a2.184,2.184,0,0,1,.35.038c.079.017.153.045.23.069a2.6,2.6,0,0,0,.444.086,2.194,2.194,0,0,0,.351.029.336.336,0,0,0,.123-.017v-.019l-.005,0v.019a.453.453,0,0,0,.123-.026l.279-.062.281-.062a.653.653,0,0,1,.137-.029v-.019a1.168,1.168,0,0,1-.336.075c-.159.031-.321.06-.478.1a1.078,1.078,0,0,0-.326.2c-.062.046-.123.093-.183.141-.029.022-.057.039-.055.079s.118.057.153.065a1.518,1.518,0,0,1,.29.12,1.353,1.353,0,0,0,.489.1c.158.017.307.041.463.07a3.863,3.863,0,0,0,.487.027,2.212,2.212,0,0,0,.261.014c.161-.01.324-.031.485-.029a3.278,3.278,0,0,0,.389-.033.972.972,0,0,1,.307.019.242.242,0,0,1,.084.027c-.007-.005.009-.009-.015,0a.662.662,0,0,1-.1,0,1.2,1.2,0,0,0-.549.154,1.02,1.02,0,0,0-.163.123,1.266,1.266,0,0,0-.259.228c-.132.207.473.3.583.334a2.594,2.594,0,0,0,.566.147,1.342,1.342,0,0,1,.41.084c.079.031.158.06.237.084s.175.024.259.05a1.567,1.567,0,0,1,.194.111.344.344,0,0,0,.247.027.186.186,0,0,1,.206.057c.036.045.062.129.13.118a.456.456,0,0,1,.153.01c.031.009.067.038.077.009L37,19.789a3.625,3.625,0,0,1-.214.4,9.4,9.4,0,0,1-.8,1.26,5.565,5.565,0,0,1-1.061,1A7.12,7.12,0,0,1,33.9,23.1a3.272,3.272,0,0,1-1.166.293,8.38,8.38,0,0,1-1.538-.038,3.177,3.177,0,0,1-1.311-.441,7.091,7.091,0,0,1-1.9-1.719,4.929,4.929,0,0,1-.725-1.243c-.019-.046-.036-.093-.051-.141l-.012-.033,0-.007c.009.029.024.019.055.015a4.2,4.2,0,0,0,.6-.1.842.842,0,0,0,.255-.091.878.878,0,0,1,.25-.1,2.544,2.544,0,0,0,.422-.127c.036-.015.077-.039.075-.084s-.127-.082-.063-.1a.5.5,0,0,1,.151.007,1.022,1.022,0,0,1,.3.033.438.438,0,0,0,.156.019c.027,0,.132-.01.142-.039.024-.063-.038-.134-.06-.19s-.017-.081-.084-.087c-.021,0-.038-.026-.057-.036s-.048-.015-.07-.026c-.06-.022-.11-.065-.17-.086a.585.585,0,0,0-.108-.015.984.984,0,0,1-.324-.1,1.2,1.2,0,0,0-.307-.1c-.065-.017-.13-.021-.2-.036-.129-.029-.254-.077-.384-.108v.019c.041,0,.29.065.29.024,0-.015-.012-.022-.024-.033-.048-.045.139-.033.153-.033.087,0,.175-.005.261-.007a.629.629,0,0,0,.271-.05c.036-.019.278.115.276.012,0-.026-.012-.065.019-.069s.094.033.129.045a.5.5,0,0,0,.225-.01,1.342,1.342,0,0,1,.185-.01.262.262,0,0,0,.127-.014.686.686,0,0,1,.1-.063c.13-.053.007-.111-.065-.13-.041-.01-.075-.057-.106-.082a.691.691,0,0,0-.13-.093,1.594,1.594,0,0,0-.367-.1c-.345-.091-.693-.17-1.037-.262v.021c.123.033.249.06.374.084a2.959,2.959,0,0,0,.523.038c.079,0,.159.024.238.022a1.674,1.674,0,0,0,.2-.019.458.458,0,0,0,.228-.06.537.537,0,0,1,.267-.091c.045-.007.235-.012.242-.077a.051.051,0,0,0-.021-.048,1.4,1.4,0,0,0-.3-.144c-.1-.053-.139-.192-.221-.269a1.572,1.572,0,0,0-.266-.166,3.265,3.265,0,0,1-.278-.209c-.043-.034-.218-.159-.159-.216s.159-.062.226-.1c.034-.022.005-.053-.021-.063a2.513,2.513,0,0,0-.375-.1.954.954,0,0,1-.418-.2c-.11-.106.166-.123.166-.219,0-.022-.021-.033-.036-.046a2.19,2.19,0,0,0-.2-.132c-.062-.041-.125-.079-.189-.117-.017-.01-.034-.019-.05-.029-.065-.043,0-.151.036-.189a.744.744,0,0,1,.252-.141c.1-.046.2-.091.293-.139a2.618,2.618,0,0,0,.435-.317c.135-.106.269-.214.4-.322v-.019q-.288.231-.578.461a1.549,1.549,0,0,1-.261.177c-.089.045-.18.087-.269.129a.987.987,0,0,0-.276.153c-.039.038-.1.161-.045.218a.606.606,0,0,0,.127.079c.075.046.151.093.225.142.022.015.141.077.113.111a.565.565,0,0,1-.17.1c-.017.009-.015.046-.014.062.005.05.06.084.1.11a1.276,1.276,0,0,0,.447.168c.065.017.13.031.2.046a.3.3,0,0,1,.115.043.967.967,0,0,1-.178.086c-.038.014-.075.031-.077.075a.139.139,0,0,0,.053.094,1.773,1.773,0,0,0,.23.2,2.138,2.138,0,0,0,.257.177.652.652,0,0,1,.252.2.893.893,0,0,0,.089.127.444.444,0,0,0,.153.1c.057.027.115.05.17.079.079.038.021.069-.034.084a1.979,1.979,0,0,0-.374.089.571.571,0,0,1-.125.063,2.063,2.063,0,0,1-.307.041c-.082.005-.158-.017-.24-.017s-.151,0-.226,0a2.807,2.807,0,0,1-.711-.127v.021c.257.067.513.137.771.2a4.093,4.093,0,0,1,.609.149,2.092,2.092,0,0,1,.245.18.631.631,0,0,0,.1.033c.084.038-.033.072-.065.089s-.036.033-.057.046a.335.335,0,0,1-.149.009,1.152,1.152,0,0,0-.171.014.5.5,0,0,1-.231,0c-.031-.01-.127-.074-.129-.005a.179.179,0,0,0,0,.043c.005.045-.086.026-.108.024-.055-.007-.129-.058-.178-.034a.713.713,0,0,1-.274.043c-.1,0-.2.009-.293.005-.033,0-.153-.009-.113.06a.123.123,0,0,0,.026.026c.009.007.005-.005,0,0a.181.181,0,0,1-.043,0c-.079-.007-.156-.029-.235-.036v.019a3.533,3.533,0,0,0,.429.117,1.762,1.762,0,0,1,.415.108,2.733,2.733,0,0,0,.333.118c.046.012.1.01.144.024.075.021.141.079.218.1a.214.214,0,0,1,.065.039c.036.026.058-.01.084.041s.033.1.057.142c.036.07-.01.077-.069.093a.376.376,0,0,1-.2-.009,1.014,1.014,0,0,0-.279-.033c-.024,0-.214-.043-.211.024,0,.014,0,.012.009.024a.277.277,0,0,0,.067.043c.051.031-.043.079-.055.084a1.089,1.089,0,0,1-.319.1c-.075.015-.151.041-.225.063-.1.033-.19.1-.3.137a2.292,2.292,0,0,1-.343.07,3.127,3.127,0,0,1-.4.057v.019a5.1,5.1,0,0,0,1.149,1.845,5.622,5.622,0,0,0,2.2,1.6,2.96,2.96,0,0,0,.689.137q.409.041.818.051a4.9,4.9,0,0,0,1.332-.122,3.74,3.74,0,0,0,1.039-.489A7.058,7.058,0,0,0,35.5,22a4.905,4.905,0,0,0,.681-.778c.2-.288.374-.6.549-.9.082-.141.163-.283.237-.427a.683.683,0,0,0,.043-.1v-.019a.423.423,0,0,0-.23-.036c-.067.01-.1-.074-.13-.118a.189.189,0,0,0-.206-.058.354.354,0,0,1-.247-.027c-.069-.029-.125-.084-.194-.111a.386.386,0,0,0-.11-.015.781.781,0,0,1-.149-.034c-.12-.034-.231-.089-.351-.118-.177-.041-.36-.038-.533-.086s-.363-.122-.552-.163a.956.956,0,0,1-.262-.1.656.656,0,0,1-.07-.05c-.086-.072.024-.153.081-.2a2.308,2.308,0,0,1,.454-.319,1.235,1.235,0,0,1,.273-.063.8.8,0,0,1,.111-.019.59.59,0,0,0,.146-.009c.007,0,0-.019,0-.024-.007-.036-.158-.046-.182-.05a4.416,4.416,0,0,0-.542.031c-.1,0-.2.005-.3.012a1.672,1.672,0,0,1-.423.014,2.849,2.849,0,0,0-.453-.021c-.158-.01-.31-.07-.468-.079a2.368,2.368,0,0,1-.514-.072,1.639,1.639,0,0,1-.209-.1,1.2,1.2,0,0,0-.171-.062c-.039-.01-.2-.029-.108-.1.139-.106.276-.221.425-.314a.6.6,0,0,1,.173-.057c.1-.024.2-.043.3-.063s.192-.036.286-.057a.554.554,0,0,0,.153-.039v-.019a.453.453,0,0,0-.123.026l-.278.062-.283.062a.478.478,0,0,1-.137.029v.019l.005,0v-.019a.367.367,0,0,1-.1.015,2.06,2.06,0,0,1-.37-.027,3.05,3.05,0,0,1-.446-.086c-.069-.021-.135-.046-.206-.065a1.8,1.8,0,0,0-.372-.041.351.351,0,0,1-.178-.036c-.038-.026-.063-.07-.1-.1a1.783,1.783,0,0,1-.237-.189.544.544,0,0,0-.228-.189,1.679,1.679,0,0,1-.331-.159.9.9,0,0,1-.111-.084.357.357,0,0,1-.034-.038c-.029-.033.012-.06.036-.082.221-.214-.4-.315-.5-.339-.127-.029-.255-.057-.382-.087l-.067-.017c-.017-.005.081-.045.086-.046.053-.019.151-.05.163-.115s-.159-.134-.211-.159a2.278,2.278,0,0,1-.458-.25c-.1-.089.365-.3.41-.322a2.2,2.2,0,0,0,.327-.223c.2-.146.386-.3.566-.465v-.019",
    transform: "translate(19.424 10.202)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9447",
    "data-name": "Caminho 9447",
    d: "M26.834,14.492a1.144,1.144,0,0,1-.156.185c-.007.007.005.033,0,.038a1.1,1.1,0,0,0,.158-.187c.005-.009,0-.033,0-.036",
    transform: "translate(19.054 10.351)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9448",
    "data-name": "Caminho 9448",
    d: "M26.853,14.539a1.163,1.163,0,0,0-.094.177c-.005.01,0,.031,0,.038a1.113,1.113,0,0,1,.1-.178c.005-.009,0-.033,0-.036",
    transform: "translate(19.112 10.385)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9449",
    "data-name": "Caminho 9449",
    d: "M29.285,16.158c.067-.046.127-.026.2-.007a.278.278,0,0,0,.182-.021v-.019a.277.277,0,0,1-.182.019c-.074-.015-.132-.039-.2.009v.019",
    transform: "translate(20.918 11.507)",
    fill: "#4f91c5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9450",
    "data-name": "Caminho 9450",
    d: "M29.348,16.211c.017-.043.081-.033.117-.033V16.16c-.038,0-.1-.012-.117.033v.019",
    transform: "translate(20.963 11.542)",
    fill: "#4f91c5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9451",
    "data-name": "Caminho 9451",
    d: "M29.227,16.127a.481.481,0,0,1,.225-.046v-.019a.46.46,0,0,0-.225.046v.019",
    transform: "translate(20.876 11.473)",
    fill: "#4f91c5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9452",
    "data-name": "Caminho 9452",
    d: "M29.169,16.242c-.158-.069-.321.048-.48-.019v.019c.159.067.322-.05.48.019v-.019",
    transform: "translate(20.492 11.586)",
    fill: "#4f91c5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9453",
    "data-name": "Caminho 9453",
    d: "M28.894,16.256c-.094-.043-.185.033-.283,0v.021c.1.033.189-.043.283,0v-.019",
    transform: "translate(20.436 11.601)",
    fill: "#4f91c5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9454",
    "data-name": "Caminho 9454",
    d: "M28.777,16.3c-.07-.057-.183-.007-.266-.009v.019c.082,0,.2-.048.266.009V16.3",
    transform: "translate(20.365 11.627)",
    fill: "#4f91c5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9455",
    "data-name": "Caminho 9455",
    d: "M29.074,18.658a.323.323,0,0,1-.3-.024c-.084-.087-.171-.039-.279-.027v.019c.089-.009.2-.063.267.014a.31.31,0,0,0,.309.038v-.019",
    transform: "translate(20.356 13.274)",
    fill: "#4f91c5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9456",
    "data-name": "Caminho 9456",
    d: "M28.081,17.355c.154-.089.309.027.47-.019v-.019c-.161.046-.315-.07-.47.019v.019",
    transform: "translate(20.058 12.358)",
    fill: "#4f91c5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9457",
    "data-name": "Caminho 9457",
    d: "M27.309,17.554a.266.266,0,0,1,.185-.014,1.291,1.291,0,0,0,.18.057,2.856,2.856,0,0,0,.48-.043v-.019a4.544,4.544,0,0,1-.48.043.734.734,0,0,1-.18-.057.248.248,0,0,0-.185.014v.019",
    transform: "translate(19.506 12.506)",
    fill: "#4f91c5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9458",
    "data-name": "Caminho 9458",
    d: "M27.4,17.659c.177-.07.363,0,.543-.038V17.6c-.18.041-.367-.031-.543.039v.019",
    transform: "translate(19.573 12.572)",
    fill: "#4f91c5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9459",
    "data-name": "Caminho 9459",
    d: "M28.272,17.283a1.091,1.091,0,0,1,.459-.019v-.019a1.092,1.092,0,0,0-.459.019v.019",
    transform: "translate(20.194 12.307)",
    fill: "#4f91c5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9460",
    "data-name": "Caminho 9460",
    d: "M28.562,17.18a.908.908,0,0,1,.273,0v-.019a.855.855,0,0,0-.273,0v.019",
    transform: "translate(20.401 12.249)",
    fill: "#4f91c5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9461",
    "data-name": "Caminho 9461",
    d: "M27.621,17.96c.192-.108.4.067.591-.048v-.019c-.187.115-.4-.06-.591.048v.019",
    transform: "translate(19.729 12.781)",
    fill: "#4f91c5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9462",
    "data-name": "Caminho 9462",
    d: "M27.714,18.051c.127-.027.255-.048.384-.067v-.019c-.129.019-.257.039-.384.067v.019",
    transform: "translate(19.796 12.832)",
    fill: "#4f91c5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9463",
    "data-name": "Caminho 9463",
    d: "M27.955,17.788c.123-.069.285.012.384-.106v-.019c-.1.118-.262.038-.384.106v.019",
    transform: "translate(19.968 12.616)",
    fill: "#4f91c5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9464",
    "data-name": "Caminho 9464",
    d: "M28.316,18.177c.139-.106.317,0,.459-.086v-.019c-.142.089-.321-.021-.459.086v.019",
    transform: "translate(20.226 12.909)",
    fill: "#4f91c5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9465",
    "data-name": "Caminho 9465",
    d: "M28.289,17.947a.782.782,0,0,1,.281-.022c.089.022.158.082.254.081v-.021a.578.578,0,0,1-.228-.07.6.6,0,0,0-.307.014v.019",
    transform: "translate(20.206 12.784)",
    fill: "#4f91c5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9466",
    "data-name": "Caminho 9466",
    d: "M28.344,18.589a.592.592,0,0,1,.42-.029c.134.031.216.084.319-.038V18.5c-.1.115-.192.079-.319.038a.55.55,0,0,0-.42.029v.019",
    transform: "translate(20.246 13.216)",
    fill: "#4f91c5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9467",
    "data-name": "Caminho 9467",
    d: "M29.11,18.366a.758.758,0,0,0,.435-.043.925.925,0,0,1,.235-.069,1.479,1.479,0,0,1,.23.015v-.019c-.077-.005-.153-.017-.23-.015a.755.755,0,0,0-.235.069.757.757,0,0,1-.435.043v.019",
    transform: "translate(20.793 13.026)",
    fill: "#4f91c5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9468",
    "data-name": "Caminho 9468",
    d: "M29.717,18.294a1.582,1.582,0,0,1,.369-.045c.127.012.228.079.353.015v-.019c-.11.057-.206.014-.319-.009a1.147,1.147,0,0,0-.4.038v.019",
    transform: "translate(21.226 13.021)",
    fill: "#4f91c5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9469",
    "data-name": "Caminho 9469",
    d: "M30.3,18.273c.243-.091.423.127.657.144V18.4c-.233-.017-.413-.235-.657-.144v.019",
    transform: "translate(21.641 13.023)",
    fill: "#4f91c5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9470",
    "data-name": "Caminho 9470",
    d: "M30.839,18.3a.582.582,0,0,1,.321.007.444.444,0,0,0,.327-.036V18.25a.453.453,0,0,1-.327.036.6.6,0,0,0-.321-.007V18.3",
    transform: "translate(22.028 13.036)",
    fill: "#4f91c5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9471",
    "data-name": "Caminho 9471",
    d: "M31.294,18.39a2.035,2.035,0,0,1,.543-.115v-.019a2.035,2.035,0,0,0-.543.115v.019",
    transform: "translate(22.353 13.04)",
    fill: "#4f91c5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9472",
    "data-name": "Caminho 9472",
    d: "M30.538,18.731a.312.312,0,0,1,.279-.051c.1.014.2.039.274-.034v-.019a.279.279,0,0,1-.252.038.336.336,0,0,0-.3.048v.019",
    transform: "translate(21.813 13.304)",
    fill: "#4f91c5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9473",
    "data-name": "Caminho 9473",
    d: "M30.61,18.872c.139-.115.317-.065.468-.144v-.019c-.151.079-.329.029-.468.144v.019",
    transform: "translate(21.864 13.364)",
    fill: "#4f91c5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9474",
    "data-name": "Caminho 9474",
    d: "M31.622,18.557a4.041,4.041,0,0,0,.478-.019v-.019a4.45,4.45,0,0,1-.478.019v.019",
    transform: "translate(22.587 13.228)",
    fill: "#4f91c5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9475",
    "data-name": "Caminho 9475",
    d: "M31.655,18.678a.421.421,0,0,1,.18-.053c.057,0,.111.009.168.005v-.019c-.057,0-.111,0-.168-.005a.378.378,0,0,0-.18.053v.019",
    transform: "translate(22.611 13.29)",
    fill: "#4f91c5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9476",
    "data-name": "Caminho 9476",
    d: "M31.852,18.446c.051-.055.132-.033.2-.048v-.019c-.067.014-.146-.007-.2.048v.019",
    transform: "translate(22.751 13.128)",
    fill: "#4f91c5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9477",
    "data-name": "Caminho 9477",
    d: "M29.225,18.666a.416.416,0,0,1,.307-.072.417.417,0,0,0,.322-.1v-.019a.41.41,0,0,1-.322.1.414.414,0,0,0-.307.072v.019",
    transform: "translate(20.875 13.196)",
    fill: "#4f91c5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9478",
    "data-name": "Caminho 9478",
    d: "M29.279,18.684c.147-.115.331-.021.5-.067V18.6c-.166.046-.35-.048-.5.067v.019",
    transform: "translate(20.914 13.284)",
    fill: "#4f91c5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9479",
    "data-name": "Caminho 9479",
    d: "M29.153,18.466c.216-.12.487.127.675-.067V18.38c-.189.192-.459-.055-.675.067v.019",
    transform: "translate(20.824 13.129)",
    fill: "#4f91c5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9480",
    "data-name": "Caminho 9480",
    d: "M29.575,18.99c.089-.067.139-.033.235-.01a1.664,1.664,0,0,0,.413.039V19a1.748,1.748,0,0,1-.379-.031c-.106-.022-.171-.072-.269,0v.019",
    transform: "translate(21.125 13.523)",
    fill: "#4f91c5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9481",
    "data-name": "Caminho 9481",
    d: "M29.575,19.075c.17-.123.379.069.562.038v-.019c-.183.031-.393-.161-.562-.038v.019",
    transform: "translate(21.125 13.582)",
    fill: "#4f91c5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9482",
    "data-name": "Caminho 9482",
    d: "M28.951,17.256c.175-.127.358.036.543-.029v-.019c-.185.065-.369-.1-.543.029v.019",
    transform: "translate(20.679 12.276)",
    fill: "#4f91c5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9483",
    "data-name": "Caminho 9483",
    d: "M29.011,17.3c.118-.031.238.021.357-.01v-.019c-.118.031-.238-.021-.357.01V17.3",
    transform: "translate(20.722 12.333)",
    fill: "#4f91c5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9484",
    "data-name": "Caminho 9484",
    d: "M28.448,17.855a.984.984,0,0,1,.441-.048v-.019a.984.984,0,0,0-.441.048v.019",
    transform: "translate(20.32 12.704)",
    fill: "#4f91c5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9485",
    "data-name": "Caminho 9485",
    d: "M31.518,18.034c.1-.123.279-.089.422-.106v-.019c-.142.017-.317-.019-.422.106v.019",
    transform: "translate(22.513 12.792)",
    fill: "#4f91c5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9486",
    "data-name": "Caminho 9486",
    d: "M31.266,18.219c.173-.17.391-.024.591-.106v-.019c-.2.082-.418-.063-.591.106v.019",
    transform: "translate(22.333 12.924)",
    fill: "#4f91c5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9487",
    "data-name": "Caminho 9487",
    d: "M28.792,18.4c.111-.147.276-.1.432-.144v-.019c-.156.041-.321,0-.432.144V18.4",
    transform: "translate(20.566 13.024)",
    fill: "#4f91c5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9488",
    "data-name": "Caminho 9488",
    d: "M32.308,17.5a.967.967,0,0,1,.3-.039.528.528,0,0,0,.291-.026v-.019a.5.5,0,0,1-.291.026.918.918,0,0,0-.3.039V17.5",
    transform: "translate(23.077 12.439)",
    fill: "#4f91c5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9489",
    "data-name": "Caminho 9489",
    d: "M32.262,17.609a1.351,1.351,0,0,1,.2-.021.344.344,0,0,0,.156-.057v-.021a.372.372,0,0,1-.141.058c-.074.01-.146.005-.219.021v.019",
    transform: "translate(23.044 12.508)",
    fill: "#4f91c5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9490",
    "data-name": "Caminho 9490",
    d: "M32.1,17.393c.127-.058.322.075.413-.065v-.017c-.091.137-.288.005-.413.063v.019",
    transform: "translate(22.927 12.365)",
    fill: "#4f91c5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9491",
    "data-name": "Caminho 9491",
    d: "M32.4,17.658a.554.554,0,0,1,.2-.041.294.294,0,0,0,.18-.019v-.019a.294.294,0,0,1-.18.019.485.485,0,0,0-.2.041v.019",
    transform: "translate(23.141 12.556)",
    fill: "#4f91c5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9492",
    "data-name": "Caminho 9492",
    d: "M31.843,17.36c.122-.141.336.075.48-.019v-.019c-.144.094-.358-.122-.48.019v.019",
    transform: "translate(22.745 12.352)",
    fill: "#4f91c5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9493",
    "data-name": "Caminho 9493",
    d: "M31.7,17.367c.043-.07.137-.048.207-.053a.322.322,0,0,0,.192-.106v-.021a.334.334,0,0,1-.192.108c-.072.009-.163-.019-.207.053v.019",
    transform: "translate(22.642 12.276)",
    fill: "#4f91c5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9494",
    "data-name": "Caminho 9494",
    d: "M29.576,16.394c.115-.057.231.01.35-.019v-.019c-.118.029-.235-.038-.35.019v.019",
    transform: "translate(21.126 11.679)",
    fill: "#4f91c5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9495",
    "data-name": "Caminho 9495",
    d: "M29.66,16.459c.058-.05.13,0,.194-.033v-.019c-.063.029-.135-.017-.194.033v.019",
    transform: "translate(21.186 11.72)",
    fill: "#4f91c5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9496",
    "data-name": "Caminho 9496",
    d: "M31.175,18.406c.063-.007.134.027.194-.005v-.019c-.06.033-.13,0-.194.005v.019",
    transform: "translate(22.268 13.13)",
    fill: "#4f91c5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9497",
    "data-name": "Caminho 9497",
    d: "M28.687,16.681a.513.513,0,0,0-.291-.027c-.065.017-.062.082-.142.058v.019c.074.022.084-.031.142-.057a.44.44,0,0,1,.291.026v-.019",
    transform: "translate(20.181 11.888)",
    fill: "#4f91c5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9498",
    "data-name": "Caminho 9498",
    d: "M28.686,16.74c-.165-.075-.339-.01-.513-.027v.019c.173.017.348-.048.513.027V16.74",
    transform: "translate(20.124 11.93)",
    fill: "#4f91c5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9499",
    "data-name": "Caminho 9499",
    d: "M28.581,16.843c-.084-.029-.165-.072-.25-.1s-.207-.031-.307-.053v.019c.091.021.182.033.274.045a1.708,1.708,0,0,1,.283.106v-.019",
    transform: "translate(20.017 11.923)",
    fill: "#4f91c5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9500",
    "data-name": "Caminho 9500",
    d: "M28.14,17.856c.115-.147.286-.045.441-.079v-.019c-.154.034-.326-.069-.441.079v.019",
    transform: "translate(20.1 12.682)",
    fill: "#4f91c5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9501",
    "data-name": "Caminho 9501",
    d: "M28.142,17.9a.446.446,0,0,1,.171-.06,1.245,1.245,0,0,1,.17.046v-.019c-.058-.009-.111-.038-.17-.046s-.12.036-.171.06V17.9",
    transform: "translate(20.101 12.727)",
    fill: "#4f91c5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9502",
    "data-name": "Caminho 9502",
    d: "M28.2,18.035a.1.1,0,0,1,.113-.027c.038.014.069.029.106.009V18a.123.123,0,0,1-.106-.009.094.094,0,0,0-.113.027v.019",
    transform: "translate(20.145 12.843)",
    fill: "#4f91c5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9503",
    "data-name": "Caminho 9503",
    d: "M28.247,17.693a.129.129,0,0,1,.127-.005.132.132,0,0,0,.129.005v-.019a.129.129,0,0,1-.12,0,.136.136,0,0,0-.135,0v.019",
    transform: "translate(20.176 12.611)",
    fill: "#4f91c5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9504",
    "data-name": "Caminho 9504",
    d: "M27.985,17.655c.074-.019.132.024.2.034.057.009.118-.029.173-.039v-.019a.766.766,0,0,1-.173.039c-.075,0-.127-.053-.2-.034v.019",
    transform: "translate(19.989 12.594)",
    fill: "#4f91c5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9505",
    "data-name": "Caminho 9505",
    d: "M28.617,18.278c.091-.1.221-.015.327-.069v-.019c-.106.053-.237-.027-.327.069v.019",
    transform: "translate(20.441 12.994)",
    fill: "#4f91c5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9506",
    "data-name": "Caminho 9506",
    d: "M29.785,18.349c.122-.074.25-.022.382-.022v-.019c-.132,0-.261-.051-.382.022v.019",
    transform: "translate(21.275 13.065)",
    fill: "#4f91c5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9507",
    "data-name": "Caminho 9507",
    d: "M30.278,18.325c.154-.057.278.091.432.06v-.019c-.154.031-.278-.117-.432-.06v.019",
    transform: "translate(21.627 13.067)",
    fill: "#4f91c5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9508",
    "data-name": "Caminho 9508",
    d: "M30.9,18.339c.125-.022.312.1.413-.009v-.019c-.1.106-.288-.014-.413.009v.019",
    transform: "translate(22.071 13.08)",
    fill: "#4f91c5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9509",
    "data-name": "Caminho 9509",
    d: "M31.332,18.435c.046-.093.142-.053.223-.045a.331.331,0,0,0,.266-.06v-.019a.378.378,0,0,1-.295.058c-.077-.009-.153-.038-.194.046v.019",
    transform: "translate(22.38 13.08)",
    fill: "#4f91c5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9510",
    "data-name": "Caminho 9510",
    d: "M29.313,18.4a.78.78,0,0,0,.23-.065c.086-.029.177,0,.261-.036v-.019a1.354,1.354,0,0,1-.235.029,1.668,1.668,0,0,1-.255.072V18.4",
    transform: "translate(20.938 13.056)",
    fill: "#4f91c5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9511",
    "data-name": "Caminho 9511",
    d: "M29.641,18.836c.13-.151.331,0,.485-.1v-.019c-.154.093-.355-.057-.485.1v.019",
    transform: "translate(21.172 13.372)",
    fill: "#4f91c5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9512",
    "data-name": "Caminho 9512",
    d: "M29.746,18.862c.123-.045.322.031.413-.087v-.019c-.091.118-.29.043-.413.087v.019",
    transform: "translate(21.247 13.397)",
    fill: "#4f91c5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9513",
    "data-name": "Caminho 9513",
    d: "M30.427,19.159a.315.315,0,0,1,.319-.084,1,1,0,0,0,.427.024V19.08a.929.929,0,0,1-.394-.017.333.333,0,0,0-.351.077v.019",
    transform: "translate(21.734 13.604)",
    fill: "#4f91c5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9514",
    "data-name": "Caminho 9514",
    d: "M30.462,19.171a.336.336,0,0,1,.245-.06v-.019a.336.336,0,0,0-.245.06v.019",
    transform: "translate(21.759 13.635)",
    fill: "#4f91c5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9515",
    "data-name": "Caminho 9515",
    d: "M29.009,18.24c.06-.077.175-.031.255-.067v-.019c-.081.036-.2-.01-.255.067v.019",
    transform: "translate(20.721 12.967)",
    fill: "#4f91c5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9516",
    "data-name": "Caminho 9516",
    d: "M29.265,18.256c.019-.108.171-.051.24-.1v-.019c-.072.046-.221-.012-.242.1l0,.017",
    transform: "translate(20.902 12.958)",
    fill: "#4f91c5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9517",
    "data-name": "Caminho 9517",
    d: "M29.879,18.177a1.279,1.279,0,0,0-.182-.022.959.959,0,0,0-.2.06v.019a1.464,1.464,0,0,1,.2-.06.824.824,0,0,1,.182.022v-.019",
    transform: "translate(21.066 12.967)",
    fill: "#4f91c5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9518",
    "data-name": "Caminho 9518",
    d: "M29.879,18.2a.745.745,0,0,1,.247-.009.77.77,0,0,0,.211.038v-.019a.565.565,0,0,1-.182-.033.713.713,0,0,0-.276,0V18.2",
    transform: "translate(21.342 12.976)",
    fill: "#4f91c5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9519",
    "data-name": "Caminho 9519",
    d: "M30.393,18.234c.106-.012.216.022.305-.051v-.021c-.089.075-.2.041-.305.053v.019",
    transform: "translate(21.709 12.973)",
    fill: "#4f91c5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9520",
    "data-name": "Caminho 9520",
    d: "M30.728,18.232c.171-.18.415.009.619-.051v-.019c-.2.06-.447-.129-.619.051v.019",
    transform: "translate(21.949 12.952)",
    fill: "#4f91c5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9521",
    "data-name": "Caminho 9521",
    d: "M28.555,18.239a.791.791,0,0,1,.269-.1v-.019a.791.791,0,0,0-.269.1v.019",
    transform: "translate(20.396 12.946)",
    fill: "#4f91c5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9522",
    "data-name": "Caminho 9522",
    d: "M30.245,18.259c.069-.1.185-.1.291-.134v-.019c-.106.029-.223.034-.291.134v.019",
    transform: "translate(21.604 12.933)",
    fill: "#4f91c5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9523",
    "data-name": "Caminho 9523",
    d: "M31.14,18.2c.069-.07.166-.055.255-.074v-.019c-.089.019-.187,0-.255.074V18.2",
    transform: "translate(22.243 12.934)",
    fill: "#4f91c5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9524",
    "data-name": "Caminho 9524",
    d: "M31.386,18.1a.389.389,0,0,1,.211-.051v-.019a.389.389,0,0,0-.211.051V18.1",
    transform: "translate(22.419 12.881)",
    fill: "#4f91c5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9525",
    "data-name": "Caminho 9525",
    d: "M31.386,18a.661.661,0,0,0,.2-.074V17.9a.661.661,0,0,1-.2.074V18",
    transform: "translate(22.419 12.788)",
    fill: "#4f91c5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9526",
    "data-name": "Caminho 9526",
    d: "M28.381,18.009a.95.95,0,0,1,.24-.022v-.019a.949.949,0,0,0-.24.022v.019",
    transform: "translate(20.272 12.832)",
    fill: "#4f91c5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9527",
    "data-name": "Caminho 9527",
    d: "M26.4,14.737s.66-.062.629.055.031.115.209.115.662-.065.711.017.516-.034.694-.067.307-.033.4-.05.274-.065.274,0a1.018,1.018,0,0,0,.05.214.764.764,0,0,0,.355.182c.146,0,.194.05.226.1s0,.149.129.115a.805.805,0,0,0,.322-.082c.307-.115.178-.015.259-.082a.355.355,0,0,1,.324-.082c.144.033.257.1.307.082a.463.463,0,0,1,.37.05,1.857,1.857,0,0,0,.614.149c.178.015.274.05.372,0a1.123,1.123,0,0,1,.387-.05c.065,0-.065-.034.307.015s.4.05.453,0a.6.6,0,0,1,.242-.1c.065-.017.1-.1.161-.067s.226.1.357.165a1.232,1.232,0,0,0,.612.067c.178-.033.065-.017.357.05a2.235,2.235,0,0,0,.5.082c.113,0,.519-.05.519-.05l-.149-.034c-.177-.149-.1-.015-.435-.2a1.576,1.576,0,0,0-.694-.231c-.5-.115-.387-.214-.549-.312s-.178,0-.357,0-.113-.117-.531-.43-.387-.23-.55-.362-.5-.346-.677-.513-.55-.125-.711-.132c-.358-.012-.494-.36-.807-.29-.141.031-.387-.189-.742-.271s-.694.214-.953.379a10.749,10.749,0,0,0-1.147.759,4.206,4.206,0,0,1-1.217.66,2.149,2.149,0,0,1-.612.113",
    transform: "translate(18.856 9.129)",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9528",
    "data-name": "Caminho 9528",
    d: "M26.4,14.737s.66-.062.629.055.031.115.209.115.662-.065.711.017.516-.034.694-.067.307-.033.4-.05.274-.065.274,0a1.018,1.018,0,0,0,.05.214.764.764,0,0,0,.355.182c.146,0,.194.05.226.1s0,.149.129.115a.805.805,0,0,0,.322-.082c.307-.115.178-.015.259-.082a.355.355,0,0,1,.324-.082c.144.033.257.1.307.082a.463.463,0,0,1,.37.05,1.857,1.857,0,0,0,.614.149c.178.015.274.05.372,0a1.123,1.123,0,0,1,.387-.05c.065,0-.065-.034.307.015s.4.05.453,0a.6.6,0,0,1,.242-.1c.065-.017.1-.1.161-.067s.226.1.357.165a1.232,1.232,0,0,0,.612.067c.178-.033.065-.017.357.05a2.235,2.235,0,0,0,.5.082c.113,0,.519-.05.519-.05l-.149-.034c-.177-.149-.1-.015-.435-.2a1.576,1.576,0,0,0-.694-.231c-.5-.115-.387-.214-.549-.312s-.178,0-.357,0-.113-.117-.531-.43-.387-.23-.55-.362-.5-.346-.677-.513-.55-.125-.711-.132c-.358-.012-.494-.36-.807-.29-.141.031-.387-.189-.742-.271s-.694.214-.953.379a10.749,10.749,0,0,0-1.147.759,4.206,4.206,0,0,1-1.217.66,2.149,2.149,0,0,1-.612.113",
    transform: "translate(18.856 9.129)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9529",
    "data-name": "Caminho 9529",
    d: "M28.829,13.235a.621.621,0,0,1-.146.065v.039a.562.562,0,0,0,.146-.067c.007-.005,0-.036,0-.038",
    transform: "translate(20.488 9.454)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9530",
    "data-name": "Caminho 9530",
    d: "M30.255,13.447c-.171.093-.3.242-.468.346-.007.005,0,.036,0,.038.165-.1.3-.254.468-.346.007,0,0-.036,0-.038",
    transform: "translate(21.275 9.605)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9531",
    "data-name": "Caminho 9531",
    d: "M30.206,13.3a1.067,1.067,0,0,1-.331.319c-.007,0,0,.036,0,.038a1.079,1.079,0,0,0,.333-.321c.005-.007,0-.033,0-.036",
    transform: "translate(21.338 9.501)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9532",
    "data-name": "Caminho 9532",
    d: "M30.08,13.231a.533.533,0,0,1-.213.129V13.4a.533.533,0,0,0,.213-.129c.007-.007-.005-.034,0-.038",
    transform: "translate(21.334 9.451)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9533",
    "data-name": "Caminho 9533",
    d: "M30.127,13.291a1.1,1.1,0,0,1-.307.262c-.007,0,0,.038,0,.038a1.069,1.069,0,0,0,.307-.262c.007-.007-.005-.033,0-.038",
    transform: "translate(21.298 9.494)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9534",
    "data-name": "Caminho 9534",
    d: "M30.154,13.578c-.089.115-.144.259-.283.319-.007,0,0,.038,0,.039.139-.062.194-.2.283-.321.005-.009-.007-.031,0-.038",
    transform: "translate(21.335 9.699)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9535",
    "data-name": "Caminho 9535",
    d: "M30.062,13.738c-.051.06-.093.137-.17.166v.038c.077-.029.118-.106.17-.166.007-.009-.005-.033,0-.038",
    transform: "translate(21.351 9.813)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9536",
    "data-name": "Caminho 9536",
    d: "M30.014,13.88c.074.053.108.144.182.2,0,0,.007-.034,0-.039-.074-.053-.108-.144-.182-.2,0,0-.007.033,0,.038",
    transform: "translate(21.437 9.887)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9537",
    "data-name": "Caminho 9537",
    d: "M30.109,14.108a.66.66,0,0,1,.087.1l0-.019,0-.019a.582.582,0,0,0-.087-.1l0,.019,0,.019",
    transform: "translate(21.505 10.05)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9538",
    "data-name": "Caminho 9538",
    d: "M28.811,13.428a1.141,1.141,0,0,1-.345.255c-.007,0,0,.038,0,.038a1.142,1.142,0,0,0,.345-.255c.007-.007-.005-.033,0-.038",
    transform: "translate(20.331 9.591)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9539",
    "data-name": "Caminho 9539",
    d: "M28.8,13.6a1.565,1.565,0,0,1-.543.281c-.007,0,0,.038,0,.038a1.523,1.523,0,0,0,.543-.281c.007-.007,0-.034,0-.038",
    transform: "translate(20.18 9.711)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9540",
    "data-name": "Caminho 9540",
    d: "M28.564,13.764a.693.693,0,0,1-.35.3V14.1a.7.7,0,0,0,.351-.3c.005-.007,0-.033,0-.036",
    transform: "translate(20.153 9.831)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9541",
    "data-name": "Caminho 9541",
    d: "M28.014,13.839a1.594,1.594,0,0,1-.281.153c-.007,0,0,.038,0,.039a1.6,1.6,0,0,0,.281-.154c.007-.005,0-.036,0-.038",
    transform: "translate(19.807 9.885)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9542",
    "data-name": "Caminho 9542",
    d: "M27.817,13.8c-.024.007-.046.017-.069.026-.007,0,0,.038,0,.038.022-.009.045-.019.069-.026V13.8",
    transform: "translate(19.818 9.858)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9543",
    "data-name": "Caminho 9543",
    d: "M28.637,13.943a1.446,1.446,0,0,0-.137.089c-.009.005,0,.036,0,.038.045-.031.089-.062.137-.089.007,0,0-.036,0-.038",
    transform: "translate(20.355 9.959)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9544",
    "data-name": "Caminho 9544",
    d: "M29.664,13.988a1.6,1.6,0,0,0-.194.1c-.007,0,0,.036,0,.038a1.9,1.9,0,0,1,.194-.1c.007,0,0-.036,0-.038",
    transform: "translate(21.048 9.991)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9545",
    "data-name": "Caminho 9545",
    d: "M29.887,13.943a.3.3,0,0,0-.106.11l0,.022,0,.014a.305.305,0,0,1,.106-.108c.007,0,0-.036,0-.038",
    transform: "translate(21.271 9.959)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_865",
    "data-name": "Grupo 865",
    transform: "translate(45.793 25.909)",
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_864",
    "data-name": "Grupo 864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_863",
    "data-name": "Grupo 863",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9546",
    "data-name": "Caminho 9546",
    d: "M27.425,16.439a.408.408,0,0,0,.043.259s.007-.029,0-.038a.291.291,0,0,1-.039-.194c0-.005,0-.043,0-.027",
    transform: "translate(-26.205 -14.17)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9547",
    "data-name": "Caminho 9547",
    d: "M27.429,16.661c-.029-.046-.082-.11-.079-.168,0-.007,0-.043,0-.021a.367.367,0,0,0,.081.225s.007-.027,0-.036",
    transform: "translate(-26.259 -14.148)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9548",
    "data-name": "Caminho 9548",
    d: "M27.384,16.744a.773.773,0,0,1-.158-.439c0-.022,0,.014,0,.021a.792.792,0,0,0,.161.456c-.005-.005.007-.029,0-.038",
    transform: "translate(-26.348 -14.268)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9549",
    "data-name": "Caminho 9549",
    d: "M27.527,16.585a.177.177,0,0,1-.026-.046l0,.012,0,.024a.218.218,0,0,0,.027.048l0-.019,0-.019",
    transform: "translate(-26.151 -14.095)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9550",
    "data-name": "Caminho 9550",
    d: "M27.582,16.585a.07.07,0,0,1-.039-.026l0,.012,0,.024a.065.065,0,0,0,.039.027s.007-.036,0-.038",
    transform: "translate(-26.121 -14.081)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9551",
    "data-name": "Caminho 9551",
    d: "M27.2,16.676a.871.871,0,0,1-.065-.351c0-.022,0,.014,0,.021a.889.889,0,0,0,.067.367s.007-.027,0-.036",
    transform: "translate(-26.411 -14.253)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9552",
    "data-name": "Caminho 9552",
    d: "M27.255,15.943c0,.067.027.209-.058.231v.039c.093-.026.063-.2.062-.271,0-.022,0-.022,0,0",
    transform: "translate(-26.366 -14.533)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9553",
    "data-name": "Caminho 9553",
    d: "M27.148,16.141a.2.2,0,0,0,.041-.069.112.112,0,0,0,0-.024l0-.012a.177.177,0,0,1-.039.067l0,.019,0,.019",
    transform: "translate(-26.403 -14.455)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9554",
    "data-name": "Caminho 9554",
    d: "M27.245,16.174c.055-.038.048-.108.048-.168,0-.022,0-.022,0,0,0,.051,0,.1-.045.13-.007.005,0,.036,0,.038",
    transform: "translate(-26.334 -14.488)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9555",
    "data-name": "Caminho 9555",
    d: "M27.6,16.01a.441.441,0,0,1,.005.165c0,.022,0,.022,0,0a.525.525,0,0,0-.007-.2c0,.005-.005.026,0,.036",
    transform: "translate(-26.079 -14.499)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9556",
    "data-name": "Caminho 9556",
    d: "M27.287,16.195c.072-.045.074-.149.06-.225l0,.033a.148.148,0,0,1-.058.154c-.007,0,0,.036,0,.038",
    transform: "translate(-26.304 -14.502)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9557",
    "data-name": "Caminho 9557",
    d: "M27.57,16.137a.145.145,0,0,0,.021-.081.111.111,0,0,0,0-.024l0,.014a.111.111,0,0,1-.019.055v.022l0,.014",
    transform: "translate(-26.101 -14.458)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9558",
    "data-name": "Caminho 9558",
    d: "M27.419,15.934c.033.081-.012.189-.021.274,0,0,0,.041,0,.026a.724.724,0,0,0,.021-.336c0,.005-.005.026,0,.036",
    transform: "translate(-26.223 -14.553)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9559",
    "data-name": "Caminho 9559",
    d: "M27.633,16.126V16.05l0-.019,0,.019v.075l0,.019,0-.019",
    transform: "translate(-26.057 -14.458)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9560",
    "data-name": "Caminho 9560",
    d: "M28.043,16.228a.26.26,0,0,0,.041-.182c0-.022,0-.022,0,0a.2.2,0,0,1-.038.144c-.007.007.005.033,0,.038",
    transform: "translate(-25.764 -14.46)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9561",
    "data-name": "Caminho 9561",
    d: "M27.431,16.218a.46.46,0,0,0,.079-.281c0-.005,0-.043,0-.019a.454.454,0,0,1-.079.262c-.009.009,0,.033,0,.038",
    transform: "translate(-26.201 -14.544)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9562",
    "data-name": "Caminho 9562",
    d: "M27.329,16.242c.118-.039.069-.259.055-.348l0,.033c.015.086.055.243-.051.278v.038",
    transform: "translate(-26.272 -14.556)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9563",
    "data-name": "Caminho 9563",
    d: "M27.52,16a.167.167,0,0,1-.051.134c-.007.005,0,.034,0,.038a.188.188,0,0,0,.055-.153c0-.005,0-.043,0-.019",
    transform: "translate(-26.174 -14.485)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9564",
    "data-name": "Caminho 9564",
    d: "M27.64,16.137a.076.076,0,0,0,.029-.062l0-.024,0,.014a.066.066,0,0,1-.026.034l0,.019,0,.019",
    transform: "translate(-26.051 -14.444)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9565",
    "data-name": "Caminho 9565",
    d: "M27.52,16.226a.47.47,0,0,0,.082-.279c0-.012,0-.036-.005-.009a.405.405,0,0,1-.077.25c-.007.009.005.031,0,.038",
    transform: "translate(-26.137 -14.534)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9566",
    "data-name": "Caminho 9566",
    d: "M27.109,16.11a.038.038,0,0,0,.014-.022l0-.027s0-.014,0-.007a.036.036,0,0,1-.012.019l0,.019,0,.019",
    transform: "translate(-26.431 -14.443)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9567",
    "data-name": "Caminho 9567",
    d: "M27.305,16.669a.828.828,0,0,1-.118-.305c0,.007-.005.026,0,.038a.8.8,0,0,0,.12.305c-.005-.005.007-.029,0-.038",
    transform: "translate(-26.375 -14.22)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9568",
    "data-name": "Caminho 9568",
    d: "M27.143,16.572a.633.633,0,0,1-.053-.108l0,.012a.113.113,0,0,0,0,.024.7.7,0,0,0,.053.108l0-.012,0-.024",
    transform: "translate(-26.444 -14.149)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9569",
    "data-name": "Caminho 9569",
    d: "M27.623,16.529a.335.335,0,0,0,.014.072l0-.012a.057.057,0,0,0,0-.024.377.377,0,0,1-.014-.063h0a.074.074,0,0,0,0,.027",
    transform: "translate(-26.063 -14.122)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9570",
    "data-name": "Caminho 9570",
    d: "M28,16.952a.285.285,0,0,0,.053.113l0-.014,0-.022a.319.319,0,0,1-.053-.1h0v.027",
    transform: "translate(-25.791 -13.82)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9571",
    "data-name": "Caminho 9571",
    d: "M28.025,17.065a.219.219,0,0,1-.06-.115.28.28,0,0,0,0,.038.219.219,0,0,0,.06.115s.007-.031,0-.038",
    transform: "translate(-25.819 -13.802)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9572",
    "data-name": "Caminho 9572",
    d: "M30.2,16.227a.379.379,0,0,0,.12-.2c0-.01,0-.031,0-.038a.376.376,0,0,1-.118.2c-.007.005,0,.036,0,.038",
    transform: "translate(-24.22 -14.486)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9573",
    "data-name": "Caminho 9573",
    d: "M30.3,16.3a.793.793,0,0,0,.048-.456c0-.022,0,.014,0,.021a.689.689,0,0,1-.046.4c-.005.009,0,.033,0,.036",
    transform: "translate(-24.151 -14.598)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9574",
    "data-name": "Caminho 9574",
    d: "M32.359,16.408v-.087l0-.021,0,.021v.087l0,.019,0-.019",
    transform: "translate(-22.682 -14.266)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9575",
    "data-name": "Caminho 9575",
    d: "M32.583,16.416a.349.349,0,0,0,.007-.084l0-.019,0,.019a.263.263,0,0,1-.005.051.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-22.521 -14.257)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9576",
    "data-name": "Caminho 9576",
    d: "M32.4,16.553a.968.968,0,0,0,.067-.334c0-.007,0-.043,0-.019a.919.919,0,0,1-.065.317c0,.009,0,.031,0,.036",
    transform: "translate(-22.654 -14.344)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9577",
    "data-name": "Caminho 9577",
    d: "M32.525,16.49c0-.077.012-.154.014-.231,0-.021,0-.021,0,0,0,.077-.014.154-.014.231,0,.022,0,.022,0,0",
    transform: "translate(-22.563 -14.307)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9578",
    "data-name": "Caminho 9578",
    d: "M32.47,16.572a1.715,1.715,0,0,0,.081-.434c0-.012,0-.038,0-.01a1.591,1.591,0,0,1-.079.408c0,.01,0,.029,0,.036",
    transform: "translate(-22.601 -14.398)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9579",
    "data-name": "Caminho 9579",
    d: "M32.312,16.432c0-.036.007-.072.007-.108l0-.019,0,.019c0,.036-.007.072-.007.108l0,.019,0-.019",
    transform: "translate(-22.715 -14.263)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9580",
    "data-name": "Caminho 9580",
    d: "M32.424,16.575a2.354,2.354,0,0,0,.046-.382c0-.007,0-.036,0-.033a2.177,2.177,0,0,1-.046.379c0,.01,0,.029,0,.036",
    transform: "translate(-22.634 -14.366)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9581",
    "data-name": "Caminho 9581",
    d: "M32.374,16.492A.984.984,0,0,0,32.4,16.3c0-.012,0-.036,0-.009a.909.909,0,0,1-.026.165.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-22.67 -14.279)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9582",
    "data-name": "Caminho 9582",
    d: "M32.459,16.481c0-.07.012-.141.014-.213,0-.012,0-.036,0-.01,0,.075-.014.149-.014.223,0,.022,0,.022,0,0",
    transform: "translate(-22.61 -14.305)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9583",
    "data-name": "Caminho 9583",
    d: "M30.254,16.239a.46.46,0,0,0,.094-.273c0-.012,0-.036,0-.009a.438.438,0,0,1-.091.243c-.007.009.005.031,0,.038",
    transform: "translate(-24.184 -14.519)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9584",
    "data-name": "Caminho 9584",
    d: "M30.158,16.2c.019-.038.039-.074.06-.108l0-.024,0-.014c-.021.036-.041.072-.06.11v.022l0,.014",
    transform: "translate(-24.253 -14.443)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9585",
    "data-name": "Caminho 9585",
    d: "M30.363,16.147a1.122,1.122,0,0,0,.007-.153l0-.019,0,.019a.921.921,0,0,1-.005.12.064.064,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-24.107 -14.498)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9586",
    "data-name": "Caminho 9586",
    d: "M30.452,16.192c.026-.1.041-.2.06-.307a.141.141,0,0,0,0-.033c-.019.1-.034.2-.06.3,0,.01,0,.029,0,.036",
    transform: "translate(-24.043 -14.586)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9587",
    "data-name": "Caminho 9587",
    d: "M30.519,16.091c0-.058.007-.118.007-.177,0-.021,0-.021,0,0,0,.058-.007.118-.007.177,0,.022,0,.022,0,0",
    transform: "translate(-23.996 -14.553)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9588",
    "data-name": "Caminho 9588",
    d: "M30.58,16.131a1.451,1.451,0,0,0,.062-.321c0-.007,0-.043,0-.019a1.323,1.323,0,0,1-.06.3c0,.01,0,.029,0,.036",
    transform: "translate(-23.951 -14.635)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9589",
    "data-name": "Caminho 9589",
    d: "M30.665,16.08a.544.544,0,0,0,.053-.221c0-.005,0-.043,0-.027a.513.513,0,0,1-.053.213c-.005.009,0,.033,0,.036",
    transform: "translate(-23.891 -14.603)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9590",
    "data-name": "Caminho 9590",
    d: "M30.735,16.1a.483.483,0,0,0,.067-.228c0-.005,0-.043,0-.027a.5.5,0,0,1-.067.219c-.005.009,0,.033,0,.036",
    transform: "translate(-23.841 -14.592)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9591",
    "data-name": "Caminho 9591",
    d: "M30.851,16.062A.478.478,0,0,0,31,15.831c0-.01,0-.031,0-.036a.508.508,0,0,1-.146.23c-.007.007,0,.034,0,.038",
    transform: "translate(-23.758 -14.627)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9592",
    "data-name": "Caminho 9592",
    d: "M31.01,16.089a.551.551,0,0,0,.055-.293c0-.007,0-.043,0-.021a.512.512,0,0,1-.053.278c-.005.007,0,.033,0,.036",
    transform: "translate(-23.645 -14.646)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9593",
    "data-name": "Caminho 9593",
    d: "M31.1,16.022a.242.242,0,0,0,.108-.225c0-.012,0-.036,0-.01a.219.219,0,0,1-.1.2c-.007,0,0,.036,0,.038",
    transform: "translate(-23.579 -14.641)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9594",
    "data-name": "Caminho 9594",
    d: "M30.933,16.009a.561.561,0,0,1,.005-.093l0-.026s0-.014,0-.007a.765.765,0,0,0-.007.125l0,.019,0-.019",
    transform: "translate(-23.7 -14.565)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9595",
    "data-name": "Caminho 9595",
    d: "M30.7,16.069a.831.831,0,0,1,.005-.113l0-.026s0-.014,0-.007a1.04,1.04,0,0,0-.007.146l0,.019,0-.019",
    transform: "translate(-23.868 -14.537)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9596",
    "data-name": "Caminho 9596",
    d: "M30.583,16.148a.26.26,0,0,0,.055-.175c0-.005,0-.043,0-.027a.242.242,0,0,1-.051.165c-.007.007.005.034,0,.038",
    transform: "translate(-23.949 -14.522)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9597",
    "data-name": "Caminho 9597",
    d: "M30.529,16.155a.439.439,0,0,0,.027-.189c0-.021,0-.021,0,0a.358.358,0,0,1-.026.153c0,.009,0,.031,0,.036",
    transform: "translate(-23.988 -14.515)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9598",
    "data-name": "Caminho 9598",
    d: "M30.457,16.15v-.094l0-.019,0,.019v.094l0,.019,0-.019",
    transform: "translate(-24.04 -14.454)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9599",
    "data-name": "Caminho 9599",
    d: "M30.386,16.267a2.464,2.464,0,0,0,.1-.307c0-.009,0-.036,0-.033a2.72,2.72,0,0,1-.1.3c-.005.01,0,.031,0,.036",
    transform: "translate(-24.09 -14.533)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9600",
    "data-name": "Caminho 9600",
    d: "M30.785,16.107a.664.664,0,0,0,.053-.223s0-.041,0-.026a.616.616,0,0,1-.053.213c0,.009,0,.031,0,.036",
    transform: "translate(-23.805 -14.584)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9601",
    "data-name": "Caminho 9601",
    d: "M30.866,16.013l.021-.048a.049.049,0,0,0,0-.022l0-.014a.293.293,0,0,1-.021.048V16l0,.014",
    transform: "translate(-23.747 -14.531)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9602",
    "data-name": "Caminho 9602",
    d: "M30.975,16.094A.577.577,0,0,0,31,15.77c0-.014,0,.022,0,.027a.435.435,0,0,1-.019.261c0,.009,0,.033,0,.036",
    transform: "translate(-23.67 -14.647)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9603",
    "data-name": "Caminho 9603",
    d: "M31.068,16.1a.89.89,0,0,0,.067-.341c0-.007,0-.043,0-.019a.841.841,0,0,1-.065.324c0,.009,0,.031,0,.036",
    transform: "translate(-23.603 -14.672)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9604",
    "data-name": "Caminho 9604",
    d: "M30.117,16a.578.578,0,0,0-.026.187c0,.007,0-.007,0-.007a.144.144,0,0,0,0-.027c-.005-.021.01-.05.015-.07a.307.307,0,0,0,.01-.055c0-.005,0-.043,0-.027",
    transform: "translate(-24.301 -14.486)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9605",
    "data-name": "Caminho 9605",
    d: "M30.107,16.218c.012-.05.021-.1.033-.149,0-.01,0-.031,0-.036-.014.048-.022.1-.034.149,0,.01,0,.029,0,.036",
    transform: "translate(-24.289 -14.457)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9606",
    "data-name": "Caminho 9606",
    d: "M30.492,16.094v-.075l0-.019,0,.019v.075l0,.019,0-.019",
    transform: "translate(-24.015 -14.48)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9607",
    "data-name": "Caminho 9607",
    d: "M30.653,16.1a.845.845,0,0,0-.034-.183c0,.007,0,.026,0,.038a.681.681,0,0,1,.033.156c0,.026,0,0,0-.01",
    transform: "translate(-23.924 -14.543)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9608",
    "data-name": "Caminho 9608",
    d: "M30.812,16.109a.688.688,0,0,0,.081-.254l0-.033a.682.682,0,0,1-.081.25c-.005.009,0,.033,0,.036",
    transform: "translate(-23.786 -14.607)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9609",
    "data-name": "Caminho 9609",
    d: "M31.424,16.669a1.753,1.753,0,0,0,.1-.225c0-.01,0-.031,0-.036a1.631,1.631,0,0,1-.1.225c0,.009,0,.031,0,.036",
    transform: "translate(-23.349 -14.189)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9610",
    "data-name": "Caminho 9610",
    d: "M31.559,16.66a.458.458,0,0,0,.108-.233l0-.033a.424.424,0,0,1-.1.228c-.007.009.005.033,0,.038",
    transform: "translate(-23.252 -14.199)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9611",
    "data-name": "Caminho 9611",
    d: "M31.672,16.666a.41.41,0,0,0,.087-.327.15.15,0,0,0,0,.033.344.344,0,0,1-.086.257c-.007.009.005.033,0,.038",
    transform: "translate(-23.171 -14.239)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9612",
    "data-name": "Caminho 9612",
    d: "M31.777,16.663a.666.666,0,0,0,.034-.384c0-.015,0,.021,0,.026a.531.531,0,0,1-.033.322c0,.009,0,.031,0,.036",
    transform: "translate(-23.097 -14.284)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9613",
    "data-name": "Caminho 9613",
    d: "M31.513,16.472c.009.027.033.067,0,.084-.007.005,0,.038,0,.039.026-.014.024-.045.022-.07a.4.4,0,0,0-.021-.089c0,.005-.005.026,0,.036",
    transform: "translate(-23.285 -14.169)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9614",
    "data-name": "Caminho 9614",
    d: "M31.606,16.609a.228.228,0,0,0,.036-.154l0-.019,0,.019a.165.165,0,0,1-.031.117c-.007.007.005.033,0,.038",
    transform: "translate(-23.219 -14.169)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9615",
    "data-name": "Caminho 9615",
    d: "M31.73,16.59a.414.414,0,0,0,.034-.163c0-.012,0-.036,0-.01a.35.35,0,0,1-.033.137c0,.009,0,.031,0,.036",
    transform: "translate(-23.13 -14.191)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9616",
    "data-name": "Caminho 9616",
    d: "M31.479,16.574a.338.338,0,0,1,.005-.072l0-.026s0-.014,0-.007a.535.535,0,0,0-.007.1l0,.019,0-.019",
    transform: "translate(-23.31 -14.146)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9617",
    "data-name": "Caminho 9617",
    d: "M31.37,16.621a.411.411,0,0,1,.026-.093.057.057,0,0,0,0-.024l0-.014a.4.4,0,0,0-.027.1.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-23.388 -14.13)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9618",
    "data-name": "Caminho 9618",
    d: "M31.71,16.326c0,.075-.048.144-.026.219,0-.005.005-.026,0-.036-.01-.033.01-.074.019-.106a.3.3,0,0,0,.009-.067c0-.012,0-.038,0-.01",
    transform: "translate(-23.165 -14.256)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9619",
    "data-name": "Caminho 9619",
    d: "M31.563,16.47a.635.635,0,0,1-.005-.1l0-.019,0,.019a.843.843,0,0,0,.007.132c0,.007,0-.005,0-.007a.065.065,0,0,0,0-.026",
    transform: "translate(-23.254 -14.229)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9620",
    "data-name": "Caminho 9620",
    d: "M31.645,16.511l.021-.142v-.026s0-.015,0-.007c-.005.046-.012.094-.019.142a.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-23.191 -14.242)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9621",
    "data-name": "Caminho 9621",
    d: "M31.588,16.48a.271.271,0,0,1,.012-.091l0-.022,0-.014a.4.4,0,0,0-.014.127l0,.019,0-.019",
    transform: "translate(-23.232 -14.228)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9622",
    "data-name": "Caminho 9622",
    d: "M31.774,16.461a.47.47,0,0,0-.007-.1c0-.007,0,.005,0,.007a.129.129,0,0,0,0,.026.28.28,0,0,1,.007.065l0,.019,0-.019",
    transform: "translate(-23.105 -14.223)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9623",
    "data-name": "Caminho 9623",
    d: "M31.637,16.58a.232.232,0,0,0,.021-.1.113.113,0,0,0,0-.024l0,.014a.169.169,0,0,1-.019.075v.022l0,.014",
    transform: "translate(-23.196 -14.155)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9624",
    "data-name": "Caminho 9624",
    d: "M31.521,16.466c0-.029-.007-.058-.007-.087l0-.014a.05.05,0,0,0,0,.022c0,.031.007.06.007.089l0,.014a.057.057,0,0,0,0-.024",
    transform: "translate(-23.285 -14.22)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9625",
    "data-name": "Caminho 9625",
    d: "M32.788,17.081c.021-.146.141-.249.166-.394a.149.149,0,0,0,0-.033c-.027.146-.146.249-.166.394a.149.149,0,0,0,0,.033",
    transform: "translate(-22.374 -14.013)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9626",
    "data-name": "Caminho 9626",
    d: "M32.843,16.931a.133.133,0,0,1,.045-.1c.007-.007,0-.034,0-.038a.162.162,0,0,0-.048.129c0,.012,0,.038,0,.01",
    transform: "translate(-22.336 -13.915)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9627",
    "data-name": "Caminho 9627",
    d: "M32.741,16.951a.3.3,0,0,1,.072-.1l0-.019,0-.019a.294.294,0,0,0-.072.1l0,.022,0,.014",
    transform: "translate(-22.408 -13.9)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9628",
    "data-name": "Caminho 9628",
    d: "M32.885,16.976a1.186,1.186,0,0,0,.041-.255c0-.005,0-.043,0-.027a1.091,1.091,0,0,1-.039.247c0,.01,0,.029,0,.036",
    transform: "translate(-22.305 -13.988)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9629",
    "data-name": "Caminho 9629",
    d: "M32.717,16.867l-.005-.009h0v.027l.009.019,0-.019,0-.019",
    transform: "translate(-22.43 -13.868)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9630",
    "data-name": "Caminho 9630",
    d: "M32.9,17.082a.715.715,0,0,0,.087-.459c0-.015,0,.022,0,.027a.6.6,0,0,1-.086.4c-.005.009,0,.033,0,.036",
    transform: "translate(-22.292 -14.038)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9631",
    "data-name": "Caminho 9631",
    d: "M32.555,16.462a.569.569,0,0,0-.007-.187c0-.007,0,.007,0,.007l0,.027a.435.435,0,0,1,.007.125c0,.005,0,.043,0,.027",
    transform: "translate(-22.546 -14.286)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9632",
    "data-name": "Caminho 9632",
    d: "M32.939,17.025a.876.876,0,0,0,.067-.365s0-.041,0-.026a.833.833,0,0,1-.067.355c-.005.009,0,.033,0,.036",
    transform: "translate(-22.267 -14.03)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9633",
    "data-name": "Caminho 9633",
    d: "M32.152,16.884a.153.153,0,0,0,.007.079l0-.014a.051.051,0,0,0,0-.022l-.005-.015v-.027c0-.007,0-.007,0,0",
    transform: "translate(-22.829 -13.853)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9634",
    "data-name": "Caminho 9634",
    d: "M29.964,16.133A.364.364,0,0,0,30.1,15.9c0-.01,0-.031,0-.036a.362.362,0,0,1-.132.23c-.007.005,0,.036,0,.038",
    transform: "translate(-24.392 -14.576)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9635",
    "data-name": "Caminho 9635",
    d: "M32.115,16.959a.148.148,0,0,0-.01-.072V16.9c0,.007,0,.017,0,.024a.088.088,0,0,1,.005.036l0,.019,0-.019",
    transform: "translate(-22.862 -13.847)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9636",
    "data-name": "Caminho 9636",
    d: "M32.188,17v-.17c0-.022,0-.022,0,0V17c0,.022,0,.022,0,0",
    transform: "translate(-22.803 -13.9)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9637",
    "data-name": "Caminho 9637",
    d: "M30.007,15.859c-.007.081-.01.178-.086.225-.007.005,0,.036,0,.038.079-.048.081-.153.087-.235,0-.005,0-.043,0-.027",
    transform: "translate(-24.422 -14.584)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9638",
    "data-name": "Caminho 9638",
    d: "M30.123,16.314a1.064,1.064,0,0,0,.074-.372c0-.014,0-.038,0-.01a1,1,0,0,1-.072.346c0,.01,0,.031,0,.036",
    transform: "translate(-24.278 -14.539)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9639",
    "data-name": "Caminho 9639",
    d: "M29.886,16.051a.246.246,0,0,0,.026-.062.05.05,0,0,0,0-.022l0-.014a.283.283,0,0,1-.027.062v.022l0,.014",
    transform: "translate(-24.447 -14.514)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9640",
    "data-name": "Caminho 9640",
    d: "M30.058,16.146V16.1l0-.019,0,.019v.048l0,.019,0-.019",
    transform: "translate(-24.325 -14.424)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9641",
    "data-name": "Caminho 9641",
    d: "M29.854,16.025l.014-.007,0-.019,0-.019-.014.007v.038",
    transform: "translate(-24.468 -14.494)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9642",
    "data-name": "Caminho 9642",
    d: "M32.087,15.676a.125.125,0,0,1,.015-.07l0-.022,0-.014a.19.19,0,0,0-.019.106l0,.019,0-.019",
    transform: "translate(-22.876 -14.788)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9643",
    "data-name": "Caminho 9643",
    d: "M32.73,15.7a.448.448,0,0,1,.015-.1l0-.024,0-.012a.482.482,0,0,0-.019.132l0,.019,0-.019",
    transform: "translate(-22.416 -14.787)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9644",
    "data-name": "Caminho 9644",
    d: "M32.408,15.849a1.529,1.529,0,0,0,.053-.441c0-.022,0-.022,0,0a1.4,1.4,0,0,1-.051.4c0,.01,0,.029,0,.036",
    transform: "translate(-22.646 -14.915)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9645",
    "data-name": "Caminho 9645",
    d: "M32.329,15.706v-.1l0-.021,0,.021v.1l0,.019,0-.019",
    transform: "translate(-22.703 -14.773)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9646",
    "data-name": "Caminho 9646",
    d: "M32.588,15.712a.208.208,0,0,0-.009-.117l0,.014a.113.113,0,0,0,0,.024.076.076,0,0,1,.01.043.049.049,0,0,0,0,.022l0,.014",
    transform: "translate(-22.524 -14.77)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9647",
    "data-name": "Caminho 9647",
    d: "M32.258,15.761c0-.089.017-.178.026-.267,0-.005,0-.043,0-.027-.009.1-.024.2-.026.295,0,.022,0,.022,0,0",
    transform: "translate(-22.753 -14.864)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9648",
    "data-name": "Caminho 9648",
    d: "M32.493,15.759a.5.5,0,0,0,.053-.225c0-.005,0-.041,0-.027a.465.465,0,0,1-.05.216c-.007.009,0,.033,0,.036",
    transform: "translate(-22.585 -14.835)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9649",
    "data-name": "Caminho 9649",
    d: "M32.147,15.72c.009-.046.009-.094.017-.141a.065.065,0,0,0,0-.026s0-.015,0-.007c-.009.046-.009.094-.017.141a.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-22.833 -14.806)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9650",
    "data-name": "Caminho 9650",
    d: "M32.368,15.719a.667.667,0,0,0,.01-.13l0-.019,0,.019a.47.47,0,0,1-.007.1.064.064,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-22.675 -14.788)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9651",
    "data-name": "Caminho 9651",
    d: "M32.277,15.8a1.923,1.923,0,0,0,.1-.293l0-.033a1.622,1.622,0,0,1-.1.29c0,.01,0,.031,0,.036",
    transform: "translate(-22.74 -14.857)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9652",
    "data-name": "Caminho 9652",
    d: "M32.2,15.657a.145.145,0,0,1-.024-.075l0-.012a.049.049,0,0,0,0,.022.186.186,0,0,0,.026.1l0-.012,0-.024",
    transform: "translate(-22.811 -14.788)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9653",
    "data-name": "Caminho 9653",
    d: "M32.463,15.69c.007-.017.01-.036.017-.053l0-.022,0-.014c-.009.017-.01.036-.017.053l0,.022,0,.014",
    transform: "translate(-22.606 -14.765)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9654",
    "data-name": "Caminho 9654",
    d: "M32.678,15.581a.217.217,0,0,1,.009.123l0,.026s0,.015,0,.007a.347.347,0,0,0-.009-.192s-.007.026,0,.036",
    transform: "translate(-22.453 -14.805)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9655",
    "data-name": "Caminho 9655",
    d: "M32.523,15.721a.148.148,0,0,0,.051-.089.049.049,0,0,0,0-.022l0-.014a.149.149,0,0,1-.051.087l0,.019,0,.019",
    transform: "translate(-22.563 -14.769)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9656",
    "data-name": "Caminho 9656",
    d: "M32.647,15.829a.478.478,0,0,0-.017-.351s-.007.029,0,.036a.367.367,0,0,1,.017.283.149.149,0,0,0,0,.033",
    transform: "translate(-22.488 -14.853)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9657",
    "data-name": "Caminho 9657",
    d: "M32.423,15.754a1.726,1.726,0,0,1,.043-.225c0-.01,0-.029,0-.036a2.157,2.157,0,0,0-.045.233c0,.005,0,.043,0,.027",
    transform: "translate(-22.636 -14.843)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9658",
    "data-name": "Caminho 9658",
    d: "M32.213,15.722v-.177c0-.021,0-.021,0,0v.177c0,.022,0,.022,0,0",
    transform: "translate(-22.786 -14.816)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9659",
    "data-name": "Caminho 9659",
    d: "M32.106,15.674a.084.084,0,0,0,.01-.055l0-.019,0,.019-.007.017,0,.019,0,.019",
    transform: "translate(-22.861 -14.766)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9660",
    "data-name": "Caminho 9660",
    d: "M32.629,15.714a1.087,1.087,0,0,0-.01-.183c0-.007,0,.005,0,.007v.026a.89.89,0,0,1,.009.151c0,.022,0,.022,0,0",
    transform: "translate(-22.495 -14.817)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9661",
    "data-name": "Caminho 9661",
    d: "M32.739,15.677a.155.155,0,0,0,.01-.062l0-.019,0,.019a.076.076,0,0,1-.009.026v.022l0,.014",
    transform: "translate(-22.409 -14.769)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9662",
    "data-name": "Caminho 9662",
    d: "M32.233,15.741a1.826,1.826,0,0,1-.009-.216c0-.021-.005-.021-.005,0,0,.082,0,.163.009.243,0,.014.005-.022.005-.027",
    transform: "translate(-22.779 -14.83)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9663",
    "data-name": "Caminho 9663",
    d: "M32.293,15.834c.009-.123.009-.247.017-.37,0-.005,0-.041,0-.019-.009.123-.009.247-.017.37,0,.005,0,.043,0,.019",
    transform: "translate(-22.728 -14.882)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9664",
    "data-name": "Caminho 9664",
    d: "M32.388,15.728a.375.375,0,0,0,0-.2c0,.007,0,.026,0,.036a.217.217,0,0,1,0,.132c0,.01,0,.029,0,.036",
    transform: "translate(-22.66 -14.82)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9665",
    "data-name": "Caminho 9665",
    d: "M32.478,15.744a.622.622,0,0,0,.027-.177c0-.022,0-.022,0,0a.5.5,0,0,1-.026.141c0,.01,0,.029,0,.036",
    transform: "translate(-22.596 -14.802)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9666",
    "data-name": "Caminho 9666",
    d: "M32.577,15.591a.483.483,0,0,1,.043.153c0,.005,0,.043,0,.027a.546.546,0,0,0-.043-.216c0,.005-.005.026,0,.036",
    transform: "translate(-22.524 -14.798)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9667",
    "data-name": "Caminho 9667",
    d: "M32.123,15.655v-.036l0-.019,0,.019v.036l0,.019,0-.019",
    transform: "translate(-22.85 -14.766)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9668",
    "data-name": "Caminho 9668",
    d: "M32.776,15.644a.053.053,0,0,1-.015-.034s0-.014,0-.007v.026a.084.084,0,0,0,.019.053l0-.019,0-.019",
    transform: "translate(-22.395 -14.766)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9669",
    "data-name": "Caminho 9669",
    d: "M32.534,15.788a1.723,1.723,0,0,0,.027-.3c0-.021,0-.021-.005,0a1.533,1.533,0,0,1-.024.266.15.15,0,0,0,0,.033",
    transform: "translate(-22.556 -14.856)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9670",
    "data-name": "Caminho 9670",
    d: "M32.322,16.457a.566.566,0,0,0,.019-.118l0-.024,0,.014a.443.443,0,0,1-.017.093.1.1,0,0,0,0,.022l0,.014",
    transform: "translate(-22.707 -14.255)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9671",
    "data-name": "Caminho 9671",
    d: "M32.483,16.466a.271.271,0,0,0,.045-.187c0-.021,0-.021,0,0a.207.207,0,0,1-.041.149c-.007.007.005.033,0,.038",
    transform: "translate(-22.592 -14.292)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9672",
    "data-name": "Caminho 9672",
    d: "M32.873,16.816c0,.033.005.065.009.1,0,.007,0,.007,0,0v-.026c0-.033-.007-.065-.009-.1h0v.027",
    transform: "translate(-22.312 -13.917)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9673",
    "data-name": "Caminho 9673",
    d: "M32.209,16.9v.045l0,.019,0-.019V16.9l0-.019,0,.019",
    transform: "translate(-22.786 -13.853)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9674",
    "data-name": "Caminho 9674",
    d: "M32.169,16.835v.185c0,.021,0,.021,0,0v-.185c0-.022,0-.022,0,0",
    transform: "translate(-22.815 -13.896)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9675",
    "data-name": "Caminho 9675",
    d: "M31.759,16.57a.434.434,0,0,0,.053-.207c0-.012,0-.036,0-.01a.4.4,0,0,1-.051.182c0,.009,0,.031,0,.036",
    transform: "translate(-23.11 -14.237)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9676",
    "data-name": "Caminho 9676",
    d: "M31.774,16.665a.16.16,0,0,0,.087-.125v-.027s0-.014,0-.007a.153.153,0,0,1-.086.122c-.007,0,0,.036,0,.038",
    transform: "translate(-23.099 -14.121)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9677",
    "data-name": "Caminho 9677",
    d: "M32.14,16.987a.462.462,0,0,0-.019-.118l0,.012,0,.024a.434.434,0,0,1,.015.093l0,.014a.057.057,0,0,0,0-.024",
    transform: "translate(-22.851 -13.86)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9678",
    "data-name": "Caminho 9678",
    d: "M31.758,16.51a.359.359,0,0,1,.007.1l0,.019,0-.019a.479.479,0,0,0-.009-.141c0,.005-.005.026,0,.036",
    transform: "translate(-23.109 -14.142)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9679",
    "data-name": "Caminho 9679",
    d: "M31.705,16.626a.714.714,0,0,0,.017-.134.057.057,0,0,0,0-.024l0,.014a.621.621,0,0,1-.015.111.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-23.148 -14.146)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9680",
    "data-name": "Caminho 9680",
    d: "M31.48,16.26a.6.6,0,0,1-.033.281c-.005.009,0,.033,0,.036a.662.662,0,0,0,.036-.317c0-.022,0-.022,0,0",
    transform: "translate(-23.331 -14.307)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9681",
    "data-name": "Caminho 9681",
    d: "M31.516,16.6a.25.25,0,0,1,.005-.062l0-.022,0-.014a.317.317,0,0,0-.01.1l0,.019,0-.019",
    transform: "translate(-23.285 -14.124)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9682",
    "data-name": "Caminho 9682",
    d: "M31.882,16.4a.31.31,0,0,1-.1.223c-.007.007.005.034,0,.038a.353.353,0,0,0,.1-.288c0-.014,0,.022,0,.027",
    transform: "translate(-23.095 -14.219)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9683",
    "data-name": "Caminho 9683",
    d: "M31.563,16.321a1.479,1.479,0,0,0-.027.192c0,.022.005.022.005,0a1.023,1.023,0,0,1,.024-.159.064.064,0,0,0,0-.026s0-.014,0-.007",
    transform: "translate(-23.267 -14.253)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9684",
    "data-name": "Caminho 9684",
    d: "M31.644,16.657a.371.371,0,0,0,.087-.206v-.026s0-.014,0-.007a.359.359,0,0,1-.086.2c-.007.007.005.033,0,.038",
    transform: "translate(-23.191 -14.183)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9685",
    "data-name": "Caminho 9685",
    d: "M30.681,15.984a.089.089,0,0,1-.033.063l0,.019,0,.021a.136.136,0,0,0,.036-.113l0-.014a.057.057,0,0,0,0,.024",
    transform: "translate(-23.902 -14.509)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9686",
    "data-name": "Caminho 9686",
    d: "M30.485,16.11V16l0-.019,0,.019v.106l0,.019,0-.019",
    transform: "translate(-24.02 -14.491)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9687",
    "data-name": "Caminho 9687",
    d: "M30.378,16.121A.16.16,0,0,0,30.395,16l0,.014a.114.114,0,0,0,0,.024c.005.015-.009.038-.017.051v.022l0,.014",
    transform: "translate(-24.096 -14.483)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9688",
    "data-name": "Caminho 9688",
    d: "M30.192,16.159a.505.505,0,0,0,.01-.113l0-.019,0,.019a.425.425,0,0,1-.007.081.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-24.229 -14.461)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9689",
    "data-name": "Caminho 9689",
    d: "M29.991,16.176a.114.114,0,0,0,.036-.084.057.057,0,0,0,0-.024l0,.014a.1.1,0,0,1-.033.057l0,.019,0,.019",
    transform: "translate(-24.372 -14.432)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9690",
    "data-name": "Caminho 9690",
    d: "M30.041,15.983c0,.014-.012.017-.026.015v.038c.017,0,.024-.005.027-.021a.065.065,0,0,0,0-.026s0-.014,0-.007",
    transform: "translate(-24.353 -14.494)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9691",
    "data-name": "Caminho 9691",
    d: "M30.147,16.188a.7.7,0,0,0,.069-.115l0-.022,0-.014a.8.8,0,0,1-.07.115c-.005.007,0,.033,0,.036",
    transform: "translate(-24.261 -14.454)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9692",
    "data-name": "Caminho 9692",
    d: "M30.831,15.912a.212.212,0,0,1-.041.132c-.007.009.005.031,0,.038a.244.244,0,0,0,.045-.151c0-.005,0-.043,0-.019",
    transform: "translate(-23.801 -14.549)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9693",
    "data-name": "Caminho 9693",
    d: "M30.95,15.885a.138.138,0,0,1-.015.094l0,.019,0,.019a.238.238,0,0,0,.019-.151c0-.024,0,.012,0,.019",
    transform: "translate(-23.698 -14.582)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9694",
    "data-name": "Caminho 9694",
    d: "M31.036,15.977a.162.162,0,0,0,.019-.062l0-.026c0-.007,0,.005,0,.007a.141.141,0,0,1-.017.045v.022l0,.014",
    transform: "translate(-23.626 -14.561)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9695",
    "data-name": "Caminho 9695",
    d: "M31.177,15.9,31.17,15.9v.038c.012,0,.01-.012.01-.022a.057.057,0,0,0,0-.024l0,.014",
    transform: "translate(-23.528 -14.56)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9696",
    "data-name": "Caminho 9696",
    d: "M30,15.5a.556.556,0,0,0,.01-.13l0-.019,0,.019a.468.468,0,0,1-.007.1.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(-24.365 -14.941)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9697",
    "data-name": "Caminho 9697",
    d: "M30.319,15.485c0-.062.009-.123.009-.185,0-.021,0-.021,0,0,0,.062-.009.123-.009.185,0,.022,0,.022,0,0",
    transform: "translate(-24.138 -14.992)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9698",
    "data-name": "Caminho 9698",
    d: "M30.168,15.281c.007.041.029.108-.015.132-.009,0,0,.036,0,.038.058-.031.026-.153.017-.2,0-.007,0,.005,0,.007a.064.064,0,0,0,0,.026",
    transform: "translate(-24.258 -15.018)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9699",
    "data-name": "Caminho 9699",
    d: "M30.24,15.368a.243.243,0,0,1-.007-.062l0-.019,0,.019a.363.363,0,0,0,.009.1l0-.012,0-.024",
    transform: "translate(-24.2 -14.99)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9700",
    "data-name": "Caminho 9700",
    d: "M30.116,15.255a.441.441,0,0,1-.024.177c-.005.009,0,.031,0,.036a.493.493,0,0,0,.027-.194c0-.005,0-.043,0-.019",
    transform: "translate(-24.3 -15.018)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9701",
    "data-name": "Caminho 9701",
    d: "M30.267,15.394a.1.1,0,0,0,.019-.072l0-.019,0,.019a.053.053,0,0,1-.015.034l0,.019,0,.019",
    transform: "translate(-24.175 -14.978)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9702",
    "data-name": "Caminho 9702",
    d: "M30.033,15.473a.213.213,0,0,1,.015-.065.059.059,0,0,0,0-.024l0-.014a.288.288,0,0,0-.019.093.057.057,0,0,0,0,.024l0-.014",
    transform: "translate(-24.344 -14.93)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9703",
    "data-name": "Caminho 9703",
    d: "M30.117,15.4a.162.162,0,0,0,.019-.062l0-.026c0-.007,0,.005,0,.007a.2.2,0,0,1-.015.045l0,.022,0,.014",
    transform: "translate(-24.282 -14.971)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9704",
    "data-name": "Caminho 9704",
    d: "M30.048,15.428c0-.024.009-.046.009-.07a.057.057,0,0,0,0-.024l0,.014c0,.024-.009.046-.009.07a.057.057,0,0,0,0,.024l0-.014",
    transform: "translate(-24.333 -14.956)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9705",
    "data-name": "Caminho 9705",
    d: "M30.2,15.359l-.007-.015,0-.021,0,.021a.081.081,0,0,0,.01.053l0-.019,0-.019",
    transform: "translate(-24.228 -14.964)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9706",
    "data-name": "Caminho 9706",
    d: "M30.272,15.442a.192.192,0,0,0,.034-.07.059.059,0,0,0,0-.024l0-.014a.207.207,0,0,1-.034.07l0,.019,0,.019",
    transform: "translate(-24.171 -14.956)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9707",
    "data-name": "Caminho 9707",
    d: "M27.008,15.557v-.334c0-.022,0-.022,0,0v.334c0,.022,0,.022,0,0",
    transform: "translate(-26.503 -15.047)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9708",
    "data-name": "Caminho 9708",
    d: "M26.854,15.668a.636.636,0,0,1-.12-.518c0-.01,0-.029,0-.036a.731.731,0,0,0,.12.59s.007-.027,0-.036",
    transform: "translate(-26.712 -15.113)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9709",
    "data-name": "Caminho 9709",
    d: "M26.958,15.48a.12.12,0,0,1-.017-.1c0-.01,0-.031,0-.036a.226.226,0,0,0,.017.177s.007-.027,0-.036",
    transform: "translate(-26.558 -14.953)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9710",
    "data-name": "Caminho 9710",
    d: "M27.032,15.5a.511.511,0,0,0,.01-.115l0-.019,0,.019a.317.317,0,0,1-.009.079.1.1,0,0,0,0,.022l0,.014",
    transform: "translate(-26.486 -14.934)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9711",
    "data-name": "Caminho 9711",
    d: "M26.9,15.525a.624.624,0,0,1-.077-.233c0-.014,0,.022,0,.027a.624.624,0,0,0,.077.242s.007-.027,0-.036",
    transform: "translate(-26.633 -14.988)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9712",
    "data-name": "Caminho 9712",
    d: "M26.993,15.48l-.026-.125c0,.007,0,.026,0,.036.01.041.017.082.026.122,0,.007,0-.005,0-.007a.065.065,0,0,0,0-.026",
    transform: "translate(-26.532 -14.941)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9713",
    "data-name": "Caminho 9713",
    d: "M26.905,15.548a.3.3,0,0,1,.009-.279c.007-.009-.005-.033,0-.038a.411.411,0,0,0-.01.353c0-.005.005-.026,0-.036",
    transform: "translate(-26.601 -15.03)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9714",
    "data-name": "Caminho 9714",
    d: "M26.8,15.489a.167.167,0,0,1,.077-.235c.007,0,0-.038,0-.038a.229.229,0,0,0-.079.309c0-.005.005-.026,0-.036",
    transform: "translate(-26.672 -15.04)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9715",
    "data-name": "Caminho 9715",
    d: "M27.065,15.425a.072.072,0,0,1-.007-.026l0-.019,0,.019a.146.146,0,0,0,.009.062l0-.012a.057.057,0,0,0,0-.024",
    transform: "translate(-26.468 -14.923)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9716",
    "data-name": "Caminho 9716",
    d: "M26.933,15.282a.324.324,0,0,0-.043.132.27.27,0,0,0,0,.038.352.352,0,0,1,.043-.132c.007-.009-.005-.033,0-.038",
    transform: "translate(-26.586 -14.993)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9717",
    "data-name": "Caminho 9717",
    d: "M26.837,15.457a.146.146,0,0,1-.024-.075l0-.012a.1.1,0,0,0,0,.022.186.186,0,0,0,.026.1l0-.012,0-.024",
    transform: "translate(-26.644 -14.93)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9718",
    "data-name": "Caminho 9718",
    d: "M26.934,15.442a.137.137,0,0,1-.015-.053s0-.014,0-.007a.129.129,0,0,0,0,.026.163.163,0,0,0,.017.07l0-.012a.057.057,0,0,0,0-.024",
    transform: "translate(-26.568 -14.923)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9719",
    "data-name": "Caminho 9719",
    d: "M27.05,15.414v.07l0,.019,0-.019v-.07l0-.019,0,.019",
    transform: "translate(-26.471 -14.912)",
    fill: "#007638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9720",
    "data-name": "Caminho 9720",
    d: "M26.745,15.558c0-.091-.009-.182-.009-.273,0-.022,0-.022,0,0,0,.091.009.182.009.273,0,.022,0,.022,0,0",
    transform: "translate(-26.698 -15.003)",
    fill: "#007638"
  }))))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9721",
    "data-name": "Caminho 9721",
    d: "M28.9,14.724a.313.313,0,0,0-.084.048l0,.019,0,.019a.368.368,0,0,1,.084-.048c.007,0,0-.038,0-.038",
    transform: "translate(20.579 10.517)",
    fill: "#999b9e"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9722",
    "data-name": "Caminho 9722",
    d: "M28.685,14.585a.7.7,0,0,0-.2.177c-.007.01.005.033,0,.039a.681.681,0,0,1,.2-.178c.007,0,0-.036,0-.038",
    transform: "translate(20.346 10.418)",
    fill: "#999b9e"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9723",
    "data-name": "Caminho 9723",
    d: "M37.245,13.294c.063.117.331,1.008.331,1.008-.886-1-2.964-1.7-5.386-1.7-2.388,0-4.457.684-5.364,1.659a8.125,8.125,0,0,1,.319-.888,8.318,8.318,0,0,1,.4-.852,9.148,9.148,0,0,1,4.649-1.094,9.131,9.131,0,0,1,4.673,1.107A4.3,4.3,0,0,1,37.245,13.294Z",
    transform: "translate(19.16 8.164)",
    fill: "#949699"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9724",
    "data-name": "Caminho 9724",
    d: "M37.245,13.294c.063.117.331,1.008.331,1.008-.886-1-2.964-1.7-5.386-1.7-2.388,0-4.457.684-5.364,1.659a8.125,8.125,0,0,1,.319-.888,8.318,8.318,0,0,1,.4-.852,9.148,9.148,0,0,1,4.649-1.094,9.131,9.131,0,0,1,4.673,1.107A4.3,4.3,0,0,1,37.245,13.294Z",
    transform: "translate(19.16 8.164)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9725",
    "data-name": "Caminho 9725",
    d: "M29.9,12.288a4.12,4.12,0,0,0,.161.658,4.459,4.459,0,0,0,.182-.651",
    transform: "translate(21.357 8.777)",
    fill: "#fd0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9726",
    "data-name": "Caminho 9726",
    d: "M29.9,12.288a4.12,4.12,0,0,0,.161.658,4.459,4.459,0,0,0,.182-.651",
    transform: "translate(21.357 8.777)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9727",
    "data-name": "Caminho 9727",
    d: "M29.767,12.208a4.235,4.235,0,0,0-.117.669,4.294,4.294,0,0,0,.427-.519",
    transform: "translate(21.179 8.72)",
    fill: "#fd0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9728",
    "data-name": "Caminho 9728",
    d: "M29.767,12.208a4.235,4.235,0,0,0-.117.669,4.294,4.294,0,0,0,.427-.519",
    transform: "translate(21.179 8.72)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9729",
    "data-name": "Caminho 9729",
    d: "M29.741,12.047a4.066,4.066,0,0,0-.389.55,4.286,4.286,0,0,0,.605-.278",
    transform: "translate(20.966 8.605)",
    fill: "#fd0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9730",
    "data-name": "Caminho 9730",
    d: "M29.741,12.047a4.066,4.066,0,0,0-.389.55,4.286,4.286,0,0,0,.605-.278",
    transform: "translate(20.966 8.605)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9731",
    "data-name": "Caminho 9731",
    d: "M29.757,11.872a3.922,3.922,0,0,0-.561.363,4.162,4.162,0,0,0,.662-.027",
    transform: "translate(20.854 8.48)",
    fill: "#fd0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9732",
    "data-name": "Caminho 9732",
    d: "M29.757,11.872a3.922,3.922,0,0,0-.561.363,4.162,4.162,0,0,0,.662-.027",
    transform: "translate(20.854 8.48)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9733",
    "data-name": "Caminho 9733",
    d: "M29.807,11.69a3.935,3.935,0,0,0-.653.125,4.185,4.185,0,0,0,.626.225",
    transform: "translate(20.824 8.35)",
    fill: "#fd0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9734",
    "data-name": "Caminho 9734",
    d: "M29.807,11.69a3.935,3.935,0,0,0-.653.125,4.185,4.185,0,0,0,.626.225",
    transform: "translate(20.824 8.35)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9735",
    "data-name": "Caminho 9735",
    d: "M29.881,11.582a3.868,3.868,0,0,0-.655-.118,4.374,4.374,0,0,0,.507.435",
    transform: "translate(20.876 8.189)",
    fill: "#fd0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9736",
    "data-name": "Caminho 9736",
    d: "M29.881,11.582a3.868,3.868,0,0,0-.655-.118,4.374,4.374,0,0,0,.507.435",
    transform: "translate(20.876 8.189)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9737",
    "data-name": "Caminho 9737",
    d: "M29.972,11.556a4,4,0,0,0-.566-.357,4.482,4.482,0,0,0,.315.6",
    transform: "translate(21.004 7.999)",
    fill: "#fd0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9738",
    "data-name": "Caminho 9738",
    d: "M29.972,11.556a4,4,0,0,0-.566-.357,4.482,4.482,0,0,0,.315.6",
    transform: "translate(21.004 7.999)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9739",
    "data-name": "Caminho 9739",
    d: "M30.078,11.569a3.92,3.92,0,0,0-.372-.562,4.56,4.56,0,0,0,.046.675",
    transform: "translate(21.219 7.862)",
    fill: "#fd0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9740",
    "data-name": "Caminho 9740",
    d: "M30.078,11.569a3.92,3.92,0,0,0-.372-.562,4.56,4.56,0,0,0,.046.675",
    transform: "translate(21.219 7.862)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9741",
    "data-name": "Caminho 9741",
    d: "M30.23,11.613a4.117,4.117,0,0,0-.161-.658,4.4,4.4,0,0,0-.182.651",
    transform: "translate(21.348 7.825)",
    fill: "#fd0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9742",
    "data-name": "Caminho 9742",
    d: "M30.23,11.613a4.117,4.117,0,0,0-.161-.658,4.4,4.4,0,0,0-.182.651",
    transform: "translate(21.348 7.825)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9743",
    "data-name": "Caminho 9743",
    d: "M30.4,11.7a4.247,4.247,0,0,0,.123-.667,4.385,4.385,0,0,0-.432.513",
    transform: "translate(21.495 7.881)",
    fill: "#fd0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9744",
    "data-name": "Caminho 9744",
    d: "M30.4,11.7a4.247,4.247,0,0,0,.123-.667,4.385,4.385,0,0,0-.432.513",
    transform: "translate(21.495 7.881)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9745",
    "data-name": "Caminho 9745",
    d: "M30.492,11.8a4.126,4.126,0,0,0,.36-.571,4.24,4.24,0,0,0-.59.31",
    transform: "translate(21.616 8.019)",
    fill: "#fd0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9746",
    "data-name": "Caminho 9746",
    d: "M30.492,11.8a4.126,4.126,0,0,0,.36-.571,4.24,4.24,0,0,0-.59.31",
    transform: "translate(21.616 8.019)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9747",
    "data-name": "Caminho 9747",
    d: "M30.51,11.895a4.213,4.213,0,0,0,.543-.391,4.239,4.239,0,0,0-.662.06",
    transform: "translate(21.709 8.217)",
    fill: "#fd0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9748",
    "data-name": "Caminho 9748",
    d: "M30.51,11.895a4.213,4.213,0,0,0,.543-.391,4.239,4.239,0,0,0-.662.06",
    transform: "translate(21.709 8.217)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9749",
    "data-name": "Caminho 9749",
    d: "M30.463,12.04a3.9,3.9,0,0,0,.638-.185,4.279,4.279,0,0,0-.643-.166",
    transform: "translate(21.756 8.349)",
    fill: "#fd0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9750",
    "data-name": "Caminho 9750",
    d: "M30.463,12.04a3.9,3.9,0,0,0,.638-.185,4.279,4.279,0,0,0-.643-.166",
    transform: "translate(21.756 8.349)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9751",
    "data-name": "Caminho 9751",
    d: "M30.4,12.191a3.812,3.812,0,0,0,.663.05,4.292,4.292,0,0,0-.549-.381",
    transform: "translate(21.718 8.471)",
    fill: "#fd0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9752",
    "data-name": "Caminho 9752",
    d: "M30.4,12.191a3.812,3.812,0,0,0,.663.05,4.292,4.292,0,0,0-.549-.381",
    transform: "translate(21.718 8.471)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9753",
    "data-name": "Caminho 9753",
    d: "M30.3,12.3a3.959,3.959,0,0,0,.6.288,4.433,4.433,0,0,0-.379-.555",
    transform: "translate(21.639 8.594)",
    fill: "#fd0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9754",
    "data-name": "Caminho 9754",
    d: "M30.3,12.3a3.959,3.959,0,0,0,.6.288,4.433,4.433,0,0,0-.379-.555",
    transform: "translate(21.639 8.594)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9755",
    "data-name": "Caminho 9755",
    d: "M30.1,12.343a4.147,4.147,0,0,0,.418.528,4.289,4.289,0,0,0-.1-.669",
    transform: "translate(21.503 8.716)",
    fill: "#fd0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9756",
    "data-name": "Caminho 9756",
    d: "M30.1,12.343a4.147,4.147,0,0,0,.418.528,4.289,4.289,0,0,0-.1-.669",
    transform: "translate(21.503 8.716)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9757",
    "data-name": "Caminho 9757",
    d: "M30.349,11.321a.844.844,0,1,1-.861.845.854.854,0,0,1,.861-.845",
    transform: "translate(21.063 8.086)",
    fill: "#fd0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9758",
    "data-name": "Caminho 9758",
    d: "M30.349,11.321a.844.844,0,1,1-.861.845A.854.854,0,0,1,30.349,11.321Z",
    transform: "translate(21.063 8.086)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9759",
    "data-name": "Caminho 9759",
    d: "M29.89,11.7a.077.077,0,1,1-.077-.074.075.075,0,0,1,.077.074",
    transform: "translate(21.24 8.305)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9760",
    "data-name": "Caminho 9760",
    d: "M29.69,11.708a.181.181,0,0,1,.317,0",
    transform: "translate(21.207 8.296)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9761",
    "data-name": "Caminho 9761",
    d: "M30.3,11.707a.077.077,0,1,1-.077-.074.075.075,0,0,1,.077.074",
    transform: "translate(21.536 8.309)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9762",
    "data-name": "Caminho 9762",
    d: "M30.1,11.713a.181.181,0,0,1,.317,0",
    transform: "translate(21.503 8.3)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9763",
    "data-name": "Caminho 9763",
    d: "M29.91,11.857c.05,0,.086.027.137.031a.349.349,0,0,0,.129-.036",
    transform: "translate(21.364 8.466)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9764",
    "data-name": "Caminho 9764",
    d: "M30.068,11.988c.106,0,.192.012.192.027s-.086.027-.192.027-.192-.012-.192-.027S29.962,11.988,30.068,11.988Z",
    transform: "translate(21.34 8.563)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9765",
    "data-name": "Caminho 9765",
    d: "M29.942,12.126a.436.436,0,0,0,.142-.005",
    transform: "translate(21.387 8.658)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9766",
    "data-name": "Caminho 9766",
    d: "M28.366,12.1l-.077-.168a.467.467,0,0,0-.355.23.367.367,0,0,0-.422-.079l-.009.247s.182-.255.37-.081c0,0-.086.37.13.353s.069-.326.026-.345l-.043-.017A.331.331,0,0,1,28.366,12.1Zm-.355.3c.012.051.007.1-.014.1s-.048-.033-.062-.086-.007-.1.015-.1S28,12.35,28.011,12.4Z",
    transform: "translate(19.646 8.525)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9767",
    "data-name": "Caminho 9767",
    d: "M29.126,11.683A.161.161,0,0,0,29,11.654s.057.053.048.075a.052.052,0,0,1-.058.041.565.565,0,0,0-.346.084s-.108.015-.117-.007c0,0-.019-.038,0-.053l.005,0c.022-.012-.117.021-.084.087a.165.165,0,0,0,.168.089l.009,0h0c.005.01.178.4.29.36s.129-.406.117-.446l-.005-.015h0S29.274,11.772,29.126,11.683Zm-.235.506c-.082.015-.182-.247-.171-.254a.248.248,0,0,1,.209-.069c-.012-.017.009,0,.009,0l-.009,0C28.945,11.885,28.974,12.173,28.891,12.189Z",
    transform: "translate(20.317 8.323)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9768",
    "data-name": "Caminho 9768",
    d: "M31.391,11.937a.413.413,0,0,0-.009-.093.218.218,0,0,0-.036-.065.325.325,0,0,0-.074-.072c-.046-.029-.091-.007-.089.048a.177.177,0,0,0,.093.127.707.707,0,0,0,.115.055,2.092,2.092,0,0,1,.35.13.559.559,0,0,0,.1.057.194.194,0,0,0,.171-.007c.038-.022.094-.082.051-.125a.184.184,0,0,0-.192-.01.652.652,0,0,0-.135.075c.022.05-.009.1-.019.154a.463.463,0,0,0-.026.129c0,.06.089.189.125.082a.158.158,0,0,0-.051-.189.4.4,0,0,0-.048-.022c-.12-.05-.243-.072-.35-.122a.314.314,0,0,0-.125-.026.107.107,0,0,0-.091.053.093.093,0,0,0-.012.089c.034.058.13.005.168-.024a.175.175,0,0,0,.06-.093A.453.453,0,0,0,31.391,11.937Z",
    transform: "translate(22.235 8.353)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9769",
    "data-name": "Caminho 9769",
    d: "M32.409,12.374a.139.139,0,0,0-.185.062s-.274-.031-.1-.459c.005-.012-.177.075-.137.35a.466.466,0,0,0,.293.336s.218.05.209-.166C32.49,12.5,32.479,12.393,32.409,12.374Zm-.063.189a.05.05,0,1,1,.048-.05A.049.049,0,0,1,32.346,12.563Z",
    transform: "translate(22.844 8.554)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9770",
    "data-name": "Caminho 9770",
    d: "M32.192,12.291a.137.137,0,0,0,.168-.1s.276-.026.187.43c0,.014.158-.11.069-.372a.464.464,0,0,0-.353-.271s-.223,0-.173.206C32.089,12.188,32.12,12.287,32.192,12.291Zm.026-.2a.048.048,0,0,1,.057.039.049.049,0,0,1-.038.058.047.047,0,0,1-.055-.039A.048.048,0,0,1,32.218,12.093Z",
    transform: "translate(22.916 8.559)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9771",
    "data-name": "Caminho 9771",
    d: "M28.366,12.1l-.077-.168a.467.467,0,0,0-.355.23.367.367,0,0,0-.422-.079l-.009.247s.182-.255.37-.081c0,0-.086.37.13.353s.069-.326.026-.345l-.043-.017a.331.331,0,0,1,.379-.141m-.355.3c.012.051.007.1-.014.1s-.048-.033-.062-.086-.007-.1.015-.1.046.033.06.084",
    transform: "translate(19.646 8.525)",
    fill: "#fd0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9772",
    "data-name": "Caminho 9772",
    d: "M29.126,11.683A.161.161,0,0,0,29,11.654s.057.053.048.075a.052.052,0,0,1-.058.041.565.565,0,0,0-.346.084s-.108.015-.117-.007c0,0-.019-.038,0-.053l.005,0c.022-.012-.117.021-.084.087a.165.165,0,0,0,.168.089l.009,0h0c.005.01.178.4.29.36s.129-.406.117-.446l-.005-.015h0s.247-.093.1-.182m-.235.506c-.082.015-.182-.247-.171-.254a.248.248,0,0,1,.209-.069c-.012-.017.009,0,.009,0l-.009,0c.015.019.045.307-.038.322",
    transform: "translate(20.317 8.323)",
    fill: "#fd0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9773",
    "data-name": "Caminho 9773",
    d: "M31.391,11.937a.413.413,0,0,0-.009-.093.218.218,0,0,0-.036-.065.325.325,0,0,0-.074-.072c-.046-.029-.091-.007-.089.048a.177.177,0,0,0,.093.127.707.707,0,0,0,.115.055,2.092,2.092,0,0,1,.35.13.559.559,0,0,0,.1.057.194.194,0,0,0,.171-.007c.038-.022.094-.082.051-.125a.184.184,0,0,0-.192-.01.652.652,0,0,0-.135.075c.022.05-.009.1-.019.154a.463.463,0,0,0-.026.129c0,.06.089.189.125.082a.158.158,0,0,0-.051-.189.4.4,0,0,0-.048-.022c-.12-.05-.243-.072-.35-.122a.314.314,0,0,0-.125-.026.107.107,0,0,0-.091.053.093.093,0,0,0-.012.089c.034.058.13.005.168-.024a.175.175,0,0,0,.06-.093A.453.453,0,0,0,31.391,11.937Z",
    transform: "translate(22.235 8.353)",
    fill: "none",
    stroke: "#fd0",
    strokeWidth: 0.05
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9774",
    "data-name": "Caminho 9774",
    d: "M32.409,12.374a.139.139,0,0,0-.185.062s-.274-.031-.1-.459c.005-.012-.177.075-.137.35a.466.466,0,0,0,.293.336s.218.05.209-.166c0,0-.01-.1-.081-.122m-.063.189a.05.05,0,1,1,.048-.05.049.049,0,0,1-.048.05",
    transform: "translate(22.844 8.554)",
    fill: "#fd0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9775",
    "data-name": "Caminho 9775",
    d: "M32.192,12.291a.137.137,0,0,0,.168-.1s.276-.026.187.43c0,.014.158-.11.069-.372a.464.464,0,0,0-.353-.271s-.223,0-.173.206c0,0,.031.1.1.1m.026-.2a.048.048,0,0,1,.057.039.049.049,0,0,1-.038.058.047.047,0,0,1-.055-.039.048.048,0,0,1,.036-.058",
    transform: "translate(22.916 8.559)",
    fill: "#fd0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9776",
    "data-name": "Caminho 9776",
    d: "M29.85,17.991l.007-.261s1.149.051,1.7.045v.2s-1.509.024-1.707.012",
    transform: "translate(21.321 12.664)",
    fill: "#fd0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_561",
    "data-name": "Ret\\xE2ngulo 561",
    width: 0.461,
    height: 0.118,
    transform: "translate(53.157 30.274)",
    fill: "#5c5342"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9777",
    "data-name": "Caminho 9777",
    d: "M31.527,18.256V18.5H31.5v-.242L31.244,16.9l.014,0,.261,1.341.219-.447.014,0",
    transform: "translate(22.317 12.072)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_562",
    "data-name": "Ret\\xE2ngulo 562",
    width: 0.024,
    height: 0.165,
    transform: "translate(52.894 30.417)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_563",
    "data-name": "Ret\\xE2ngulo 563",
    width: 0.024,
    height: 0.165,
    transform: "translate(52.939 30.417)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_564",
    "data-name": "Ret\\xE2ngulo 564",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.043 30.417)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_565",
    "data-name": "Ret\\xE2ngulo 565",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.103 30.417)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_566",
    "data-name": "Ret\\xE2ngulo 566",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.193 30.417)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_567",
    "data-name": "Ret\\xE2ngulo 567",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.283 30.417)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_568",
    "data-name": "Ret\\xE2ngulo 568",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.343 30.417)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_569",
    "data-name": "Ret\\xE2ngulo 569",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.417 30.417)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_570",
    "data-name": "Ret\\xE2ngulo 570",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.491 30.417)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_571",
    "data-name": "Ret\\xE2ngulo 571",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.561 30.417)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_572",
    "data-name": "Ret\\xE2ngulo 572",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.662 30.417)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_573",
    "data-name": "Ret\\xE2ngulo 573",
    width: 0.024,
    height: 0.165,
    transform: "translate(53.921 30.399)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_574",
    "data-name": "Ret\\xE2ngulo 574",
    width: 0.024,
    height: 0.381,
    transform: "translate(53.99 30.158)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_575",
    "data-name": "Ret\\xE2ngulo 575",
    width: 0.024,
    height: 0.355,
    transform: "translate(53.702 30.226)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_576",
    "data-name": "Ret\\xE2ngulo 576",
    width: 0.034,
    height: 0.045,
    transform: "translate(52.989 30.537)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9778",
    "data-name": "Caminho 9778",
    d: "M31.364,17.867l0,0a.8.8,0,0,1,.185-.1.774.774,0,0,0,.082,0v.027l-.084,0-.144.075",
    transform: "translate(22.403 12.686)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9779",
    "data-name": "Caminho 9779",
    d: "M31.441,17.876l0,0a.7.7,0,0,1,.183-.1.8.8,0,0,0,.082-.005v.027l-.084.005-.142.077",
    transform: "translate(22.458 12.689)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_577",
    "data-name": "Ret\\xE2ngulo 577",
    width: 0.115,
    height: 0.021,
    transform: "translate(53.614 30.211)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9780",
    "data-name": "Caminho 9780",
    d: "M31.354,17.569c-.015,0-.026.043-.026.094s.015.089.031.086.024-.043.024-.094-.015-.089-.029-.086m0,.154c-.01,0-.021-.026-.021-.062s.007-.065.017-.067.021.026.021.062-.007.065-.017.067",
    transform: "translate(22.377 12.549)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9781",
    "data-name": "Caminho 9781",
    d: "M31.346,17.012l-.643.027v-.017l.67-.024",
    transform: "translate(21.931 12.141)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9782",
    "data-name": "Caminho 9782",
    d: "M30.709,16.756,31,18.41l-.267-.917,0-.046.2.7-.228-1.282Z",
    transform: "translate(21.933 11.969)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9783",
    "data-name": "Caminho 9783",
    d: "M30.855,18.163l-.129-1.046-.01.041.111.991.022.009",
    transform: "translate(21.94 12.227)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9784",
    "data-name": "Caminho 9784",
    d: "M30.772,17.924a2.253,2.253,0,0,0-.048-.483l-.005.031s.039.415.043.447.01.005.01.005",
    transform: "translate(21.942 12.458)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9785",
    "data-name": "Caminho 9785",
    d: "M30.765,17.242l-.108.816.019.012.1-.8",
    transform: "translate(21.898 12.315)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9786",
    "data-name": "Caminho 9786",
    d: "M30.762,17.008l-.139,1.143.014.019.123-1.138",
    transform: "translate(21.874 12.149)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9787",
    "data-name": "Caminho 9787",
    d: "M31.092,17.187l-.89.591-.01-.015.895-.593v.012",
    transform: "translate(21.566 12.264)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9788",
    "data-name": "Caminho 9788",
    d: "M31.033,17.614h.461l-.024.077h-.461Z",
    transform: "translate(22.149 12.582)",
    fill: "#858d8d"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9789",
    "data-name": "Caminho 9789",
    d: "M31.462,17.958l0-.009.135-.574.017,0-.135.566",
    transform: "translate(22.473 12.411)",
    fill: "#755338"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9790",
    "data-name": "Caminho 9790",
    d: "M31.841,17.608c-.058.022-.134-.1-.168-.165s-.123-.038-.123-.038l-.022.075c.017,0,.089-.014.118.039s.11.185.168.165l-.033.094h0Z",
    transform: "translate(22.519 12.43)",
    fill: "#fd0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9791",
    "data-name": "Caminho 9791",
    d: "M31.65,17.489a.111.111,0,0,0-.118-.039l-.012.041a.106.106,0,0,1,.115.039c.034.06.11.185.168.163l-.019.053,0,0,.033-.094c-.058.021-.134-.1-.168-.165",
    transform: "translate(22.514 12.462)",
    fill: "#034ea2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9792",
    "data-name": "Caminho 9792",
    d: "M31.515,17.5h.005a.15.15,0,0,1,.141.12c.017.043.111.1.127.111l.019-.053c-.06.021-.134-.1-.17-.165s-.093-.043-.115-.039l-.007.022v0",
    transform: "translate(22.511 12.479)",
    fill: "#ed1c24"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9793",
    "data-name": "Caminho 9793",
    d: "M30.722,17.474l.936-.571v-.012h-.021l-.917.545v.027",
    transform: "translate(21.943 12.065)",
    fill: "#a37853"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9794",
    "data-name": "Caminho 9794",
    d: "M30.747,17.383l.017,1.2-.036.014L30.7,17.436l0-.927.01.007.009.857Z",
    transform: "translate(21.928 11.792)",
    fill: "#a37853"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9795",
    "data-name": "Caminho 9795",
    d: "M30.671,17.752a.028.028,0,0,0,.026.029l1.389-.021a.03.03,0,0,0,0-.058l-1.39.021a.027.027,0,0,0-.024.029",
    transform: "translate(21.908 12.644)",
    fill: "#a37853"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9796",
    "data-name": "Caminho 9796",
    d: "M30.531,17.579s.057,0,.173.021a1.677,1.677,0,0,0-.2.041,1,1,0,0,0-.233.18l-.043.038h-.218a1.308,1.308,0,0,1,.144-.163.612.612,0,0,1,.173-.1.856.856,0,0,1,.2-.021",
    transform: "translate(21.438 12.555)",
    fill: "#616264"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9797",
    "data-name": "Caminho 9797",
    d: "M31.071,17.873a.434.434,0,0,0-.423-.283l-.007,0c-.324.012-.339.146-.463.257h-.022l0,0S30.817,17.873,31.071,17.873Z",
    transform: "translate(21.537 12.564)",
    fill: "#a3a5a8"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9798",
    "data-name": "Caminho 9798",
    d: "M31.071,17.873a.434.434,0,0,0-.423-.283l-.007,0c-.324.012-.339.146-.463.257h-.022l0,0S30.817,17.873,31.071,17.873Z",
    transform: "translate(21.537 12.564)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9799",
    "data-name": "Caminho 9799",
    d: "M30.64,17.734l-.01,0,0-.01.01,0,0,.01",
    transform: "translate(21.879 12.658)",
    fill: "#797a7d"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9800",
    "data-name": "Caminho 9800",
    d: "M30.63,17.714l-.01,0,0-.012.01,0,0,.01",
    transform: "translate(21.871 12.643)",
    fill: "#797a7d"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9801",
    "data-name": "Caminho 9801",
    d: "M30.618,17.694l-.01,0,0-.01h.01l0,.012",
    transform: "translate(21.862 12.63)",
    fill: "#797a7d"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9802",
    "data-name": "Caminho 9802",
    d: "M30.6,17.677h-.01v-.012l.01,0v.01",
    transform: "translate(21.852 12.618)",
    fill: "#797a7d"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9803",
    "data-name": "Caminho 9803",
    d: "M30.588,17.661l-.01,0,0-.012h.01l0,.01",
    transform: "translate(21.84 12.608)",
    fill: "#797a7d"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9804",
    "data-name": "Caminho 9804",
    d: "M30.572,17.647l-.01,0,0-.01.012,0,0,.01",
    transform: "translate(21.827 12.598)",
    fill: "#797a7d"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9805",
    "data-name": "Caminho 9805",
    d: "M30.552,17.635l-.01,0,0-.01.01,0,0,.01",
    transform: "translate(21.813 12.589)",
    fill: "#797a7d"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9806",
    "data-name": "Caminho 9806",
    d: "M30.532,17.626l-.01.005,0-.01.009-.005.005.01",
    transform: "translate(21.799 12.583)",
    fill: "#797a7d"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9807",
    "data-name": "Caminho 9807",
    d: "M30.512,17.617l-.009.005-.007-.009.01-.005.005.009",
    transform: "translate(21.783 12.577)",
    fill: "#797a7d"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9808",
    "data-name": "Caminho 9808",
    d: "M30.491,17.612l-.009.007-.007-.01.009-.005.007.009",
    transform: "translate(21.768 12.574)",
    fill: "#797a7d"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9809",
    "data-name": "Caminho 9809",
    d: "M30.469,17.609l-.009.007-.007-.007.009-.009.007.009",
    transform: "translate(21.752 12.572)",
    fill: "#797a7d"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9810",
    "data-name": "Caminho 9810",
    d: "M30.447,17.608l-.007.007-.009-.007.007-.009.009.009",
    transform: "translate(21.737 12.571)",
    fill: "#797a7d"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9811",
    "data-name": "Caminho 9811",
    d: "M30.424,17.609l-.007.009-.009-.007.007-.009.009.007",
    transform: "translate(21.721 12.573)",
    fill: "#797a7d"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9812",
    "data-name": "Caminho 9812",
    d: "M30.4,17.611l-.007.009-.009-.007.007-.009.009.007",
    transform: "translate(21.705 12.575)",
    fill: "#797a7d"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9813",
    "data-name": "Caminho 9813",
    d: "M30.381,17.614l-.005.009-.01-.005.007-.009.009.005",
    transform: "translate(21.69 12.578)",
    fill: "#797a7d"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9814",
    "data-name": "Caminho 9814",
    d: "M30.359,17.619l-.005.009-.01-.005.005-.009.01.005",
    transform: "translate(21.674 12.581)",
    fill: "#797a7d"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9815",
    "data-name": "Caminho 9815",
    d: "M30.338,17.625l0,.01-.01-.005,0-.009.01,0",
    transform: "translate(21.66 12.587)",
    fill: "#797a7d"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9816",
    "data-name": "Caminho 9816",
    d: "M30.316,17.634l0,.01-.009,0,0-.01.01,0",
    transform: "translate(21.646 12.594)",
    fill: "#797a7d"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9817",
    "data-name": "Caminho 9817",
    d: "M30.3,17.646l0,.01-.01,0,0-.01.01,0",
    transform: "translate(21.633 12.603)",
    fill: "#797a7d"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9818",
    "data-name": "Caminho 9818",
    d: "M30.281,17.659v.01h-.012l0-.01h.01",
    transform: "translate(21.62 12.614)",
    fill: "#797a7d"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9819",
    "data-name": "Caminho 9819",
    d: "M30.264,17.675v.01l-.01,0v-.012h.01",
    transform: "translate(21.61 12.625)",
    fill: "#797a7d"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9820",
    "data-name": "Caminho 9820",
    d: "M30.249,17.692v.01l-.01,0v-.01l.01,0",
    transform: "translate(21.599 12.637)",
    fill: "#797a7d"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9821",
    "data-name": "Caminho 9821",
    d: "M30.235,17.709v.01l-.01,0v-.012h.01",
    transform: "translate(21.589 12.649)",
    fill: "#797a7d"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9822",
    "data-name": "Caminho 9822",
    d: "M30.588,17.588c-.333.012-.346.147-.47.259l.062,0H30.2c.123-.111.139-.245.463-.257A.373.373,0,0,0,30.588,17.588Z",
    transform: "translate(21.513 12.563)",
    fill: "#939598"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9823",
    "data-name": "Caminho 9823",
    d: "M30.588,17.588c-.333.012-.346.147-.47.259l.062,0H30.2c.123-.111.139-.245.463-.257A.373.373,0,0,0,30.588,17.588Z",
    transform: "translate(21.513 12.563)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9824",
    "data-name": "Caminho 9824",
    d: "M29.866,17.819l.01-.189.043,0v.051l.305-.009-.067.175-.288-.01-.007-.026",
    transform: "translate(21.33 12.592)",
    fill: "#442c13"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9825",
    "data-name": "Caminho 9825",
    d: "M29.866,17.819l.01-.189.043,0v.051l.305-.009-.067.175-.288-.01-.007-.026",
    transform: "translate(21.33 12.592)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9826",
    "data-name": "Caminho 9826",
    d: "M29.963,17.4l.009.466-.038,0,.019-.47Z",
    transform: "translate(21.381 12.43)",
    fill: "#442c13"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9827",
    "data-name": "Caminho 9827",
    d: "M29.963,17.4l.009.466-.038,0,.019-.47Z",
    transform: "translate(21.381 12.43)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9828",
    "data-name": "Caminho 9828",
    d: "M30.057,17.387l.009.475-.027.005,0-.48Z",
    transform: "translate(21.456 12.419)",
    fill: "#442c13"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9829",
    "data-name": "Caminho 9829",
    d: "M30.057,17.387l.009.475-.027.005,0-.48Z",
    transform: "translate(21.456 12.419)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_578",
    "data-name": "Ret\\xE2ngulo 578",
    width: 0.016,
    height: 0.454,
    transform: "translate(51.667 29.731) rotate(-2.386)",
    fill: "#442c13"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_579",
    "data-name": "Ret\\xE2ngulo 579",
    width: 0.016,
    height: 0.454,
    transform: "translate(51.667 29.731) rotate(-2.386)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9830",
    "data-name": "Caminho 9830",
    d: "M30.328,17.752l.081-.417-.009.005-.1.41Z",
    transform: "translate(21.645 12.383)",
    fill: "#442c13"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9831",
    "data-name": "Caminho 9831",
    d: "M30.328,17.752l.081-.417-.009.005-.1.41Z",
    transform: "translate(21.645 12.383)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9832",
    "data-name": "Caminho 9832",
    d: "M30.231,17.345l-.183.543-.031-.005.194-.542Z",
    transform: "translate(21.441 12.387)",
    fill: "#442c13"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9833",
    "data-name": "Caminho 9833",
    d: "M30.231,17.345l-.183.543-.031-.005.194-.542Z",
    transform: "translate(21.441 12.387)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9834",
    "data-name": "Caminho 9834",
    d: "M30.167,17.348l.046.41.024,0-.051-.406Z",
    transform: "translate(21.548 12.392)",
    fill: "#442c13"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9835",
    "data-name": "Caminho 9835",
    d: "M30.167,17.348l.046.41.024,0-.051-.406Z",
    transform: "translate(21.548 12.392)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9836",
    "data-name": "Caminho 9836",
    d: "M30.657,17.339h-.417l-.3.11.35.01Z",
    transform: "translate(21.389 12.385)",
    fill: "#a48b58"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9837",
    "data-name": "Caminho 9837",
    d: "M30.657,17.339h-.417l-.3.11.35.01Z",
    transform: "translate(21.389 12.385)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9838",
    "data-name": "Caminho 9838",
    d: "M29.938,17.469l.315-.106.417-.009,0-.029-.427.007-.3.1Z",
    transform: "translate(21.384 12.375)",
    fill: "#a37853"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9839",
    "data-name": "Caminho 9839",
    d: "M29.938,17.469l.315-.106.417-.009,0-.029-.427.007-.3.1Z",
    transform: "translate(21.384 12.375)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9840",
    "data-name": "Caminho 9840",
    d: "M30.1,17.646a.1.1,0,0,1,.086-.1.091.091,0,0,1,.084.082l.017,0a.113.113,0,0,0-.1-.1.116.116,0,0,0-.1.125.136.136,0,0,0,.01.055l.015-.01A.122.122,0,0,1,30.1,17.646Z",
    transform: "translate(21.488 12.515)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9841",
    "data-name": "Caminho 9841",
    d: "M30.1,17.646a.1.1,0,0,1,.086-.1.091.091,0,0,1,.084.082l.017,0a.113.113,0,0,0-.1-.1.116.116,0,0,0-.1.125.136.136,0,0,0,.01.055l.015-.01A.122.122,0,0,1,30.1,17.646Z",
    transform: "translate(21.488 12.515)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9842",
    "data-name": "Caminho 9842",
    d: "M30.079,17.85c.135-.113.141-.255.477-.269a.389.389,0,0,0-.077-.005c-.343.012-.348.156-.483.271l-.009.009.086,0Z",
    transform: "translate(21.419 12.554)",
    fill: "#939598"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9843",
    "data-name": "Caminho 9843",
    d: "M30.079,17.85c.135-.113.141-.255.477-.269a.389.389,0,0,0-.077-.005c-.343.012-.348.156-.483.271l-.009.009.086,0Z",
    transform: "translate(21.419 12.554)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9844",
    "data-name": "Caminho 9844",
    d: "M31.072,17.911v-.017a5.376,5.376,0,0,0,.905-.051,3.845,3.845,0,0,0-1.126,0",
    transform: "translate(22.036 12.722)",
    fill: "#fd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_868",
    "data-name": "Grupo 868",
    transform: "translate(50.375 29.175)",
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_867",
    "data-name": "Grupo 867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_866",
    "data-name": "Grupo 866",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9845",
    "data-name": "Caminho 9845",
    d: "M29.573,17.185c-.053.007-.093-.055-.144.024l0,.005a.133.133,0,0,0-.031.137c.012.026.072.048.1.051a.115.115,0,0,0,.125-.108c.031.038.12.039.165.043.079,0,.1-.01.113-.094.046.065.084.07.163.057a.456.456,0,0,0,.262-.094.121.121,0,0,0,.1.06.341.341,0,0,0,.125-.019c.031-.012.063-.055.094-.06.024.036.069.022.1.027a.188.188,0,0,0,.213.009c.024-.014.111.019.142,0s.026-.031.043-.041c.038.029.1,0,.141-.012s.077,0,.089-.043c.055-.034.039-.063.022-.081a.211.211,0,0,0-.237.026c-.027-.009-.041-.007-.062.029a.113.113,0,0,0-.165-.033c-.055-.031-.084-.007-.129-.005a.351.351,0,0,0-.362.005c-.127-.058-.165-.024-.249.039a.342.342,0,0,0-.156-.005c-.048,0-.072.063-.111.045-.091-.045-.134.022-.2.019-.074-.063-.151.015-.151.015",
    transform: "translate(-29.385 -17.018)",
    fill: "#696161"
  }))))), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9846",
    "data-name": "Caminho 9846",
    d: "M29.558,18.307a.077.077,0,1,1-.154,0v-.97a.077.077,0,1,1,.154,0Z",
    transform: "translate(21.003 12.327)",
    fill: "#84848a"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9847",
    "data-name": "Caminho 9847",
    d: "M30,17.767a.419.419,0,0,1-.062.053.829.829,0,0,1-.084.031l-.067,0h-.053l-.05,0,.021.1.269.005Z",
    transform: "translate(21.206 12.691)",
    fill: "#453717"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9848",
    "data-name": "Caminho 9848",
    d: "M29.789,17.772h-.1l0,.01H29.6l-.019.161.2,0",
    transform: "translate(21.129 12.694)",
    fill: "#6a5e46"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9849",
    "data-name": "Caminho 9849",
    d: "M29.605,17.892l0,0-.005,0v-.084l.005,0,0,0Z",
    transform: "translate(21.141 12.718)",
    fill: "#453717"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9850",
    "data-name": "Caminho 9850",
    d: "M29.618,17.892l0,0-.005,0v-.084l.005,0,0,0Z",
    transform: "translate(21.15 12.718)",
    fill: "#453717"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9851",
    "data-name": "Caminho 9851",
    d: "M29.632,17.892l0,0-.005,0v-.084l.005,0,0,0Z",
    transform: "translate(21.16 12.718)",
    fill: "#453717"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9852",
    "data-name": "Caminho 9852",
    d: "M29.653,17.892l0,0-.005,0v-.084l.005,0,0,0Z",
    transform: "translate(21.175 12.718)",
    fill: "#453717"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9853",
    "data-name": "Caminho 9853",
    d: "M29.673,17.892l0,0-.005,0v-.084l.005,0,0,0Z",
    transform: "translate(21.189 12.718)",
    fill: "#453717"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9854",
    "data-name": "Caminho 9854",
    d: "M29.69,17.892l0,0-.005,0v-.084l.005,0,0,0Z",
    transform: "translate(21.201 12.718)",
    fill: "#453717"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9855",
    "data-name": "Caminho 9855",
    d: "M29.609,17.949v-.009l0-.185-.019.005,0,.094-.021.009-.009-.022h-.048l-.015.007v.089Z",
    transform: "translate(21.071 12.683)",
    fill: "#2f2311"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9856",
    "data-name": "Caminho 9856",
    d: "M29.269,17.895l-.026,0v.015h-.031l0-.029h-.026V17.86l-.033,0-.005-.079H29.13v-.106l-.022,0,.007.226-.012,0v.026h.014L29.111,18l.3.017-.007-.123h-.029v.017L29.3,17.9l-.005.027h-.021Z",
    transform: "translate(20.788 12.623)",
    fill: "#2f2311"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9857",
    "data-name": "Caminho 9857",
    d: "M29.344,17.82l-.065,0,.01.089.057-.005Z",
    transform: "translate(20.913 12.726)",
    fill: "#866d46"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9858",
    "data-name": "Caminho 9858",
    d: "M29.569,17.507a.12.12,0,0,0-.084-.031.124.124,0,0,0-.086.031l0,.01,0,.01a.115.115,0,0,1,.086-.033.114.114,0,0,1,.084.033l0-.01,0-.01",
    transform: "translate(20.999 12.483)",
    fill: "#acacad"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9859",
    "data-name": "Caminho 9859",
    d: "M29.512,17.827l0-.027.019-.024-.05-.009,0,.026-.026,0,0,.014H29.43l-.012.005-.009.026-.014-.017.007.113.158,0v-.1",
    transform: "translate(20.997 12.691)",
    fill: "#866d46"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9860",
    "data-name": "Caminho 9860",
    d: "M29.306,17.908l.171-.005-.005-.089-.161,0",
    transform: "translate(20.933 12.724)",
    fill: "#2f2311"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9861",
    "data-name": "Caminho 9861",
    d: "M29.484,17.99l0-.125-.036.005h-.024l-.019-.01,0,.007-.089,0-.01-.027-.053.005,0,.019-.067,0-.01-.024h-.019v-.137l-.029,0-.014.163-.026,0v-.022l-.034,0-.007.041-.039-.005,0-.038h-.038l-.005.043-.228.005.012-.2-.038-.005,0,.2a.8.8,0,0,1-.17-.074l.087.106a5.1,5.1,0,0,0,.852.063",
    transform: "translate(20.389 12.642)",
    fill: "#453717"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9862",
    "data-name": "Caminho 9862",
    d: "M28.994,17.969s-.05-.014-.422-.129-.554-.2-.588-.207-.087,0,.07.072a5.185,5.185,0,0,0,.852.273.844.844,0,0,0,.173-.009c.065-.014-.086,0-.086,0",
    transform: "translate(19.962 12.593)",
    fill: "#895f33"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9863",
    "data-name": "Caminho 9863",
    d: "M29.573,17.185c-.053.007-.093-.055-.144.024l0,.005a.133.133,0,0,0-.031.137c.012.026.072.048.1.051a.115.115,0,0,0,.125-.108c.031.038.12.039.165.043.079,0,.1-.01.113-.094.046.065.084.07.163.057a.456.456,0,0,0,.262-.094.117.117,0,0,0,.1.06.341.341,0,0,0,.125-.019c.031-.012.063-.055.094-.06.024.036.069.022.1.027a.188.188,0,0,0,.213.009c.024-.014.111.019.142,0s.026-.031.043-.041c.038.029.1,0,.141-.012s.077,0,.089-.043c.055-.034.039-.063.022-.081a.211.211,0,0,0-.237.026c-.027-.009-.041-.007-.062.029a.113.113,0,0,0-.165-.033c-.055-.031-.084-.007-.129-.005a.351.351,0,0,0-.362.005c-.127-.058-.165-.024-.249.039a.342.342,0,0,0-.156-.005c-.048,0-.072.063-.111.045-.091-.045-.134.022-.2.019-.074-.063-.151.015-.151.015",
    transform: "translate(20.99 12.157)",
    fill: "#fff"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9864",
    "data-name": "Caminho 9864",
    d: "M32.7,17.885l.043.055H30.982l-1.287-.017s-.561-.014-.837-.039a4.656,4.656,0,0,1-.588-.108.246.246,0,0,0,.11.173.126.126,0,0,0,.034.017,3.585,3.585,0,0,0,.477.111,6.136,6.136,0,0,0,.727.038c.25,0,2.8-.014,2.8-.014v-.024c.1.015,1.353-.077,1.353-.077l.012-.026c.014-.033.027-.079.034-.1l0-.009Z",
    transform: "translate(20.193 12.696)",
    fill: "#ffe600"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9865",
    "data-name": "Caminho 9865",
    d: "M28.73,18.207l-.631-.5.048.017.583.463Z",
    transform: "translate(20.071 12.646)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9866",
    "data-name": "Caminho 9866",
    d: "M28.511,17.85a.039.039,0,0,1,.039.039.039.039,0,1,1-.079,0,.039.039,0,0,1,.039-.039",
    transform: "translate(20.337 12.75)",
    fill: "#565759"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9867",
    "data-name": "Caminho 9867",
    d: "M28.511,17.85a.039.039,0,0,1,.039.039.039.039,0,1,1-.079,0A.039.039,0,0,1,28.511,17.85Z",
    transform: "translate(20.337 12.75)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9868",
    "data-name": "Caminho 9868",
    d: "M28.581,17.983l.005.014c-.026.029-.05.015-.05.015V17.9a.015.015,0,0,0,.012-.014.018.018,0,0,0-.017-.017.017.017,0,0,0-.015.017l.009.014v.113s-.022.014-.048-.015l.005-.014-.036.005.014.031.007-.01a.131.131,0,0,0,.063.031h0a.131.131,0,0,0,.063-.031l.005.01.014-.031Z",
    transform: "translate(20.319 12.763)",
    fill: "#565759"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9869",
    "data-name": "Caminho 9869",
    d: "M28.581,17.983l.005.014c-.026.029-.05.015-.05.015V17.9a.015.015,0,0,0,.012-.014.018.018,0,0,0-.017-.017.017.017,0,0,0-.015.017l.009.014v.113s-.022.014-.048-.015l.005-.014-.036.005.014.031.007-.01a.131.131,0,0,0,.063.031h0a.131.131,0,0,0,.063-.031l.005.01.014-.031Z",
    transform: "translate(20.319 12.763)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9870",
    "data-name": "Caminho 9870",
    d: "M28.577,17.883a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(20.412 12.756)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9871",
    "data-name": "Caminho 9871",
    d: "M28.7,17.908a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(20.502 12.774)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9872",
    "data-name": "Caminho 9872",
    d: "M28.827,17.913a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(20.591 12.778)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9873",
    "data-name": "Caminho 9873",
    d: "M28.97,17.911a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(20.693 12.776)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9874",
    "data-name": "Caminho 9874",
    d: "M29.108,17.913a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(20.791 12.778)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9875",
    "data-name": "Caminho 9875",
    d: "M29.237,17.911a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(20.884 12.776)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9876",
    "data-name": "Caminho 9876",
    d: "M29.6,17.925a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(21.144 12.786)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9877",
    "data-name": "Caminho 9877",
    d: "M29.975,17.935A.023.023,0,0,1,30,17.911a.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(21.411 12.794)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9878",
    "data-name": "Caminho 9878",
    d: "M30.1,17.939a.022.022,0,0,1,.024-.024.024.024,0,0,1,0,.048.022.022,0,0,1-.024-.024",
    transform: "translate(21.503 12.796)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9879",
    "data-name": "Caminho 9879",
    d: "M30.216,17.939a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(21.583 12.796)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9880",
    "data-name": "Caminho 9880",
    d: "M30.33,17.939a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(21.664 12.796)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9881",
    "data-name": "Caminho 9881",
    d: "M30.44,17.937a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(21.743 12.795)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9882",
    "data-name": "Caminho 9882",
    d: "M30.545,17.932a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(21.818 12.791)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9883",
    "data-name": "Caminho 9883",
    d: "M30.656,17.932a.022.022,0,0,1,.024-.024.024.024,0,0,1,0,.048.022.022,0,0,1-.024-.024",
    transform: "translate(21.897 12.791)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9884",
    "data-name": "Caminho 9884",
    d: "M29.36,17.913a.023.023,0,0,1,.024-.024.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(20.971 12.778)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9885",
    "data-name": "Caminho 9885",
    d: "M29.477,17.92A.023.023,0,0,1,29.5,17.9a.024.024,0,0,1,0,.048.023.023,0,0,1-.024-.024",
    transform: "translate(21.055 12.783)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9886",
    "data-name": "Caminho 9886",
    d: "M31.1,17.883a.03.03,0,0,1,.029.029.029.029,0,1,1-.058,0A.03.03,0,0,1,31.1,17.883Z",
    transform: "translate(22.193 12.774)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9887",
    "data-name": "Caminho 9887",
    d: "M31.2,17.874a.03.03,0,0,1,.029.029.029.029,0,1,1-.058,0A.03.03,0,0,1,31.2,17.874Z",
    transform: "translate(22.266 12.767)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9888",
    "data-name": "Caminho 9888",
    d: "M31.3,17.867a.03.03,0,0,1,.027.029.03.03,0,0,1-.027.031.029.029,0,0,1-.029-.031A.029.029,0,0,1,31.3,17.867Z",
    transform: "translate(22.339 12.762)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9889",
    "data-name": "Caminho 9889",
    d: "M28.434,17.971,28.47,18l-.007.022.015.021.007.005h0a1.806,1.806,0,0,0,.278.185l.867.026h.015s3.939-.027,3.939-.048-.034-.182-.034-.182a.054.054,0,0,0-.041-.012c-.053.012-.338.038-.54.058-.069.007-.129.012-.166.017-.149.022-.019,0-.019,0s-1.539.017-1.752.012-1.455.007-1.455.007-.78-.057-.843-.057a2.366,2.366,0,0,1-.247-.06A.187.187,0,0,1,28.434,17.971Z",
    transform: "translate(20.31 12.836)",
    fill: "#ed1c24"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9890",
    "data-name": "Caminho 9890",
    d: "M33.745,17.893l-.012.026s-1.253.094-1.353.077v.024l-2.8.014A5.758,5.758,0,0,1,28.853,18a3.855,3.855,0,0,1-.477-.11l-.053.007s.113.091.189.137a.157.157,0,0,0,.058.026c.053.005.182.06.245.06s.843.055.843.055,1.239-.01,1.454-.005,1.752-.012,1.752-.012-.129.022.022,0,.636-.06.7-.075a.15.15,0,0,0,.069-.051.809.809,0,0,0,.093-.134h-.007",
    transform: "translate(20.231 12.776)",
    fill: "#034ea2"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9891",
    "data-name": "Caminho 9891",
    d: "M29.85,17.991l.007-.261s1.149.051,1.7.045v.2s-1.509.024-1.707.012",
    transform: "translate(21.321 12.664)",
    fill: "#fd0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9892",
    "data-name": "Caminho 9892",
    d: "M30.411,18.2l.027.021.031-.021-.012-.2H30.42Z",
    transform: "translate(21.722 12.859)",
    fill: "#9b7e39"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9893",
    "data-name": "Caminho 9893",
    d: "M30.408,18l-.06.177.021.027.036-.01.043-.2h-.007l-.033,0",
    transform: "translate(21.677 12.858)",
    fill: "#9b7e39"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9894",
    "data-name": "Caminho 9894",
    d: "M30.292,18.125l.012.033h.036L30.426,18l-.05,0Z",
    transform: "translate(21.637 12.859)",
    fill: "#9b7e39"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9895",
    "data-name": "Caminho 9895",
    d: "M30.249,18.05l0,.034.034.01L30.374,18l-.074,0Z",
    transform: "translate(21.606 12.861)",
    fill: "#9b7e39"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9896",
    "data-name": "Caminho 9896",
    d: "M30.512,18.185l.033.01.022-.031L30.5,18l-.043,0Z",
    transform: "translate(21.754 12.859)",
    fill: "#9b7e39"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9897",
    "data-name": "Caminho 9897",
    d: "M30.569,18.148l.034,0,.014-.034-.081-.11-.051,0Z",
    transform: "translate(21.775 12.86)",
    fill: "#9b7e39"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9898",
    "data-name": "Caminho 9898",
    d: "M30.614,18.083l.033-.007.005-.038-.038-.031-.079,0Z",
    transform: "translate(21.811 12.861)",
    fill: "#9b7e39"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9899",
    "data-name": "Caminho 9899",
    d: "M30.263,16.911l.009.007s.009-.014.017-.014a.126.126,0,0,1,.031.01l0-.014.039.01,0-.019.024,0,0-.015.031,0,0-.014.043,0-.01-.017s.036.005.051.005.012,0,.012,0v-.012l.057,0-.009-.012.043,0-.019-.019s.086.027.113,0a.225.225,0,0,1-.084-.012c-.043-.014-.084-.017-.1-.022a.406.406,0,0,1-.074-.024.285.285,0,0,1-.046-.022H30.4a.935.935,0,0,0-.144-.045s-.063-.014-.093.009a.061.061,0,0,1-.024.021.185.185,0,0,0-.036.024s-.007-.005-.036.012l-.007,0a.163.163,0,0,0-.122,0l0,0a.15.15,0,0,0-.048-.012l-.027-.015h0s-.027-.055-.075-.05a.251.251,0,0,0-.079.017l-.067.022a.2.2,0,0,0-.033.012.559.559,0,0,1-.055.021l-.074.015.009,0a.617.617,0,0,1-.074.017c-.026,0-.106.015-.113.014s0,0,0,0a.2.2,0,0,0,.091.007l.027,0h0l-.029.014s.07,0,.058,0l-.022.012.067,0-.009.009s.06,0,.067,0l-.01.014a.243.243,0,0,0,.051-.009l-.01.015.045,0-.015.017.036,0c.007,0,0,0,0,0l-.012.01h.043l-.005.009.038-.007.01.01.034-.012.019.014.022-.017h0s.007.017.015.021l.019-.01.01.012.01-.01.024.01s.005-.014.014-.012a.16.16,0,0,0,.1.06.132.132,0,0,0,.118-.041l.026-.017,0,.015.026-.012v.007s.034-.014.034-.021l.012.019.024-.014s.007.009.024.012",
    transform: "translate(20.925 11.913)",
    fill: "#fff"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9900",
    "data-name": "Caminho 9900",
    d: "M30.263,16.911l.009.007s.009-.014.017-.014a.126.126,0,0,1,.031.01l0-.014.039.01,0-.019.024,0,0-.015.031,0,0-.014.043,0-.01-.017s.036.005.051.005.012,0,.012,0v-.012l.057,0-.009-.012.043,0-.019-.019s.086.027.113,0a.225.225,0,0,1-.084-.012c-.043-.014-.084-.017-.1-.022a.406.406,0,0,1-.074-.024.285.285,0,0,1-.046-.022H30.4a.935.935,0,0,0-.144-.045s-.063-.014-.093.009a.061.061,0,0,1-.024.021.185.185,0,0,0-.036.024s-.007-.005-.036.012l-.007,0a.163.163,0,0,0-.122,0l0,0a.15.15,0,0,0-.048-.012l-.027-.015h0s-.027-.055-.075-.05a.251.251,0,0,0-.079.017l-.067.022a.2.2,0,0,0-.033.012.559.559,0,0,1-.055.021l-.074.015.009,0a.617.617,0,0,1-.074.017c-.026,0-.106.015-.113.014s0,0,0,0a.2.2,0,0,0,.091.007l.027,0h0l-.029.014s.07,0,.058,0l-.022.012.067,0-.009.009s.06,0,.067,0l-.01.014a.243.243,0,0,0,.051-.009l-.01.015.045,0-.015.017.036,0c.007,0,0,0,0,0l-.012.01h.043l-.005.009.038-.007.01.01.034-.012.019.014.022-.017h0s.007.017.015.021l.019-.01.01.012.01-.01.024.01s.005-.014.014-.012a.16.16,0,0,0,.1.06.132.132,0,0,0,.118-.041l.026-.017,0,.015.026-.012v.007s.034-.014.034-.021l.012.019.024-.014s.007.009.024.012",
    transform: "translate(20.925 11.913)",
    fill: "none",
    stroke: "#999b9e",
    strokeWidth: 0.05
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9901",
    "data-name": "Caminho 9901",
    d: "M29.715,16.809l.005.005",
    transform: "translate(21.225 12.006)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9902",
    "data-name": "Caminho 9902",
    d: "M29.707,16.812l0,.009",
    transform: "translate(21.219 12.009)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9903",
    "data-name": "Caminho 9903",
    d: "M29.423,16.757l-.007,0",
    transform: "translate(21.011 11.969)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.05
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9904",
    "data-name": "Caminho 9904",
    d: "M29.412,16.76l-.01.005",
    transform: "translate(21.001 11.971)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.05
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9905",
    "data-name": "Caminho 9905",
    d: "M30.06,16.811a.4.4,0,0,1-.13-.058l0-.012,0,0a.062.062,0,0,0,.033.009.038.038,0,0,0-.01-.017",
    transform: "translate(21.376 11.95)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9906",
    "data-name": "Caminho 9906",
    d: "M30.028,16.737a.778.778,0,0,1-.084,0",
    transform: "translate(21.389 11.954)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9907",
    "data-name": "Caminho 9907",
    d: "M30.069,16.755a.13.13,0,0,0-.029,0,.135.135,0,0,1-.063-.005.1.1,0,0,0-.031-.012",
    transform: "translate(21.39 11.958)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9908",
    "data-name": "Caminho 9908",
    d: "M30.005,16.8a.248.248,0,0,1-.094-.051",
    transform: "translate(21.365 11.964)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9909",
    "data-name": "Caminho 9909",
    d: "M29.992,16.815a.222.222,0,0,1-.1-.065",
    transform: "translate(21.348 11.964)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9910",
    "data-name": "Caminho 9910",
    d: "M29.975,16.829s-.1-.033-.106-.081",
    transform: "translate(21.335 11.963)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9911",
    "data-name": "Caminho 9911",
    d: "M29.962,16.839a.2.2,0,0,1-.108-.086",
    transform: "translate(21.324 11.966)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9912",
    "data-name": "Caminho 9912",
    d: "M29.927,16.84a.331.331,0,0,1-.075-.079",
    transform: "translate(21.323 11.972)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9913",
    "data-name": "Caminho 9913",
    d: "M29.9,16.846a.335.335,0,0,1-.048-.087",
    transform: "translate(21.32 11.971)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9914",
    "data-name": "Caminho 9914",
    d: "M29.852,16.845a.22.22,0,0,1-.014-.093",
    transform: "translate(21.311 11.966)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9915",
    "data-name": "Caminho 9915",
    d: "M29.826,16.829s0-.005,0-.024a.062.062,0,0,0,0-.036",
    transform: "translate(21.303 11.978)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9916",
    "data-name": "Caminho 9916",
    d: "M29.8,16.847a.105.105,0,0,1,.007-.038.045.045,0,0,0,0-.046",
    transform: "translate(21.289 11.974)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9917",
    "data-name": "Caminho 9917",
    d: "M29.787,16.836A.037.037,0,0,1,29.8,16.8l0-.015,0,0,0-.01",
    transform: "translate(21.276 11.981)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9918",
    "data-name": "Caminho 9918",
    d: "M29.759,16.781l.014-.019,0-.007.005.007.01,0,.019-.01.01-.01h.014l.024-.015.007-.01.009-.009a.128.128,0,0,0,.029.005h.027a.417.417,0,0,1,.046,0l.038.005.024.005a.119.119,0,0,0,.027,0",
    transform: "translate(21.256 11.931)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9919",
    "data-name": "Caminho 9919",
    d: "M29.788,16.786l.015.009c0-.007.01-.014.014-.019a.034.034,0,0,0,.007-.022",
    transform: "translate(21.277 11.966)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9920",
    "data-name": "Caminho 9920",
    d: "M29.8,16.746a.308.308,0,0,1,.039.043l.005-.027s.01-.009.009-.015",
    transform: "translate(21.287 11.961)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9921",
    "data-name": "Caminho 9921",
    d: "M29.818,16.72l.01.024.012.022.017.014.017.009.005-.015,0-.021",
    transform: "translate(21.299 11.943)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9922",
    "data-name": "Caminho 9922",
    d: "M29.844,16.718c0,.022.014.034.036.046a.062.062,0,0,0,.031.012c.012,0,.005-.017.007-.024",
    transform: "translate(21.317 11.941)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9923",
    "data-name": "Caminho 9923",
    d: "M29.857,16.722l.021.014.015.012,0-.007",
    transform: "translate(21.327 11.944)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9924",
    "data-name": "Caminho 9924",
    d: "M29.869,16.716l.014.024a.109.109,0,0,0,.026.022.057.057,0,0,0,.024.009c.009,0,.009-.01.005-.015s.024.005.033.009",
    transform: "translate(21.335 11.94)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9925",
    "data-name": "Caminho 9925",
    d: "M29.816,16.729a.5.5,0,0,0,.05-.007.13.13,0,0,1,.036,0l.031.005-.007-.019",
    transform: "translate(21.297 11.934)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9926",
    "data-name": "Caminho 9926",
    d: "M29.887,16.71a.082.082,0,0,0,.029.017l.012,0,.01.007",
    transform: "translate(21.348 11.936)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9927",
    "data-name": "Caminho 9927",
    d: "M29.892,16.722c.009,0,.019.005.021.015",
    transform: "translate(21.351 11.944)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9928",
    "data-name": "Caminho 9928",
    d: "M29.786,16.777l-.014.019",
    transform: "translate(21.266 11.984)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9929",
    "data-name": "Caminho 9929",
    d: "M29.8,16.777v.012",
    transform: "translate(21.287 11.984)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9930",
    "data-name": "Caminho 9930",
    d: "M29.8,16.795l-.005.019,0,0",
    transform: "translate(21.285 11.996)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9931",
    "data-name": "Caminho 9931",
    d: "M29.823,16.8l0,.009",
    transform: "translate(21.301 11.997)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9932",
    "data-name": "Caminho 9932",
    d: "M29.811,16.759l.009.015.007.01",
    transform: "translate(21.293 11.971)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9933",
    "data-name": "Caminho 9933",
    d: "M29.834,16.772l0-.007",
    transform: "translate(21.308 11.975)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9934",
    "data-name": "Caminho 9934",
    d: "M29.831,16.76l.005.009",
    transform: "translate(21.308 11.971)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9935",
    "data-name": "Caminho 9935",
    d: "M29.832,16.754l0,.005",
    transform: "translate(21.309 11.967)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9936",
    "data-name": "Caminho 9936",
    d: "M29.84,16.8l0,0",
    transform: "translate(21.314 12.001)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9937",
    "data-name": "Caminho 9937",
    d: "M29.85,16.79l.005.014",
    transform: "translate(21.321 11.993)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9938",
    "data-name": "Caminho 9938",
    d: "M29.864,16.81l0-.012",
    transform: "translate(21.329 11.999)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9939",
    "data-name": "Caminho 9939",
    d: "M29.9,16.8l.01.005",
    transform: "translate(21.354 11.999)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9940",
    "data-name": "Caminho 9940",
    d: "M29.908,16.805h.012",
    transform: "translate(21.363 12.004)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9941",
    "data-name": "Caminho 9941",
    d: "M29.907,16.788l.012.01",
    transform: "translate(21.362 11.991)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9942",
    "data-name": "Caminho 9942",
    d: "M29.945,16.775c.009,0,.014.005.021.005",
    transform: "translate(21.389 11.982)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9943",
    "data-name": "Caminho 9943",
    d: "M29.946,16.758l.015.014",
    transform: "translate(21.39 11.97)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9944",
    "data-name": "Caminho 9944",
    d: "M29.97,16.77l.017.007",
    transform: "translate(21.407 11.979)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9945",
    "data-name": "Caminho 9945",
    d: "M29.875,16.695l.014.007.014,0",
    transform: "translate(21.339 11.925)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9946",
    "data-name": "Caminho 9946",
    d: "M29.866,16.695c.009,0,.014.007.021.007l-.009,0",
    transform: "translate(21.333 11.925)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9947",
    "data-name": "Caminho 9947",
    d: "M29.855,16.7l.014.009v0",
    transform: "translate(21.325 11.926)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9948",
    "data-name": "Caminho 9948",
    d: "M29.845,16.693l.012.01",
    transform: "translate(21.318 11.924)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9949",
    "data-name": "Caminho 9949",
    d: "M29.84,16.694l.005.007",
    transform: "translate(21.314 11.924)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9950",
    "data-name": "Caminho 9950",
    d: "M29.829,16.7l-.005-.007",
    transform: "translate(21.303 11.924)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9951",
    "data-name": "Caminho 9951",
    d: "M29.832,16.724a.049.049,0,0,1,.021.034",
    transform: "translate(21.309 11.946)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9952",
    "data-name": "Caminho 9952",
    d: "M29.94,16.721c.01,0,.015.01.024.014l0,0",
    transform: "translate(21.386 11.944)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9953",
    "data-name": "Caminho 9953",
    d: "M29.921,16.717c.009,0,.017,0,.024.01l.009.007,0,0",
    transform: "translate(21.372 11.941)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9954",
    "data-name": "Caminho 9954",
    d: "M29.883,16.755l.014.014.007.01",
    transform: "translate(21.345 11.968)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9955",
    "data-name": "Caminho 9955",
    d: "M29.784,16.732c0,.005.019.005.015.015l0,.009,0,.01",
    transform: "translate(21.274 11.951)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9956",
    "data-name": "Caminho 9956",
    d: "M29.781,16.741l0,.012,0,0",
    transform: "translate(21.272 11.958)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9957",
    "data-name": "Caminho 9957",
    d: "M29.8,16.726l.026.017.01.015",
    transform: "translate(21.286 11.947)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9958",
    "data-name": "Caminho 9958",
    d: "M29.794,16.717c.014,0,.014-.007.021-.012",
    transform: "translate(21.281 11.932)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9959",
    "data-name": "Caminho 9959",
    d: "M29.81,16.717c.005-.005,0-.017.01-.019",
    transform: "translate(21.293 11.927)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9960",
    "data-name": "Caminho 9960",
    d: "M29.8,16.706c.009-.007.012-.015.024-.017",
    transform: "translate(21.287 11.921)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9961",
    "data-name": "Caminho 9961",
    d: "M29.753,16.729l.01.01",
    transform: "translate(21.252 11.949)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9962",
    "data-name": "Caminho 9962",
    d: "M29.751,16.735l0,.007,0,0",
    transform: "translate(21.25 11.954)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9963",
    "data-name": "Caminho 9963",
    d: "M29.742,16.732l.005.005,0,0",
    transform: "translate(21.244 11.952)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9964",
    "data-name": "Caminho 9964",
    d: "M29.759,16.754v.017",
    transform: "translate(21.256 11.967)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9965",
    "data-name": "Caminho 9965",
    d: "M29.745,16.807l0,.015",
    transform: "translate(21.245 12.005)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9966",
    "data-name": "Caminho 9966",
    d: "M29.639,16.762l.007-.005.012,0",
    transform: "translate(21.171 11.968)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9967",
    "data-name": "Caminho 9967",
    d: "M29.652,16.766v.005",
    transform: "translate(21.18 11.976)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9968",
    "data-name": "Caminho 9968",
    d: "M29.645,16.767v0",
    transform: "translate(21.175 11.976)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9969",
    "data-name": "Caminho 9969",
    d: "M29.64,16.767v.005",
    transform: "translate(21.171 11.976)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9970",
    "data-name": "Caminho 9970",
    d: "M29.668,16.728l-.009.017h0",
    transform: "translate(21.185 11.949)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9971",
    "data-name": "Caminho 9971",
    d: "M29.672,16.732l0,.01",
    transform: "translate(21.192 11.951)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9972",
    "data-name": "Caminho 9972",
    d: "M29.688,16.722l-.012.009",
    transform: "translate(21.197 11.944)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9973",
    "data-name": "Caminho 9973",
    d: "M29.755,16.766c-.01,0-.014-.007-.014-.015s-.021-.014-.015-.021c0,.014-.021.009-.029,0a.075.075,0,0,1-.033-.033l-.017.005-.045,0c-.017,0-.033-.005-.05-.005s-.026.009-.039.009l-.036,0",
    transform: "translate(21.055 11.929)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9974",
    "data-name": "Caminho 9974",
    d: "M29.658,16.725l-.021.005v0",
    transform: "translate(21.169 11.946)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9975",
    "data-name": "Caminho 9975",
    d: "M29.4,16.734c.019,0,.038.005.058.005l.027-.005.026-.005",
    transform: "translate(21.003 11.949)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9976",
    "data-name": "Caminho 9976",
    d: "M29.409,16.8a.3.3,0,0,0,.053-.012.242.242,0,0,0,.053-.019.033.033,0,0,0,.017-.017l.009-.022",
    transform: "translate(21.006 11.949)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9977",
    "data-name": "Caminho 9977",
    d: "M29.442,16.8c.009,0,.017-.012.024-.017l.026-.009a.129.129,0,0,0,.051-.031",
    transform: "translate(21.03 11.96)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9978",
    "data-name": "Caminho 9978",
    d: "M29.466,16.811a.079.079,0,0,1,.027-.012.236.236,0,0,0,.034-.022.3.3,0,0,0,.033-.034",
    transform: "translate(21.047 11.959)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9979",
    "data-name": "Caminho 9979",
    d: "M29.488,16.817c.019-.01.039-.019.057-.029a.1.1,0,0,0,.026-.019l.015-.022",
    transform: "translate(21.063 11.962)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9980",
    "data-name": "Caminho 9980",
    d: "M29.5,16.833c.021-.012.041-.026.06-.039a.115.115,0,0,0,.045-.041",
    transform: "translate(21.072 11.966)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9981",
    "data-name": "Caminho 9981",
    d: "M29.518,16.84a.158.158,0,0,1,.045-.045.052.052,0,0,0,.027-.036",
    transform: "translate(21.084 11.971)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9982",
    "data-name": "Caminho 9982",
    d: "M29.539,16.836c0-.007.007-.012.01-.017l.015-.022.014-.029",
    transform: "translate(21.099 11.976)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9983",
    "data-name": "Caminho 9983",
    d: "M29.565,16.843a.331.331,0,0,0,.01-.057l0-.014.005-.021",
    transform: "translate(21.118 11.966)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9984",
    "data-name": "Caminho 9984",
    d: "M29.59,16.836l0-.012,0-.012V16.79a.122.122,0,0,1,0-.024.019.019,0,0,1,.015-.012",
    transform: "translate(21.134 11.967)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9985",
    "data-name": "Caminho 9985",
    d: "M29.617,16.843c-.005-.019-.021-.036-.019-.055a.029.029,0,0,1,.01-.026",
    transform: "translate(21.141 11.973)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9986",
    "data-name": "Caminho 9986",
    d: "M29.62,16.829a.072.072,0,0,0,0-.046",
    transform: "translate(21.157 11.988)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9987",
    "data-name": "Caminho 9987",
    d: "M29.648,16.83c-.005-.012-.017-.019-.014-.033l.005-.019",
    transform: "translate(21.167 11.985)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9988",
    "data-name": "Caminho 9988",
    d: "M29.649,16.8l-.017.012-.021,0,0-.027a.074.074,0,0,1,0-.027.053.053,0,0,1,.041-.029",
    transform: "translate(21.149 11.954)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9989",
    "data-name": "Caminho 9989",
    d: "M29.645,16.73c-.009.014-.027.007-.036.017a.045.045,0,0,0-.009.041l.012-.007",
    transform: "translate(21.142 11.95)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9990",
    "data-name": "Caminho 9990",
    d: "M29.607,16.717c0,.009-.012.014-.017.021l-.009.019a.048.048,0,0,0,0,.022l.009.019",
    transform: "translate(21.129 11.941)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9991",
    "data-name": "Caminho 9991",
    d: "M29.6,16.707c0,.015-.024.027-.034.038a.022.022,0,0,0-.009.019l.009.014,0,.009.014-.007.017-.005",
    transform: "translate(21.111 11.934)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9992",
    "data-name": "Caminho 9992",
    d: "M29.513,16.711c-.015.012-.041.019-.05.038",
    transform: "translate(21.045 11.936)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9993",
    "data-name": "Caminho 9993",
    d: "M29.538,16.735l-.015.014-.022,0",
    transform: "translate(21.071 11.954)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9994",
    "data-name": "Caminho 9994",
    d: "M29.48,16.75c.009,0,.039,0,.039-.015",
    transform: "translate(21.057 11.954)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9995",
    "data-name": "Caminho 9995",
    d: "M29.526,16.755a.031.031,0,0,0,.027-.01",
    transform: "translate(21.09 11.961)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9996",
    "data-name": "Caminho 9996",
    d: "M29.505,16.735l-.005.017",
    transform: "translate(21.071 11.954)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9997",
    "data-name": "Caminho 9997",
    d: "M29.521,16.736c.009.007,0,.022.009.027",
    transform: "translate(21.086 11.954)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9998",
    "data-name": "Caminho 9998",
    d: "M29.572,16.713l-.019.019-.012.014c0,.007,0,.014,0,.021",
    transform: "translate(21.1 11.938)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9999",
    "data-name": "Caminho 9999",
    d: "M29.533,16.708l.021,0a.068.068,0,0,0,.019,0,.036.036,0,0,1,.019,0l.01.007",
    transform: "translate(21.095 11.934)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10000",
    "data-name": "Caminho 10000",
    d: "M29.561,16.741l-.019.009",
    transform: "translate(21.101 11.958)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10001",
    "data-name": "Caminho 10001",
    d: "M29.505,16.727l0,.009",
    transform: "translate(21.073 11.948)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10002",
    "data-name": "Caminho 10002",
    d: "M29.514,16.734a.052.052,0,0,1,.024-.019",
    transform: "translate(21.081 11.939)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10003",
    "data-name": "Caminho 10003",
    d: "M29.619,16.708v.007",
    transform: "translate(21.156 11.935)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10004",
    "data-name": "Caminho 10004",
    d: "M29.611,16.7l0,.015,0,0",
    transform: "translate(21.151 11.93)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10005",
    "data-name": "Caminho 10005",
    d: "M29.606,16.7v.01",
    transform: "translate(21.147 11.929)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10006",
    "data-name": "Caminho 10006",
    d: "M29.593,16.7l.009-.009",
    transform: "translate(21.138 11.921)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10007",
    "data-name": "Caminho 10007",
    d: "M29.6,16.688l-.01.01",
    transform: "translate(21.132 11.92)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10008",
    "data-name": "Caminho 10008",
    d: "M29.588,16.687l-.009.01",
    transform: "translate(21.128 11.919)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10009",
    "data-name": "Caminho 10009",
    d: "M29.58,16.69l-.012.009",
    transform: "translate(21.12 11.921)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10010",
    "data-name": "Caminho 10010",
    d: "M29.566,16.691l-.01.007",
    transform: "translate(21.111 11.922)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10011",
    "data-name": "Caminho 10011",
    d: "M29.554,16.691l-.007,0",
    transform: "translate(21.105 11.922)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10012",
    "data-name": "Caminho 10012",
    d: "M29.635,16.752c0-.007.014-.007.019-.005",
    transform: "translate(21.168 11.961)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10013",
    "data-name": "Caminho 10013",
    d: "M29.627,16.756l.005-.005",
    transform: "translate(21.162 11.965)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10014",
    "data-name": "Caminho 10014",
    d: "M29.583,16.772c0,.007,0,.012,0,.019",
    transform: "translate(21.129 11.98)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Linha_85",
    "data-name": "Linha 85",
    y1: 0.007,
    transform: "translate(50.698 28.803)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10015",
    "data-name": "Caminho 10015",
    d: "M29.58,16.8l0,.005",
    transform: "translate(21.127 12)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10016",
    "data-name": "Caminho 10016",
    d: "M29.573,16.8l0,0",
    transform: "translate(21.122 11.998)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10017",
    "data-name": "Caminho 10017",
    d: "M29.549,16.807l0,0",
    transform: "translate(21.106 12.003)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10018",
    "data-name": "Caminho 10018",
    d: "M29.558,16.8v0",
    transform: "translate(21.113 12)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10019",
    "data-name": "Caminho 10019",
    d: "M29.57,16.766c0,.007,0,.019-.007.024",
    transform: "translate(21.116 11.976)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10020",
    "data-name": "Caminho 10020",
    d: "M29.6,16.717c-.007.009-.029.017-.029.029",
    transform: "translate(21.122 11.941)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10021",
    "data-name": "Caminho 10021",
    d: "M29.552,16.715l-.005,0",
    transform: "translate(21.105 11.939)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10022",
    "data-name": "Caminho 10022",
    d: "M29.564,16.718l-.007.01",
    transform: "translate(21.112 11.941)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10023",
    "data-name": "Caminho 10023",
    d: "M29.614,16.73c-.01,0-.021.007-.022.017",
    transform: "translate(21.137 11.95)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10024",
    "data-name": "Caminho 10024",
    d: "M29.534,16.755c0,.01-.01.019-.021.022",
    transform: "translate(21.081 11.968)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10025",
    "data-name": "Caminho 10025",
    d: "M29.559,16.755l-.015.012",
    transform: "translate(21.103 11.968)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10026",
    "data-name": "Caminho 10026",
    d: "M29.513,16.784l-.007.009",
    transform: "translate(21.076 11.989)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10027",
    "data-name": "Caminho 10027",
    d: "M29.5,16.79l-.012.005",
    transform: "translate(21.065 11.993)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10028",
    "data-name": "Caminho 10028",
    d: "M29.481,16.765l-.01.009",
    transform: "translate(21.051 11.975)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10029",
    "data-name": "Caminho 10029",
    d: "M29.464,16.775l-.017,0",
    transform: "translate(21.034 11.982)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10030",
    "data-name": "Caminho 10030",
    d: "M29.446,16.77l-.01.007",
    transform: "translate(21.026 11.979)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.05
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10031",
    "data-name": "Caminho 10031",
    d: "M29.47,16.722a.06.06,0,0,0-.029.01",
    transform: "translate(21.029 11.944)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10032",
    "data-name": "Caminho 10032",
    d: "M29.417,16.767l-.012,0",
    transform: "translate(21.004 11.976)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.05
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10033",
    "data-name": "Caminho 10033",
    d: "M29.365,16.767a.163.163,0,0,1,.051-.015l.021-.007.019-.01",
    transform: "translate(20.975 11.953)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_86",
    "data-name": "Linha 86",
    x1: 0.01,
    transform: "translate(50.455 28.744)",
    fill: "none",
    stroke: "#d0c9ce",
    strokeWidth: 0.05
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10034",
    "data-name": "Caminho 10034",
    d: "M29.657,18.229s.019-.1.089-.117.142-.075.142-.147a.145.145,0,0,0-.084-.135.307.307,0,0,0,.132-.221.26.26,0,0,0-.139-.2s.213-.082.228-.192-.1-.237-.129-.274a.14.14,0,0,0-.086-.041l.022.045-.045-.019a.3.3,0,0,0,.082.113c.043.038.122.117.1.177s-.218.159-.218.159v.082s.141.086.135.161-.125.163-.125.163l-.007.075s.084.055.081.117-.091.089-.091.089a.16.16,0,0,0-.093.158",
    transform: "translate(21.18 12.069)",
    fill: "#2f3b30"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10035",
    "data-name": "Caminho 10035",
    d: "M29.657,18.229s.019-.1.089-.117.142-.075.142-.147a.145.145,0,0,0-.084-.135.307.307,0,0,0,.132-.221.26.26,0,0,0-.139-.2s.213-.082.228-.192-.1-.237-.129-.274a.14.14,0,0,0-.086-.041l.022.045-.045-.019a.3.3,0,0,0,.082.113c.043.038.122.117.1.177s-.218.159-.218.159v.082s.141.086.135.161-.125.163-.125.163l-.007.075s.084.055.081.117-.091.089-.091.089a.16.16,0,0,0-.093.158",
    transform: "translate(21.18 12.069)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.05
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10036",
    "data-name": "Caminho 10036",
    d: "M29.918,18.229s-.021-.1-.089-.117-.144-.075-.144-.147a.145.145,0,0,1,.084-.135.307.307,0,0,1-.13-.221.26.26,0,0,1,.137-.2s-.213-.082-.226-.192.094-.237.127-.274a.143.143,0,0,1,.087-.041l-.024.045.045-.019a.285.285,0,0,1-.081.113c-.045.038-.123.117-.1.177s.218.159.218.159v.082s-.141.086-.135.161.125.163.125.163l.007.075s-.084.055-.081.117.093.089.093.089a.159.159,0,0,1,.091.158",
    transform: "translate(21.106 12.069)",
    fill: "#2f3b30"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10037",
    "data-name": "Caminho 10037",
    d: "M29.918,18.229s-.021-.1-.089-.117-.144-.075-.144-.147a.145.145,0,0,1,.084-.135.307.307,0,0,1-.13-.221.26.26,0,0,1,.137-.2s-.213-.082-.226-.192.094-.237.127-.274a.143.143,0,0,1,.087-.041l-.024.045.045-.019a.285.285,0,0,1-.081.113c-.045.038-.123.117-.1.177s.218.159.218.159v.082s-.141.086-.135.161.125.163.125.163l.007.075s-.084.055-.081.117.093.089.093.089a.159.159,0,0,1,.091.158",
    transform: "translate(21.106 12.069)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.05
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_581",
    "data-name": "Ret\\xE2ngulo 581",
    width: 0.053,
    height: 1.992,
    transform: "translate(50.895 28.605)",
    fill: "#64472d"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_582",
    "data-name": "Ret\\xE2ngulo 582",
    width: 0.014,
    height: 0.038,
    transform: "translate(50.914 28.581)",
    fill: "#64472d"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10038",
    "data-name": "Caminho 10038",
    d: "M29.674,16.663a.053.053,0,1,1,.053.055.054.054,0,0,1-.053-.055",
    transform: "translate(21.196 11.863)",
    fill: "#64472d"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10039",
    "data-name": "Caminho 10039",
    d: "M32.062,10.225c2.22,1.361,3.763,4.382,3.763,7.889,0,4.174-2.186,7.658-5.1,8.479",
    transform: "translate(21.949 7.304)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10040",
    "data-name": "Caminho 10040",
    d: "M32,10.308c2.189,1.327,3.713,4.3,3.713,7.747,0,4.1-2.148,7.515-5.006,8.313",
    transform: "translate(21.933 7.363)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10041",
    "data-name": "Caminho 10041",
    d: "M29.164,19.8a4.757,4.757,0,0,0,2.784-.012",
    transform: "translate(20.831 14.134)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10042",
    "data-name": "Caminho 10042",
    d: "M36.894,17.291a6.178,6.178,0,0,1-3.888,3.73l.015-.084a4.175,4.175,0,0,1-2.213-.039l.01.094a6.1,6.1,0,0,1-3.646-3.4l.043.087a6.051,6.051,0,0,0,3.6,3.315l-.01-.094a4.175,4.175,0,0,0,2.213.039l-.015.084A6.126,6.126,0,0,0,36.847,17.4",
    transform: "translate(19.409 12.351)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10043",
    "data-name": "Caminho 10043",
    d: "M35.318,10.5a5.686,5.686,0,0,0-2.781-.73,6.761,6.761,0,0,0-2.469.675,7.8,7.8,0,0,0-3.081,3.909,11.16,11.16,0,0,0-.754,4.077c0,4.222,2.347,7.6,5.278,8.405a2.825,2.825,0,0,0,1.032.19,9.51,9.51,0,0,0,1.145-.075c2.99-.742,5.347-4.2,5.347-8.475A10.669,10.669,0,0,0,35.318,10.5M33.691,26.4a7.477,7.477,0,0,1-1.14.11,4.644,4.644,0,0,1-1.051-.137c-2.64-.737-4.737-3.938-4.737-7.8a10.8,10.8,0,0,1,.732-3.814,7.054,7.054,0,0,1,2.83-3.518,5.282,5.282,0,0,1,2.237-.758,4.405,4.405,0,0,1,2.489.807c1.989,1.262,3.37,4.037,3.37,7.26,0,3.917-2.04,7.174-4.731,7.853",
    transform: "translate(18.739 6.976)",
    fill: "#b1babf"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10044",
    "data-name": "Caminho 10044",
    d: "M30.056,10.295c-2.2,1.329-3.739,4.325-3.739,7.81,0,4.126,2.155,7.569,5.019,8.366l-.077.156c-2.9-.838-5.069-4.335-5.069-8.522,0-3.509,1.519-6.535,3.72-7.915l.146.106Z",
    transform: "translate(18.707 7.279)",
    fill: "#c69024"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10045",
    "data-name": "Caminho 10045",
    d: "M30.056,10.295c-2.2,1.329-3.739,4.325-3.739,7.81,0,4.126,2.155,7.569,5.019,8.366l-.077.156c-2.9-.838-5.069-4.335-5.069-8.522,0-3.509,1.519-6.535,3.72-7.915l.146.106Z",
    transform: "translate(18.707 7.279)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10046",
    "data-name": "Caminho 10046",
    d: "M32.017,10.307c2.2,1.329,3.744,4.327,3.744,7.812,0,4.128-2.16,7.572-5.028,8.369l.077.156c2.9-.838,5.078-4.337,5.078-8.525,0-3.513-1.529-6.538-3.732-7.918l-.019-.014-.154.1Z",
    transform: "translate(21.952 7.276)",
    fill: "#c69024"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10047",
    "data-name": "Caminho 10047",
    d: "M32.017,10.307c2.2,1.329,3.744,4.327,3.744,7.812,0,4.128-2.16,7.572-5.028,8.369l.077.156c2.9-.838,5.078-4.337,5.078-8.525,0-3.513-1.529-6.538-3.732-7.918l-.019-.014-.154.1Z",
    transform: "translate(21.952 7.276)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10048",
    "data-name": "Caminho 10048",
    d: "M30.076,10.716c-2.007,1.222-3.408,3.982-3.408,7.19,0,3.8,1.965,6.969,4.574,7.7l.05.194-.118-.05c-2.64-.773-4.622-3.993-4.622-7.846,0-3.231,1.392-6.017,3.4-7.287l.015-.012.141.094Z",
    transform: "translate(18.965 7.576)",
    fill: "#c69024"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10049",
    "data-name": "Caminho 10049",
    d: "M30.076,10.716c-2.007,1.222-3.408,3.982-3.408,7.19,0,3.8,1.965,6.969,4.574,7.7l.05.194-.118-.05c-2.64-.773-4.622-3.993-4.622-7.846,0-3.231,1.392-6.017,3.4-7.287l.015-.012.141.094Z",
    transform: "translate(18.965 7.576)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10050",
    "data-name": "Caminho 10050",
    d: "M33.751,10.515l.019.014-.387.831-.012-.009a4.569,4.569,0,0,0-2.385-.7,5.261,5.261,0,0,0-2.167.686c.075-.189-.415-.826-.415-.826l.106-.063a6.077,6.077,0,0,1,2.465-.782,5.121,5.121,0,0,1,2.775.845",
    transform: "translate(20.289 6.907)",
    fill: "#c69024"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10051",
    "data-name": "Caminho 10051",
    d: "M33.751,10.515l.019.014-.387.831-.012-.009a4.569,4.569,0,0,0-2.385-.7,5.261,5.261,0,0,0-2.167.686c.075-.189-.415-.826-.415-.826l.106-.063a6.077,6.077,0,0,1,2.465-.782,5.121,5.121,0,0,1,2.775.845",
    transform: "translate(20.289 6.907)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10052",
    "data-name": "Caminho 10052",
    d: "M31.8,10.74c2.011,1.222,3.413,3.982,3.413,7.191,0,3.8-1.966,6.972-4.582,7.7l.005.166.1-.033c2.625-.792,4.589-4,4.589-7.838,0-3.231-1.394-6.019-3.4-7.289l0,0-.117-.069-.039.153Z",
    transform: "translate(21.879 7.551)",
    fill: "#c69024"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10053",
    "data-name": "Caminho 10053",
    d: "M31.8,10.74c2.011,1.222,3.413,3.982,3.413,7.191,0,3.8-1.966,6.972-4.582,7.7l.005.166.1-.033c2.625-.792,4.589-4,4.589-7.838,0-3.231-1.394-6.019-3.4-7.289l0,0-.117-.069-.039.153Z",
    transform: "translate(21.879 7.551)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10054",
    "data-name": "Caminho 10054",
    d: "M31.871,10.261l-.005,0a.826.826,0,0,0-.394.578,1.15,1.15,0,0,0-.026.269,1.352,1.352,0,0,1-.206-.129.915.915,0,0,1,.022-.221.8.8,0,0,1,.458-.612Z",
    transform: "translate(22.314 7.25)",
    fill: "#c69024"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10055",
    "data-name": "Caminho 10055",
    d: "M31.871,10.261l-.005,0a.826.826,0,0,0-.394.578,1.15,1.15,0,0,0-.026.269,1.352,1.352,0,0,1-.206-.129.915.915,0,0,1,.022-.221.8.8,0,0,1,.458-.612Z",
    transform: "translate(22.314 7.25)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10056",
    "data-name": "Caminho 10056",
    d: "M28.293,10.273l.005,0a.826.826,0,0,1,.394.578,1.152,1.152,0,0,1,.026.269,1.352,1.352,0,0,0,.206-.129.914.914,0,0,0-.022-.221.8.8,0,0,0-.454-.61Z",
    transform: "translate(20.209 7.259)",
    fill: "#c69024"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10057",
    "data-name": "Caminho 10057",
    d: "M28.293,10.273l.005,0a.826.826,0,0,1,.394.578,1.152,1.152,0,0,1,.026.269,1.352,1.352,0,0,0,.206-.129.914.914,0,0,0-.022-.221.8.8,0,0,0-.454-.61Z",
    transform: "translate(20.209 7.259)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10058",
    "data-name": "Caminho 10058",
    d: "M31.941,20.129a.772.772,0,0,1-.1-.094.622.622,0,0,0-.185-.379l-.029,0a.709.709,0,0,1-.019-.315l-.015,0a4.663,4.663,0,0,1-1.138.132,4.044,4.044,0,0,1-.981-.153l-.057.005a.557.557,0,0,1,.005.326h0a.617.617,0,0,0-.177.338,1.317,1.317,0,0,1-.1.113l.084.024v.015c-.007.228.206.266.346.267.045.286.225.242.319.2l-.021.027c.015.194.115.209.226.3a.634.634,0,0,1,.1.087l.005,0c.1.146.182.513.317.513h.036c.135,0,.213-.363.317-.511a.57.57,0,0,1,.1-.087c.111-.094.211-.11.225-.3l-.021-.027c.1.046.276.091.319-.2.139,0,.35-.039.348-.261Z",
    transform: "translate(20.816 13.804)",
    fill: "#c69024"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10059",
    "data-name": "Caminho 10059",
    d: "M31.941,20.129a.772.772,0,0,1-.1-.094.622.622,0,0,0-.185-.379l-.029,0a.709.709,0,0,1-.019-.315l-.015,0a4.663,4.663,0,0,1-1.138.132,4.044,4.044,0,0,1-.981-.153l-.057.005a.557.557,0,0,1,.005.326h0a.617.617,0,0,0-.177.338,1.317,1.317,0,0,1-.1.113l.084.024v.015c-.007.228.206.266.346.267.045.286.225.242.319.2l-.021.027c.015.194.115.209.226.3a.634.634,0,0,1,.1.087l.005,0c.1.146.182.513.317.513h.036c.135,0,.213-.363.317-.511a.57.57,0,0,1,.1-.087c.111-.094.211-.11.225-.3l-.021-.027c.1.046.276.091.319-.2.139,0,.35-.039.348-.261Z",
    transform: "translate(20.816 13.804)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10060",
    "data-name": "Caminho 10060",
    d: "M31.056,20.087a.76.76,0,0,1-.315-.535.892.892,0,0,1-.005-.213l-.168-.015a.761.761,0,0,0-.009.288.71.71,0,0,0,.375.562Z",
    transform: "translate(21.821 13.803)",
    fill: "#c69024"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10061",
    "data-name": "Caminho 10061",
    d: "M31.056,20.087a.76.76,0,0,1-.315-.535.892.892,0,0,1-.005-.213l-.168-.015a.761.761,0,0,0-.009.288.71.71,0,0,0,.375.562Z",
    transform: "translate(21.821 13.803)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10062",
    "data-name": "Caminho 10062",
    d: "M29.079,20.082a.76.76,0,0,0,.315-.535.889.889,0,0,0,.005-.213l.168-.015a.73.73,0,0,1,.007.288.705.705,0,0,1-.374.562Z",
    transform: "translate(20.771 13.799)",
    fill: "#c69024"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10063",
    "data-name": "Caminho 10063",
    d: "M29.079,20.082a.76.76,0,0,0,.315-.535.889.889,0,0,0,.005-.213l.168-.015a.73.73,0,0,1,.007.288.705.705,0,0,1-.374.562Z",
    transform: "translate(20.771 13.799)",
    fill: "none",
    stroke: "#080101",
    strokeWidth: 0.05
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10064",
    "data-name": "Caminho 10064",
    d: "M29.39,20.151a.653.653,0,0,0,.207-.41.148.148,0,0,0,0-.033.651.651,0,0,1-.206.4c-.007.005,0,.034,0,.038",
    transform: "translate(20.991 14.078)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10065",
    "data-name": "Caminho 10065",
    d: "M29.567,20.292c.151-.062.23-.3.267-.446a.275.275,0,0,0,0-.038c-.038.147-.118.384-.267.446-.007,0,0,.038,0,.038",
    transform: "translate(21.117 14.149)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10066",
    "data-name": "Caminho 10066",
    d: "M29.77,20.542a.928.928,0,0,0,.17-.49c0-.005,0-.041,0-.026a.92.92,0,0,1-.168.478c-.007.009.005.031,0,.038",
    transform: "translate(21.263 14.301)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10067",
    "data-name": "Caminho 10067",
    d: "M30.6,20.114a.646.646,0,0,1-.206-.4.149.149,0,0,0,0,.033.653.653,0,0,0,.207.41s.007-.033,0-.038",
    transform: "translate(21.712 14.078)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10068",
    "data-name": "Caminho 10068",
    d: "M30.459,20.255c-.149-.062-.23-.3-.267-.446a.272.272,0,0,0,0,.038c.038.146.117.384.267.446,0,0,.007-.034,0-.038",
    transform: "translate(21.565 14.149)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10069",
    "data-name": "Caminho 10069",
    d: "M30.214,20.51a.915.915,0,0,1-.168-.478c0-.015,0,.022,0,.026a.928.928,0,0,0,.17.49c-.005-.007.007-.029,0-.038",
    transform: "translate(21.46 14.306)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10070",
    "data-name": "Caminho 10070",
    d: "M27.664,7.833s-.3.694-.137.763.574-.041.926-.667-.207-.393-.207-.393Z",
    transform: "translate(19.628 5.352)",
    fill: "#452c25"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10071",
    "data-name": "Caminho 10071",
    d: "M27.664,7.833s-.3.694-.137.763.574-.041.926-.667-.207-.393-.207-.393Z",
    transform: "translate(19.628 5.352)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10072",
    "data-name": "Caminho 10072",
    d: "M28.676,8.1a6.439,6.439,0,0,0,0,.981c.05.069.513.069.538-.612s-.1-.71-.1-.71l-.449.314",
    transform: "translate(20.467 5.544)",
    fill: "#452c25"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10073",
    "data-name": "Caminho 10073",
    d: "M28.676,8.1a6.439,6.439,0,0,0,0,.981c.05.069.513.069.538-.612s-.1-.71-.1-.71l-.449.314",
    transform: "translate(20.467 5.544)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10074",
    "data-name": "Caminho 10074",
    d: "M28.891,7.387s-.326,1.022-.012,1.226.562-1.008.574-1.281S28.891,7.387,28.891,7.387Z",
    transform: "translate(20.53 5.16)",
    fill: "#452c25"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10075",
    "data-name": "Caminho 10075",
    d: "M28.891,7.387s-.326,1.022-.012,1.226.562-1.008.574-1.281S28.891,7.387,28.891,7.387Z",
    transform: "translate(20.53 5.16)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10076",
    "data-name": "Caminho 10076",
    d: "M28.964,8.222s.062.953.238.994.463-.273.463-.518a2.884,2.884,0,0,0-.3-.818l-.411.3",
    transform: "translate(20.68 5.629)",
    fill: "#452c25"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10077",
    "data-name": "Caminho 10077",
    d: "M28.964,8.222s.062.953.238.994.463-.273.463-.518a2.884,2.884,0,0,0-.3-.818l-.411.3",
    transform: "translate(20.68 5.629)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10078",
    "data-name": "Caminho 10078",
    d: "M29.026,7.482S28.7,8.5,29.014,8.708s.562-1.008.574-1.281S29.026,7.482,29.026,7.482Z",
    transform: "translate(20.627 5.228)",
    fill: "#452c25"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10079",
    "data-name": "Caminho 10079",
    d: "M29.026,7.482S28.7,8.5,29.014,8.708s.562-1.008.574-1.281S29.026,7.482,29.026,7.482Z",
    transform: "translate(20.627 5.228)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10080",
    "data-name": "Caminho 10080",
    d: "M29.172,6.457s-.475.49-.463.763.7-.369.763-.49S29.172,6.457,29.172,6.457Z",
    transform: "translate(20.506 4.612)",
    fill: "#452c25"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10081",
    "data-name": "Caminho 10081",
    d: "M29.172,6.457s-.475.49-.463.763.7-.369.763-.49S29.172,6.457,29.172,6.457Z",
    transform: "translate(20.506 4.612)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10082",
    "data-name": "Caminho 10082",
    d: "M28.91,6.3s-.375.694-.276.912.463-.163.639-.408S28.91,6.3,28.91,6.3Z",
    transform: "translate(20.441 4.498)",
    fill: "#452c25"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10083",
    "data-name": "Caminho 10083",
    d: "M28.91,6.3s-.375.694-.276.912.463-.163.639-.408S28.91,6.3,28.91,6.3Z",
    transform: "translate(20.441 4.498)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10084",
    "data-name": "Caminho 10084",
    d: "M28.351,6.412s-.25.939-.062,1.035c.367.187.6-.651.638-.967C28.965,6.126,28.351,6.412,28.351,6.412Z",
    transform: "translate(20.156 4.502)",
    fill: "#452c25"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10085",
    "data-name": "Caminho 10085",
    d: "M28.351,6.412s-.25.939-.062,1.035c.367.187.6-.651.638-.967C28.965,6.126,28.351,6.412,28.351,6.412Z",
    transform: "translate(20.156 4.502)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10086",
    "data-name": "Caminho 10086",
    d: "M28.8,6.363s-.475.49-.463.763.7-.369.763-.49S28.8,6.363,28.8,6.363Z",
    transform: "translate(20.244 4.545)",
    fill: "#452c25"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10087",
    "data-name": "Caminho 10087",
    d: "M28.8,6.363s-.475.49-.463.763.7-.369.763-.49S28.8,6.363,28.8,6.363Z",
    transform: "translate(20.244 4.545)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10088",
    "data-name": "Caminho 10088",
    d: "M24.328,6.9s-.982.494-1.068.7,2.962-.321,4.637-1.5l-.679-.4Z",
    transform: "translate(16.613 4.073)",
    fill: "#452c25"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10089",
    "data-name": "Caminho 10089",
    d: "M24.328,6.9s-.982.494-1.068.7,2.962-.321,4.637-1.5l-.679-.4Z",
    transform: "translate(16.613 4.073)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10090",
    "data-name": "Caminho 10090",
    d: "M24.961,7.086s-1.79.669-.5.694A11.957,11.957,0,0,0,28.391,6.2l-.345-.509Z",
    transform: "translate(17.139 4.067)",
    fill: "#452c25"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10091",
    "data-name": "Caminho 10091",
    d: "M24.961,7.086s-1.79.669-.5.694A11.957,11.957,0,0,0,28.391,6.2l-.345-.509Z",
    transform: "translate(17.139 4.067)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10092",
    "data-name": "Caminho 10092",
    d: "M26.8,5.658s-1.889.967-1.677,1.077a4.524,4.524,0,0,0,2.253-.627,10.926,10.926,0,0,0,1-.681l-.838-.231Z",
    transform: "translate(17.931 3.711)",
    fill: "#452c25"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10093",
    "data-name": "Caminho 10093",
    d: "M26.8,5.658s-1.889.967-1.677,1.077a4.524,4.524,0,0,0,2.253-.627,10.926,10.926,0,0,0,1-.681l-.838-.231Z",
    transform: "translate(17.931 3.711)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10094",
    "data-name": "Caminho 10094",
    d: "M25.926,7.064s-.675.566-.6.629a4.63,4.63,0,0,0,2.534-1l-.137-.5-1.814.838",
    transform: "translate(18.088 4.427)",
    fill: "#452c25"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10095",
    "data-name": "Caminho 10095",
    d: "M25.926,7.064s-.675.566-.6.629a4.63,4.63,0,0,0,2.534-1l-.137-.5-1.814.838",
    transform: "translate(18.088 4.427)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10096",
    "data-name": "Caminho 10096",
    d: "M25.208,7.213s-.646.516-.506.557.691.432,3.118-1.152l.286-.175-.429-.605Z",
    transform: "translate(17.63 4.17)",
    fill: "#452c25"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10097",
    "data-name": "Caminho 10097",
    d: "M25.208,7.213s-.646.516-.506.557.691.432,3.118-1.152l.286-.175-.429-.605Z",
    transform: "translate(17.63 4.17)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10098",
    "data-name": "Caminho 10098",
    d: "M26.4,5.554A20.067,20.067,0,0,0,22.313,7.69c.2-.069,5.251-2.1,5.251-2.1",
    transform: "translate(15.938 3.967)",
    fill: "#452c25"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10099",
    "data-name": "Caminho 10099",
    d: "M26.4,5.554A20.067,20.067,0,0,0,22.313,7.69c.2-.069,5.251-2.1,5.251-2.1",
    transform: "translate(15.938 3.967)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10100",
    "data-name": "Caminho 10100",
    d: "M27.461,7.62s-.437.667-.35.749.626.341,1.25-.518-.588-.722-.588-.722Z",
    transform: "translate(19.357 5.087)",
    fill: "#452c25"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10101",
    "data-name": "Caminho 10101",
    d: "M27.461,7.62s-.437.667-.35.749.626.341,1.25-.518-.588-.722-.588-.722Z",
    transform: "translate(19.357 5.087)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10102",
    "data-name": "Caminho 10102",
    d: "M27.246,7.294s-.657.825-.519.933.888.1,1.452-.694.012-.041.012-.041l-.163-.722Z",
    transform: "translate(19.077 4.835)",
    fill: "#452c25"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10103",
    "data-name": "Caminho 10103",
    d: "M27.246,7.294s-.657.825-.519.933.888.1,1.452-.694.012-.041.012-.041l-.163-.722Z",
    transform: "translate(19.077 4.835)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10104",
    "data-name": "Caminho 10104",
    d: "M26.895,7.183s-.638.763-.576.886.926.081,1.639-.669.139-1.022.139-1.022l-1.19.763",
    transform: "translate(18.796 4.556)",
    fill: "#452c25"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10105",
    "data-name": "Caminho 10105",
    d: "M26.895,7.183s-.638.763-.576.886.926.081,1.639-.669.139-1.022.139-1.022l-1.19.763",
    transform: "translate(18.796 4.556)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10106",
    "data-name": "Caminho 10106",
    d: "M26.162,7.239l-.406.566s.113.531,1.514-.435A11.131,11.131,0,0,1,28.6,6.483l-.751-.135Z",
    transform: "translate(18.397 4.534)",
    fill: "#452c25"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10107",
    "data-name": "Caminho 10107",
    d: "M26.162,7.239l-.406.566s.113.531,1.514-.435A11.131,11.131,0,0,1,28.6,6.483l-.751-.135Z",
    transform: "translate(18.397 4.534)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10108",
    "data-name": "Caminho 10108",
    d: "M23.775,7.142l-.888.4s-.2.177.321.189a7.052,7.052,0,0,0,3.475-1.193A9.8,9.8,0,0,0,28.066,5.6l-.682-.254Z",
    transform: "translate(16.321 3.817)",
    fill: "#452c25"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10109",
    "data-name": "Caminho 10109",
    d: "M23.775,7.142l-.888.4s-.2.177.321.189a7.052,7.052,0,0,0,3.475-1.193A9.8,9.8,0,0,0,28.066,5.6l-.682-.254Z",
    transform: "translate(16.321 3.817)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10110",
    "data-name": "Caminho 10110",
    d: "M22.5,7.814a5.651,5.651,0,0,0,1.786-.471s-.1.154.549-.1l3.711-1.812-.123-.242s-4.042,1.733-4.349,1.829S22.5,7.814,22.5,7.814Z",
    transform: "translate(16.073 3.706)",
    fill: "#452c25"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10111",
    "data-name": "Caminho 10111",
    d: "M22.5,7.814a5.651,5.651,0,0,0,1.786-.471s-.1.154.549-.1l3.711-1.812-.123-.242s-4.042,1.733-4.349,1.829S22.5,7.814,22.5,7.814Z",
    transform: "translate(16.073 3.706)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10112",
    "data-name": "Caminho 10112",
    d: "M27.936,7.838s-.125,1.013.026,1.051.574-.281.749-.9-.687-.545-.687-.545L27.9,7.8",
    transform: "translate(19.92 5.315)",
    fill: "#452c25"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10113",
    "data-name": "Caminho 10113",
    d: "M27.936,7.838s-.125,1.013.026,1.051.574-.281.749-.9-.687-.545-.687-.545L27.9,7.8",
    transform: "translate(19.92 5.315)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10114",
    "data-name": "Caminho 10114",
    d: "M28.314,8.1s-.075.742.026.811.35.094.65-.49.163-.369.163-.369l-.675-.367Z",
    transform: "translate(20.205 5.488)",
    fill: "#452c25"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10115",
    "data-name": "Caminho 10115",
    d: "M28.314,8.1s-.075.742.026.811.35.094.65-.49.163-.369.163-.369l-.675-.367Z",
    transform: "translate(20.205 5.488)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10116",
    "data-name": "Caminho 10116",
    d: "M28.551,7.192s-.55,1.2-.238,1.185.739-.912.8-1.116S28.551,7.192,28.551,7.192Z",
    transform: "translate(20.155 5.106)",
    fill: "#452c25"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10117",
    "data-name": "Caminho 10117",
    d: "M28.551,7.192s-.55,1.2-.238,1.185.739-.912.8-1.116S28.551,7.192,28.551,7.192Z",
    transform: "translate(20.155 5.106)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10118",
    "data-name": "Caminho 10118",
    d: "M28.413,7.245s-.207,1.322.089,1.209.463-1.106.468-1.322S28.413,7.245,28.413,7.245Z",
    transform: "translate(20.245 5.043)",
    fill: "#452c25"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10119",
    "data-name": "Caminho 10119",
    d: "M28.413,7.245s-.207,1.322.089,1.209.463-1.106.468-1.322S28.413,7.245,28.413,7.245Z",
    transform: "translate(20.245 5.043)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10120",
    "data-name": "Caminho 10120",
    d: "M28.707,7.314s-.326,1.022-.012,1.226.562-1.008.574-1.281S28.707,7.314,28.707,7.314Z",
    transform: "translate(20.399 5.108)",
    fill: "#452c25"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10121",
    "data-name": "Caminho 10121",
    d: "M28.707,7.314s-.326,1.022-.012,1.226.562-1.008.574-1.281S28.707,7.314,28.707,7.314Z",
    transform: "translate(20.399 5.108)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10122",
    "data-name": "Caminho 10122",
    d: "M27.952,7.094s-.25.939-.063,1.035c.369.187.605-.651.639-.967C28.566,6.808,27.952,7.094,27.952,7.094Z",
    transform: "translate(19.871 4.99)",
    fill: "#452c25"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10123",
    "data-name": "Caminho 10123",
    d: "M27.952,7.094s-.25.939-.063,1.035c.369.187.605-.651.639-.967C28.566,6.808,27.952,7.094,27.952,7.094Z",
    transform: "translate(19.871 4.99)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10124",
    "data-name": "Caminho 10124",
    d: "M26.847,6.128s-.838.694-.739.8a2.549,2.549,0,0,0,1.514-.382,5.534,5.534,0,0,0,.614-.463l-.751-.463Z",
    transform: "translate(18.643 4.017)",
    fill: "#452c25"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10125",
    "data-name": "Caminho 10125",
    d: "M26.847,6.128s-.838.694-.739.8a2.549,2.549,0,0,0,1.514-.382,5.534,5.534,0,0,0,.614-.463l-.751-.463Z",
    transform: "translate(18.643 4.017)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10126",
    "data-name": "Caminho 10126",
    d: "M27.154,5.641s-.538.435-.437.545S27.78,5.9,27.955,5.71a.587.587,0,0,0,.163-.4Z",
    transform: "translate(19.075 3.796)",
    fill: "#452c25"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10127",
    "data-name": "Caminho 10127",
    d: "M27.154,5.641s-.538.435-.437.545S27.78,5.9,27.955,5.71a.587.587,0,0,0,.163-.4Z",
    transform: "translate(19.075 3.796)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10128",
    "data-name": "Caminho 10128",
    d: "M27.491,5.493s-.687.614-.513.831,1.188-.749,1.325-.873S27.491,5.493,27.491,5.493Z",
    transform: "translate(19.25 3.862)",
    fill: "#452c25"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10129",
    "data-name": "Caminho 10129",
    d: "M27.491,5.493s-.687.614-.513.831,1.188-.749,1.325-.873S27.491,5.493,27.491,5.493Z",
    transform: "translate(19.25 3.862)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10130",
    "data-name": "Caminho 10130",
    d: "M28.175,5.306,26.711,6s-1.238.8-1.113.886a4.306,4.306,0,0,0,1.776-.518,11.281,11.281,0,0,0,1.452-.914",
    transform: "translate(18.278 3.79)",
    fill: "#452c25"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10131",
    "data-name": "Caminho 10131",
    d: "M28.175,5.306,26.711,6s-1.238.8-1.113.886a4.306,4.306,0,0,0,1.776-.518,11.281,11.281,0,0,0,1.452-.914",
    transform: "translate(18.278 3.79)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10132",
    "data-name": "Caminho 10132",
    d: "M27.907,5.768s-1.584,1.361-1.346,1.5,1.1-.238,1.81-.891",
    transform: "translate(18.955 4.12)",
    fill: "#452c25"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10133",
    "data-name": "Caminho 10133",
    d: "M27.907,5.768s-1.584,1.361-1.346,1.5,1.1-.238,1.81-.891",
    transform: "translate(18.955 4.12)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10134",
    "data-name": "Caminho 10134",
    d: "M27.848,5.989s-.957,1.581-.855,1.731.751-.355,1.077-.735a4.781,4.781,0,0,0,.579-.945",
    transform: "translate(19.275 4.278)",
    fill: "#452c25"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10135",
    "data-name": "Caminho 10135",
    d: "M27.848,5.989s-.957,1.581-.855,1.731.751-.355,1.077-.735a4.781,4.781,0,0,0,.579-.945",
    transform: "translate(19.275 4.278)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10136",
    "data-name": "Caminho 10136",
    d: "M28.116,6.107a9.307,9.307,0,0,0-.859,1.954c.113.151.675.027,1.013-.681a2.612,2.612,0,0,0,.309-1.166Z",
    transform: "translate(19.463 4.362)",
    fill: "#452c25"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10137",
    "data-name": "Caminho 10137",
    d: "M28.116,6.107a9.307,9.307,0,0,0-.859,1.954c.113.151.675.027,1.013-.681a2.612,2.612,0,0,0,.309-1.166Z",
    transform: "translate(19.463 4.362)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10138",
    "data-name": "Caminho 10138",
    d: "M28.455,6.175S27.375,8.4,27.59,8.621,29,6.931,29.052,6.662c.1-.473-.609-.528-.609-.528",
    transform: "translate(19.687 4.381)",
    fill: "#452c25"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10139",
    "data-name": "Caminho 10139",
    d: "M28.455,6.175S27.375,8.4,27.59,8.621,29,6.931,29.052,6.662c.1-.473-.609-.528-.609-.528",
    transform: "translate(19.687 4.381)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10140",
    "data-name": "Caminho 10140",
    d: "M27.089,5.3s-.975.463-.775.559,1.113-.314,1.238-.355S27.089,5.3,27.089,5.3Z",
    transform: "translate(18.777 3.785)",
    fill: "#452c25"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10141",
    "data-name": "Caminho 10141",
    d: "M27.089,5.3s-.975.463-.775.559,1.113-.314,1.238-.355S27.089,5.3,27.089,5.3Z",
    transform: "translate(18.777 3.785)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10142",
    "data-name": "Caminho 10142",
    d: "M27.048,5.392s-.6.477-.475.6,1.037-.369,1.214-.518S27.048,5.392,27.048,5.392Z",
    transform: "translate(18.969 3.841)",
    fill: "#452c25"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10143",
    "data-name": "Caminho 10143",
    d: "M27.048,5.392s-.6.477-.475.6,1.037-.369,1.214-.518S27.048,5.392,27.048,5.392Z",
    transform: "translate(18.969 3.841)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10144",
    "data-name": "Caminho 10144",
    d: "M27.835,5.408s-.821,1.1-.569,1.147,1.205-.711,1.217-.842S27.835,5.408,27.835,5.408Z",
    transform: "translate(19.441 3.863)",
    fill: "#452c25"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10145",
    "data-name": "Caminho 10145",
    d: "M27.835,5.408s-.821,1.1-.569,1.147,1.205-.711,1.217-.842S27.835,5.408,27.835,5.408Z",
    transform: "translate(19.441 3.863)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10146",
    "data-name": "Caminho 10146",
    d: "M28.07,5.559s-.876,1.1-.626,1.171.276-.108.276-.108a4.9,4.9,0,0,0,.737-.722c.05-.151-.362-.355-.362-.355",
    transform: "translate(19.571 3.961)",
    fill: "#452c25"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10147",
    "data-name": "Caminho 10147",
    d: "M28.07,5.559s-.876,1.1-.626,1.171.276-.108.276-.108a4.9,4.9,0,0,0,.737-.722c.05-.151-.362-.355-.362-.355",
    transform: "translate(19.571 3.961)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10148",
    "data-name": "Caminho 10148",
    d: "M28.161,5.7s-.638,1.1-.475,1.171.425-.2.687-.531S28.161,5.7,28.161,5.7Z",
    transform: "translate(19.757 4.074)",
    fill: "#452c25"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10149",
    "data-name": "Caminho 10149",
    d: "M28.161,5.7s-.638,1.1-.475,1.171.425-.2.687-.531S28.161,5.7,28.161,5.7Z",
    transform: "translate(19.757 4.074)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10150",
    "data-name": "Caminho 10150",
    d: "M28.169,6s-.375.694-.276.912.463-.163.639-.408S28.169,6,28.169,6Z",
    transform: "translate(19.912 4.284)",
    fill: "#452c25"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10151",
    "data-name": "Caminho 10151",
    d: "M28.169,6s-.375.694-.276.912.463-.163.639-.408S28.169,6,28.169,6Z",
    transform: "translate(19.912 4.284)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10152",
    "data-name": "Caminho 10152",
    d: "M28.194,7.168s-.25.939-.062,1.035c.367.187.6-.651.638-.967C28.808,6.882,28.194,7.168,28.194,7.168Z",
    transform: "translate(20.044 5.042)",
    fill: "#452c25"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10153",
    "data-name": "Caminho 10153",
    d: "M28.194,7.168s-.25.939-.062,1.035c.367.187.6-.651.638-.967C28.808,6.882,28.194,7.168,28.194,7.168Z",
    transform: "translate(20.044 5.042)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10154",
    "data-name": "Caminho 10154",
    d: "M32.862,7.36a1.733,1.733,0,0,0-.437-.082,2.762,2.762,0,0,0-.852-.477c-.3-.041-.043-.048-.043-.048s-.033-.715-.12-.77c0,0-.05-.735-.513-.79s-1.5.041-1.689-.026a2.77,2.77,0,0,0-1.851-.014c-1.114.3-3.307,1.286-3.42,1.313a32.466,32.466,0,0,0,3.257-.905,7.977,7.977,0,0,0,.963-.122s-.838.408-.063.231.6,0,.6,0-.075.177.362.081.439,0,.439,0a1.168,1.168,0,0,0,.888-.055s.2.7.451.79a1.445,1.445,0,0,0,.922.759s.3.211.36.252l.353.117.379-.3",
    transform: "translate(17.096 3.579)",
    fill: "#452c25"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10155",
    "data-name": "Caminho 10155",
    d: "M32.862,7.36a1.733,1.733,0,0,0-.437-.082,2.762,2.762,0,0,0-.852-.477c-.3-.041-.043-.048-.043-.048s-.033-.715-.12-.77c0,0-.05-.735-.513-.79s-1.5.041-1.689-.026a2.77,2.77,0,0,0-1.851-.014c-1.114.3-3.307,1.286-3.42,1.313a32.466,32.466,0,0,0,3.257-.905,7.977,7.977,0,0,0,.963-.122s-.838.408-.063.231.6,0,.6,0-.075.177.362.081.439,0,.439,0a1.168,1.168,0,0,0,.888-.055s.2.7.451.79a1.445,1.445,0,0,0,.922.759s.3.211.36.252l.353.117.379-.3",
    transform: "translate(17.096 3.579)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10156",
    "data-name": "Caminho 10156",
    d: "M27.156,5.291s-2.5.9-2.415,1.145,2.616-.7,3.015-.955-.562-.2-.562-.2",
    transform: "translate(17.671 3.766)",
    fill: "#452c25"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10157",
    "data-name": "Caminho 10157",
    d: "M27.156,5.291s-2.5.9-2.415,1.145,2.616-.7,3.015-.955-.562-.2-.562-.2",
    transform: "translate(17.671 3.766)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10158",
    "data-name": "Caminho 10158",
    d: "M38.027,7.35l.984.559s.24.2-.286.081a12.688,12.688,0,0,1-3.775-1.87c-.96-.617-1.262-.6-1.262-.6l1.337.036Z",
    transform: "translate(24.063 3.942)",
    fill: "#452c25"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10159",
    "data-name": "Caminho 10159",
    d: "M38.027,7.35l.984.559s.24.2-.286.081a12.688,12.688,0,0,1-3.775-1.87c-.96-.617-1.262-.6-1.262-.6l1.337.036Z",
    transform: "translate(24.063 3.942)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10160",
    "data-name": "Caminho 10160",
    d: "M37.892,7.054l.984.559s.24.2-.286.081a12.688,12.688,0,0,1-3.775-1.87c-.96-.617-.187.509-.187.509l.163-.741Z",
    transform: "translate(24.524 3.994)",
    fill: "#452c25"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10161",
    "data-name": "Caminho 10161",
    d: "M37.892,7.054l.984.559s.24.2-.286.081a12.688,12.688,0,0,1-3.775-1.87c-.96-.617-.187.509-.187.509l.163-.741Z",
    transform: "translate(24.524 3.994)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10162",
    "data-name": "Caminho 10162",
    d: "M39.3,7.569a5.575,5.575,0,0,1-1.6-.531s.075.135-.5-.127c0,0,.221.5-1.4-.6s-1.053-.549-1.053-.549l.453-.117s2.484.993,2.757,1.1A14.765,14.765,0,0,1,39.3,7.569Z",
    transform: "translate(24.752 4.018)",
    fill: "#452c25"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10163",
    "data-name": "Caminho 10163",
    d: "M39.3,7.569a5.575,5.575,0,0,1-1.6-.531s.075.135-.5-.127c0,0,.221.5-1.4-.6s-1.053-.549-1.053-.549l.453-.117s2.484.993,2.757,1.1A14.765,14.765,0,0,1,39.3,7.569Z",
    transform: "translate(24.752 4.018)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10164",
    "data-name": "Caminho 10164",
    d: "M34.78,7.425l.394.562s-.132.526-1.5-.5a11.936,11.936,0,0,0-1.294-.939l.754-.1,1.658.939",
    transform: "translate(23.129 4.603)",
    fill: "#452c25"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10165",
    "data-name": "Caminho 10165",
    d: "M34.78,7.425l.394.562s-.132.526-1.5-.5a11.936,11.936,0,0,0-1.294-.939l.754-.1,1.658.939",
    transform: "translate(23.129 4.603)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10166",
    "data-name": "Caminho 10166",
    d: "M33.233,7.67s.634.83.494.934-.891.058-1.426-.754-.012-.041-.012-.041l.05-1.315.909,1.135",
    transform: "translate(22.9 4.639)",
    fill: "#452c25"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10167",
    "data-name": "Caminho 10167",
    d: "M33.233,7.67s.634.83.494.934-.891.058-1.426-.754-.012-.041-.012-.041l.05-1.315.909,1.135",
    transform: "translate(22.9 4.639)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10168",
    "data-name": "Caminho 10168",
    d: "M33.711,7.312s.609.789.543.909-.929.043-1.615-.734-.1-1.027-.1-1.027l1.162.811",
    transform: "translate(23.075 4.614)",
    fill: "#452c25"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10169",
    "data-name": "Caminho 10169",
    d: "M33.711,7.312s.609.789.543.909-.929.043-1.615-.734-.1-1.027-.1-1.027l1.162.811",
    transform: "translate(23.075 4.614)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10170",
    "data-name": "Caminho 10170",
    d: "M36.568,7.349s1.742.749.449.7a12.03,12.03,0,0,1-3.838-1.8l.37-.49,3,1.55",
    transform: "translate(23.699 4.111)",
    fill: "#452c25"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10171",
    "data-name": "Caminho 10171",
    d: "M36.568,7.349s1.742.749.449.7a12.03,12.03,0,0,1-3.838-1.8l.37-.49,3,1.55",
    transform: "translate(23.699 4.111)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10172",
    "data-name": "Caminho 10172",
    d: "M37.147,7.157s.943.573,1.013.789-2.93-.559-4.512-1.877l.706-.346Z",
    transform: "translate(24.034 4.087)",
    fill: "#452c25"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10173",
    "data-name": "Caminho 10173",
    d: "M37.147,7.157s.943.573,1.013.789-2.93-.559-4.512-1.877l.706-.346Z",
    transform: "translate(24.034 4.087)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10174",
    "data-name": "Caminho 10174",
    d: "M34.9,7.217s.682.559.605.624a4.644,4.644,0,0,1-2.546-.977l.13-.5,1.824.825",
    transform: "translate(23.543 4.546)",
    fill: "#452c25"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10175",
    "data-name": "Caminho 10175",
    d: "M34.9,7.217s.682.559.605.624a4.644,4.644,0,0,1-2.546-.977l.13-.5,1.824.825",
    transform: "translate(23.543 4.546)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10176",
    "data-name": "Caminho 10176",
    d: "M35.993,7.366s.672.465.533.513-.667.463-3.17-1l-.295-.161.4-.626L36,7.325",
    transform: "translate(23.616 4.349)",
    fill: "#452c25"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10177",
    "data-name": "Caminho 10177",
    d: "M35.993,7.366s.672.465.533.513-.667.463-3.17-1l-.295-.161.4-.626L36,7.325",
    transform: "translate(23.616 4.349)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10178",
    "data-name": "Caminho 10178",
    d: "M33.909,6.254s.814.729.71.833a2.561,2.561,0,0,1-1.5-.442,4.239,4.239,0,0,1-.737-.725l.907-.2Z",
    transform: "translate(23.13 4.089)",
    fill: "#452c25"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10179",
    "data-name": "Caminho 10179",
    d: "M33.909,6.254s.814.729.71.833a2.561,2.561,0,0,1-1.5-.442,4.239,4.239,0,0,1-.737-.725l.907-.2Z",
    transform: "translate(23.13 4.089)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10180",
    "data-name": "Caminho 10180",
    d: "M32.981,5.323l1.481.883s1.21.855,1.082.931a4.332,4.332,0,0,1-1.757-.59,8.069,8.069,0,0,1-1.461-1.162",
    transform: "translate(23.09 3.802)",
    fill: "#452c25"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10181",
    "data-name": "Caminho 10181",
    d: "M32.981,5.323l1.481.883s1.21.855,1.082.931a4.332,4.332,0,0,1-1.757-.59,8.069,8.069,0,0,1-1.461-1.162",
    transform: "translate(23.09 3.802)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10182",
    "data-name": "Caminho 10182",
    d: "M32.538,7.9s.276.706.111.768-.574-.065-.9-.7.173-.307.173-.307Z",
    transform: "translate(22.597 5.406)",
    fill: "#452c25"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10183",
    "data-name": "Caminho 10183",
    d: "M32.538,7.9s.276.706.111.768-.574-.065-.9-.7.173-.307.173-.307Z",
    transform: "translate(22.597 5.406)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10184",
    "data-name": "Caminho 10184",
    d: "M32.9,7.71s.415.686.324.763-.636.315-1.233-.569.614-.7.614-.7Z",
    transform: "translate(22.73 5.137)",
    fill: "#452c25"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10185",
    "data-name": "Caminho 10185",
    d: "M32.9,7.71s.415.686.324.763-.636.315-1.233-.569.614-.7.614-.7Z",
    transform: "translate(22.73 5.137)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10186",
    "data-name": "Caminho 10186",
    d: "M31.835,5.691a19.868,19.868,0,0,1,1.3,2.875c-.118.146-.675,0-.989-.722a14.946,14.946,0,0,1-.569-1.659Z",
    transform: "translate(22.552 4.065)",
    fill: "#452c25"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10187",
    "data-name": "Caminho 10187",
    d: "M31.835,5.691a19.868,19.868,0,0,1,1.3,2.875c-.118.146-.675,0-.989-.722a14.946,14.946,0,0,1-.569-1.659Z",
    transform: "translate(22.552 4.065)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10188",
    "data-name": "Caminho 10188",
    d: "M32.973,6.132s1.179,1,.938,1.13-.711-.057-1.4-.741.453-.43.453-.43",
    transform: "translate(23.062 4.318)",
    fill: "#452c25"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10189",
    "data-name": "Caminho 10189",
    d: "M32.973,6.132s1.179,1,.938,1.13-.711-.057-1.4-.741.453-.43.453-.43",
    transform: "translate(23.062 4.318)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10190",
    "data-name": "Caminho 10190",
    d: "M32.711,6.128s.843,1.548.737,1.694-.737-.384-1.049-.778a4.77,4.77,0,0,1-.547-.969",
    transform: "translate(22.751 4.339)",
    fill: "#452c25"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10191",
    "data-name": "Caminho 10191",
    d: "M32.711,6.128s.843,1.548.737,1.694-.737-.384-1.049-.778a4.77,4.77,0,0,1-.547-.969",
    transform: "translate(22.751 4.339)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10192",
    "data-name": "Caminho 10192",
    d: "M31.994,5.76s.6,1.13.434,1.19-.417-.221-.669-.559.235-.631.235-.631",
    transform: "translate(22.634 4.114)",
    fill: "#452c25"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10193",
    "data-name": "Caminho 10193",
    d: "M31.994,5.76s.6,1.13.434,1.19-.417-.221-.669-.559S31.994,5.76,31.994,5.76Z",
    transform: "translate(22.634 4.114)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10194",
    "data-name": "Caminho 10194",
    d: "M32.115,7.159s.218.95.027,1.037c-.374.171-.583-.675-.605-.993C31.512,6.849,32.115,7.159,32.115,7.159Z",
    transform: "translate(22.526 5.024)",
    fill: "#452c25"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10195",
    "data-name": "Caminho 10195",
    d: "M32.115,7.159s.218.95.027,1.037c-.374.171-.583-.675-.605-.993C31.512,6.849,32.115,7.159,32.115,7.159Z",
    transform: "translate(22.526 5.024)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10196",
    "data-name": "Caminho 10196",
    d: "M31.8,8.175s.05.711-.051.775-.353.081-.634-.516-.149-.375-.149-.375l.687-.339.149.387",
    transform: "translate(22.095 5.514)",
    fill: "#452c25"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10197",
    "data-name": "Caminho 10197",
    d: "M31.8,8.175s.05.711-.051.775-.353.081-.634-.516-.149-.375-.149-.375l.687-.339.149.387",
    transform: "translate(22.095 5.514)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10198",
    "data-name": "Caminho 10198",
    d: "M32.16,8.022s.1.741-.051.761a.984.984,0,0,1-.727-.684c-.159-.456.7-.367.7-.367L32.2,8",
    transform: "translate(22.402 5.518)",
    fill: "#452c25"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10199",
    "data-name": "Caminho 10199",
    d: "M32.16,8.022s.1.741-.051.761a.984.984,0,0,1-.727-.684c-.159-.456.7-.367.7-.367L32.2,8",
    transform: "translate(22.402 5.518)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10200",
    "data-name": "Caminho 10200",
    d: "M31.659,6.581a7.368,7.368,0,0,1,.646,1.977c-.243.482-.945-1.054-1.157-1.654C30.912,6.233,31.659,6.581,31.659,6.581Z",
    transform: "translate(22.216 4.636)",
    fill: "#452c25"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10201",
    "data-name": "Caminho 10201",
    d: "M31.659,6.581a7.368,7.368,0,0,1,.646,1.977c-.243.482-.945-1.054-1.157-1.654C30.912,6.233,31.659,6.581,31.659,6.581Z",
    transform: "translate(22.216 4.636)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10202",
    "data-name": "Caminho 10202",
    d: "M31.547,6.717s1.054,1.9.609,1.947S30.9,7.285,30.769,6.954,31.547,6.717,31.547,6.717Z",
    transform: "translate(21.968 4.789)",
    fill: "#452c25"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10203",
    "data-name": "Caminho 10203",
    d: "M31.547,6.717s1.054,1.9.609,1.947S30.9,7.285,30.769,6.954,31.547,6.717,31.547,6.717Z",
    transform: "translate(21.968 4.789)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10204",
    "data-name": "Caminho 10204",
    d: "M31.435,7.054s.518,1.824.185,1.663-.737-1.536-.792-1.833S31.435,7.054,31.435,7.054Z",
    transform: "translate(22.018 4.847)",
    fill: "#452c25"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10205",
    "data-name": "Caminho 10205",
    d: "M31.435,7.054s.518,1.824.185,1.663-.737-1.536-.792-1.833S31.435,7.054,31.435,7.054Z",
    transform: "translate(22.018 4.847)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10206",
    "data-name": "Caminho 10206",
    d: "M32.524,5.429s.8,1.221.54,1.257-1.207-.814-1.215-.957S32.524,5.429,32.524,5.429Z",
    transform: "translate(22.749 3.878)",
    fill: "#452c25"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10207",
    "data-name": "Caminho 10207",
    d: "M32.524,5.429s.8,1.221.54,1.257-1.207-.814-1.215-.957S32.524,5.429,32.524,5.429Z",
    transform: "translate(22.749 3.878)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10208",
    "data-name": "Caminho 10208",
    d: "M32.157,5.466s1.02,1.39.711,1.462-.331-.147-.331-.147a6.057,6.057,0,0,1-.867-.919c-.055-.185.458-.413.458-.413",
    transform: "translate(22.618 3.892)",
    fill: "#452c25"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10209",
    "data-name": "Caminho 10209",
    d: "M32.157,5.466s1.02,1.39.711,1.462-.331-.147-.331-.147a6.057,6.057,0,0,1-.867-.919c-.055-.185.458-.413.458-.413",
    transform: "translate(22.618 3.892)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10210",
    "data-name": "Caminho 10210",
    d: "M33.279,5.4s.96.5.756.59-1.1-.358-1.226-.4S33.279,5.4,33.279,5.4Z",
    transform: "translate(23.423 3.86)",
    fill: "#452c25"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10211",
    "data-name": "Caminho 10211",
    d: "M33.279,5.4s.96.5.756.59-1.1-.358-1.226-.4S33.279,5.4,33.279,5.4Z",
    transform: "translate(23.423 3.86)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10212",
    "data-name": "Caminho 10212",
    d: "M32.868,5.532s.7.723.518.967S32.227,5.585,32.1,5.438s.849.065.849.065",
    transform: "translate(22.916 3.847)",
    fill: "#452c25"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10213",
    "data-name": "Caminho 10213",
    d: "M32.868,5.532s.7.723.518.967S32.227,5.585,32.1,5.438s.849.065.849.065",
    transform: "translate(22.916 3.847)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10214",
    "data-name": "Caminho 10214",
    d: "M31.793,6.074s1.128,2.2.921,2.422-1.462-1.649-1.505-1.92.6-.543.6-.543",
    transform: "translate(22.29 4.309)",
    fill: "#452c25"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10215",
    "data-name": "Caminho 10215",
    d: "M31.793,6.074s1.128,2.2.921,2.422-1.462-1.649-1.505-1.92.6-.543.6-.543",
    transform: "translate(22.29 4.309)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10216",
    "data-name": "Caminho 10216",
    d: "M31.3,6.173a2.579,2.579,0,0,1,.425,1.058c-.026.372-.682-.53-.739-.7S31.3,6.173,31.3,6.173Z",
    transform: "translate(22.132 4.409)",
    fill: "#452c25"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10217",
    "data-name": "Caminho 10217",
    d: "M31.3,6.173a2.579,2.579,0,0,1,.425,1.058c-.026.372-.682-.53-.739-.7S31.3,6.173,31.3,6.173Z",
    transform: "translate(22.132 4.409)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10218",
    "data-name": "Caminho 10218",
    d: "M31.935,5.966s.351.71.243.924-.586-.432-.753-.684S31.935,5.966,31.935,5.966Z",
    transform: "translate(22.428 4.261)",
    fill: "#452c25"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10219",
    "data-name": "Caminho 10219",
    d: "M31.935,5.966s.351.71.243.924-.586-.432-.753-.684S31.935,5.966,31.935,5.966Z",
    transform: "translate(22.428 4.261)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10220",
    "data-name": "Caminho 10220",
    d: "M30.922,6.373s.549.61.525.936-.826-.475-.9-.624S30.922,6.373,30.922,6.373Z",
    transform: "translate(21.815 4.552)",
    fill: "#452c25"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10221",
    "data-name": "Caminho 10221",
    d: "M30.922,6.373s.549.61.525.936-.826-.475-.9-.624S30.922,6.373,30.922,6.373Z",
    transform: "translate(21.815 4.552)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10222",
    "data-name": "Caminho 10222",
    d: "M33.15,5.368s.833.747.7.866-1.257-.691-1.428-.849S33.15,5.368,33.15,5.368Z",
    transform: "translate(23.147 3.793)",
    fill: "#452c25"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10223",
    "data-name": "Caminho 10223",
    d: "M33.15,5.368s.833.747.7.866-1.257-.691-1.428-.849S33.15,5.368,33.15,5.368Z",
    transform: "translate(23.147 3.793)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10224",
    "data-name": "Caminho 10224",
    d: "M32.518,5.312l.651.549s.607.406.5.511-1.053-.331-1.221-.528a.586.586,0,0,1-.149-.4Z",
    transform: "translate(23.073 3.794)",
    fill: "#452c25"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10225",
    "data-name": "Caminho 10225",
    d: "M32.518,5.312l.651.549s.607.406.5.511-1.053-.331-1.221-.528a.586.586,0,0,1-.149-.4Z",
    transform: "translate(23.073 3.794)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10226",
    "data-name": "Caminho 10226",
    d: "M33.974,5.426s2.469,1,2.373,1.243-2.589-.8-2.979-1.077.569-.182.569-.182",
    transform: "translate(23.767 3.854)",
    fill: "#452c25"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10227",
    "data-name": "Caminho 10227",
    d: "M33.974,5.426s2.469,1,2.373,1.243-2.589-.8-2.979-1.077.569-.182.569-.182",
    transform: "translate(23.767 3.854)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10228",
    "data-name": "Caminho 10228",
    d: "M34.387,5.8s1.855,1.044,1.637,1.145a4.556,4.556,0,0,1-2.229-.72,10.886,10.886,0,0,1-.975-.722l.845-.2Z",
    transform: "translate(23.443 3.793)",
    fill: "#452c25"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10229",
    "data-name": "Caminho 10229",
    d: "M34.387,5.8s1.855,1.044,1.637,1.145a4.556,4.556,0,0,1-2.229-.72,10.886,10.886,0,0,1-.975-.722l.845-.2Z",
    transform: "translate(23.443 3.793)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10230",
    "data-name": "Caminho 10230",
    d: "M31.243,6.339s.351.71.243.924-.458-.183-.624-.435S31.243,6.339,31.243,6.339Z",
    transform: "translate(22.022 4.528)",
    fill: "#452c25"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10231",
    "data-name": "Caminho 10231",
    d: "M31.243,6.339s.351.71.243.924-.458-.183-.624-.435S31.243,6.339,31.243,6.339Z",
    transform: "translate(22.022 4.528)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10232",
    "data-name": "Caminho 10232",
    d: "M31.354,7.347s.29,1.034-.029,1.226-.528-1.03-.531-1.3S31.354,7.347,31.354,7.347Z",
    transform: "translate(21.995 5.119)",
    fill: "#452c25"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10233",
    "data-name": "Caminho 10233",
    d: "M31.354,7.347s.29,1.034-.029,1.226-.528-1.03-.531-1.3S31.354,7.347,31.354,7.347Z",
    transform: "translate(21.995 5.119)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10234",
    "data-name": "Caminho 10234",
    d: "M30.316,7.112A5.83,5.83,0,0,1,31.53,6.7a1.135,1.135,0,0,0,.333-.144c.117-.091.382-.309.382-.309A.948.948,0,0,1,33.376,5.12c1.313.127,3.043.29,3.393.345a13.6,13.6,0,0,1,1.929.561c.3.146,2.249,1.029,2.649,1.173a8.332,8.332,0,0,1,1.143.663c.266.173-.009.05-.009.05a28.477,28.477,0,0,0-4.274-1.9c-.279-.057.019.321.019.321S37.5,6.044,37.2,5.917a1.736,1.736,0,0,0-.831-.163,1.717,1.717,0,0,1-.665-.091c-.166-.055-1.114-.091-1.281-.108a2.271,2.271,0,0,1-.3-.055l.067.108-.465-.072-.134.2s-.449.091-.482-.053-.267.651-.382.886-.55.235-.682.381a1.469,1.469,0,0,1-.283.271,1.961,1.961,0,0,1-.516.237c-.117,0-.831.053-.831.053l-.182-.29Z",
    transform: "translate(21.596 3.651)",
    fill: "#452c25"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10235",
    "data-name": "Caminho 10235",
    d: "M30.316,7.112A5.83,5.83,0,0,1,31.53,6.7a1.135,1.135,0,0,0,.333-.144c.117-.091.382-.309.382-.309A.948.948,0,0,1,33.376,5.12c1.313.127,3.043.29,3.393.345a13.6,13.6,0,0,1,1.929.561c.3.146,2.249,1.029,2.649,1.173a8.332,8.332,0,0,1,1.143.663c.266.173-.009.05-.009.05a28.477,28.477,0,0,0-4.274-1.9c-.279-.057.019.321.019.321S37.5,6.044,37.2,5.917a1.736,1.736,0,0,0-.831-.163,1.717,1.717,0,0,1-.665-.091c-.166-.055-1.114-.091-1.281-.108a2.271,2.271,0,0,1-.3-.055l.067.108-.465-.072-.134.2s-.449.091-.482-.053-.267.651-.382.886-.55.235-.682.381a1.469,1.469,0,0,1-.283.271,1.961,1.961,0,0,1-.516.237c-.117,0-.831.053-.831.053l-.182-.29Z",
    transform: "translate(21.596 3.651)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10236",
    "data-name": "Caminho 10236",
    d: "M31.3,8.135a6.314,6.314,0,0,1-.034.981c-.051.065-.514.046-.516-.634s.125-.7.125-.7l.439.331",
    transform: "translate(21.966 5.555)",
    fill: "#452c25"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10237",
    "data-name": "Caminho 10237",
    d: "M31.3,8.135a6.314,6.314,0,0,1-.034.981c-.051.065-.514.046-.516-.634s.125-.7.125-.7l.439.331",
    transform: "translate(21.966 5.555)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10238",
    "data-name": "Caminho 10238",
    d: "M31.168,7.413s.29,1.034-.029,1.226-.528-1.03-.531-1.3S31.168,7.413,31.168,7.413Z",
    transform: "translate(21.862 5.166)",
    fill: "#452c25"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10239",
    "data-name": "Caminho 10239",
    d: "M31.168,7.413s.29,1.034-.029,1.226-.528-1.03-.531-1.3S31.168,7.413,31.168,7.413Z",
    transform: "translate(21.862 5.166)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10240",
    "data-name": "Caminho 10240",
    d: "M31.029,7.5s.29,1.034-.029,1.226-.528-1.03-.531-1.3S31.029,7.5,31.029,7.5Z",
    transform: "translate(21.763 5.23)",
    fill: "#452c25"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10241",
    "data-name": "Caminho 10241",
    d: "M31.029,7.5s.29,1.034-.029,1.226-.528-1.03-.531-1.3S31.029,7.5,31.029,7.5Z",
    transform: "translate(21.763 5.23)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10242",
    "data-name": "Caminho 10242",
    d: "M30.906,9.95s.178.221.156.293c0,0,.182-.185-.053-.446Z",
    transform: "translate(22.076 6.998)",
    fill: "#d9c0b9"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10243",
    "data-name": "Caminho 10243",
    d: "M30.906,9.95s.178.221.156.293c0,0,.182-.185-.053-.446Z",
    transform: "translate(22.076 6.998)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10244",
    "data-name": "Caminho 10244",
    d: "M30.087,9.641h.106l.041.1-.015.093-.093.041s-.151-.038-.113.142C30.013,10.016,29.941,9.686,30.087,9.641Z",
    transform: "translate(21.425 6.886)",
    fill: "#d9c0b9"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10245",
    "data-name": "Caminho 10245",
    d: "M30.087,9.641h.106l.041.1-.015.093-.093.041s-.151-.038-.113.142C30.013,10.016,29.941,9.686,30.087,9.641Z",
    transform: "translate(21.425 6.886)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10246",
    "data-name": "Caminho 10246",
    d: "M30.488,10.125,30.6,10l.118.063a2.944,2.944,0,0,1-.067.345c-.019.022-.022.027-.022.036a.471.471,0,0,0-.055-.1C30.538,10.3,30.5,10.128,30.488,10.125Z",
    transform: "translate(21.777 7.145)",
    fill: "#d9c0b9"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10247",
    "data-name": "Caminho 10247",
    d: "M30.488,10.125,30.6,10l.118.063a2.944,2.944,0,0,1-.067.345c-.019.022-.022.027-.022.036a.471.471,0,0,0-.055-.1C30.538,10.3,30.5,10.128,30.488,10.125Z",
    transform: "translate(21.777 7.145)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10248",
    "data-name": "Caminho 10248",
    d: "M29.84,9.945l-.055-.161.063-.086.127,0,.055.026s.1.233.012.357c0,0-.038-.132-.081-.151C29.962,9.927,29.867,9.912,29.84,9.945Z",
    transform: "translate(21.275 6.926)",
    fill: "#d9c0b9"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10249",
    "data-name": "Caminho 10249",
    d: "M29.84,9.945l-.055-.161.063-.086.127,0,.055.026s.1.233.012.357c0,0-.038-.132-.081-.151C29.962,9.927,29.867,9.912,29.84,9.945Z",
    transform: "translate(21.275 6.926)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10250",
    "data-name": "Caminho 10250",
    d: "M29.15,10s-.18.3.053.449c0,0-.014-.279.168-.339Z",
    transform: "translate(20.774 7.146)",
    fill: "#d9c0b9"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10251",
    "data-name": "Caminho 10251",
    d: "M29.15,10s-.18.3.053.449c0,0-.014-.279.168-.339Z",
    transform: "translate(20.774 7.146)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10252",
    "data-name": "Caminho 10252",
    d: "M28.765,9.95l.163-.041.015.005s-.106.206-.079.255S28.72,10.08,28.765,9.95Z",
    transform: "translate(20.541 7.078)",
    fill: "#d9c0b9"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10253",
    "data-name": "Caminho 10253",
    d: "M28.765,9.95l.163-.041.015.005s-.106.206-.079.255S28.72,10.08,28.765,9.95Z",
    transform: "translate(20.541 7.078)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10254",
    "data-name": "Caminho 10254",
    d: "M30.728,8.9s.005.557.005.657a.674.674,0,0,1-.067.333.241.241,0,0,1-.206.137c-.091,0-.329-.012-.374.074a1.51,1.51,0,0,1-.081.137s.147-.087.17,0a.178.178,0,0,1-.057.159.411.411,0,0,0,.262-.05.466.466,0,0,1,.25-.086.151.151,0,0,1,.1.062,1.418,1.418,0,0,1,.024.3c-.012.111-.034.334.091.334,0,0,.045-.111.091-.123s.17.111.147.149a1.182,1.182,0,0,0-.022-.372A1.872,1.872,0,0,1,31,10.327a2.208,2.208,0,0,1,.42.185c.034.05.125.137.159.123s0-.123.069-.147a.082.082,0,0,1,.1.038.818.818,0,0,0-.283-.348c-.171-.086-.285-.086-.353-.159a.418.418,0,0,1-.091-.249c-.012-.086,0-.835,0-.835Z",
    transform: "translate(21.433 6.36)",
    fill: "#bd8759"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10255",
    "data-name": "Caminho 10255",
    d: "M30.728,8.9s.005.557.005.657a.674.674,0,0,1-.067.333.241.241,0,0,1-.206.137c-.091,0-.329-.012-.374.074a1.51,1.51,0,0,1-.081.137s.147-.087.17,0a.178.178,0,0,1-.057.159.411.411,0,0,0,.262-.05.466.466,0,0,1,.25-.086.151.151,0,0,1,.1.062,1.418,1.418,0,0,1,.024.3c-.012.111-.034.334.091.334,0,0,.045-.111.091-.123s.17.111.147.149a1.182,1.182,0,0,0-.022-.372A1.872,1.872,0,0,1,31,10.327a2.208,2.208,0,0,1,.42.185c.034.05.125.137.159.123s0-.123.069-.147a.082.082,0,0,1,.1.038.818.818,0,0,0-.283-.348c-.171-.086-.285-.086-.353-.159a.418.418,0,0,1-.091-.249c-.012-.086,0-.835,0-.835Z",
    transform: "translate(21.433 6.36)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10256",
    "data-name": "Caminho 10256",
    d: "M29.687,10.4s-.283.219-.315.322a1.134,1.134,0,0,0-.039.2s.252-.031.221.11c0,0,.082.046.213-.257s.255-.434.348-.425a.529.529,0,0,1,.269.163.238.238,0,0,0,.245.081s-.108-.165-.039-.2a.38.38,0,0,1,.171-.029.407.407,0,0,0-.271-.235c-.187-.031-.315-.082-.271-.163s.281-.708.281-.708L30.186,8.8l-.127.4s.041.238.043.3a3.265,3.265,0,0,1-.285.61c-.033.031-.708.291-.789.317a1.066,1.066,0,0,0-.247.225l-.021.151s.113-.093.149-.038c0,0,.079-.1.149-.062s.06.051.06.051a.7.7,0,0,0,.146-.123c.022-.039.029-.034.029-.034s.106-.021.2-.036",
    transform: "translate(20.544 6.283)",
    fill: "#bd8759"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10257",
    "data-name": "Caminho 10257",
    d: "M29.687,10.4s-.283.219-.315.322a1.134,1.134,0,0,0-.039.2s.252-.031.221.11c0,0,.082.046.213-.257s.255-.434.348-.425a.529.529,0,0,1,.269.163.238.238,0,0,0,.245.081s-.108-.165-.039-.2a.38.38,0,0,1,.171-.029.407.407,0,0,0-.271-.235c-.187-.031-.315-.082-.271-.163s.281-.708.281-.708L30.186,8.8l-.127.4s.041.238.043.3a3.265,3.265,0,0,1-.285.61c-.033.031-.708.291-.789.317a1.066,1.066,0,0,0-.247.225l-.021.151s.113-.093.149-.038c0,0,.079-.1.149-.062s.06.051.06.051a.7.7,0,0,0,.146-.123c.022-.039.029-.034.029-.034s.106-.021.2-.036",
    transform: "translate(20.544 6.283)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10258",
    "data-name": "Caminho 10258",
    d: "M29.543,9.4a.088.088,0,0,1-.07-.012",
    transform: "translate(21.052 6.705)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10259",
    "data-name": "Caminho 10259",
    d: "M29.617,9.248a.246.246,0,0,1-.093-.033",
    transform: "translate(21.089 6.582)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10260",
    "data-name": "Caminho 10260",
    d: "M29.512,9.316a.1.1,0,0,0,.07.012",
    transform: "translate(21.08 6.654)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10261",
    "data-name": "Caminho 10261",
    d: "M29.377,9.568a.108.108,0,0,0,.046.017",
    transform: "translate(20.984 6.834)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10262",
    "data-name": "Caminho 10262",
    d: "M30.51,9.416c.046.009.089.033.137.038",
    transform: "translate(21.793 6.726)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10263",
    "data-name": "Caminho 10263",
    d: "M30.594,9.347a.087.087,0,0,1-.091-.024",
    transform: "translate(21.788 6.659)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10264",
    "data-name": "Caminho 10264",
    d: "M30.621,9.248a.255.255,0,0,1-.125-.012",
    transform: "translate(21.783 6.597)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10265",
    "data-name": "Caminho 10265",
    d: "M30.477,9.561A1.049,1.049,0,0,1,30.6,9.6",
    transform: "translate(21.769 6.829)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10266",
    "data-name": "Caminho 10266",
    d: "M30.483,9.663a.061.061,0,0,1,.057.012",
    transform: "translate(21.774 6.9)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10267",
    "data-name": "Caminho 10267",
    d: "M30.5,9.937a.111.111,0,0,1,.079.012",
    transform: "translate(21.788 7.096)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10268",
    "data-name": "Caminho 10268",
    d: "M29.707,9.581a.1.1,0,0,0-.079.062",
    transform: "translate(21.163 6.844)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10269",
    "data-name": "Caminho 10269",
    d: "M29.851,9.594a.179.179,0,0,0-.1.127",
    transform: "translate(21.25 6.853)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10270",
    "data-name": "Caminho 10270",
    d: "M28.971,9.743c.039.034.1.057.129.087",
    transform: "translate(20.694 6.959)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10271",
    "data-name": "Caminho 10271",
    d: "M30.772,9.633a.1.1,0,0,0-.057.074",
    transform: "translate(21.939 6.881)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10272",
    "data-name": "Caminho 10272",
    d: "M30.855,9.662a.055.055,0,0,0-.034.05",
    transform: "translate(22.015 6.901)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10273",
    "data-name": "Caminho 10273",
    d: "M32.75,8.621A1.748,1.748,0,0,0,32.6,8.17c-.062-.055.026-.108.026-.108a1.763,1.763,0,0,0-.262-.465c-.1-.069.012-.123.012-.123a1.614,1.614,0,0,0-.3-.355c-.125-.082,0-.094,0-.094a1.1,1.1,0,0,0-.435-.535,1.122,1.122,0,0,0-.408-.271,5.618,5.618,0,0,0-1.337-.1,1.12,1.12,0,0,0-.926.463l-.043.525.094-.063-.137.651c-.022.149.117.408.123.72,0,.1.009.2.021.307a2.689,2.689,0,0,0,.221.85c.01.022.021.086.033.065.031-.055.1.183.166.269,0,0,.039.326.07.206.012-.046.117.183.18.329.024.053.147.411.142.247s.108.381.108.461l.151-.219.075.247.125-.014-.038.231s.35-.286.362-.4.026-.19.026-.19l.113-.11.175-.273a2.706,2.706,0,0,1,.487.465c.051.122.1.231.1.231l.113-.11.1.247.062-.123.062.17.005-.01.039.113c.031.027.1.043.231-.177a1.327,1.327,0,0,0,.189-.615c.012-.053.087.1.087.1a1.076,1.076,0,0,0,.137-.49c-.024-.192.1-.123.1-.123a5.353,5.353,0,0,0,0-.627c-.026-.123.087-.1.087-.1a5.042,5.042,0,0,0-.075-.669C32.625,8.635,32.75,8.621,32.75,8.621Z",
    transform: "translate(20.629 4.368)",
    fill: "#452c25"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10274",
    "data-name": "Caminho 10274",
    d: "M32.75,8.621A1.748,1.748,0,0,0,32.6,8.17c-.062-.055.026-.108.026-.108a1.763,1.763,0,0,0-.262-.465c-.1-.069.012-.123.012-.123a1.614,1.614,0,0,0-.3-.355c-.125-.082,0-.094,0-.094a1.1,1.1,0,0,0-.435-.535,1.122,1.122,0,0,0-.408-.271,5.618,5.618,0,0,0-1.337-.1,1.12,1.12,0,0,0-.926.463l-.043.525.094-.063-.137.651c-.022.149.117.408.123.72,0,.1.009.2.021.307a2.689,2.689,0,0,0,.221.85c.01.022.021.086.033.065.031-.055.1.183.166.269,0,0,.039.326.07.206.012-.046.117.183.18.329.024.053.147.411.142.247s.108.381.108.461l.151-.219.075.247.125-.014-.038.231s.35-.286.362-.4.026-.19.026-.19l.113-.11.175-.273a2.706,2.706,0,0,1,.487.465c.051.122.1.231.1.231l.113-.11.1.247.062-.123.062.17.005-.01.039.113c.031.027.1.043.231-.177a1.327,1.327,0,0,0,.189-.615c.012-.053.087.1.087.1a1.076,1.076,0,0,0,.137-.49c-.024-.192.1-.123.1-.123a5.353,5.353,0,0,0,0-.627c-.026-.123.087-.1.087-.1a5.042,5.042,0,0,0-.075-.669C32.625,8.635,32.75,8.621,32.75,8.621Z",
    transform: "translate(20.629 4.368)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10275",
    "data-name": "Caminho 10275",
    d: "M30.626,6.783c.087.026.132.127.17.2,0-.005.005-.027,0-.038-.038-.077-.081-.178-.17-.2v.038",
    transform: "translate(21.876 4.818)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10276",
    "data-name": "Caminho 10276",
    d: "M30.674,7a.6.6,0,0,1,.168.533c0,.005,0,.041,0,.019a.667.667,0,0,0-.171-.59s-.007.031,0,.038",
    transform: "translate(21.908 4.975)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10277",
    "data-name": "Caminho 10277",
    d: "M30.872,7.114a.891.891,0,0,1,.1.482c0,.021.005.021.005,0a.957.957,0,0,0-.1-.518s-.007.027,0,.036",
    transform: "translate(22.05 5.056)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10278",
    "data-name": "Caminho 10278",
    d: "M30.961,7.517c-.01.106-.029.209-.05.314a.15.15,0,0,0,0,.033c.021-.106.041-.213.051-.319,0-.005,0-.043,0-.027",
    transform: "translate(22.079 5.366)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10279",
    "data-name": "Caminho 10279",
    d: "M30.876,7.847a.932.932,0,0,1,.01.207c0,.005,0,.043,0,.027a1.119,1.119,0,0,0-.009-.262c0-.014,0,.022,0,.027",
    transform: "translate(22.054 5.583)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10280",
    "data-name": "Caminho 10280",
    d: "M30.753,7.441c0,.117,0,.233.01.35,0,.015,0-.022,0-.027-.009-.106-.01-.214-.01-.322,0-.022,0-.022,0,0",
    transform: "translate(21.966 5.303)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10281",
    "data-name": "Caminho 10281",
    d: "M30.7,7.889c.009.111.009.223.009.333,0,.022.005.022.005,0,0-.12,0-.24-.01-.36,0-.014,0,.022,0,.027",
    transform: "translate(21.929 5.613)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10282",
    "data-name": "Caminho 10282",
    d: "M30.994,7.836a.344.344,0,0,1,.089.182c0,.007,0-.007,0-.007a.074.074,0,0,0,0-.027.344.344,0,0,0-.091-.185c.005.005-.007.031,0,.038",
    transform: "translate(22.137 5.57)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10283",
    "data-name": "Caminho 10283",
    d: "M30.977,7.389a1.026,1.026,0,0,1,.13.142c-.005-.005.007-.029,0-.038a.937.937,0,0,0-.13-.142s-.007.031,0,.038",
    transform: "translate(22.125 5.251)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10284",
    "data-name": "Caminho 10284",
    d: "M30.748,7.714a1.713,1.713,0,0,1-.029.31.15.15,0,0,0,0,.033,1.772,1.772,0,0,0,.031-.343c0-.022,0-.022,0,0",
    transform: "translate(21.942 5.498)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10285",
    "data-name": "Caminho 10285",
    d: "M30.608,7.853a1.521,1.521,0,0,1,0,.279c0,.005,0,.041,0,.026a2.16,2.16,0,0,0,0-.333c0-.014,0,.022,0,.027",
    transform: "translate(21.863 5.587)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10286",
    "data-name": "Caminho 10286",
    d: "M30.25,6.461a.592.592,0,0,1,.158.062l.027.009-.017-.024a.475.475,0,0,0-.106-.079.685.685,0,0,0-.2-.081c-.015,0,.039.05.043.051a.237.237,0,0,0,.1.062",
    transform: "translate(21.505 4.534)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10287",
    "data-name": "Caminho 10287",
    d: "M29.055,7.531c.038.07.043.153.081.225,0-.005.005-.027,0-.038-.036-.07-.043-.153-.079-.223,0,0-.007.027,0,.036",
    transform: "translate(20.752 5.354)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10288",
    "data-name": "Caminho 10288",
    d: "M29.253,6.425a1.215,1.215,0,0,1,.259-.041V6.346a1.116,1.116,0,0,0-.259.041c-.007,0,0,.038,0,.038",
    transform: "translate(20.893 4.533)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10289",
    "data-name": "Caminho 10289",
    d: "M29.544,6.4a.563.563,0,0,1,.25-.041V6.322a.563.563,0,0,0-.25.041c-.007,0,0,.036,0,.038",
    transform: "translate(21.101 4.516)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10290",
    "data-name": "Caminho 10290",
    d: "M29.042,6.625c-.01,0-.01.01-.012.019l0,.027c0,.007,0-.007,0-.007s0,0,.009,0V6.625",
    transform: "translate(20.736 4.732)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10291",
    "data-name": "Caminho 10291",
    d: "M29.006,7.417a1.448,1.448,0,0,0,.01.211c0,.007,0-.007,0-.007l0-.027a1.21,1.21,0,0,1-.009-.177c0-.022,0-.022,0,0",
    transform: "translate(20.719 5.286)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10292",
    "data-name": "Caminho 10292",
    d: "M30.452,6.652a.1.1,0,0,1,.069.07l0-.012,0-.024a.1.1,0,0,0-.07-.072v.038",
    transform: "translate(21.751 4.724)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10293",
    "data-name": "Caminho 10293",
    d: "M30.476,7.008a.512.512,0,0,1,.12.2.281.281,0,0,0,0-.038.5.5,0,0,0-.12-.2c.005.005-.007.031,0,.038",
    transform: "translate(21.767 4.979)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10294",
    "data-name": "Caminho 10294",
    d: "M30.4,6.747a2.079,2.079,0,0,1,.149.153s.009-.031,0-.038a2.082,2.082,0,0,0-.149-.153s-.007.031,0,.038",
    transform: "translate(21.713 4.792)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10295",
    "data-name": "Caminho 10295",
    d: "M30.5,7.338a.431.431,0,0,1-.039.25c0,.01,0,.033,0,.038a.571.571,0,0,0,.039-.321.15.15,0,0,0,0,.033",
    transform: "translate(21.759 5.218)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10296",
    "data-name": "Caminho 10296",
    d: "M30.569,7.523a.429.429,0,0,1,0,.141.064.064,0,0,0,0,.026s0,.014,0,.007a.637.637,0,0,0,0-.206c0-.007,0,.005,0,.007a.064.064,0,0,0,0,.026",
    transform: "translate(21.834 5.349)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10297",
    "data-name": "Caminho 10297",
    d: "M30.882,8.173a1.409,1.409,0,0,1,.038.389c0,.022.005.022.005,0a1.606,1.606,0,0,0-.041-.425c0,.005-.005.026,0,.036",
    transform: "translate(22.058 5.812)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10298",
    "data-name": "Caminho 10298",
    d: "M30.872,8.31a2.061,2.061,0,0,1-.1.266c-.005.009,0,.031,0,.036a2.363,2.363,0,0,0,.1-.266c0-.01,0-.031,0-.036",
    transform: "translate(21.979 5.936)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10299",
    "data-name": "Caminho 10299",
    d: "M29.073,7.824a3.639,3.639,0,0,1,.2.357s.007-.027,0-.038a3.647,3.647,0,0,0-.2-.357c.005.005-.007.029,0,.038",
    transform: "translate(20.765 5.561)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10300",
    "data-name": "Caminho 10300",
    d: "M29.448,7.866c-.075.01-.094-.1-.159-.122,0,0-.007.036,0,.038.063.022.084.132.159.122V7.866",
    transform: "translate(20.918 5.531)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10301",
    "data-name": "Caminho 10301",
    d: "M29.206,8.125c.055.1.091.2.149.3,0-.005.007-.029,0-.038-.058-.094-.094-.2-.149-.295,0,0-.007.027,0,.036",
    transform: "translate(20.86 5.778)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10302",
    "data-name": "Caminho 10302",
    d: "M29.41,8.2a.81.81,0,0,1,.149.243c0-.005.005-.026,0-.036a.8.8,0,0,0-.151-.245c.005.005-.007.029,0,.038",
    transform: "translate(21.006 5.829)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10303",
    "data-name": "Caminho 10303",
    d: "M29.393,8.411c.031.063.057.13.087.194,0-.005.009-.027,0-.036-.029-.065-.058-.13-.089-.194,0,0-.005.026,0,.036",
    transform: "translate(20.993 5.982)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10304",
    "data-name": "Caminho 10304",
    d: "M29.584,8.453a.829.829,0,0,1,.029.206c0,.022,0,.022,0,0a1.038,1.038,0,0,0-.031-.242c0,.005-.005.026,0,.036",
    transform: "translate(21.131 6.012)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10305",
    "data-name": "Caminho 10305",
    d: "M29.5,8.629a.931.931,0,0,0,.1.278c0-.005.005-.029,0-.038a.944.944,0,0,1-.1-.273.149.149,0,0,0,0,.033",
    transform: "translate(21.073 6.14)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10306",
    "data-name": "Caminho 10306",
    d: "M29.55,7.877a2.327,2.327,0,0,0,.24.082V7.92a2.316,2.316,0,0,1-.24-.081s-.007.036,0,.038",
    transform: "translate(21.105 5.599)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10307",
    "data-name": "Caminho 10307",
    d: "M29.585,8.074c.094.053.194.094.29.142,0,0,.007-.034,0-.038-.1-.048-.2-.091-.29-.142,0,0-.007.034,0,.038",
    transform: "translate(21.13 5.74)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10308",
    "data-name": "Caminho 10308",
    d: "M29.637,8.294a1.194,1.194,0,0,0,.159.163s.009-.031,0-.038a1.3,1.3,0,0,1-.159-.163c.005.005-.007.029,0,.038",
    transform: "translate(21.168 5.897)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10309",
    "data-name": "Caminho 10309",
    d: "M29.695,8.566a.52.52,0,0,1,.07.213c0,.007,0-.007,0-.007V8.746a.526.526,0,0,0-.07-.216s-.007.027,0,.036",
    transform: "translate(21.209 6.093)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10310",
    "data-name": "Caminho 10310",
    d: "M29.858,7.885q.013.067.031.134c0-.005,0-.026,0-.036-.01-.043-.021-.087-.029-.13,0-.007,0,.005,0,.007a.064.064,0,0,0,0,.026",
    transform: "translate(21.326 5.608)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10311",
    "data-name": "Caminho 10311",
    d: "M30.295,7.708a.914.914,0,0,1-.07.142c-.005.009,0,.033,0,.038a1.4,1.4,0,0,0,.07-.144c0-.009,0-.031,0-.036",
    transform: "translate(21.588 5.506)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10312",
    "data-name": "Caminho 10312",
    d: "M30.441,7.708a1.11,1.11,0,0,1-.019.238.141.141,0,0,0,0,.033,1.2,1.2,0,0,0,.021-.271c0-.022,0-.022,0,0",
    transform: "translate(21.73 5.494)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10313",
    "data-name": "Caminho 10313",
    d: "M30.472,7.972a.811.811,0,0,1-.01.2l0,.034a1.151,1.151,0,0,0,.01-.266c0-.014,0,.022,0,.027",
    transform: "translate(21.759 5.672)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10314",
    "data-name": "Caminho 10314",
    d: "M30.656,8.2a.393.393,0,0,1-.139.231c-.007.007.005.034,0,.039a.4.4,0,0,0,.141-.238.148.148,0,0,0,0-.033",
    transform: "translate(21.796 5.859)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10315",
    "data-name": "Caminho 10315",
    d: "M30.215,7.964c-.022.039-.048.075-.072.111l0,.024,0,.014c.024-.038.05-.074.07-.113V7.964",
    transform: "translate(21.529 5.689)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10316",
    "data-name": "Caminho 10316",
    d: "M30.273,8.291a.514.514,0,0,1-.1.111c-.009.007,0,.036,0,.039a.566.566,0,0,0,.1-.113l0-.019,0-.019",
    transform: "translate(21.55 5.922)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10317",
    "data-name": "Caminho 10317",
    d: "M30.136,8.63a.341.341,0,0,1-.1-.36c0-.01,0-.031,0-.038a.424.424,0,0,0,.1.435c-.005,0,.007-.031,0-.038",
    transform: "translate(21.438 5.88)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10318",
    "data-name": "Caminho 10318",
    d: "M29.9,8.3a.4.4,0,0,1-.01.17c0,.01,0,.031,0,.036a.558.558,0,0,0,.01-.238c0-.007,0,.005,0,.007a.065.065,0,0,0,0,.026",
    transform: "translate(21.347 5.901)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10319",
    "data-name": "Caminho 10319",
    d: "M30.373,8.5a1.32,1.32,0,0,1-.089.194c-.005.01,0,.033,0,.036a1.111,1.111,0,0,0,.091-.194c0-.01,0-.029,0-.036",
    transform: "translate(21.63 6.071)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10320",
    "data-name": "Caminho 10320",
    d: "M30.681,8.619c-.045.074-.093.144-.142.214-.005.009,0,.033,0,.036a2.029,2.029,0,0,0,.142-.214c.005-.009-.005-.033,0-.036",
    transform: "translate(21.812 6.156)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10321",
    "data-name": "Caminho 10321",
    d: "M30.777,8.769c-.021.13-.031.262-.041.394,0,.007,0,.043,0,.019.01-.127.021-.254.039-.381a.151.151,0,0,0,0-.033",
    transform: "translate(21.954 6.263)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10322",
    "data-name": "Caminho 10322",
    d: "M30.94,8.511c0,.045.009.087.01.132,0,.027,0,0,0-.01,0-.043-.01-.087-.01-.132,0-.026,0,0,0,.01",
    transform: "translate(22.1 6.064)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10323",
    "data-name": "Caminho 10323",
    d: "M29.027,7.662a.8.8,0,0,0,.041.382c0-.007,0-.027,0-.038a.661.661,0,0,1-.039-.312.15.15,0,0,0,0-.033",
    transform: "translate(20.728 5.473)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10324",
    "data-name": "Caminho 10324",
    d: "M29.051,7.262s-.038-.379.069-.42c0,0,.038-.348.5-.3a.305.305,0,0,1,.406-.122s.238-.117.375-.048a1.287,1.287,0,0,1,.319.211.442.442,0,0,1,.295.034c.094.075.05.321.05.321s.225.171.243.324.019.214-.031.254a.234.234,0,0,1,.081.2.641.641,0,0,1-.13.283c-.019,0,.012.3-.087.4a.483.483,0,0,1-.238.135c-.043.014-.156.178-.262.2s-.25-.165-.262-.219S30.22,8.4,30.22,8.4s-.324.348-.543.293a.568.568,0,0,1-.345-.273c-.019-.034-.081-.286-.081-.286s-.243-.144-.226-.279a.968.968,0,0,1,.12-.3Z",
    transform: "translate(20.732 4.536)",
    fill: "#dcddde"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10325",
    "data-name": "Caminho 10325",
    d: "M29.685,6.872a.92.92,0,0,1,.789-.326V6.508a.92.92,0,0,0-.789.326c-.007.007.005.034,0,.038",
    transform: "translate(21.202 4.638)",
    fill: "#fff"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10326",
    "data-name": "Caminho 10326",
    d: "M30.6,6.9a.7.7,0,0,0-.789-.019c-.007.007.005.034,0,.038a.707.707,0,0,1,.789.019s.007-.033,0-.038",
    transform: "translate(21.296 4.837)",
    fill: "#fff"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10327",
    "data-name": "Caminho 10327",
    d: "M29.805,7.053a1.885,1.885,0,0,1,.149.866l0,.034a2.04,2.04,0,0,0-.149-.936c0,.005-.005.026,0,.036",
    transform: "translate(21.289 5.012)",
    fill: "#fff"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10328",
    "data-name": "Caminho 10328",
    d: "M29.607,7.152a3.484,3.484,0,0,1,0,.855c0,.007,0,.043,0,.019a3.649,3.649,0,0,0,0-.907.15.15,0,0,0,0,.033",
    transform: "translate(21.148 5.085)",
    fill: "#fff"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10329",
    "data-name": "Caminho 10329",
    d: "M29.871,7.032a1.132,1.132,0,0,1,.694.5s.005-.027,0-.036a1.13,1.13,0,0,0-.694-.5v.038",
    transform: "translate(21.336 4.996)",
    fill: "#fff"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10330",
    "data-name": "Caminho 10330",
    d: "M29.742,7.247a1.744,1.744,0,0,1-.036.518c0,.012,0,.031,0,.038a1.83,1.83,0,0,0,.039-.555c0-.022,0-.022,0,0",
    transform: "translate(21.218 5.164)",
    fill: "#fff"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10331",
    "data-name": "Caminho 10331",
    d: "M29.981,7.233a.933.933,0,0,1,.336.588c0,.015,0-.021,0-.026a.944.944,0,0,0-.339-.6s-.007.031,0,.038",
    transform: "translate(21.413 5.139)",
    fill: "#fff"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10332",
    "data-name": "Caminho 10332",
    d: "M29.237,7.6a.532.532,0,0,1,.225-.211c.007,0,0-.038,0-.038a.54.54,0,0,0-.226.213c-.005.007,0,.033,0,.036",
    transform: "translate(20.881 5.251)",
    fill: "#fff"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10333",
    "data-name": "Caminho 10333",
    d: "M29.593,6.766a.571.571,0,0,0-.279-.333s-.007.031,0,.034a.569.569,0,0,1,.278.331.177.177,0,0,0,0-.033",
    transform: "translate(20.937 4.595)",
    fill: "#fff"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10334",
    "data-name": "Caminho 10334",
    d: "M29.522,6.657a1.011,1.011,0,0,0-.451-.077v.038a1.035,1.035,0,0,1,.451.077s.007-.034,0-.038",
    transform: "translate(20.765 4.7)",
    fill: "#fff"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10335",
    "data-name": "Caminho 10335",
    d: "M29.653,6.771a.378.378,0,0,0-.132-.384s-.007.029,0,.034a.315.315,0,0,1,.13.321l0,.029",
    transform: "translate(21.085 4.562)",
    fill: "#fff"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10336",
    "data-name": "Caminho 10336",
    d: "M29.915,6.754a.879.879,0,0,1,.432-.058V6.658a.879.879,0,0,0-.432.058c-.007,0,0,.036,0,.038",
    transform: "translate(21.366 4.755)",
    fill: "#fff"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10337",
    "data-name": "Caminho 10337",
    d: "M30.059,6.958a.773.773,0,0,1,.507.288c-.01-.01.014-.06,0-.077a.77.77,0,0,0-.507-.286s-.009.075,0,.075",
    transform: "translate(21.467 4.916)",
    fill: "#fff"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10338",
    "data-name": "Caminho 10338",
    d: "M29.623,7.263c-.05.2-.012.453-.243.535-.012.005,0,.075,0,.077.235-.084.2-.336.245-.538.005-.022-.005-.06,0-.074",
    transform: "translate(20.982 5.188)",
    fill: "#fff"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10339",
    "data-name": "Caminho 10339",
    d: "M29.805,7.2a1.235,1.235,0,0,1,.149.658.226.226,0,0,0,0,.067,1.441,1.441,0,0,0-.151-.8c.005.012-.01.053,0,.074",
    transform: "translate(21.287 5.092)",
    fill: "#fff"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10340",
    "data-name": "Caminho 10340",
    d: "M29.982,7.181a.5.5,0,0,1,.411.417c0,.015.005-.012.005-.014l0-.051a.5.5,0,0,0-.415-.427s-.009.074,0,.075",
    transform: "translate(21.412 5.076)",
    fill: "#fff"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10341",
    "data-name": "Caminho 10341",
    d: "M29.979,7.353A.975.975,0,0,1,30,7.878c-.007.021.007.062,0,.074a1.264,1.264,0,0,0-.019-.663.211.211,0,0,0,0,.065",
    transform: "translate(21.413 5.205)",
    fill: "#fff"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10342",
    "data-name": "Caminho 10342",
    d: "M29.916,6.927A.806.806,0,0,1,30.572,7c-.007-.007.015-.065,0-.077a.805.805,0,0,0-.657-.075c-.009,0,0,.075,0,.075",
    transform: "translate(21.365 4.87)",
    fill: "#fff"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10343",
    "data-name": "Caminho 10343",
    d: "M29.677,6.811a.519.519,0,0,1,.355-.379c.012,0,0-.074,0-.075a.522.522,0,0,0-.358.389.173.173,0,0,0,0,.051s0,.029.005.014",
    transform: "translate(21.193 4.541)",
    fill: "#fff"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10344",
    "data-name": "Caminho 10344",
    d: "M29.634,6.917a1.3,1.3,0,0,0-.185-.552c.005.009-.009.048,0,.065a1.222,1.222,0,0,1,.18.5c0,.048.007.005.007-.017",
    transform: "translate(21.032 4.546)",
    fill: "#fff"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10345",
    "data-name": "Caminho 10345",
    d: "M29.581,6.913a.573.573,0,0,0-.321-.389c.005,0-.014.069,0,.077a.565.565,0,0,1,.317.377.211.211,0,0,0,0-.065",
    transform: "translate(20.896 4.66)",
    fill: "#fff"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10346",
    "data-name": "Caminho 10346",
    d: "M29.412,6.775a.811.811,0,0,0-.343-.161s-.007.058,0,.058a.835.835,0,0,1,.343.163c-.005-.005.012-.051,0-.06",
    transform: "translate(20.761 4.724)",
    fill: "#fff"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10347",
    "data-name": "Caminho 10347",
    d: "M29.674,7.236a.961.961,0,0,1-.055.569c-.01.019.007.065,0,.074a1.188,1.188,0,0,0,.058-.7c0-.031-.007.043-.005.053",
    transform: "translate(21.154 5.125)",
    fill: "#fff"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10348",
    "data-name": "Caminho 10348",
    d: "M29.783,7.18a1.467,1.467,0,0,1,.129.576c0,.014,0,.086.007.039a1.708,1.708,0,0,0-.134-.689c.005.012-.009.053,0,.074",
    transform: "translate(21.272 5.076)",
    fill: "#fff"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10349",
    "data-name": "Caminho 10349",
    d: "M29.873,7.025a1.052,1.052,0,0,1,.507.269c-.01-.01.014-.062,0-.077a1.063,1.063,0,0,0-.507-.267s-.012.072,0,.075",
    transform: "translate(21.334 4.964)",
    fill: "#fff"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10350",
    "data-name": "Caminho 10350",
    d: "M29.578,6.968a4.241,4.241,0,0,0,.039-.487c0-.043-.009-.043-.009,0a4.076,4.076,0,0,1-.036.434c0,.009,0,.082.005.053",
    transform: "translate(21.123 4.607)",
    fill: "#fff"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10351",
    "data-name": "Caminho 10351",
    d: "M29.537,6.8a1.661,1.661,0,0,1-.375-.249c.009.007-.015.063,0,.075a1.6,1.6,0,0,0,.375.249s.014-.069,0-.075",
    transform: "translate(20.826 4.676)",
    fill: "#fff"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10352",
    "data-name": "Caminho 10352",
    d: "M29.425,7.262a.472.472,0,0,0-.189.231.141.141,0,0,0,0,.046l.005.027a.474.474,0,0,1,.187-.23c.015-.009-.007-.072,0-.075",
    transform: "translate(20.881 5.187)",
    fill: "#fff"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10353",
    "data-name": "Caminho 10353",
    d: "M29.556,7.356a.516.516,0,0,1-.165.336c-.015.015.009.067,0,.077a.567.567,0,0,0,.171-.393c0-.024-.005-.074-.007-.021",
    transform: "translate(20.99 5.237)",
    fill: "#fff"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10354",
    "data-name": "Caminho 10354",
    d: "M29.855,6.864c.111-.175.379-.19.557-.238.012,0,0-.075,0-.075-.182.048-.447.063-.559.24-.01.017.007.067,0,.074",
    transform: "translate(21.321 4.679)",
    fill: "#fff"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10355",
    "data-name": "Caminho 10355",
    d: "M29.187,6.756a.653.653,0,0,1-.122-.057s-.009.041,0,.046a.559.559,0,0,0,.122.057s.007-.045,0-.046",
    transform: "translate(20.759 4.785)",
    fill: "#fff"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10356",
    "data-name": "Caminho 10356",
    d: "M29.195,7.254a.225.225,0,0,0-.1.067c-.007.007-.005.027-.005.038l0,.026,0,.012a.239.239,0,0,1,.1-.067l0-.038,0-.038",
    transform: "translate(20.775 5.181)",
    fill: "#fff"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10357",
    "data-name": "Caminho 10357",
    d: "M29.322,7.278a.494.494,0,0,0-.187.175c-.009.012.005.051,0,.057a.48.48,0,0,1,.185-.171c.01-.005,0-.058,0-.06",
    transform: "translate(20.809 5.199)",
    fill: "#fff"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10358",
    "data-name": "Caminho 10358",
    d: "M29.493,7.322c-.069.17-.259.355-.122.545-.005-.007.014-.058,0-.074-.094-.13.072-.278.122-.4.009-.021-.007-.063,0-.074",
    transform: "translate(20.945 5.23)",
    fill: "#fff"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10359",
    "data-name": "Caminho 10359",
    d: "M29.571,7.339a2.561,2.561,0,0,1-.055.511.213.213,0,0,0,0,.065,2.78,2.78,0,0,0,.058-.6c0-.053-.007,0-.007.021",
    transform: "translate(21.082 5.211)",
    fill: "#fff"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10360",
    "data-name": "Caminho 10360",
    d: "M29.873,7.233a1.571,1.571,0,0,1,.29.543c0-.012.009-.051,0-.072a1.547,1.547,0,0,0-.291-.547c.009.012-.014.058,0,.075",
    transform: "translate(21.335 5.113)",
    fill: "#fff"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10361",
    "data-name": "Caminho 10361",
    d: "M29.911,7.156a2.336,2.336,0,0,1,.581.528c-.005-.007.014-.057,0-.074a2.322,2.322,0,0,0-.583-.53c.007.005-.015.063,0,.075",
    transform: "translate(21.361 5.058)",
    fill: "#fff"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10362",
    "data-name": "Caminho 10362",
    d: "M29.982,6.995a.482.482,0,0,1,.221.022,1.183,1.183,0,0,1,.18.115.781.781,0,0,1,.17.12.551.551,0,0,1,.082.269.161.161,0,0,0,0-.057,1.5,1.5,0,0,0-.048-.211.291.291,0,0,0-.137-.146c-.069-.043-.135-.087-.2-.132a.42.42,0,0,0-.269-.046c-.007,0,0,.065,0,.065",
    transform: "translate(21.413 4.947)",
    fill: "#fff"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10363",
    "data-name": "Caminho 10363",
    d: "M30.275,7.233c.022.067.05.132.072.2,0-.009.007-.034,0-.048-.022-.067-.05-.132-.072-.2,0,.009-.007.034,0,.048",
    transform: "translate(21.624 5.132)",
    fill: "#fff"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10364",
    "data-name": "Caminho 10364",
    d: "M29.939,6.679c.146-.039.295-.067.437-.117.012,0,0-.074,0-.075-.142.05-.291.075-.437.117-.012,0,0,.075,0,.075",
    transform: "translate(21.381 4.634)",
    fill: "#fff"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10365",
    "data-name": "Caminho 10365",
    d: "M29.585,6.866a.65.65,0,0,1,.1-.206c.053-.081.062-.182.129-.255.014-.017-.01-.067,0-.077a.737.737,0,0,0-.106.214,1.876,1.876,0,0,0-.122.25c-.005.022.005.06,0,.074",
    transform: "translate(21.13 4.52)",
    fill: "#fff"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10366",
    "data-name": "Caminho 10366",
    d: "M29.3,7.438a.668.668,0,0,0,.026.375c-.005-.01.009-.053,0-.074A.4.4,0,0,1,29.3,7.5a.255.255,0,0,0,0-.051s0-.027-.005-.014",
    transform: "translate(20.918 5.31)",
    fill: "#fff"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10367",
    "data-name": "Caminho 10367",
    d: "M29.488,7.574a.3.3,0,0,0-.026.261l.005-.026a.118.118,0,0,0,0-.043.122.122,0,0,1,.024-.12.086.086,0,0,0,0-.036l0-.036",
    transform: "translate(21.032 5.41)",
    fill: "#fff"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10368",
    "data-name": "Caminho 10368",
    d: "M29.631,7.511a.546.546,0,0,1-.07.2c-.007.014,0,.046,0,.053a.638.638,0,0,0,.074-.243c0-.017,0-.051-.005-.014",
    transform: "translate(21.113 5.353)",
    fill: "#fff"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10369",
    "data-name": "Caminho 10369",
    d: "M29.6,7.273v.091l0,.038,0-.038V7.273l0-.038,0,.038",
    transform: "translate(21.146 5.168)",
    fill: "#fff"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10370",
    "data-name": "Caminho 10370",
    d: "M29.547,7.319l.014.033c0,.017.005.017.005,0l0,.019a.259.259,0,0,0,0,.051s0,.029.005.014a.3.3,0,0,0-.017-.194l-.005.027a.106.106,0,0,0,0,.046",
    transform: "translate(21.102 5.175)",
    fill: "#fff"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10371",
    "data-name": "Caminho 10371",
    d: "M29.475,7.26a.873.873,0,0,0-.033.144.184.184,0,0,0,0,.053s0,.027.005.014a.889.889,0,0,1,.031-.137.141.141,0,0,0,0-.046l-.005-.027",
    transform: "translate(21.028 5.186)",
    fill: "#fff"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10372",
    "data-name": "Caminho 10372",
    d: "M29.5,7.264a.85.85,0,0,1-.252.19c-.014.009.005.072,0,.075a.85.85,0,0,0,.252-.19c.007-.007,0-.027,0-.038l0-.038",
    transform: "translate(20.889 5.189)",
    fill: "#fff"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10373",
    "data-name": "Caminho 10373",
    d: "M29.34,7.283a.461.461,0,0,1-.137.074c-.012.005,0,.075,0,.077a.43.43,0,0,0,.137-.075c.007-.005,0-.031,0-.038l0-.038",
    transform: "translate(20.856 5.202)",
    fill: "#fff"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10374",
    "data-name": "Caminho 10374",
    d: "M29.173,7.244c-.039.017-.081.033-.122.051-.01.005,0,.06,0,.06.041-.017.082-.033.122-.05.01-.005,0-.06,0-.062",
    transform: "translate(20.748 5.174)",
    fill: "#fff"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10375",
    "data-name": "Caminho 10375",
    d: "M29.609,7.243a.864.864,0,0,0,.017.147c0,.014.005-.012.005-.014a.186.186,0,0,0,0-.053.5.5,0,0,1-.015-.1l0-.026a.141.141,0,0,0,0,.046",
    transform: "translate(21.149 5.141)",
    fill: "#fff"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10376",
    "data-name": "Caminho 10376",
    d: "M29.685,7.2a.476.476,0,0,0,.027.17l0-.027a.105.105,0,0,0,0-.046.312.312,0,0,1-.022-.1l0-.038,0,.038",
    transform: "translate(21.204 5.119)",
    fill: "#fff"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10377",
    "data-name": "Caminho 10377",
    d: "M29.745,7.213a.173.173,0,0,1,.038.089l.005.027a.151.151,0,0,0,0-.048.236.236,0,0,0-.043-.142l-.005.027c0,.01,0,.036,0,.046",
    transform: "translate(21.243 5.099)",
    fill: "#fff"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10378",
    "data-name": "Caminho 10378",
    d: "M29.816,7.185a.218.218,0,0,1,.113.058l0-.038c0-.009,0-.033,0-.039a.216.216,0,0,0-.113-.057s-.01.074,0,.075",
    transform: "translate(21.294 5.079)",
    fill: "#fff"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10379",
    "data-name": "Caminho 10379",
    d: "M29.854,7.127a.336.336,0,0,0,.17.082s.009-.074,0-.075a.35.35,0,0,1-.17-.082l0,.038c0,.007,0,.033,0,.038",
    transform: "translate(21.321 5.037)",
    fill: "#fff"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10380",
    "data-name": "Caminho 10380",
    d: "M29.932,6.934a.679.679,0,0,1,.13.017s.009-.075,0-.077a.676.676,0,0,0-.13-.015v.075",
    transform: "translate(21.38 4.899)",
    fill: "#fff"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10381",
    "data-name": "Caminho 10381",
    d: "M29.9,6.887A.411.411,0,0,1,30,6.78c.007-.005,0-.031,0-.038l0-.038a.425.425,0,0,0-.106.108c-.007.01,0,.036,0,.046l.005.027",
    transform: "translate(21.351 4.789)",
    fill: "#fff"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10382",
    "data-name": "Caminho 10382",
    d: "M29.828,6.81a.284.284,0,0,1,.055-.135c.007-.009,0-.029,0-.038l0-.038a.312.312,0,0,0-.058.146.172.172,0,0,0,0,.051s0,.029.005.014",
    transform: "translate(21.301 4.714)",
    fill: "#fff"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10383",
    "data-name": "Caminho 10383",
    d: "M29.771,6.8c.05-.07.084-.151.13-.223a.141.141,0,0,0,0-.046L29.9,6.507c-.046.072-.079.153-.129.223-.007.01,0,.036,0,.046l.005.027",
    transform: "translate(21.26 4.648)",
    fill: "#fff"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10384",
    "data-name": "Caminho 10384",
    d: "M29.638,6.553a1.385,1.385,0,0,0,.026.254c0,.015.005-.01.005-.014a.175.175,0,0,0,0-.051,1.22,1.22,0,0,1-.022-.209c0-.053-.007,0-.007.021",
    transform: "translate(21.17 4.649)",
    fill: "#fff"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10385",
    "data-name": "Caminho 10385",
    d: "M29.428,6.6c.014.031.031.06.046.089l.026.058.007.022c-.005-.015,0-.012-.007.005s.007.065,0,.074a.231.231,0,0,0,.009-.141,1.153,1.153,0,0,0-.082-.182c.005.01-.01.053,0,.074",
    transform: "translate(21.018 4.662)",
    fill: "#fff"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10386",
    "data-name": "Caminho 10386",
    d: "M29.454,6.711a1.464,1.464,0,0,0-.161-.132l-.005.038c0,.007,0,.033.005.038a1.465,1.465,0,0,1,.161.132l0-.038c0-.009,0-.031,0-.038",
    transform: "translate(20.92 4.699)",
    fill: "#fff"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10387",
    "data-name": "Caminho 10387",
    d: "M29.542,6.906a.8.8,0,0,0-.041-.49c.005.01-.01.053,0,.072a.566.566,0,0,1,.039.353.169.169,0,0,0,0,.051s0,.027.005.014",
    transform: "translate(21.069 4.583)",
    fill: "#fff"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10388",
    "data-name": "Caminho 10388",
    d: "M29.729,6.606v0",
    transform: "translate(21.235 4.665)",
    fill: "#fff"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10389",
    "data-name": "Caminho 10389",
    d: "M29.5,6.864c.009-.094.031-.187.041-.281a.634.634,0,0,0,0-.081c0-.019-.007-.019-.009,0-.01.094-.031.187-.041.281a.622.622,0,0,0,0,.081c0,.019.007.019.009,0",
    transform: "translate(21.064 4.634)",
    fill: "#fff"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10390",
    "data-name": "Caminho 10390",
    d: "M30.1,7.1a.334.334,0,0,1,.2.163L30.3,7.22a.194.194,0,0,0,0-.07.343.343,0,0,0-.2-.168s-.017.11,0,.115",
    transform: "translate(21.492 4.987)",
    fill: "#fff"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10391",
    "data-name": "Caminho 10391",
    d: "M29.933,7.427a.292.292,0,0,1,.007.144.29.29,0,0,0,0,.077s0,.043.007.021a.785.785,0,0,0-.009-.351l-.007.039a.194.194,0,0,0,0,.07",
    transform: "translate(21.377 5.226)",
    fill: "#fff"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10392",
    "data-name": "Caminho 10392",
    d: "M29.8,7.315a1.4,1.4,0,0,1-.014.281.3.3,0,0,0,0,.079s0,.041.007.021a1.885,1.885,0,0,0,.021-.381s0-.057-.007-.057l-.005.057",
    transform: "translate(21.276 5.184)",
    fill: "#fff"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10393",
    "data-name": "Caminho 10393",
    d: "M29.769,7.35c-.034.125-.065.25-.093.377a.406.406,0,0,0,0,.079s.005.041.009.021c.024-.123.057-.245.087-.367.01-.033-.007-.091,0-.11",
    transform: "translate(21.195 5.25)",
    fill: "#fff"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10394",
    "data-name": "Caminho 10394",
    d: "M29.821,7.421a2.551,2.551,0,0,1,0,.324.315.315,0,0,0,0,.081c0,.019.005.019.009,0a3.976,3.976,0,0,0,0-.4s0-.057-.007-.057l-.005.057",
    transform: "translate(21.3 5.26)",
    fill: "#fff"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10395",
    "data-name": "Caminho 10395",
    d: "M29.391,7.474c0-.034,0-.041,0-.021l-.005.022a.212.212,0,0,1-.015.034.161.161,0,0,0-.005.07s.005.046.007.039a.382.382,0,0,0,.026-.243c0-.022-.007.015-.007.019a.4.4,0,0,0,0,.079",
    transform: "translate(20.973 5.264)",
    fill: "#fff"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10396",
    "data-name": "Caminho 10396",
    d: "M29.575,7.345a.248.248,0,0,1,.021.127s0,.057.005.057.005-.053.005-.057a.5.5,0,0,0-.027-.237l-.007.039a.161.161,0,0,0,0,.07",
    transform: "translate(21.121 5.168)",
    fill: "#fff"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10397",
    "data-name": "Caminho 10397",
    d: "M29.628,7.324a.147.147,0,0,1,.031.034l.009.019c0,.007,0,.027,0,0l0,.034s0,.014,0,.007a.194.194,0,0,0,0-.07.166.166,0,0,0-.053-.142l0,.017,0,.041,0,.039,0,.017",
    transform: "translate(21.159 5.149)",
    fill: "#fff"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10398",
    "data-name": "Caminho 10398",
    d: "M29.692,7.264c.019.036.039.072.057.108l.005-.007,0-.034V7.288a.151.151,0,0,0,0-.027c-.019-.036-.039-.07-.057-.106,0-.007-.005.005-.005.005l0,.034v.045a.066.066,0,0,0,0,.026",
    transform: "translate(21.206 5.108)",
    fill: "#fff"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10399",
    "data-name": "Caminho 10399",
    d: "M29.84,7.21c.045.063.089.125.139.183l.005-.057c0-.014.005-.046-.005-.057-.048-.058-.093-.118-.135-.18l-.007.039c0,.015-.007.057,0,.07",
    transform: "translate(21.31 5.071)",
    fill: "#fff"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10400",
    "data-name": "Caminho 10400",
    d: "M29.916,7.084a1.386,1.386,0,0,0,.115.168l.005-.058c0-.014,0-.045-.005-.057a1.3,1.3,0,0,1-.111-.163l-.007.039a.139.139,0,0,0,0,.07",
    transform: "translate(21.364 4.981)",
    fill: "#fff"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10401",
    "data-name": "Caminho 10401",
    d: "M29.23,6.734a.444.444,0,0,0-.122-.074l-.005.057c0,.007,0,.053.005.057a.5.5,0,0,1,.122.075l.005-.058c0-.01.005-.048-.005-.057",
    transform: "translate(20.788 4.757)",
    fill: "#fff"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10402",
    "data-name": "Caminho 10402",
    d: "M29.41,6.671l.007.019.005.015h0l0,.034s0,.012,0,.005a.161.161,0,0,0,0-.07.286.286,0,0,0-.019-.113c0-.007-.005.005-.005.005l0,.034a.161.161,0,0,0,0,.07",
    transform: "translate(21.003 4.685)",
    fill: "#fff"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10403",
    "data-name": "Caminho 10403",
    d: "M29.61,6.48a.418.418,0,0,1-.045.219.138.138,0,0,0,0,.07l.007.039a.694.694,0,0,0,.051-.36l-.007-.039a.242.242,0,0,0,0,.07",
    transform: "translate(21.114 4.579)",
    fill: "#fff"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10404",
    "data-name": "Caminho 10404",
    d: "M29.633,6.819a.467.467,0,0,0,.147-.183.194.194,0,0,0,0-.07c0-.005,0-.046-.007-.039a.443.443,0,0,1-.144.178c-.01.007-.005.048-.005.058l.005.057",
    transform: "translate(21.162 4.661)",
    fill: "#fff"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10405",
    "data-name": "Caminho 10405",
    d: "M29.745,6.771c.022-.024.043-.051.065-.074l0-.017,0-.041,0-.039,0-.017c-.022.024-.043.051-.065.074l0,.017,0,.041,0,.039,0,.017",
    transform: "translate(21.243 4.701)",
    fill: "#fff"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10406",
    "data-name": "Caminho 10406",
    d: "M30.006,6.726c-.074,0-.146,0-.218-.009-.005,0-.012.113,0,.115.072.007.144.007.218.009a.26.26,0,0,0,0-.115",
    transform: "translate(21.273 4.798)",
    fill: "#fff"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10407",
    "data-name": "Caminho 10407",
    d: "M29.879,6.923c.1.058.19.122.291.173-.009,0,.021-.1,0-.113-.1-.053-.194-.117-.291-.175.009.007-.022.1,0,.115",
    transform: "translate(21.337 4.863)",
    fill: "#fff"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10408",
    "data-name": "Caminho 10408",
    d: "M29.884,7.039a2.132,2.132,0,0,1,.259.165l.005-.057c0-.01.005-.048-.005-.057a1.954,1.954,0,0,0-.259-.166l-.005.058c0,.009-.005.05.005.057",
    transform: "translate(21.341 4.946)",
    fill: "#fff"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10409",
    "data-name": "Caminho 10409",
    d: "M29.559,6.827a.46.46,0,0,0,.012-.129c0-.005,0-.058-.005-.058s-.005.053-.005.058h0l-.005.019a.316.316,0,0,0,0,.07l0,.034s0,.012.005.005",
    transform: "translate(21.108 4.743)",
    fill: "#fff"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10410",
    "data-name": "Caminho 10410",
    d: "M29.161,6.62a1.5,1.5,0,0,0,.266.233c.07.053.12.146.2.189-.009-.005.022-.1,0-.115-.067-.038-.113-.118-.171-.17a1.839,1.839,0,0,1-.29-.252c.014.017-.021.089,0,.115",
    transform: "translate(20.824 4.646)",
    fill: "#fff"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10411",
    "data-name": "Caminho 10411",
    d: "M29.31,6.813c-.046-.048-.087-.1-.13-.149l0,.017,0,.039c0,.015,0,.046.005.058.043.051.084.1.13.149l.005-.058c0-.012.005-.046-.005-.057",
    transform: "translate(20.838 4.76)",
    fill: "#fff"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10412",
    "data-name": "Caminho 10412",
    d: "M29.242,7.191a1.193,1.193,0,0,1-.1.163c-.009.012-.005.043-.005.058l.005.057a1.272,1.272,0,0,0,.1-.168.192.192,0,0,0,0-.07l-.007-.039",
    transform: "translate(20.815 5.136)",
    fill: "#fff"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10413",
    "data-name": "Caminho 10413",
    d: "M29.265,7.274c0,.063-.024.127-.033.19a.318.318,0,0,0,0,.081c0,.019.005.019.009,0,.009-.081.031-.158.033-.24a.16.16,0,0,0,0-.07l-.005.039",
    transform: "translate(20.878 5.168)",
    fill: "#fff"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10414",
    "data-name": "Caminho 10414",
    d: "M29.426,7.811a1.846,1.846,0,0,0,.045-.557c0-.081-.012-.007-.01.029a1.371,1.371,0,0,1-.038.418c-.009.031.009.091,0,.11",
    transform: "translate(21.015 5.156)",
    fill: "#fff"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10415",
    "data-name": "Caminho 10415",
    d: "M29.528,7.354a.4.4,0,0,1,.015.185.293.293,0,0,0,0,.077s0,.043.007.021a.868.868,0,0,0-.017-.393l-.007.039a.193.193,0,0,0,0,.07",
    transform: "translate(21.088 5.174)",
    fill: "#fff"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10416",
    "data-name": "Caminho 10416",
    d: "M29.629,7.319A.391.391,0,0,1,29.7,7.6c0,.019.005.129.01.058a.652.652,0,0,0-.086-.451l-.005.058c0,.014-.005.045.005.057",
    transform: "translate(21.159 5.146)",
    fill: "#fff"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10417",
    "data-name": "Caminho 10417",
    d: "M29.654,7.273a3.768,3.768,0,0,1,.087.5c0,.045.009-.065.007-.081a3.878,3.878,0,0,0-.091-.526,1.045,1.045,0,0,0,0,.11",
    transform: "translate(21.18 5.116)",
    fill: "#fff"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10418",
    "data-name": "Caminho 10418",
    d: "M29.75,7.248a1.057,1.057,0,0,1,.17.322l.007-.039a.194.194,0,0,0,0-.07,1.1,1.1,0,0,0-.17-.322c.007.009-.021.086,0,.11",
    transform: "translate(21.246 5.099)",
    fill: "#fff"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10419",
    "data-name": "Caminho 10419",
    d: "M30.014,7.068a.16.16,0,0,0-.163-.06c-.012,0-.005.115,0,.115a.158.158,0,0,1,.159.055l.007-.039a.139.139,0,0,0,0-.07",
    transform: "translate(21.317 5.004)",
    fill: "#fff"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10420",
    "data-name": "Caminho 10420",
    d: "M29.846,7.069a2.15,2.15,0,0,1,.315-.017.251.251,0,0,0,0-.113,2.415,2.415,0,0,0-.315.015c-.014,0,0,.115,0,.115",
    transform: "translate(21.314 4.956)",
    fill: "#fff"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10421",
    "data-name": "Caminho 10421",
    d: "M30.023,6.51a.85.85,0,0,0-.156.363.232.232,0,0,0,0,.077c0,.005,0,.043.007.021a.839.839,0,0,1,.151-.346c.01-.012.005-.045.005-.058l-.005-.057",
    transform: "translate(21.33 4.65)",
    fill: "#fff"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10422",
    "data-name": "Caminho 10422",
    d: "M29.691,6.611a2.245,2.245,0,0,0,.082.278l.007-.039a.321.321,0,0,0,0-.07,2.494,2.494,0,0,1-.081-.266c0-.022-.007.015-.007.019a.41.41,0,0,0,0,.079",
    transform: "translate(21.206 4.647)",
    fill: "#fff"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10423",
    "data-name": "Caminho 10423",
    d: "M29.679,6.729a.445.445,0,0,1-.087-.154c0-.009-.005.007-.005.005l0,.034a.321.321,0,0,0,0,.07.493.493,0,0,0,.091.159l0-.017,0-.041c0-.014.005-.045-.005-.057",
    transform: "translate(21.132 4.695)",
    fill: "#fff"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10424",
    "data-name": "Caminho 10424",
    d: "M29.7,6.78a1.206,1.206,0,0,1-.357-.173c.012.009-.022.1,0,.113A1.171,1.171,0,0,0,29.7,6.9s.017-.11,0-.115",
    transform: "translate(20.955 4.719)",
    fill: "#fff"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10425",
    "data-name": "Caminho 10425",
    d: "M27.941,7.608s-.211-.363.374-.54a.824.824,0,0,1,.218.163.584.584,0,0,1-.435.214S27.948,7.49,27.941,7.608Z",
    transform: "translate(19.932 5.049)",
    fill: "#d9c0b9"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10426",
    "data-name": "Caminho 10426",
    d: "M27.941,7.608s-.211-.363.374-.54a.824.824,0,0,1,.218.163.584.584,0,0,1-.435.214S27.948,7.49,27.941,7.608Z",
    transform: "translate(19.932 5.049)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10427",
    "data-name": "Caminho 10427",
    d: "M28.266,7.123c-.1.058-.247.06-.276.192v.007c.031-.13.182-.132.276-.189v-.01",
    transform: "translate(19.993 5.088)",
    fill: "#5e3f17"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10428",
    "data-name": "Caminho 10428",
    d: "M27.961,7.482a.558.558,0,0,0,.394-.067c.13-.094.177-.051.211-.045a.308.308,0,0,0-.075-.207,1.079,1.079,0,0,1-.286.173C28.081,7.374,28,7.362,27.961,7.482Z",
    transform: "translate(19.972 5.116)",
    fill: "#d9c0b9"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10429",
    "data-name": "Caminho 10429",
    d: "M27.961,7.482a.558.558,0,0,0,.394-.067c.13-.094.177-.051.211-.045a.308.308,0,0,0-.075-.207,1.079,1.079,0,0,1-.286.173C28.081,7.374,28,7.362,27.961,7.482Z",
    transform: "translate(19.972 5.116)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10430",
    "data-name": "Caminho 10430",
    d: "M30.731,6.689s-.506.086-.638.117a3.578,3.578,0,0,1-.538.062,2.478,2.478,0,0,1-.377-.108c-.111-.022-.477-.06-.607.077s-.218.182-.261.228-.211.2-.216.261.041.166.125.166.261.178.261.214c0,.063.23.13.447.129.393,0,.585-.2,1.173-.13a1.566,1.566,0,0,0,1.013-.365.419.419,0,0,0,.063-.487C31.072,6.677,30.757,6.694,30.731,6.689Z",
    transform: "translate(20.067 4.778)",
    fill: "#dba05f"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10431",
    "data-name": "Caminho 10431",
    d: "M30.731,6.689s-.506.086-.638.117a3.578,3.578,0,0,1-.538.062,2.478,2.478,0,0,1-.377-.108c-.111-.022-.477-.06-.607.077s-.218.182-.261.228-.211.2-.216.261.041.166.125.166.261.178.261.214c0,.063.23.13.447.129.393,0,.585-.2,1.173-.13a1.566,1.566,0,0,0,1.013-.365.419.419,0,0,0,.063-.487C31.072,6.677,30.757,6.694,30.731,6.689Z",
    transform: "translate(20.067 4.778)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10432",
    "data-name": "Caminho 10432",
    d: "M28.407,7.11s0,.01,0-.007l0-.012,0-.01v-.01s.01,0,.051-.038l.034-.051a.238.238,0,0,1,.127-.082.452.452,0,0,1,.158-.005s-.175-.007-.187.015a.4.4,0,0,1,.18-.009s-.159-.005-.171.017a.366.366,0,0,1,.163,0l-.034,0,.012,0h-.021l-.012,0,.034.007s.015-.005-.043,0a.2.2,0,0,0-.093.012c-.075.012-.074.115-.189.18",
    transform: "translate(20.283 4.921)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10433",
    "data-name": "Caminho 10433",
    d: "M28.4,7.071c.007,0,.057-.019.1-.106-.014-.024.178-.1.2-.075a.614.614,0,0,1,.081.005",
    transform: "translate(20.282 4.917)",
    fill: "none",
    stroke: "#939598",
    strokeWidth: 0.05
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10434",
    "data-name": "Caminho 10434",
    d: "M28.585,6.9a.273.273,0,0,0-.11.084.161.161,0,0,1-.081.082",
    transform: "translate(20.282 4.926)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10435",
    "data-name": "Caminho 10435",
    d: "M28.51,6.909a.447.447,0,0,1,.158-.009",
    transform: "translate(20.364 4.926)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10436",
    "data-name": "Caminho 10436",
    d: "M28.5,6.935c0-.014.137-.033.149-.024",
    transform: "translate(20.354 4.935)",
    fill: "none",
    stroke: "#939598",
    strokeWidth: 0.05
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10437",
    "data-name": "Caminho 10437",
    d: "M28.69,6.985s.005,0,0-.005l-.007-.007,0-.005-.005,0L28.633,7a.239.239,0,0,0-.033.027.632.632,0,0,1-.072.05c-.041.005-.1.033-.1.043,0-.015.117-.048.115-.05s-.106.027-.108.05c-.005-.014.1-.041.108-.041s-.094.024-.1.045l.019-.014-.007.005.012-.005.009,0-.021.014s-.01,0,.027-.012a.425.425,0,0,0,.2-.12",
    transform: "translate(20.306 4.974)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10438",
    "data-name": "Caminho 10438",
    d: "M28.675,6.962s-.043.041-.086.072a.234.234,0,0,1-.111.053.111.111,0,0,0-.053.034",
    transform: "translate(20.304 4.973)",
    fill: "none",
    stroke: "#939598",
    strokeWidth: 0.05
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10439",
    "data-name": "Caminho 10439",
    d: "M28.494,7.068c.007-.007.063-.045.063-.046a.858.858,0,0,1,.069-.06",
    transform: "translate(20.353 4.973)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10440",
    "data-name": "Caminho 10440",
    d: "M28.536,7.029c.005.005-.084.017-.1.038",
    transform: "translate(20.313 5.021)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10441",
    "data-name": "Caminho 10441",
    d: "M28.551,7.028c.005.012-.094.038-.1.041",
    transform: "translate(20.324 5.02)",
    fill: "none",
    stroke: "#939598",
    strokeWidth: 0.05
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10442",
    "data-name": "Caminho 10442",
    d: "M29.15,6.857a.266.266,0,0,0-.163-.221.938.938,0,0,0-.391-.06c-.063.007-.074.036-.153.048a.738.738,0,0,0-.163.05s0-.007-.041.069-.111.115-.077.183.012.081.055.093S28.2,7,28.2,7s-.273.087-.206.252.13.1.151.1.153-.072.153-.072l.218-.2s.257-.1.285-.108a.958.958,0,0,1,.149,0Z",
    transform: "translate(19.987 4.695)",
    fill: "#c6262c"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10443",
    "data-name": "Caminho 10443",
    d: "M29.15,6.857a.266.266,0,0,0-.163-.221.938.938,0,0,0-.391-.06c-.063.007-.074.036-.153.048a.738.738,0,0,0-.163.05s0-.007-.041.069-.111.115-.077.183.012.081.055.093S28.2,7,28.2,7s-.273.087-.206.252.13.1.151.1.153-.072.153-.072l.218-.2s.257-.1.285-.108a.958.958,0,0,1,.149,0Z",
    transform: "translate(19.987 4.695)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10444",
    "data-name": "Caminho 10444",
    d: "M28.625,6.974a.155.155,0,0,1-.091.115c-.05.024-.091.01-.091-.029a.155.155,0,0,1,.091-.115c.05-.024.091-.01.091.029",
    transform: "translate(20.316 4.952)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10445",
    "data-name": "Caminho 10445",
    d: "M29.52,7.231a.37.37,0,0,0,.146-.067",
    transform: "translate(21.086 5.117)",
    fill: "#5e3f17"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10446",
    "data-name": "Caminho 10446",
    d: "M28.114,6.892c.039,0,.087.022.084.074a.034.034,0,0,0,0,.026h0a.2.2,0,0,0-.005-.1.08.08,0,0,0-.079-.041v.038",
    transform: "translate(20.081 4.896)",
    fill: "#842116"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10447",
    "data-name": "Caminho 10447",
    d: "M28.238,6.992a.19.19,0,0,0-.019-.171s-.007.029,0,.038a.1.1,0,0,1,.019.1c0,.01,0,.031,0,.036",
    transform: "translate(20.154 4.872)",
    fill: "#842116"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10448",
    "data-name": "Caminho 10448",
    d: "M28.362,6.895a.233.233,0,0,0-.094-.175s-.007.034,0,.038a.224.224,0,0,1,.093.17c0,.007,0-.005,0-.007a.064.064,0,0,0,0-.026",
    transform: "translate(20.19 4.8)",
    fill: "#842116"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10449",
    "data-name": "Caminho 10449",
    d: "M28.425,6.873a.176.176,0,0,0-.048-.17s-.007.033,0,.038a.114.114,0,0,1,.046.1.065.065,0,0,0,0,.026s0,.014,0,.007",
    transform: "translate(20.268 4.788)",
    fill: "#842116"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10450",
    "data-name": "Caminho 10450",
    d: "M28.268,6.722c.137-.07.418-.1.526.038-.005-.005.007-.029,0-.038-.108-.139-.389-.108-.526-.038-.007,0,0,.036,0,.038",
    transform: "translate(20.19 4.732)",
    fill: "#842116"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10451",
    "data-name": "Caminho 10451",
    d: "M28.343,7.3a.564.564,0,0,0,.132-.01V7.251a.564.564,0,0,1-.132.01V7.3",
    transform: "translate(20.245 5.179)",
    fill: "#7a2e26"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10452",
    "data-name": "Caminho 10452",
    d: "M28.316,6.923c-.036,0-.026.043-.046.062l0,.019,0,.019c.021-.017.01-.062.046-.062V6.923",
    transform: "translate(20.19 4.945)",
    fill: "#7a2e26"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10453",
    "data-name": "Caminho 10453",
    d: "M28.367,7.014a.185.185,0,0,1,.087-.065c.007,0,0-.036,0-.038a.175.175,0,0,0-.089.067V7l0,.014",
    transform: "translate(20.261 4.936)",
    fill: "#7a2e26"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10454",
    "data-name": "Caminho 10454",
    d: "M28.458,7.124a.077.077,0,0,0,.07-.034l0-.019,0-.019a.077.077,0,0,1-.07.034v.038",
    transform: "translate(20.327 5.037)",
    fill: "#7a2e26"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10455",
    "data-name": "Caminho 10455",
    d: "M28.533,7.124a.222.222,0,0,0,.11-.1.063.063,0,0,0,0-.024l-.005-.014a.2.2,0,0,1-.108.1c-.009,0,0,.038,0,.038",
    transform: "translate(20.378 4.993)",
    fill: "#7a2e26"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10456",
    "data-name": "Caminho 10456",
    d: "M28.463,6.948c-.027.046-.079.07-.111.113-.005.009,0,.034,0,.036.031-.043.082-.067.111-.113V6.962l0-.014",
    transform: "translate(20.25 4.963)",
    fill: "#7a2e26"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10457",
    "data-name": "Caminho 10457",
    d: "M28.466,7.332a.947.947,0,0,0,.293-.034V7.26a.947.947,0,0,1-.293.034v.038",
    transform: "translate(20.333 5.186)",
    fill: "#7a2e26"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10458",
    "data-name": "Caminho 10458",
    d: "M28.735,7.449a.6.6,0,0,0,.283-.341c0-.01,0-.029,0-.036a.6.6,0,0,1-.281.339c-.007.005,0,.034,0,.038",
    transform: "translate(20.523 5.051)",
    fill: "#7a2e26"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10459",
    "data-name": "Caminho 10459",
    d: "M28.781,7.277a.456.456,0,0,0,.2-.245c0-.01,0-.031,0-.036a.455.455,0,0,1-.194.243c-.007,0,0,.036,0,.038",
    transform: "translate(20.556 4.997)",
    fill: "#7a2e26"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10460",
    "data-name": "Caminho 10460",
    d: "M28.754,6.84a.289.289,0,0,1,.2.1c-.005,0,.007-.031,0-.038a.289.289,0,0,0-.2-.1V6.84",
    transform: "translate(20.539 4.858)",
    fill: "#7a2e26"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10461",
    "data-name": "Caminho 10461",
    d: "M29.851,7.162a.381.381,0,0,0-.046-.411s-.007.029,0,.038a.3.3,0,0,1,.046.338c-.005.009,0,.033,0,.036",
    transform: "translate(21.286 4.822)",
    fill: "#7a2e26"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10462",
    "data-name": "Caminho 10462",
    d: "M29.01,6.9c.082.06.307.209.245.333-.005.01,0,.033,0,.038.084-.17-.132-.326-.245-.408,0,0-.007.033,0,.038",
    transform: "translate(20.72 4.901)",
    fill: "#7a2e26"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10463",
    "data-name": "Caminho 10463",
    d: "M29.379,7.294a.446.446,0,0,0,.021-.108.074.074,0,0,0,0-.027h0a.393.393,0,0,1-.021.1.1.1,0,0,0,0,.022l0,.014",
    transform: "translate(20.983 5.114)",
    fill: "#7a2e26"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10464",
    "data-name": "Caminho 10464",
    d: "M28.082,7.08a.141.141,0,0,0-.01-.153s-.007.029,0,.038A.149.149,0,0,1,28.09,7c.007.015,0,.029-.012.043v.022l0,.014",
    transform: "translate(20.049 4.948)",
    fill: "#7a2e26"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10465",
    "data-name": "Caminho 10465",
    d: "M28.9,7.317a.184.184,0,0,0,.086-.123.129.129,0,0,0,0-.026s0-.014,0-.007a.185.185,0,0,1-.084.118c-.007.005,0,.036,0,.038",
    transform: "translate(20.638 5.113)",
    fill: "#7a2e26"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10466",
    "data-name": "Caminho 10466",
    d: "M29.019,7.282a.115.115,0,0,0,.027-.074l0-.024,0,.014a.1.1,0,0,1-.024.046l0,.019,0,.019",
    transform: "translate(20.726 5.131)",
    fill: "#7a2e26"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10467",
    "data-name": "Caminho 10467",
    d: "M29.761,6.849a.271.271,0,0,1,.024.2l0,.034a.388.388,0,0,0-.026-.267s-.007.027,0,.036",
    transform: "translate(21.256 4.866)",
    fill: "#7a2e26"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10468",
    "data-name": "Caminho 10468",
    d: "M29.686,6.924a.365.365,0,0,1,.015.192c0,.005,0,.041,0,.027a.535.535,0,0,0-.017-.255c0,.005-.005.026,0,.036",
    transform: "translate(21.204 4.92)",
    fill: "#7a2e26"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10469",
    "data-name": "Caminho 10469",
    d: "M29.624,6.981a.412.412,0,0,1-.015.137c-.005.01,0,.031,0,.036a.532.532,0,0,0,.017-.173c0-.022,0-.022,0,0",
    transform: "translate(21.148 4.974)",
    fill: "#7a2e26"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10470",
    "data-name": "Caminho 10470",
    d: "M33.289,7.514a1.886,1.886,0,0,1-1-.307.783.783,0,0,1-.662-.687c-.25-.1-.466-.739-.466-.739a1.034,1.034,0,0,1-.873,0s0-.1-.439,0-.363-.082-.363-.082.177-.177-.6,0,.063-.231.063-.231a8.019,8.019,0,0,1-.963.122,4.013,4.013,0,0,0-.845.231c-.187.053-.506.115-.667.183-.43.185-1.293.579-2,.859-.936.367-1.677.646-1.629.634s1.017-.621,2.217-1.164a25.7,25.7,0,0,1,3.036-1.155,2.9,2.9,0,0,1,1.911,0c.187.067,1.222-.033,1.685.022s.511.816.511.816c.087.053.118.77.118.77s-.255.007.045.046a2.742,2.742,0,0,1,.85.478,1.287,1.287,0,0,0,.209-.007.7.7,0,0,1,.259-.2,1.578,1.578,0,0,1,.458-.129,3.592,3.592,0,0,1,.576.005c.168.019.369.021.605.065a1.791,1.791,0,0,1,.338.084.274.274,0,0,0,.142.009,4.076,4.076,0,0,1,1.015-.331,1.109,1.109,0,0,0,.333-.146c.117-.089.382-.307.382-.307a.973.973,0,0,1,1.13-1.167c1.315.127,3.057.3,3.4.35a12.866,12.866,0,0,1,1.9.557c.3.144,1.161.53,1.543.7.154.069.747.331,1.185.5a4.351,4.351,0,0,1,1.149.691c-.411-.173-.744-.372-1.071-.514-.264-.115-.54-.168-.754-.264-.456-.2-.806-.386-1.082-.514-1.018-.473-1.008-.492-1.421-.525-.283-.022.2.346.2.346s-.931-.362-1.229-.489a1.736,1.736,0,0,0-.831-.163,1.751,1.751,0,0,1-.665-.091c-.166-.055-1.114-.091-1.281-.11a2.125,2.125,0,0,1-.3-.053l.067.108-.465-.072-.134.2s-.449.091-.482-.055-.267.653-.384.888-.646.158-.78.3a1.628,1.628,0,0,1-.483.278,1.279,1.279,0,0,1-.384.019c-.173,0-.026,0-.31.058a1.43,1.43,0,0,1-.339-.041c-.093-.039-.3-.1-.4-.129a8.12,8.12,0,0,0-1.044-.051,1.644,1.644,0,0,0-.427.117,1.052,1.052,0,0,0-.345.216",
    transform: "translate(16.312 3.584)",
    fill: "#dcddde"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10471",
    "data-name": "Caminho 10471",
    d: "M33.289,7.514a1.886,1.886,0,0,1-1-.307.783.783,0,0,1-.662-.687c-.25-.1-.466-.739-.466-.739a1.034,1.034,0,0,1-.873,0s0-.1-.439,0-.363-.082-.363-.082.177-.177-.6,0,.063-.231.063-.231a8.019,8.019,0,0,1-.963.122,4.013,4.013,0,0,0-.845.231c-.187.053-.506.115-.667.183-.43.185-1.293.579-2,.859-.936.367-1.677.646-1.629.634s1.017-.621,2.217-1.164a25.7,25.7,0,0,1,3.036-1.155,2.9,2.9,0,0,1,1.911,0c.187.067,1.222-.033,1.685.022s.511.816.511.816c.087.053.118.77.118.77s-.255.007.045.046a2.742,2.742,0,0,1,.85.478,1.287,1.287,0,0,0,.209-.007.7.7,0,0,1,.259-.2,1.578,1.578,0,0,1,.458-.129,3.592,3.592,0,0,1,.576.005c.168.019.369.021.605.065a1.791,1.791,0,0,1,.338.084.274.274,0,0,0,.142.009,4.076,4.076,0,0,1,1.015-.331,1.109,1.109,0,0,0,.333-.146c.117-.089.382-.307.382-.307a.973.973,0,0,1,1.13-1.167c1.315.127,3.057.3,3.4.35a12.866,12.866,0,0,1,1.9.557c.3.144,1.161.53,1.543.7.154.069.747.331,1.185.5a4.351,4.351,0,0,1,1.149.691c-.411-.173-.744-.372-1.071-.514-.264-.115-.54-.168-.754-.264-.456-.2-.806-.386-1.082-.514-1.018-.473-1.008-.492-1.421-.525-.283-.022.2.346.2.346s-.931-.362-1.229-.489a1.736,1.736,0,0,0-.831-.163,1.751,1.751,0,0,1-.665-.091c-.166-.055-1.114-.091-1.281-.11a2.125,2.125,0,0,1-.3-.053l.067.108-.465-.072-.134.2s-.449.091-.482-.055-.267.653-.384.888-.646.158-.78.3a1.628,1.628,0,0,1-.483.278,1.279,1.279,0,0,1-.384.019c-.173,0-.026,0-.31.058a1.43,1.43,0,0,1-.339-.041c-.093-.039-.3-.1-.4-.129a8.12,8.12,0,0,0-1.044-.051,1.644,1.644,0,0,0-.427.117,1.052,1.052,0,0,0-.345.216",
    transform: "translate(16.312 3.584)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10472",
    "data-name": "Caminho 10472",
    d: "M29,6.386a.226.226,0,0,0-.069.142c-.012.1-.007.062-.007.062",
    transform: "translate(20.657 4.561)",
    fill: "#452c25"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10473",
    "data-name": "Caminho 10473",
    d: "M30.471,6.323a1.939,1.939,0,0,1,.2.159s.021.021.014.007a.152.152,0,0,0-.031-.043,1.99,1.99,0,0,0-.216-.178c-.012-.009,0,.014,0,.015a.149.149,0,0,0,.034.039",
    transform: "translate(21.734 4.476)",
    fill: "#574f4c"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEcu);
export default __webpack_public_path__ + "static/media/flag_ECU.aa8340c7e920480bebd136226172eae6.svg";
export { ForwardRef as ReactComponent };